import * as g from "react";
import Ye, { useLayoutEffect as Mu, useEffect as bn, useState as Sr, forwardRef as Js, createElement as Wn, createContext as An, Component as Iu, useContext as Oe, useId as ea, useCallback as ta, useRef as Kt, useInsertionEffect as _u, useMemo as Wt, Fragment as Lu, Children as Xp, isValidElement as Yp } from "react";
import * as Wo from "react-dom";
import Nu from "react-dom";
var zl = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Jp(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ls = { exports: {} }, cr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ul;
function e4() {
  if (Ul) return cr;
  Ul = 1;
  var e = Ye, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(a, l, c) {
    var u, d = {}, f = null, h = null;
    c !== void 0 && (f = "" + c), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l) r.call(l, u) && !i.hasOwnProperty(u) && (d[u] = l[u]);
    if (a && a.defaultProps) for (u in l = a.defaultProps, l) d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: t, type: a, key: f, ref: h, props: d, _owner: o.current };
  }
  return cr.Fragment = n, cr.jsx = s, cr.jsxs = s, cr;
}
var ur = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Kl;
function t4() {
  return Kl || (Kl = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Ye, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), a = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), v = Symbol.iterator, m = "@@iterator";
    function y(A) {
      if (A === null || typeof A != "object")
        return null;
      var N = v && A[v] || A[m];
      return typeof N == "function" ? N : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function x(A) {
      {
        for (var N = arguments.length, K = new Array(N > 1 ? N - 1 : 0), X = 1; X < N; X++)
          K[X - 1] = arguments[X];
        w("error", A, K);
      }
    }
    function w(A, N, K) {
      {
        var X = C.ReactDebugCurrentFrame, ge = X.getStackAddendum();
        ge !== "" && (N += "%s", K = K.concat([ge]));
        var ye = K.map(function(ue) {
          return String(ue);
        });
        ye.unshift("Warning: " + N), Function.prototype.apply.call(console[A], console, ye);
      }
    }
    var S = !1, R = !1, k = !1, P = !1, T = !1, _;
    _ = Symbol.for("react.module.reference");
    function O(A) {
      return !!(typeof A == "string" || typeof A == "function" || A === r || A === i || T || A === o || A === c || A === u || P || A === h || S || R || k || typeof A == "object" && A !== null && (A.$$typeof === f || A.$$typeof === d || A.$$typeof === s || A.$$typeof === a || A.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      A.$$typeof === _ || A.getModuleId !== void 0));
    }
    function L(A, N, K) {
      var X = A.displayName;
      if (X)
        return X;
      var ge = N.displayName || N.name || "";
      return ge !== "" ? K + "(" + ge + ")" : K;
    }
    function I(A) {
      return A.displayName || "Context";
    }
    function H(A) {
      if (A == null)
        return null;
      if (typeof A.tag == "number" && x("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof A == "function")
        return A.displayName || A.name || null;
      if (typeof A == "string")
        return A;
      switch (A) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof A == "object")
        switch (A.$$typeof) {
          case a:
            var N = A;
            return I(N) + ".Consumer";
          case s:
            var K = A;
            return I(K._context) + ".Provider";
          case l:
            return L(A, A.render, "ForwardRef");
          case d:
            var X = A.displayName || null;
            return X !== null ? X : H(A.type) || "Memo";
          case f: {
            var ge = A, ye = ge._payload, ue = ge._init;
            try {
              return H(ue(ye));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, W = 0, Z, U, B, j, b, Y, Ce;
    function E() {
    }
    E.__reactDisabledLog = !0;
    function xe() {
      {
        if (W === 0) {
          Z = console.log, U = console.info, B = console.warn, j = console.error, b = console.group, Y = console.groupCollapsed, Ce = console.groupEnd;
          var A = {
            configurable: !0,
            enumerable: !0,
            value: E,
            writable: !0
          };
          Object.defineProperties(console, {
            info: A,
            log: A,
            warn: A,
            error: A,
            group: A,
            groupCollapsed: A,
            groupEnd: A
          });
        }
        W++;
      }
    }
    function Me() {
      {
        if (W--, W === 0) {
          var A = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, A, {
              value: Z
            }),
            info: z({}, A, {
              value: U
            }),
            warn: z({}, A, {
              value: B
            }),
            error: z({}, A, {
              value: j
            }),
            group: z({}, A, {
              value: b
            }),
            groupCollapsed: z({}, A, {
              value: Y
            }),
            groupEnd: z({}, A, {
              value: Ce
            })
          });
        }
        W < 0 && x("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var le = C.ReactCurrentDispatcher, Q;
    function te(A, N, K) {
      {
        if (Q === void 0)
          try {
            throw Error();
          } catch (ge) {
            var X = ge.stack.trim().match(/\n( *(at )?)/);
            Q = X && X[1] || "";
          }
        return `
` + Q + A;
      }
    }
    var se = !1, re;
    {
      var ce = typeof WeakMap == "function" ? WeakMap : Map;
      re = new ce();
    }
    function de(A, N) {
      if (!A || se)
        return "";
      {
        var K = re.get(A);
        if (K !== void 0)
          return K;
      }
      var X;
      se = !0;
      var ge = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ye;
      ye = le.current, le.current = null, xe();
      try {
        if (N) {
          var ue = function() {
            throw Error();
          };
          if (Object.defineProperty(ue.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ue, []);
            } catch (We) {
              X = We;
            }
            Reflect.construct(A, [], ue);
          } else {
            try {
              ue.call();
            } catch (We) {
              X = We;
            }
            A.call(ue.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (We) {
            X = We;
          }
          A();
        }
      } catch (We) {
        if (We && X && typeof We.stack == "string") {
          for (var ae = We.stack.split(`
`), ze = X.stack.split(`
`), Se = ae.length - 1, Re = ze.length - 1; Se >= 1 && Re >= 0 && ae[Se] !== ze[Re]; )
            Re--;
          for (; Se >= 1 && Re >= 0; Se--, Re--)
            if (ae[Se] !== ze[Re]) {
              if (Se !== 1 || Re !== 1)
                do
                  if (Se--, Re--, Re < 0 || ae[Se] !== ze[Re]) {
                    var ot = `
` + ae[Se].replace(" at new ", " at ");
                    return A.displayName && ot.includes("<anonymous>") && (ot = ot.replace("<anonymous>", A.displayName)), typeof A == "function" && re.set(A, ot), ot;
                  }
                while (Se >= 1 && Re >= 0);
              break;
            }
        }
      } finally {
        se = !1, le.current = ye, Me(), Error.prepareStackTrace = ge;
      }
      var Tn = A ? A.displayName || A.name : "", cn = Tn ? te(Tn) : "";
      return typeof A == "function" && re.set(A, cn), cn;
    }
    function _e(A, N, K) {
      return de(A, !1);
    }
    function Ue(A) {
      var N = A.prototype;
      return !!(N && N.isReactComponent);
    }
    function qe(A, N, K) {
      if (A == null)
        return "";
      if (typeof A == "function")
        return de(A, Ue(A));
      if (typeof A == "string")
        return te(A);
      switch (A) {
        case c:
          return te("Suspense");
        case u:
          return te("SuspenseList");
      }
      if (typeof A == "object")
        switch (A.$$typeof) {
          case l:
            return _e(A.render);
          case d:
            return qe(A.type, N, K);
          case f: {
            var X = A, ge = X._payload, ye = X._init;
            try {
              return qe(ye(ge), N, K);
            } catch {
            }
          }
        }
      return "";
    }
    var Ke = Object.prototype.hasOwnProperty, dt = {}, Rn = C.ReactDebugCurrentFrame;
    function rt(A) {
      if (A) {
        var N = A._owner, K = qe(A.type, A._source, N ? N.type : null);
        Rn.setExtraStackFrame(K);
      } else
        Rn.setExtraStackFrame(null);
    }
    function qr(A, N, K, X, ge) {
      {
        var ye = Function.call.bind(Ke);
        for (var ue in A)
          if (ye(A, ue)) {
            var ae = void 0;
            try {
              if (typeof A[ue] != "function") {
                var ze = Error((X || "React class") + ": " + K + " type `" + ue + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof A[ue] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ze.name = "Invariant Violation", ze;
              }
              ae = A[ue](N, ue, X, K, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Se) {
              ae = Se;
            }
            ae && !(ae instanceof Error) && (rt(ge), x("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", X || "React class", K, ue, typeof ae), rt(null)), ae instanceof Error && !(ae.message in dt) && (dt[ae.message] = !0, rt(ge), x("Failed %s type: %s", K, ae.message), rt(null));
          }
      }
    }
    var Ci = Array.isArray;
    function lr(A) {
      return Ci(A);
    }
    function yi(A) {
      {
        var N = typeof Symbol == "function" && Symbol.toStringTag, K = N && A[Symbol.toStringTag] || A.constructor.name || "Object";
        return K;
      }
    }
    function xi(A) {
      try {
        return Xr(A), !1;
      } catch {
        return !0;
      }
    }
    function Xr(A) {
      return "" + A;
    }
    function M(A) {
      if (xi(A))
        return x("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", yi(A)), Xr(A);
    }
    var V = C.ReactCurrentOwner, J = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ie, me, Be;
    Be = {};
    function Rt(A) {
      if (Ke.call(A, "ref")) {
        var N = Object.getOwnPropertyDescriptor(A, "ref").get;
        if (N && N.isReactWarning)
          return !1;
      }
      return A.ref !== void 0;
    }
    function ft(A) {
      if (Ke.call(A, "key")) {
        var N = Object.getOwnPropertyDescriptor(A, "key").get;
        if (N && N.isReactWarning)
          return !1;
      }
      return A.key !== void 0;
    }
    function an(A, N) {
      if (typeof A.ref == "string" && V.current && N && V.current.stateNode !== N) {
        var K = H(V.current.type);
        Be[K] || (x('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', H(V.current.type), A.ref), Be[K] = !0);
      }
    }
    function ln(A, N) {
      {
        var K = function() {
          ie || (ie = !0, x("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", N));
        };
        K.isReactWarning = !0, Object.defineProperty(A, "key", {
          get: K,
          configurable: !0
        });
      }
    }
    function He(A, N) {
      {
        var K = function() {
          me || (me = !0, x("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", N));
        };
        K.isReactWarning = !0, Object.defineProperty(A, "ref", {
          get: K,
          configurable: !0
        });
      }
    }
    var jt = function(A, N, K, X, ge, ye, ue) {
      var ae = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: A,
        key: N,
        ref: K,
        props: ue,
        // Record the component responsible for creating this element.
        _owner: ye
      };
      return ae._store = {}, Object.defineProperty(ae._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ae, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: X
      }), Object.defineProperty(ae, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ge
      }), Object.freeze && (Object.freeze(ae.props), Object.freeze(ae)), ae;
    };
    function ht(A, N, K, X, ge) {
      {
        var ye, ue = {}, ae = null, ze = null;
        K !== void 0 && (M(K), ae = "" + K), ft(N) && (M(N.key), ae = "" + N.key), Rt(N) && (ze = N.ref, an(N, ge));
        for (ye in N)
          Ke.call(N, ye) && !J.hasOwnProperty(ye) && (ue[ye] = N[ye]);
        if (A && A.defaultProps) {
          var Se = A.defaultProps;
          for (ye in Se)
            ue[ye] === void 0 && (ue[ye] = Se[ye]);
        }
        if (ae || ze) {
          var Re = typeof A == "function" ? A.displayName || A.name || "Unknown" : A;
          ae && ln(ue, Re), ze && He(ue, Re);
        }
        return jt(A, ae, ze, ge, X, V.current, ue);
      }
    }
    var wi = C.ReactCurrentOwner, Dl = C.ReactDebugCurrentFrame;
    function Pn(A) {
      if (A) {
        var N = A._owner, K = qe(A.type, A._source, N ? N.type : null);
        Dl.setExtraStackFrame(K);
      } else
        Dl.setExtraStackFrame(null);
    }
    var bi;
    bi = !1;
    function Ai(A) {
      return typeof A == "object" && A !== null && A.$$typeof === t;
    }
    function Ol() {
      {
        if (wi.current) {
          var A = H(wi.current.type);
          if (A)
            return `

Check the render method of \`` + A + "`.";
        }
        return "";
      }
    }
    function Hp(A) {
      return "";
    }
    var jl = {};
    function zp(A) {
      {
        var N = Ol();
        if (!N) {
          var K = typeof A == "string" ? A : A.displayName || A.name;
          K && (N = `

Check the top-level render call using <` + K + ">.");
        }
        return N;
      }
    }
    function Vl(A, N) {
      {
        if (!A._store || A._store.validated || A.key != null)
          return;
        A._store.validated = !0;
        var K = zp(N);
        if (jl[K])
          return;
        jl[K] = !0;
        var X = "";
        A && A._owner && A._owner !== wi.current && (X = " It was passed a child from " + H(A._owner.type) + "."), Pn(A), x('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', K, X), Pn(null);
      }
    }
    function Fl(A, N) {
      {
        if (typeof A != "object")
          return;
        if (lr(A))
          for (var K = 0; K < A.length; K++) {
            var X = A[K];
            Ai(X) && Vl(X, N);
          }
        else if (Ai(A))
          A._store && (A._store.validated = !0);
        else if (A) {
          var ge = y(A);
          if (typeof ge == "function" && ge !== A.entries)
            for (var ye = ge.call(A), ue; !(ue = ye.next()).done; )
              Ai(ue.value) && Vl(ue.value, N);
        }
      }
    }
    function Up(A) {
      {
        var N = A.type;
        if (N == null || typeof N == "string")
          return;
        var K;
        if (typeof N == "function")
          K = N.propTypes;
        else if (typeof N == "object" && (N.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        N.$$typeof === d))
          K = N.propTypes;
        else
          return;
        if (K) {
          var X = H(N);
          qr(K, A.props, "prop", X, A);
        } else if (N.PropTypes !== void 0 && !bi) {
          bi = !0;
          var ge = H(N);
          x("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ge || "Unknown");
        }
        typeof N.getDefaultProps == "function" && !N.getDefaultProps.isReactClassApproved && x("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Kp(A) {
      {
        for (var N = Object.keys(A.props), K = 0; K < N.length; K++) {
          var X = N[K];
          if (X !== "children" && X !== "key") {
            Pn(A), x("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", X), Pn(null);
            break;
          }
        }
        A.ref !== null && (Pn(A), x("Invalid attribute `ref` supplied to `React.Fragment`."), Pn(null));
      }
    }
    var Bl = {};
    function Hl(A, N, K, X, ge, ye) {
      {
        var ue = O(A);
        if (!ue) {
          var ae = "";
          (A === void 0 || typeof A == "object" && A !== null && Object.keys(A).length === 0) && (ae += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ze = Hp();
          ze ? ae += ze : ae += Ol();
          var Se;
          A === null ? Se = "null" : lr(A) ? Se = "array" : A !== void 0 && A.$$typeof === t ? (Se = "<" + (H(A.type) || "Unknown") + " />", ae = " Did you accidentally export a JSX literal instead of a component?") : Se = typeof A, x("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Se, ae);
        }
        var Re = ht(A, N, K, ge, ye);
        if (Re == null)
          return Re;
        if (ue) {
          var ot = N.children;
          if (ot !== void 0)
            if (X)
              if (lr(ot)) {
                for (var Tn = 0; Tn < ot.length; Tn++)
                  Fl(ot[Tn], A);
                Object.freeze && Object.freeze(ot);
              } else
                x("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Fl(ot, A);
        }
        if (Ke.call(N, "key")) {
          var cn = H(A), We = Object.keys(N).filter(function(qp) {
            return qp !== "key";
          }), Ei = We.length > 0 ? "{key: someKey, " + We.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Bl[cn + Ei]) {
            var $p = We.length > 0 ? "{" + We.join(": ..., ") + ": ...}" : "{}";
            x(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ei, cn, $p, cn), Bl[cn + Ei] = !0;
          }
        }
        return A === r ? Kp(Re) : Up(Re), Re;
      }
    }
    function Wp(A, N, K) {
      return Hl(A, N, K, !0);
    }
    function Zp(A, N, K) {
      return Hl(A, N, K, !1);
    }
    var Qp = Zp, Gp = Wp;
    ur.Fragment = r, ur.jsx = Qp, ur.jsxs = Gp;
  }()), ur;
}
process.env.NODE_ENV === "production" ? ls.exports = e4() : ls.exports = t4();
var p = ls.exports;
const n4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M14.5 4.5H5.5C5.23478 4.5 4.98043 4.60536 4.79289 4.79289C4.60536 4.98043 4.5 5.23478 4.5 5.5V14.5C4.5 14.7652 4.60536 15.0196 4.79289 15.2071C4.98043 15.3946 5.23478 15.5 5.5 15.5H14.5C14.7652 15.5 15.0196 15.3946 15.2071 15.2071C15.3946 15.0196 15.5 14.7652 15.5 14.5V5.5C15.5 5.23478 15.3946 4.98043 15.2071 4.79289C15.0196 4.60536 14.7652 4.5 14.5 4.5ZM14.5 9.5H10.5V5.5H14.5V9.5ZM9.5 5.5V9.5H5.5V5.5H9.5ZM5.5 10.5H9.5V14.5H5.5V10.5ZM14.5 14.5H10.5V10.5H14.5V14.5Z"
    fill="#576077" />
</svg>`, r4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M16 5H4C3.73478 5 3.48043 5.10536 3.29289 5.29289C3.10536 5.48043 3 5.73478 3 6V7.5C3 7.76522 3.10536 8.01957 3.29289 8.20711C3.48043 8.39464 3.73478 8.5 4 8.5V14C4 14.2652 4.10536 14.5196 4.29289 14.7071C4.48043 14.8946 4.73478 15 5 15H15C15.2652 15 15.5196 14.8946 15.7071 14.7071C15.8946 14.5196 16 14.2652 16 14V8.5C16.2652 8.5 16.5196 8.39464 16.7071 8.20711C16.8946 8.01957 17 7.76522 17 7.5V6C17 5.73478 16.8946 5.48043 16.7071 5.29289C16.5196 5.10536 16.2652 5 16 5ZM15 14H5V8.5H15V14ZM16 7.5H4V6H16V7.5ZM8 10.5C8 10.3674 8.05268 10.2402 8.14645 10.1464C8.24021 10.0527 8.36739 10 8.5 10H11.5C11.6326 10 11.7598 10.0527 11.8536 10.1464C11.9473 10.2402 12 10.3674 12 10.5C12 10.6326 11.9473 10.7598 11.8536 10.8536C11.7598 10.9473 11.6326 11 11.5 11H8.5C8.36739 11 8.24021 10.9473 8.14645 10.8536C8.05268 10.7598 8 10.6326 8 10.5Z"
    fill="#576077" />
</svg>`, o4 = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
  <g stroke="#576077" stroke-linecap="round" stroke-linejoin="round" clip-path="url(#a)">
    <path d="M5.625 15v1.875M14.375 15v1.875M15.625 7.5h-5v3.75h5V7.5Z" />
    <path
      d="M15.625 8.125h3.125v3.125c0 .9946-.3951 1.9484-1.0983 2.6517C16.9484 14.6049 15.9946 15 15 15H5c-.99456 0-1.94839-.3951-2.65165-1.0983C1.64509 13.1984 1.25 12.2446 1.25 11.25V8.125h9.375M4.375 8.125V4.0625c0-.4144.16462-.81182.45765-1.10485C5.12567 2.66462 5.5231 2.5 5.9375 2.5c.36389-.00085.71716.1226 1.00131.34993.28416.22732.48215.54487.56119.90007" />
  </g>
  <defs>
    <clipPath id="a">
      <path fill="#576077" d="M0 0h20v20H0z" />
    </clipPath>
  </defs>
</svg>`, i4 = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
  <g stroke="#576077" stroke-linecap="round" stroke-linejoin="round" clip-path="url(#a)">
    <path
      d="M8.75 13.125V6.25h8.125c.663 0 1.2989.26339 1.7678.73223.4688.46884.7322 1.10473.7322 1.76777v4.375M1.875 16.25V3.75M1.875 13.125h17.5v3.125M8.75 6.25H1.875" />
  </g>
  <defs>
    <clipPath id="a">
      <path fill="#576077" d="M0 0h20v20H0z" />
    </clipPath>
  </defs>
</svg>`, s4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M4 6C4 4.89543 4.89543 4 6 4H14C15.1046 4 16 4.89543 16 6V14C16 15.1046 15.1046 16 14 16H6C4.89543 16 4 15.1046 4 14V6Z"
    fill="#576077" fill-opacity="0.05" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M14 3H6C4.34315 3 3 4.34315 3 6V14C3 15.6569 4.34315 17 6 17H14C15.6569 17 17 15.6569 17 14V6C17 4.34315 15.6569 3 14 3ZM4 6C4 4.89543 4.89543 4 6 4H14C15.1046 4 16 4.89543 16 6V14C16 15.1046 15.1046 16 14 16H6C4.89543 16 4 15.1046 4 14V6ZM12.2239 8.11835C12.1114 8.22551 11.9587 8.28571 11.7996 8.28571H9.39961C9.24048 8.28571 9.08787 8.34592 8.97535 8.45308C8.86282 8.56025 8.79961 8.70559 8.79961 8.85714C8.79961 9.0087 8.86282 9.15404 8.97535 9.2612C9.08787 9.36837 9.24048 9.42857 9.39961 9.42857H10.5996C11.077 9.42857 11.5348 9.60918 11.8724 9.93067C12.21 10.2522 12.3996 10.6882 12.3996 11.1429C12.3996 11.5975 12.21 12.0336 11.8724 12.355C11.5348 12.6765 11.077 12.8571 10.5996 12.8571V13.4286C10.5996 13.5801 10.5364 13.7255 10.4239 13.8326C10.3114 13.9398 10.1587 14 9.99961 14C9.84048 14 9.68787 13.9398 9.57535 13.8326C9.46282 13.7255 9.39961 13.5801 9.39961 13.4286V12.8571H8.19961C8.04048 12.8571 7.88787 12.7969 7.77535 12.6898C7.66282 12.5826 7.59961 12.4373 7.59961 12.2857C7.59961 12.1342 7.66282 11.9888 7.77535 11.8817C7.88787 11.7745 8.04048 11.7143 8.19961 11.7143H10.5996C10.7587 11.7143 10.9114 11.6541 11.0239 11.5469C11.1364 11.4398 11.1996 11.2944 11.1996 11.1429C11.1996 10.9913 11.1364 10.846 11.0239 10.7388C10.9114 10.6316 10.7587 10.5714 10.5996 10.5714H9.39961C8.92222 10.5714 8.46438 10.3908 8.12682 10.0693C7.78925 9.74784 7.59961 9.3118 7.59961 8.85714C7.59961 8.40249 7.78925 7.96645 8.12682 7.64496C8.46438 7.32347 8.92222 7.14286 9.39961 7.14286V6.57143C9.39961 6.41988 9.46282 6.27453 9.57535 6.16737C9.68787 6.0602 9.84048 6 9.99961 6C10.1587 6 10.3114 6.0602 10.4239 6.16737C10.5364 6.27453 10.5996 6.41988 10.5996 6.57143V7.14286H11.7996C11.9587 7.14286 12.1114 7.20306 12.2239 7.31022C12.3364 7.41739 12.3996 7.56273 12.3996 7.71429C12.3996 7.86584 12.3364 8.01118 12.2239 8.11835Z"
    fill="#576077" />
</svg>`, a4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M17 8.5H16.325L14.5887 4.59375C14.5102 4.41702 14.382 4.26686 14.2199 4.16148C14.0577 4.05609 13.8684 4 13.675 4H6.325C6.13159 4 5.94233 4.05609 5.78014 4.16148C5.61796 4.26686 5.48982 4.41702 5.41125 4.59375L3.675 8.5H3C2.86739 8.5 2.74021 8.55268 2.64645 8.64645C2.55268 8.74021 2.5 8.86739 2.5 9C2.5 9.13261 2.55268 9.25979 2.64645 9.35355C2.74021 9.44732 2.86739 9.5 3 9.5H3.5V14.5C3.5 14.7652 3.60536 15.0196 3.79289 15.2071C3.98043 15.3946 4.23478 15.5 4.5 15.5H6C6.26522 15.5 6.51957 15.3946 6.70711 15.2071C6.89464 15.0196 7 14.7652 7 14.5V13.5H13V14.5C13 14.7652 13.1054 15.0196 13.2929 15.2071C13.4804 15.3946 13.7348 15.5 14 15.5H15.5C15.7652 15.5 16.0196 15.3946 16.2071 15.2071C16.3946 15.0196 16.5 14.7652 16.5 14.5V9.5H17C17.1326 9.5 17.2598 9.44732 17.3536 9.35355C17.4473 9.25979 17.5 9.13261 17.5 9C17.5 8.86739 17.4473 8.74021 17.3536 8.64645C17.2598 8.55268 17.1326 8.5 17 8.5ZM6.325 5H13.675L15.2306 8.5H4.76938L6.325 5ZM6 14.5H4.5V13.5H6V14.5ZM14 14.5V13.5H15.5V14.5H14ZM15.5 12.5H4.5V9.5H15.5V12.5ZM5.5 11C5.5 10.8674 5.55268 10.7402 5.64645 10.6464C5.74021 10.5527 5.86739 10.5 6 10.5H7C7.13261 10.5 7.25979 10.5527 7.35355 10.6464C7.44732 10.7402 7.5 10.8674 7.5 11C7.5 11.1326 7.44732 11.2598 7.35355 11.3536C7.25979 11.4473 7.13261 11.5 7 11.5H6C5.86739 11.5 5.74021 11.4473 5.64645 11.3536C5.55268 11.2598 5.5 11.1326 5.5 11ZM12.5 11C12.5 10.8674 12.5527 10.7402 12.6464 10.6464C12.7402 10.5527 12.8674 10.5 13 10.5H14C14.1326 10.5 14.2598 10.5527 14.3536 10.6464C14.4473 10.7402 14.5 10.8674 14.5 11C14.5 11.1326 14.4473 11.2598 14.3536 11.3536C14.2598 11.4473 14.1326 11.5 14 11.5H13C12.8674 11.5 12.7402 11.4473 12.6464 11.3536C12.5527 11.2598 12.5 11.1326 12.5 11Z"
    fill="#576077" />
</svg>`, l4 = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
  <path
    fill="#F0F2F4"
    d="M16 10c0 1.1867-.3519 2.3467-1.0112 3.3334-.6593.9867-1.5963 1.7558-2.6927 2.2099-1.0964.4541-2.30275.5729-3.46664.3414-1.16388-.2315-2.23298-.8029-3.0721-1.6421-.83911-.8391-1.41056-1.9082-1.64207-3.0721-.23151-1.1638-.11269-2.37024.34144-3.4666.45412-1.09636 1.22316-2.03343 2.20985-2.69272C7.65328 4.35189 8.81331 4 10 4c1.5913 0 3.1174.63214 4.2426 1.75736C15.3679 6.88258 16 8.4087 16 10Z"
  />
  <path
    fill="#576077"
    d="M12.8538 8.14625c.0464.04644.0833.10158.1085.16228.0251.0607.0381.12576.0381.19147 0 .06571-.013.13077-.0381.19147-.0252.0607-.0621.11584-.1085.16228L9.35375 12.3538c-.04643.0464-.10158.0833-.16228.1085-.0607.0251-.12576.0381-.19147.0381-.06571 0-.13077-.013-.19147-.0381-.0607-.0252-.11584-.0621-.16228-.1085l-1.5-1.5c-.09382-.0939-.14653-.2211-.14653-.3538s.05271-.2599.14653-.3538c.09382-.0938.22107-.14648.35375-.14648.13268 0 .25993.05268.35375.14648L9 11.2931l3.1463-3.14685c.0464-.04649.1015-.08337.1622-.10853.0607-.02516.1258-.03811.1915-.03811.0657 0 .1308.01295.1915.03811.0607.02516.1158.06204.1623.10853ZM16.5 10c0 1.2856-.3812 2.5423-1.0954 3.6112-.7143 1.0689-1.7294 1.902-2.9172 2.394-1.1877.492-2.49461.6207-3.75548.3699-1.26088-.2508-2.41907-.8699-3.32811-1.7789-.90904-.909-1.52811-2.0672-1.77891-3.3281-.25081-1.2609-.12208-2.56782.36989-3.75554.49197-1.18772 1.32509-2.20288 2.39401-2.91711C7.45772 3.88122 8.71442 3.5 10 3.5c1.7234.00182 3.3756.68722 4.5942 1.90582C15.8128 6.62441 16.4982 8.27665 16.5 10Zm-1 0c0-1.0878-.3226-2.15117-.9269-3.05564-.6044-.90447-1.4633-1.60942-2.4683-2.0257-1.005-.41628-2.1109-.5252-3.17779-.31298-1.0669.21222-2.04691.73604-2.81609 1.50523-.76919.76919-1.29302 1.7492-1.50524 2.81609-.21222 1.0669-.1033 2.1728.31298 3.1778.41629 1.005 1.12124 1.8639 2.02571 2.4683.90447.6043 1.96784.9269 3.05563.9269 1.4582-.0017 2.8562-.5816 3.8873-1.6127C14.9184 12.8562 15.4983 11.4582 15.5 10Z"
  />
</svg>
`, c4 = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
  <path fill="#576077"
    d="M10 3.5c-1.28558 0-2.54228.38122-3.6112 1.09545-1.06892.71423-1.90204 1.72939-2.39401 2.91711-.49197 1.18772-.6207 2.49464-.36989 3.75554.2508 1.2609.86987 2.4191 1.77891 3.3281.90904.909 2.06723 1.5281 3.32811 1.7789 1.26087.2508 2.56778.1221 3.75548-.3699 1.1878-.492 2.2029-1.3251 2.9172-2.394C16.1188 12.5423 16.5 11.2856 16.5 10c-.0018-1.72335-.6872-3.37559-1.9058-4.59418C13.3756 4.18722 11.7234 3.50182 10 3.5Zm0 12c-1.08779 0-2.15116-.3226-3.05563-.9269-.90447-.6044-1.60942-1.4633-2.0257-2.4683-.41629-1.005-.52521-2.1109-.31299-3.1778.21222-1.06689.73605-2.0469 1.50524-2.81609.76918-.76919 1.74919-1.29301 2.81609-1.50523 1.06689-.21222 2.17279-.1033 3.17779.31298s1.8639 1.12123 2.4683 2.0257C15.1774 7.84883 15.5 8.9122 15.5 10c-.0017 1.4582-.5816 2.8562-1.6127 3.8873C12.8562 14.9184 11.4582 15.4983 10 15.5Zm2.8538-6.85375c.0464.04644.0833.10158.1085.16228.0251.0607.0381.12576.0381.19147 0 .06571-.013.13077-.0381.19147-.0252.0607-.0621.11584-.1085.16228l-2.5 2.50005c-.0465.0464-.1016.0833-.1623.1085-.0607.0251-.1258.0381-.1915.0381-.0657 0-.13077-.013-.19147-.0381-.0607-.0252-.11584-.0621-.16228-.1085l-2.5-2.50005C7.05243 9.25993 6.99973 9.13268 6.99973 9c0-.13268.0527-.25993.14652-.35375.09382-.09382.22107-.14653.35375-.14653.13268 0 .25993.05271.35375.14653L10 10.7931l2.1463-2.14685c.0464-.04649.1015-.08337.1622-.10853.0607-.02516.1258-.03811.1915-.03811.0657 0 .1308.01295.1915.03811.0607.02516.1158.06204.1623.10853Z" />
</svg>`, u4 = `<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.3536 13.3536C10.1583 13.5488 9.84171 13.5488 9.64645 13.3536L4.64645 8.35355C4.45118 8.15829 4.45118 7.84171 4.64645 7.64645C4.84171 7.45118 5.15829 7.45118 5.35355 7.64645L10 12.2929L14.6464 7.64645C14.8417 7.45118 15.1583 7.45118 15.3536 7.64645C15.5488 7.84171 15.5488 8.15829 15.3536 8.35355L10.3536 13.3536Z"
    fill="#576077"
  />
</svg>
`, d4 = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
  <path
    fill="#576077"
    d="M16.502 10c0-1.28558-.3813-2.54229-1.0955-3.61121-.7142-1.06891-1.7294-1.90204-2.9171-2.394-1.1877-.49197-2.49465-.6207-3.75553-.36989-1.26088.2508-2.41907.86987-3.32811 1.77891-.90904.90904-1.5281 2.06723-1.77891 3.3281-.2508 1.26088-.12208 2.56779.36989 3.75549.49197 1.1878 1.32509 2.2029 2.39401 2.9172C7.45967 16.1188 8.71638 16.5 10.002 16.5c1.7233-.0018 3.3755-.6872 4.5941-1.9058S16.5001 11.7234 16.502 10ZM4.50196 10c0-1.0878.32257-2.15116.92691-3.05563.60435-.90447 1.46333-1.60942 2.46833-2.02571 1.00499-.41628 2.1109-.5252 3.1778-.31298 1.0668.21222 2.0469.73605 2.816 1.50523.7692.76919 1.2931 1.7492 1.5053 2.81609.2122 1.0669.1033 2.1728-.313 3.1778s-1.1212 1.8639-2.0257 2.4683c-.9045.6043-1.9678.9269-3.0556.9269-1.45823-.0017-2.85621-.5816-3.8873-1.6127C5.0836 12.8562 4.50361 11.4582 4.50196 10Zm4.85375 2.8538c-.04646.0464-.10161.0833-.1623.1084-.0607.0251-.12576.0381-.19145.0381-.0657 0-.13075-.013-.19145-.0381-.0607-.0251-.11585-.062-.1623-.1084-.04646-.0465-.08331-.1017-.10845-.1624-.02514-.0606-.03808-.1257-.03808-.1914 0-.0657.01294-.1308.03808-.1914.02514-.0607.06199-.1159.10845-.1623L10.7951 10 8.64821 7.85375c-.04646-.04645-.08331-.1016-.10845-.1623-.02514-.0607-.03808-.12575-.03808-.19145 0-.0657.01294-.13075.03808-.19145.02514-.06069.06199-.11584.10845-.1623.04645-.04645.1016-.0833.1623-.10844.0607-.02515.12575-.03809.19145-.03809.06569 0 .13075.01294.19144.03809.0607.02514.11585.06199.16231.10844l2.49999 2.5c.0465.04644.0834.10158.1085.16228.0252.0607.0381.12576.0381.19147 0 .0657-.0129.1308-.0381.1915-.0251.0607-.062.1158-.1085.1623l-2.49999 2.5Z"
  />
</svg>
`, f4 = `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.3536 9.64645C13.5488 9.84171 13.5488 10.1583 13.3536 10.3536L8.35355 15.3536C8.15829 15.5488 7.84171 15.5488 7.64645 15.3536C7.45118 15.1583 7.45118 14.8417 7.64645 14.6464L12.2929 10L7.64645 5.35355C7.45118 5.15829 7.45118 4.84171 7.64645 4.64645C7.84171 4.45118 8.15829 4.45118 8.35355 4.64645L13.3536 9.64645Z"
    fill="#576077"
  />
</svg>
`, h4 = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
  <path
    fill="#576077"
    d="M10 3.5c-1.28558 0-2.54229.38122-3.61121 1.09544-1.06892.71423-1.90204 1.7294-2.39401 2.91711-.49197 1.18772-.62069 2.49465-.36989 3.75555.25081 1.2609.86988 2.419 1.77892 3.3281.90904.909 2.06723 1.5281 3.3281 1.7789 1.26088.2508 2.56779.1221 3.75549-.3699 1.1878-.492 2.2029-1.3251 2.9172-2.394C16.1188 12.5423 16.5 11.2856 16.5 10c-.0018-1.72335-.6872-3.3756-1.9058-4.59419C13.3756 4.18722 11.7233 3.50182 10 3.5Zm0 12c-1.0878 0-2.15116-.3226-3.05564-.9269-.90447-.6044-1.60941-1.4634-2.0257-2.4683-.41628-1.005-.5252-2.1109-.31298-3.1778.21222-1.0669.73604-2.0469 1.50523-2.81609S7.86011 4.8179 8.927 4.60568c1.0669-.21222 2.1728-.1033 3.1778.31298s1.8639 1.12123 2.4683 2.0257C15.1774 7.84883 15.5 8.9122 15.5 10c-.0017 1.4582-.5816 2.8562-1.6127 3.8873-1.0311 1.031-2.4291 1.611-3.8873 1.6127Zm2.8538-4.8538c.0464.0465.0833.1017.1084.1623.0251.0607.0381.1258.0381.1915 0 .0657-.013.1307-.0381.1914-.0251.0607-.062.1159-.1084.1623-.0465.0465-.1017.0834-.1624.1085-.0606.0251-.1257.0381-.1914.0381-.0657 0-.1308-.013-.1914-.0381-.0607-.0251-.1159-.062-.1623-.1085L10 9.20687 7.85375 11.3537c-.04645.0465-.1016.0834-.1623.1085-.0607.0251-.12575.0381-.19145.0381-.0657 0-.13075-.013-.19145-.0381-.06069-.0251-.11584-.062-.1623-.1085-.04646-.0464-.08331-.1016-.10845-.1623-.02514-.0607-.03808-.1257-.03808-.1914 0-.0657.01294-.1308.03808-.1915.02514-.0606.06199-.1158.10845-.1623l2.5-2.49995c.04644-.04649.10158-.08337.16228-.10853.0607-.02516.12576-.03812.19147-.03812.0657 0 .1308.01296.1915.03812.0607.02516.1158.06204.1623.10853l2.5 2.49995Z"
  />
</svg>
`, p4 = `<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.64645 6.64645C9.84171 6.45118 10.1583 6.45118 10.3536 6.64645L15.3536 11.6464C15.5488 11.8417 15.5488 12.1583 15.3536 12.3536C15.1583 12.5488 14.8417 12.5488 14.6464 12.3536L10 7.70711L5.35355 12.3536C5.15829 12.5488 4.84171 12.5488 4.64645 12.3536C4.45118 12.1583 4.45118 11.8417 4.64645 11.6464L9.64645 6.64645Z"
    fill="#576077"
  />
</svg>
`, m4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g id="ui / icons/PersonChild">
    <path id="icon"
      d="M8.03711 10.875C7.88878 10.875 7.74377 10.831 7.62043 10.7486C7.4971 10.6662 7.40097 10.5491 7.3442 10.412C7.28744 10.275 7.27258 10.1242 7.30152 9.97868C7.33046 9.8332 7.40189 9.69956 7.50678 9.59467C7.61167 9.48978 7.74531 9.41835 7.89079 9.38941C8.03628 9.36047 8.18708 9.37532 8.32412 9.43209C8.46117 9.48886 8.5783 9.58499 8.66071 9.70832C8.74313 9.83166 8.78711 9.97666 8.78711 10.125C8.78711 10.3239 8.70809 10.5147 8.56744 10.6553C8.42679 10.796 8.23602 10.875 8.03711 10.875ZM12.5371 9.375C12.3888 9.375 12.2438 9.41899 12.1204 9.5014C11.9971 9.58381 11.901 9.70094 11.8442 9.83799C11.7874 9.97503 11.7726 10.1258 11.8015 10.2713C11.8305 10.4168 11.9019 10.5504 12.0068 10.6553C12.1117 10.7602 12.2453 10.8317 12.3908 10.8606C12.5363 10.8895 12.6871 10.8747 12.8241 10.8179C12.9612 10.7611 13.0783 10.665 13.1607 10.5417C13.2431 10.4183 13.2871 10.2733 13.2871 10.125C13.2871 9.92609 13.2081 9.73532 13.0674 9.59467C12.9268 9.45402 12.736 9.375 12.5371 9.375ZM11.7702 12.2019C11.3249 12.4783 10.8112 12.6247 10.2871 12.6247C9.763 12.6247 9.24931 12.4783 8.80399 12.2019C8.69177 12.1311 8.55603 12.1078 8.42663 12.1371C8.29723 12.1664 8.18477 12.2459 8.11399 12.3581C8.04321 12.4703 8.01991 12.6061 8.04921 12.7355C8.07851 12.8649 8.15802 12.9773 8.27024 13.0481C8.87533 13.4253 9.57408 13.6253 10.2871 13.6253C11.0001 13.6253 11.6989 13.4253 12.304 13.0481C12.4162 12.9773 12.4957 12.8649 12.525 12.7355C12.5543 12.6061 12.531 12.4703 12.4602 12.3581C12.3895 12.2459 12.277 12.1664 12.1476 12.1371C12.0182 12.1078 11.8825 12.1311 11.7702 12.2019ZM16.7871 10.125C16.7871 11.4106 16.4059 12.6673 15.6917 13.7362C14.9774 14.8051 13.9623 15.6382 12.7746 16.1302C11.5868 16.6222 10.2799 16.7509 9.01903 16.5001C7.75815 16.2493 6.59996 15.6302 5.69092 14.7212C4.78188 13.8122 4.16281 12.654 3.91201 11.3931C3.6612 10.1322 3.78993 8.82528 4.2819 7.63756C4.77386 6.44984 5.60699 5.43468 6.67591 4.72045C7.74483 4.00622 9.00153 3.625 10.2871 3.625C12.0105 3.62682 13.6627 4.31222 14.8813 5.53082C16.0999 6.74941 16.7853 8.40165 16.7871 10.125ZM15.7871 10.125C15.7854 8.70915 15.2384 7.34838 14.2597 6.32524C13.281 5.3021 11.9459 4.69522 10.5315 4.63063C9.80711 5.64875 9.78711 6.6175 9.78711 6.625C9.78711 6.75761 9.83979 6.88479 9.93356 6.97855C10.0273 7.07232 10.1545 7.125 10.2871 7.125C10.4197 7.125 10.5469 7.07232 10.6407 6.97855C10.7344 6.88479 10.7871 6.75761 10.7871 6.625C10.7871 6.49239 10.8398 6.36521 10.9336 6.27145C11.0273 6.17768 11.1545 6.125 11.2871 6.125C11.4197 6.125 11.5469 6.17768 11.6407 6.27145C11.7344 6.36521 11.7871 6.49239 11.7871 6.625C11.7871 7.02282 11.6291 7.40436 11.3478 7.68566C11.0665 7.96696 10.6849 8.125 10.2871 8.125C9.88929 8.125 9.50776 7.96696 9.22645 7.68566C8.94515 7.40436 8.78711 7.02282 8.78711 6.625C8.78711 6.57938 8.79524 5.73125 9.31586 4.71062C8.28609 4.89538 7.33036 5.37001 6.56085 6.07883C5.79133 6.78764 5.23995 7.70124 4.97139 8.7124C4.70284 9.72357 4.72826 10.7904 5.04468 11.7876C5.36109 12.7848 5.95536 13.6711 6.75777 14.3425C7.56018 15.0138 8.53742 15.4424 9.57483 15.5779C10.6122 15.7134 11.6668 15.5502 12.6147 15.1074C13.5626 14.6646 14.3646 13.9607 14.9265 13.0782C15.4884 12.1957 15.787 11.1712 15.7871 10.125Z"
      fill="#576077" />
  </g>
</svg>`, g4 = `<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g id="ui / icons/ResponseTime">
    <path
      id="splash"
      d="M16 10C16 11.1867 15.6481 12.3467 14.9888 13.3334C14.3295 14.3201 13.3925 15.0892 12.2961 15.5433C11.1997 15.9974 9.99335 16.1162 8.82946 15.8847C7.66558 15.6532 6.59648 15.0818 5.75736 14.2426C4.91825 13.4035 4.3468 12.3344 4.11529 11.1705C3.88378 10.0067 4.0026 8.80026 4.45673 7.7039C4.91085 6.60754 5.67989 5.67047 6.66658 5.01118C7.65328 4.35189 8.81331 4 10 4C11.5913 4 13.1174 4.63214 14.2426 5.75736C15.3679 6.88258 16 8.4087 16 10Z"
      fill="#576077"
      fill-opacity="0.05"
    />
    <path
      id="icon"
      d="M16.5003 10.5415C16.394 11.7765 15.9373 12.9554 15.1838 13.9396C14.4303 14.9239 13.4113 15.6724 12.2469 16.0972C11.0824 16.522 9.82079 16.6054 8.61053 16.3376C7.40028 16.0697 6.29169 15.4618 5.4152 14.5853C4.53871 13.7088 3.93078 12.6002 3.66293 11.39C3.39509 10.1797 3.47847 8.91811 3.90327 7.75363C4.32807 6.58915 5.07662 5.57022 6.06084 4.81671C7.04506 4.0632 8.22402 3.60646 9.459 3.50023C9.52466 3.49482 9.59075 3.50239 9.65349 3.52251C9.71622 3.54263 9.77438 3.57491 9.82464 3.61751C9.8749 3.66011 9.91628 3.71219 9.94641 3.77078C9.97654 3.82937 9.99484 3.89332 10.0003 3.95898C10.0057 4.02464 9.9981 4.09073 9.97798 4.15346C9.95786 4.2162 9.92557 4.27436 9.88297 4.32462C9.84038 4.37488 9.78829 4.41626 9.7297 4.44639C9.67111 4.47652 9.60716 4.49482 9.5415 4.50023C8.49625 4.59004 7.49838 4.97653 6.66532 5.61421C5.83226 6.2519 5.19867 7.11425 4.83908 8.09981C4.4795 9.08537 4.40889 10.1531 4.63556 11.1775C4.86223 12.2018 5.37675 13.1401 6.11858 13.8819C6.86041 14.6237 7.79869 15.1383 8.82302 15.3649C9.84735 15.5916 10.9151 15.521 11.9007 15.1614C12.8862 14.8018 13.7486 14.1682 14.3863 13.3352C15.024 12.5021 15.4104 11.5042 15.5003 10.459C15.5112 10.3264 15.5744 10.2035 15.6759 10.1175C15.7774 10.0315 15.9089 9.98929 16.0415 10.0002C16.1741 10.0112 16.2969 10.0743 16.383 10.1758C16.469 10.2774 16.5112 10.4089 16.5003 10.5415ZM9.50025 6.50023V10.0002C9.50025 10.1328 9.55293 10.26 9.6467 10.3538C9.74047 10.4476 9.86765 10.5002 10.0003 10.5002H13.5003C13.6329 10.5002 13.76 10.4476 13.8538 10.3538C13.9476 10.26 14.0003 10.1328 14.0003 10.0002C14.0003 9.86763 13.9476 9.74045 13.8538 9.64668C13.76 9.55291 13.6329 9.50023 13.5003 9.50023H10.5003V6.50023C10.5003 6.36763 10.4476 6.24045 10.3538 6.14668C10.26 6.05291 10.1329 6.00023 10.0003 6.00023C9.86765 6.00023 9.74047 6.05291 9.6467 6.14668C9.55293 6.24045 9.50025 6.36763 9.50025 6.50023ZM12.0003 5.00023C12.1486 5.00023 12.2936 4.95625 12.4169 4.87384C12.5403 4.79142 12.6364 4.67429 12.6932 4.53725C12.7499 4.4002 12.7648 4.2494 12.7358 4.10392C12.7069 3.95843 12.6355 3.82479 12.5306 3.7199C12.4257 3.61501 12.2921 3.54358 12.1466 3.51465C12.0011 3.48571 11.8503 3.50056 11.7132 3.55732C11.5762 3.61409 11.4591 3.71022 11.3767 3.83356C11.2942 3.95689 11.2503 4.1019 11.2503 4.25023C11.2503 4.44915 11.3293 4.63991 11.4699 4.78056C11.6106 4.92122 11.8013 5.00023 12.0003 5.00023ZM14.2503 6.50023C14.3986 6.50023 14.5436 6.45625 14.6669 6.37384C14.7903 6.29143 14.8864 6.17429 14.9432 6.03725C14.9999 5.9002 15.0148 5.7494 14.9858 5.60392C14.9569 5.45843 14.8855 5.32479 14.7806 5.2199C14.6757 5.11501 14.5421 5.04358 14.3966 5.01464C14.2511 4.98571 14.1003 5.00056 13.9632 5.05732C13.8262 5.11409 13.7091 5.21022 13.6267 5.33356C13.5442 5.45689 13.5003 5.6019 13.5003 5.75023C13.5003 5.94915 13.5793 6.13991 13.7199 6.28057C13.8606 6.42122 14.0513 6.50023 14.2503 6.50023ZM15.7503 8.75023C15.8986 8.75023 16.0436 8.70625 16.1669 8.62384C16.2903 8.54143 16.3864 8.42429 16.4432 8.28725C16.4999 8.1502 16.5148 7.9994 16.4858 7.85392C16.4569 7.70843 16.3855 7.57479 16.2806 7.4699C16.1757 7.36501 16.0421 7.29358 15.8966 7.26464C15.7511 7.23571 15.6003 7.25056 15.4632 7.30733C15.3262 7.36409 15.2091 7.46022 15.1267 7.58356C15.0442 7.70689 15.0003 7.8519 15.0003 8.00023C15.0003 8.19915 15.0793 8.38991 15.2199 8.53056C15.3606 8.67122 15.5513 8.75023 15.7503 8.75023Z"
      fill="#16181E"
    />
  </g>
</svg>
`, v4 = `<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g id="icon left">
    <path
      id="icon"
      d="M14.854 14.146C14.9005 14.1925 14.9373 14.2476 14.9625 14.3083C14.9876 14.369 15.0006 14.4341 15.0006 14.4998C15.0006 14.5655 14.9876 14.6305 14.9625 14.6912C14.9373 14.7519 14.9005 14.8071 14.854 14.8535C14.8076 14.9 14.7524 14.9368 14.6917 14.962C14.631 14.9871 14.566 15.0001 14.5003 15.0001C14.4346 15.0001 14.3695 14.9871 14.3088 14.962C14.2481 14.9368 14.193 14.9 14.1465 14.8535L10.0003 10.7067L5.85403 14.8535C5.76021 14.9474 5.63296 15.0001 5.50028 15.0001C5.3676 15.0001 5.24035 14.9474 5.14653 14.8535C5.05271 14.7597 5 14.6325 5 14.4998C5 14.3671 5.05271 14.2399 5.14653 14.146L9.2934 9.99979L5.14653 5.85354C5.05271 5.75972 5 5.63247 5 5.49979C5 5.36711 5.05271 5.23986 5.14653 5.14604C5.24035 5.05222 5.3676 4.99951 5.50028 4.99951C5.63296 4.99951 5.76021 5.05222 5.85403 5.14604L10.0003 9.29291L14.1465 5.14604C14.2403 5.05222 14.3676 4.99951 14.5003 4.99951C14.633 4.99951 14.7602 5.05222 14.854 5.14604C14.9478 5.23986 15.0006 5.36711 15.0006 5.49979C15.0006 5.63247 14.9478 5.75972 14.854 5.85354L10.7072 9.99979L14.854 14.146Z"
      fill="#576077"
    />
  </g>
</svg>
`, C4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M15.354 5.35403L12.2072 8.50028H14.0003C14.1329 8.50028 14.2601 8.55296 14.3538 8.64672C14.4476 8.74049 14.5003 8.86767 14.5003 9.00028C14.5003 9.13289 14.4476 9.26006 14.3538 9.35383C14.2601 9.4476 14.1329 9.50028 14.0003 9.50028H11.0003C10.8677 9.50028 10.7405 9.4476 10.6467 9.35383C10.553 9.26006 10.5003 9.13289 10.5003 9.00028V6.00028C10.5003 5.86767 10.553 5.74049 10.6467 5.64672C10.7405 5.55296 10.8677 5.50028 11.0003 5.50028C11.1329 5.50028 11.2601 5.55296 11.3538 5.64672C11.4476 5.74049 11.5003 5.86767 11.5003 6.00028V7.7934L14.6465 4.64653C14.7403 4.55271 14.8676 4.5 15.0003 4.5C15.133 4.5 15.2602 4.55271 15.354 4.64653C15.4478 4.74035 15.5006 4.8676 15.5006 5.00028C15.5006 5.13296 15.4478 5.26021 15.354 5.35403ZM9.00028 10.5003H6.00028C5.86767 10.5003 5.74049 10.553 5.64672 10.6467C5.55296 10.7405 5.50028 10.8677 5.50028 11.0003C5.50028 11.1329 5.55296 11.2601 5.64672 11.3538C5.74049 11.4476 5.86767 11.5003 6.00028 11.5003H7.7934L4.64653 14.6465C4.55271 14.7403 4.5 14.8676 4.5 15.0003C4.5 15.133 4.55271 15.2602 4.64653 15.354C4.74035 15.4478 4.8676 15.5006 5.00028 15.5006C5.13296 15.5006 5.26021 15.4478 5.35403 15.354L8.50028 12.2072V14.0003C8.50028 14.1329 8.55296 14.2601 8.64672 14.3538C8.74049 14.4476 8.86767 14.5003 9.00028 14.5003C9.13289 14.5003 9.26006 14.4476 9.35383 14.3538C9.4476 14.2601 9.50028 14.1329 9.50028 14.0003V11.0003C9.50028 10.8677 9.4476 10.7405 9.35383 10.6467C9.26006 10.553 9.13289 10.5003 9.00028 10.5003Z"
    fill="#576077" />
</svg>`, y4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M4 5.33333C4 4.04467 5.04467 3 6.33333 3H13.6667C14.9553 3 16 4.04467 16 5.33333V14.6667C16 15.9553 14.9553 17 13.6667 17H6.33333C5.04467 17 4 15.9553 4 14.6667V5.33333Z"
    fill="#576077" fill-opacity="0.05" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M5.13504 4.46774C5.41696 4.18558 5.80327 4.01642 6.47398 3.92621C7.15907 3.83407 8.06219 3.83301 9.33333 3.83301H10.6667C11.9378 3.83301 12.8409 3.83407 13.526 3.92621C14.1967 4.01642 14.583 4.18558 14.865 4.46774L14.8653 4.46805C15.1474 4.74997 15.3166 5.13627 15.4068 5.80699C15.4989 6.49208 15.5 7.3952 15.5 8.66634V11.333C15.5 12.6041 15.4989 13.5073 15.4068 14.1924C15.3166 14.8631 15.1474 15.2494 14.8653 15.5313L14.865 15.5316C14.583 15.8138 14.1967 15.9829 13.526 16.0731C12.8409 16.1653 11.9378 16.1663 10.6667 16.1663H9.33333C8.06219 16.1663 7.15907 16.1653 6.47398 16.0731C5.80327 15.9829 5.41696 15.8138 5.13504 15.5316L5.13474 15.5313C4.85258 15.2494 4.68341 14.8631 4.59321 14.1924C4.50106 13.5073 4.5 12.6041 4.5 11.333V8.66634C4.5 7.3952 4.50106 6.49208 4.59321 5.80699C4.68341 5.13627 4.85258 4.74997 5.13474 4.46805L5.13504 4.46774ZM9.33333 2.83301H9.29571H9.2957C8.07062 2.833 7.10017 2.83299 6.34069 2.93514C5.55915 3.04025 4.92651 3.26172 4.42778 3.76079C3.92871 4.25951 3.70724 4.89215 3.60213 5.67369C3.49998 6.43318 3.49999 7.40363 3.5 8.62871V8.62872V8.66634V11.333V11.3706V11.3706C3.49999 12.5957 3.49998 13.5662 3.60213 14.3257C3.70723 15.1071 3.92867 15.7397 4.42763 16.2384C4.92638 16.7376 5.55907 16.9591 6.34069 17.0642C7.10017 17.1664 8.07061 17.1664 9.29569 17.1663H9.33333H10.6667H10.7043C11.9294 17.1664 12.8998 17.1664 13.6593 17.0642C14.4409 16.9591 15.0735 16.7376 15.5722 16.2386L15.5721 16.2387L15.2187 15.885L15.5724 16.2384L15.5722 16.2386C16.0713 15.7398 16.2928 15.1072 16.3979 14.3257C16.5 13.5662 16.5 12.5957 16.5 11.3706V11.333V8.66634V8.62873C16.5 7.40364 16.5 6.43318 16.3979 5.67369C16.2927 4.89208 16.0712 4.25939 15.5721 3.76064C15.0734 3.26168 14.4408 3.04024 13.6593 2.93514C12.8998 2.83299 11.9294 2.833 10.7043 2.83301H10.7043H10.6667H9.33333ZM7.33301 6.83301C7.05687 6.83301 6.83301 7.05687 6.83301 7.33301C6.83301 7.60915 7.05687 7.83301 7.33301 7.83301H12.6663C12.9425 7.83301 13.1663 7.60915 13.1663 7.33301C13.1663 7.05687 12.9425 6.83301 12.6663 6.83301H7.33301ZM7.33301 9.49968C7.05687 9.49968 6.83301 9.72353 6.83301 9.99968C6.83301 10.2758 7.05687 10.4997 7.33301 10.4997H12.6663C12.9425 10.4997 13.1663 10.2758 13.1663 9.99968C13.1663 9.72353 12.9425 9.49968 12.6663 9.49968H7.33301ZM7.33301 12.1663C7.05687 12.1663 6.83301 12.3902 6.83301 12.6663C6.83301 12.9425 7.05687 13.1663 7.33301 13.1663H10.6663C10.9425 13.1663 11.1663 12.9425 11.1663 12.6663C11.1663 12.3902 10.9425 12.1663 10.6663 12.1663H7.33301Z"
    fill="#576077" />
</svg>`, x4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g id="icon left">
    <path id="icon"
      d="M16 11.5V15C16 15.2652 15.8946 15.5196 15.7071 15.7071C15.5196 15.8946 15.2652 16 15 16H5C4.73478 16 4.48043 15.8946 4.29289 15.7071C4.10536 15.5196 4 15.2652 4 15V11.5C4 11.3674 4.05268 11.2402 4.14645 11.1464C4.24021 11.0527 4.36739 11 4.5 11C4.63261 11 4.75979 11.0527 4.85355 11.1464C4.94732 11.2402 5 11.3674 5 11.5V15H15V11.5C15 11.3674 15.0527 11.2402 15.1464 11.1464C15.2402 11.0527 15.3674 11 15.5 11C15.6326 11 15.7598 11.0527 15.8536 11.1464C15.9473 11.2402 16 11.3674 16 11.5ZM9.64625 11.8538C9.69269 11.9002 9.74783 11.9371 9.80853 11.9623C9.86923 11.9874 9.93429 12.0004 10 12.0004C10.0657 12.0004 10.1308 11.9874 10.1915 11.9623C10.2522 11.9371 10.3073 11.9002 10.3538 11.8538L12.8538 9.35375C12.9002 9.3073 12.9371 9.25214 12.9622 9.19145C12.9873 9.13075 13.0003 9.0657 13.0003 9C13.0003 8.9343 12.9873 8.86925 12.9622 8.80855C12.9371 8.74786 12.9002 8.6927 12.8538 8.64625C12.8073 8.59979 12.7521 8.56294 12.6914 8.5378C12.6308 8.51266 12.5657 8.49972 12.5 8.49972C12.4343 8.49972 12.3692 8.51266 12.3086 8.5378C12.2479 8.56294 12.1927 8.59979 12.1462 8.64625L10.5 10.2931V4.5C10.5 4.36739 10.4473 4.24021 10.3536 4.14645C10.2598 4.05268 10.1326 4 10 4C9.86739 4 9.74021 4.05268 9.64645 4.14645C9.55268 4.24021 9.5 4.36739 9.5 4.5V10.2931L7.85375 8.64625C7.75993 8.55243 7.63268 8.49972 7.5 8.49972C7.36732 8.49972 7.24007 8.55243 7.14625 8.64625C7.05243 8.74007 6.99972 8.86732 6.99972 9C6.99972 9.13268 7.05243 9.25993 7.14625 9.35375L9.64625 11.8538Z"
      fill="#576077" />
  </g>
</svg>`, w4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink">
  <rect width="20" height="20" fill="url(#pattern0_1336_95457)" />
  <defs>
    <pattern id="pattern0_1336_95457" patternContentUnits="objectBoundingBox" width="1" height="1">
      <use xlink:href="#image0_1336_95457" transform="scale(0.00274725)" />
    </pattern>
    <image id="image0_1336_95457" width="364" height="364"
      xlink:href="data:image/png;base64,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" />
  </defs>
</svg>`, b4 = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
  <path
    fill="#576077"
    d="M14.854 14.146c.0465.0465.0833.1016.1085.1623.0251.0607.0381.1258.0381.1915 0 .0657-.013.1307-.0381.1914-.0252.0607-.062.1159-.1085.1623-.0464.0465-.1016.0833-.1623.1085-.0607.0251-.1257.0381-.1914.0381-.0657 0-.1308-.013-.1915-.0381-.0607-.0252-.1158-.062-.1623-.1085l-4.1462-4.1468-4.14627 4.1468c-.09382.0939-.22107.1466-.35375.1466-.13268 0-.25993-.0527-.35375-.1466C5.05271 14.7597 5 14.6325 5 14.4998s.05271-.2599.14653-.3538L9.2934 9.99979 5.14653 5.85354C5.05271 5.75972 5 5.63247 5 5.49979c0-.13268.05271-.25993.14653-.35375.09382-.09382.22107-.14653.35375-.14653.13268 0 .25993.05271.35375.14653l4.14627 4.14687 4.1462-4.14687c.0938-.09382.2211-.14653.3538-.14653s.2599.05271.3537.14653c.0938.09382.1466.22107.1466.35375 0 .13268-.0528.25993-.1466.35375l-4.1468 4.14625L14.854 14.146Z"
  />
</svg>
`, A4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M15.5 5V8C15.5 8.13261 15.4473 8.25979 15.3536 8.35355C15.2598 8.44732 15.1326 8.5 15 8.5C14.8674 8.5 14.7402 8.44732 14.6464 8.35355C14.5527 8.25979 14.5 8.13261 14.5 8V6.20687L11.3538 9.35375C11.2599 9.44757 11.1327 9.50028 11 9.50028C10.8673 9.50028 10.7401 9.44757 10.6462 9.35375C10.5524 9.25993 10.4997 9.13268 10.4997 9C10.4997 8.86732 10.5524 8.74007 10.6462 8.64625L13.7931 5.5H12C11.8674 5.5 11.7402 5.44732 11.6464 5.35355C11.5527 5.25979 11.5 5.13261 11.5 5C11.5 4.86739 11.5527 4.74021 11.6464 4.64645C11.7402 4.55268 11.8674 4.5 12 4.5H15C15.1326 4.5 15.2598 4.55268 15.3536 4.64645C15.4473 4.74021 15.5 4.86739 15.5 5ZM8.64625 10.6462L5.5 13.7931V12C5.5 11.8674 5.44732 11.7402 5.35355 11.6464C5.25979 11.5527 5.13261 11.5 5 11.5C4.86739 11.5 4.74021 11.5527 4.64645 11.6464C4.55268 11.7402 4.5 11.8674 4.5 12V15C4.5 15.1326 4.55268 15.2598 4.64645 15.3536C4.74021 15.4473 4.86739 15.5 5 15.5H8C8.13261 15.5 8.25979 15.4473 8.35355 15.3536C8.44732 15.2598 8.5 15.1326 8.5 15C8.5 14.8674 8.44732 14.7402 8.35355 14.6464C8.25979 14.5527 8.13261 14.5 8 14.5H6.20687L9.35375 11.3538C9.44757 11.2599 9.50028 11.1327 9.50028 11C9.50028 10.8673 9.44757 10.7401 9.35375 10.6462C9.25993 10.5524 9.13268 10.4997 9 10.4997C8.86732 10.4997 8.74007 10.5524 8.64625 10.6462Z"
    fill="#576077" />
</svg>`, E4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 8.5C16 8.63261 15.9473 8.75979 15.8536 8.85355C15.7598 8.94732 15.6326 9 15.5 9C15.3674 9 15.2402 8.94732 15.1464 8.85355C15.0527 8.75979 15 8.63261 15 8.5V5.7075L10.8544 9.85375C10.7606 9.94757 10.6333 10.0003 10.5006 10.0003C10.3679 10.0003 10.2407 9.94757 10.1469 9.85375C10.0531 9.75993 10.0003 9.63268 10.0003 9.5C10.0003 9.36732 10.0531 9.24007 10.1469 9.14625L14.2925 5H11.5C11.3674 5 11.2402 4.94732 11.1464 4.85355C11.0527 4.75979 11 4.63261 11 4.5C11 4.36739 11.0527 4.24021 11.1464 4.14645C11.2402 4.05268 11.3674 4 11.5 4H15.5C15.6326 4 15.7598 4.05268 15.8536 4.14645C15.9473 4.24021 16 4.36739 16 4.5V8.5ZM13.5 10C13.3674 10 13.2402 10.0527 13.1464 10.1464C13.0527 10.2402 13 10.3674 13 10.5V15H5V7H9.5C9.63261 7 9.75979 6.94732 9.85355 6.85355C9.94732 6.75979 10 6.63261 10 6.5C10 6.36739 9.94732 6.24021 9.85355 6.14645C9.75979 6.05268 9.63261 6 9.5 6H5C4.73478 6 4.48043 6.10536 4.29289 6.29289C4.10536 6.48043 4 6.73478 4 7V15C4 15.2652 4.10536 15.5196 4.29289 15.7071C4.48043 15.8946 4.73478 16 5 16H13C13.2652 16 13.5196 15.8946 13.7071 15.7071C13.8946 15.5196 14 15.2652 14 15V10.5C14 10.3674 13.9473 10.2402 13.8536 10.1464C13.7598 10.0527 13.6326 10 13.5 10Z" fill="black"/>
</svg>
`, S4 = `<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M17.04 10.1665C17.04 9.6465 16.9933 9.1465 16.9067 8.6665H10V11.5065H13.9467C13.7733 12.4198 13.2533 13.1932 12.4733 13.7132V15.5598H14.8533C16.24 14.2798 17.04 12.3998 17.04 10.1665Z"
    fill="#4285F4"
  />
  <path
    d="M9.99979 17.3327C11.9798 17.3327 13.6398 16.6794 14.8531 15.5594L12.4731 13.7127C11.8198 14.1527 10.9865 14.4194 9.99979 14.4194C8.09313 14.4194 6.47313 13.1327 5.89313 11.3994H3.45312V13.2927C4.65979 15.6861 7.13312 17.3327 9.99979 17.3327Z"
    fill="#34A853"
  />
  <path
    d="M5.89366 11.3934C5.74699 10.9534 5.66033 10.4867 5.66033 10C5.66033 9.51338 5.74699 9.04671 5.89366 8.60671V6.71338H3.45366C2.95366 7.70005 2.66699 8.81338 2.66699 10C2.66699 11.1867 2.95366 12.3 3.45366 13.2867L5.35366 11.8067L5.89366 11.3934Z"
    fill="#FBBC05"
  />
  <path
    d="M9.99979 5.5865C11.0798 5.5865 12.0398 5.95984 12.8065 6.67984L14.9065 4.57984C13.6331 3.39317 11.9798 2.6665 9.99979 2.6665C7.13312 2.6665 4.65979 4.31317 3.45312 6.71317L5.89313 8.6065C6.47313 6.87317 8.09313 5.5865 9.99979 5.5865Z"
    fill="#EA4335"
  />
</svg>
`, k4 = `<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.8065 6.67984C12.0398 5.95984 11.0798 5.5865 9.99979 5.5865C8.09371 5.5865 6.47412 6.87238 5.89366 8.60491V8.60671C5.74699 9.04671 5.66033 9.51338 5.66033 10C5.66033 10.4867 5.74699 10.9534 5.89366 11.3934L5.88577 11.3994H5.89313C6.47313 13.1327 8.09312 14.4194 9.99979 14.4194C10.9865 14.4194 11.8198 14.1527 12.4731 13.7127L12.4735 13.713C13.2534 13.1931 13.7733 12.4198 13.9467 11.5065H10V8.6665H16.9067C16.9933 9.1465 17.04 9.6465 17.04 10.1665C17.04 12.3998 16.24 14.2798 14.8533 15.5598H14.8527C13.6394 16.6796 11.9795 17.3327 9.99979 17.3327C7.13312 17.3327 4.65979 15.6861 3.45312 13.2927V13.2857C2.95345 12.2993 2.66699 11.1863 2.66699 10C2.66699 8.81344 2.95363 7.70016 3.45358 6.71353L3.45312 6.71317C4.65979 4.31317 7.13312 2.6665 9.99979 2.6665C11.9798 2.6665 13.6331 3.39317 14.9065 4.57984L12.8065 6.67984Z"
    fill="#16181E"
  />
</svg>
`, R4 = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
  <g clip-path="url(#a)">
    <path
      fill="#234DEC"
      fill-rule="evenodd"
      d="M2.3144 7.9999c0-2.2493 1.80828-4.07273 4.03891-4.07273 2.23063 0 4.03889 1.82343 4.03889 4.07273s-1.80826 4.0727-4.03889 4.0727c-2.23063 0-4.03891-1.8234-4.03891-4.0727Zm4.03891-5.6c-3.06712 0-5.553505 2.50721-5.553505 5.6 0 3.0928 2.486385 5.6 5.553505 5.6 3.06712 0 5.55349-2.5072 5.55349-5.6 0-3.09279-2.48637-5.6-5.55349-5.6Zm7.15149 5.60013c0 1.51118-.4609 2.91377-1.2487 4.07277h1.7667c.6364-1.2162.9966-2.60206.9966-4.07277 0-1.4707-.3602-2.85656-.9966-4.07272h-1.7667c.7878 1.15892 1.2487 2.56154 1.2487 4.07272Z"
      clip-rule="evenodd"
    />
  </g>
  <defs>
    <clipPath id="a">
      <path fill="#fff" d="M0 0h16v16H0z" />
    </clipPath>
  </defs>
</svg>
`, P4 = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
  <path
    fill="#fff"
    d="M.390625 4C.390625 2.0066 2.0066.390625 4 .390625h12C17.9934.390625 19.6094 2.0066 19.6094 4v12c0 1.9934-1.616 3.6094-3.6094 3.6094H4C2.0066 19.6094.390625 17.9934.390625 16V4Z"
  />
  <path
    stroke="#E2E4EA"
    stroke-width=".78125"
    d="M.390625 4C.390625 2.0066 2.0066.390625 4 .390625h12C17.9934.390625 19.6094 2.0066 19.6094 4v12c0 1.9934-1.616 3.6094-3.6094 3.6094H4C2.0066 19.6094.390625 17.9934.390625 16V4Z"
  />
  <path
    stroke="#234DEC"
    d="M15 10c0 2.7614-2.2386 5-5 5-1.18243 0-2.269-.4104-3.125-1.0966C5.73192 12.987 5 11.579 5 10c0-2.76142 2.23858-5 5-5 2.7614 0 5 2.23858 5 5Z"
  />
</svg>
`, T4 = `<svg xmlns="http://www.w3.org/2000/svg" width="86" height="16" fill="none">
  <path
    fill="#2C303C"
    fill-rule="evenodd"
    d="M28.8679.908691c-2.8341 0-4.7363 1.611169-4.7363 3.989569 0 1.99478 1.1603 3.29906 3.4048 3.81694l2.2636.51788c1.3125.30689 1.9021.99742 1.9021 2.09072 0 1.381-1.1603 2.2441-2.9863 2.2441-1.731 0-2.8342-.844-2.8723-2.1674h-1.9021c.1141 2.3784 1.9782 3.8553 4.7744 3.8553 2.9293 0 4.8504-1.592 4.8504-4.0855 0-1.95641-1.1413-3.18396-3.3858-3.70184l-2.2635-.53706c-1.2935-.30689-1.9212-.97821-1.9212-2.09068 0-1.36183 1.1223-2.24413 2.8532-2.24413 1.5407 0 2.5108.80558 2.6059 2.18658h1.8832C33.1858 2.3856 31.4929.908691 28.8679.908691ZM51.6408 5.6463h1.3695V4.15021c0-2.30167 1.2555-3.241519 2.9484-3.241519.3423 0 .7418.019182 1.1032.076723V2.53904h-.7989c-1.1603 0-1.4646.5946-1.4646 1.61117V5.6463h2.2064v1.51527h-2.2064v7.86403h-1.7881V7.16157h-1.3695V5.6463Zm5.892 6.7708c0 1.707 1.1793 2.8387 3.1766 2.8387 1.5027 0 2.7771-.6713 3.2526-1.7454l.1903 1.5152h1.5217V9.13717c0-2.53184-1.5598-3.75939-3.8614-3.75939-2.3967 0-3.9945 1.2851-3.9945 3.24152h1.5598c0-1.13166.856-1.80298 2.3586-1.80298 1.2555 0 2.1875.55624 2.1875 2.12905v.26853l-2.9293.23016c-2.1874.17263-3.4619 1.24674-3.4619 2.97304Zm6.4102-1.4386c0 1.7646-1.0271 2.8771-2.72 2.8771-1.1603 0-1.8831-.4987-1.8831-1.4961 0-.9207.6467-1.5344 2.2255-1.6879l2.3776-.1918v.4987Zm3.218-.6329c0-2.93468 1.8451-4.96782 4.5652-4.96782 2.3396 0 3.9754 1.34264 4.2988 3.43332h-1.788c-.3044-1.18919-1.2554-1.82215-2.4538-1.82215-1.6929 0-2.8532 1.30428-2.8532 3.33745 0 2.0139 1.0842 3.3182 2.7771 3.3182 1.2745 0 2.2255-.6713 2.5489-1.7838h1.788c-.3614 2.0332-2.0923 3.395-4.3369 3.395-2.739 0-4.5461-1.9564-4.5461-4.9102Zm14.4026 4.9102c-2.739 0-4.6222-1.9948-4.6222-4.9102 0-2.93468 1.8451-4.96782 4.5462-4.96782 2.6439 0 4.3749 1.84133 4.3749 4.62252v.6713l-7.1901.0192c.1331 1.9756 1.1603 3.0689 2.9293 3.0689 1.3885 0 2.3016-.5754 2.6059-1.6495h1.6739c-.4565 2.0139-2.0163 3.1456-4.3179 3.1456Zm-.076-8.36276c-1.5598 0-2.5489.93985-2.7772 2.58938h5.3641c0-1.55362-1.0082-2.58938-2.5869-2.58938Zm-30.5258.32607V5.56958c-.3614-.07672-.6277-.11508-.951-.11508-1.2745 0-2.2065.65214-2.5869 1.63035l-.1142-1.41937h-1.6739v9.36012h1.7881v-4.9678c0-1.80294 1.0461-2.83869 2.739-2.83869h.7989ZM41.6531 5.6463h1.769v9.3793h-1.5978l-.1902-1.4193c-.5326.9782-1.769 1.6495-3.1385 1.6495-2.1685 0-3.3858-1.4769-3.3858-3.7786V5.6463h1.788v5.2363c0 2.014.8559 2.7812 2.2255 2.7812 1.6358 0 2.5298-1.0549 2.5298-3.0689V5.6463Z"
    clip-rule="evenodd"
  />
  <path
    fill="#969EB0"
    fill-rule="evenodd"
    d="M7.29889 2.64741c-2.93168 0-5.30828 2.3965-5.30828 5.35273 0 2.95626 2.3766 5.35276 5.30828 5.35276 2.93171 0 5.30831-2.3965 5.30831-5.35276 0-2.95623-2.3766-5.35273-5.30831-5.35273ZM0 8.00014C0 3.93532 3.26783.640137 7.29889.640137c4.03111 0 7.29891 3.295183 7.29891 7.360003 0 4.06486-3.2678 7.35996-7.29891 7.35996C3.26783 15.3601 0 12.065 0 8.00014Zm15.0586 5.35276c1.0354-1.5231 1.6412-3.36659 1.6412-5.35271s-.6058-3.82957-1.6412-5.35273h2.3219c.8364 1.59839 1.3099 3.4198 1.3099 5.35273 0 1.93293-.4735 3.75431-1.3099 5.35271h-2.3219Z"
    clip-rule="evenodd"
  />
</svg>
`, M4 = `<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g id="icon left">
    <path
      id="icon"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.89324 10C2.89324 7.18837 5.15359 4.90909 7.94188 4.90909C10.7302 4.90909 12.9905 7.18837 12.9905 10C12.9905 12.8116 10.7302 15.0909 7.94188 15.0909C5.15359 15.0909 2.89324 12.8116 2.89324 10ZM7.94188 3C4.10799 3 1 6.13401 1 10C1 13.866 4.10799 17 7.94188 17C11.7758 17 14.8838 13.866 14.8838 10C14.8838 6.13401 11.7758 3 7.94188 3ZM16.8822 10.0001C16.8822 11.8891 16.3061 13.6423 15.3213 15.091H17.5296C18.3251 13.5708 18.7754 11.8385 18.7754 10.0001C18.7754 8.16171 18.3251 6.42939 17.5296 4.90918H15.3213C16.3061 6.35783 16.8822 8.11111 16.8822 10.0001Z"
      fill="#234DEC"
    />
  </g>
</svg>
`, I4 = `<svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M7.29889 2.64717C4.36721 2.64717 1.99061 5.04366 1.99061 7.99989C1.99061 10.9561 4.36721 13.3526 7.29889 13.3526C10.2306 13.3526 12.6072 10.9561 12.6072 7.99989C12.6072 5.04366 10.2306 2.64717 7.29889 2.64717ZM0 7.99989C0 3.93508 3.26783 0.639893 7.29889 0.639893C11.33 0.639893 14.5978 3.93508 14.5978 7.99989C14.5978 12.0647 11.33 15.3599 7.29889 15.3599C3.26783 15.3599 0 12.0647 0 7.99989Z"
    fill="#969EB0" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M15.0576 13.3524C16.093 11.8293 16.6988 9.98582 16.6988 7.9997C16.6988 6.01358 16.093 4.17013 15.0576 2.64697H17.3795C18.2159 4.24536 18.6894 6.06677 18.6894 7.9997C18.6894 9.93263 18.2159 11.754 17.3795 13.3524H15.0576Z"
    fill="#969EB0" />
</svg>`, _4 = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#576077" viewBox="0 0 256 256"><path d="M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM203.43,64,128,133.15,52.57,64ZM216,192H40V74.19l82.59,75.71a8,8,0,0,0,10.82,0L216,74.19V192Z"></path></svg>
`, L4 = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#576077" viewBox="0 0 256 256"><path d="M226.76,69a8,8,0,0,0-12.84-2.88l-40.3,37.19-17.23-3.7-3.7-17.23,37.19-40.3A8,8,0,0,0,187,29.24,72,72,0,0,0,88,96,72.34,72.34,0,0,0,94,124.94L33.79,177c-.15.12-.29.26-.43.39a32,32,0,0,0,45.26,45.26c.13-.13.27-.28.39-.42L131.06,162A72,72,0,0,0,232,96,71.56,71.56,0,0,0,226.76,69ZM160,152a56.14,56.14,0,0,1-27.07-7,8,8,0,0,0-9.92,1.77L67.11,211.51a16,16,0,0,1-22.62-22.62L109.18,133a8,8,0,0,0,1.77-9.93,56,56,0,0,1,58.36-82.31l-31.2,33.81a8,8,0,0,0-1.94,7.1L141.83,108a8,8,0,0,0,6.14,6.14l26.35,5.66a8,8,0,0,0,7.1-1.94l33.81-31.2A56.06,56.06,0,0,1,160,152Z"></path></svg>
`, N4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M9.5 5.5V8.5C9.5 8.76522 9.39464 9.01957 9.20711 9.20711C9.01957 9.39464 8.76522 9.5 8.5 9.5H5.5C5.23478 9.5 4.98043 9.39464 4.79289 9.20711C4.60536 9.01957 4.5 8.76522 4.5 8.5V5.5C4.5 5.23478 4.60536 4.98043 4.79289 4.79289C4.98043 4.60536 5.23478 4.5 5.5 4.5H8.5C8.76522 4.5 9.01957 4.60536 9.20711 4.79289C9.39464 4.98043 9.5 5.23478 9.5 5.5ZM14.5 4.5H11.5C11.2348 4.5 10.9804 4.60536 10.7929 4.79289C10.6054 4.98043 10.5 5.23478 10.5 5.5V8.5C10.5 8.76522 10.6054 9.01957 10.7929 9.20711C10.9804 9.39464 11.2348 9.5 11.5 9.5H14.5C14.7652 9.5 15.0196 9.39464 15.2071 9.20711C15.3946 9.01957 15.5 8.76522 15.5 8.5V5.5C15.5 5.23478 15.3946 4.98043 15.2071 4.79289C15.0196 4.60536 14.7652 4.5 14.5 4.5ZM8.5 10.5H5.5C5.23478 10.5 4.98043 10.6054 4.79289 10.7929C4.60536 10.9804 4.5 11.2348 4.5 11.5V14.5C4.5 14.7652 4.60536 15.0196 4.79289 15.2071C4.98043 15.3946 5.23478 15.5 5.5 15.5H8.5C8.76522 15.5 9.01957 15.3946 9.20711 15.2071C9.39464 15.0196 9.5 14.7652 9.5 14.5V11.5C9.5 11.2348 9.39464 10.9804 9.20711 10.7929C9.01957 10.6054 8.76522 10.5 8.5 10.5ZM14.5 10.5H11.5C11.2348 10.5 10.9804 10.6054 10.7929 10.7929C10.6054 10.9804 10.5 11.2348 10.5 11.5V14.5C10.5 14.7652 10.6054 15.0196 10.7929 15.2071C10.9804 15.3946 11.2348 15.5 11.5 15.5H14.5C14.7652 15.5 15.0196 15.3946 15.2071 15.2071C15.3946 15.0196 15.5 14.7652 15.5 14.5V11.5C15.5 11.2348 15.3946 10.9804 15.2071 10.7929C15.0196 10.6054 14.7652 10.5 14.5 10.5Z"
    fill="#D2E0FF" />
</svg>`, D4 = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#576077" viewBox="0 0 256 256"><path d="M176,16H80A24,24,0,0,0,56,40V216a24,24,0,0,0,24,24h96a24,24,0,0,0,24-24V40A24,24,0,0,0,176,16ZM72,64H184V192H72Zm8-32h96a8,8,0,0,1,8,8v8H72V40A8,8,0,0,1,80,32Zm96,192H80a8,8,0,0,1-8-8v-8H184v8A8,8,0,0,1,176,224Z"></path></svg>
`, O4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M13.5 4.29857L14 16L10 15.4783H6V9.73913L6.5 4L10.5001 4.29857H13.5Z" fill="#576077" fill-opacity="0.05" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M13.2559 4.74408C13.0996 4.5878 12.8877 4.5 12.6667 4.5H7.33333C7.11232 4.5 6.90036 4.5878 6.74408 4.74408C6.5878 4.90036 6.5 5.11232 6.5 5.33333V8H5.5V5.33333C5.5 4.8471 5.69315 4.38079 6.03697 4.03697C6.38079 3.69315 6.8471 3.5 7.33333 3.5H12.6667C13.1529 3.5 13.6192 3.69315 13.963 4.03697C14.3068 4.38079 14.5 4.8471 14.5 5.33333V15.5H16C16.2761 15.5 16.5 15.7239 16.5 16C16.5 16.2761 16.2761 16.5 16 16.5H4C3.72386 16.5 3.5 16.2761 3.5 16C3.5 15.7239 3.72386 15.5 4 15.5H5.5V13H6.5V15.5H13.5V5.33333C13.5 5.11232 13.4122 4.90036 13.2559 4.74408ZM8.16667 10.5C8.16667 10.2239 8.39052 10 8.66667 10C8.94281 10 9.16667 10.2239 9.16667 10.5V10.5067C9.16667 10.7828 8.94281 11.0067 8.66667 11.0067C8.39052 11.0067 8.16667 10.7828 8.16667 10.5067V10.5Z"
    fill="#16181E" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M4.64645 8.64645C4.84171 8.45118 5.15829 8.45118 5.35355 8.64645L6.85355 10.1464C7.04882 10.3417 7.04882 10.6583 6.85355 10.8536L5.35355 12.3536C5.15829 12.5488 4.84171 12.5488 4.64645 12.3536C4.45118 12.1583 4.45118 11.8417 4.64645 11.6464L5.29289 11H3C2.72386 11 2.5 10.7761 2.5 10.5C2.5 10.2239 2.72386 10 3 10H5.29289L4.64645 9.35355C4.45118 9.15829 4.45118 8.84171 4.64645 8.64645Z"
    fill="#16181E" />
</svg>`, j4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M13.5 4.29857L14 16L10 15.4783H6V9.73913L6.5 4L10.5001 4.29857H13.5Z" fill="#576077" fill-opacity="0.05" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M6.74408 4.74408C6.90036 4.5878 7.11232 4.5 7.33333 4.5H12.6667C12.8877 4.5 13.0996 4.5878 13.2559 4.74408C13.4122 4.90036 13.5 5.11232 13.5 5.33333V8H14.5V5.33333C14.5 4.8471 14.3068 4.38079 13.963 4.03697C13.6192 3.69315 13.1529 3.5 12.6667 3.5H7.33333C6.8471 3.5 6.38079 3.69315 6.03697 4.03697C5.69315 4.38079 5.5 4.8471 5.5 5.33333V15.5H4C3.72386 15.5 3.5 15.7239 3.5 16C3.5 16.2761 3.72386 16.5 4 16.5H16C16.2761 16.5 16.5 16.2761 16.5 16C16.5 15.7239 16.2761 15.5 16 15.5H14.5V13H13.5V15.5H6.5V5.33333C6.5 5.11232 6.5878 4.90036 6.74408 4.74408ZM11.8333 10.5C11.8333 10.2239 11.6095 10 11.3333 10C11.0572 10 10.8333 10.2239 10.8333 10.5V10.5067C10.8333 10.7828 11.0572 11.0067 11.3333 11.0067C11.6095 11.0067 11.8333 10.7828 11.8333 10.5067V10.5Z"
    fill="#16181E" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M15.1464 8.64645C15.3417 8.45118 15.6583 8.45118 15.8536 8.64645L17.3536 10.1464C17.5488 10.3417 17.5488 10.6583 17.3536 10.8536L15.8536 12.3536C15.6583 12.5488 15.3417 12.5488 15.1464 12.3536C14.9512 12.1583 14.9512 11.8417 15.1464 11.6464L15.7929 11H13.5C13.2239 11 13 10.7761 13 10.5C13 10.2239 13.2239 10 13.5 10H15.7929L15.1464 9.35355C14.9512 9.15829 14.9512 8.84171 15.1464 8.64645Z"
    fill="#16181E" />
</svg>`, V4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M13.2972 8.5471L14.7503 10.0002L9.62155 15.1215C9.0574 15.6765 8.29677 15.9861 7.50536 15.9829C6.71395 15.9797 5.95587 15.6639 5.39626 15.1043C4.83664 14.5447 4.52083 13.7866 4.5176 12.9952C4.51438 12.2038 4.82401 11.4431 5.37905 10.879L11.5859 4.58585C11.961 4.21074 12.4698 4 13.0003 4C13.5308 4 14.0396 4.21074 14.4147 4.58585C14.7898 4.96097 15.0005 5.46973 15.0005 6.00023C15.0005 6.53072 14.7898 7.03949 14.4147 7.4146L13.2972 8.5471Z"
    fill="#576077" fill-opacity="0.05" />
  <path
    d="M15.1035 9.64644C15.15 9.69288 15.1869 9.74802 15.2121 9.80872C15.2372 9.86942 15.2502 9.93449 15.2502 10.0002C15.2502 10.0659 15.2372 10.131 15.2121 10.1917C15.1869 10.2524 15.15 10.3075 15.1035 10.3539L9.9754 15.4789C9.31891 16.1354 8.42854 16.5041 7.50018 16.504C6.57181 16.504 5.6815 16.1351 5.02509 15.4786C4.36868 14.8221 3.99994 13.9318 4 13.0034C4.00006 12.075 4.36891 11.1847 5.0254 10.5283L11.2291 4.23332C11.6978 3.76413 12.3337 3.50035 12.9969 3.5C13.6601 3.49965 14.2962 3.76276 14.7654 4.23144C15.2346 4.70013 15.4984 5.33601 15.4987 5.99918C15.4991 6.66236 15.236 7.29851 14.7673 7.76769L8.56227 14.0627C8.28048 14.3445 7.89829 14.5028 7.49977 14.5028C7.10126 14.5028 6.71907 14.3445 6.43727 14.0627C6.15548 13.7809 5.99717 13.3987 5.99717 13.0002C5.99717 12.6017 6.15548 12.2195 6.43727 11.9377L11.6435 6.64894C11.6891 6.60029 11.744 6.56126 11.8049 6.53413C11.8658 6.50701 11.9316 6.49234 11.9982 6.491C12.0649 6.48966 12.1312 6.50166 12.1931 6.52632C12.2551 6.55097 12.3115 6.58776 12.359 6.63454C12.4066 6.68132 12.4443 6.73713 12.4699 6.79869C12.4955 6.86025 12.5086 6.92632 12.5083 6.993C12.508 7.05969 12.4944 7.12564 12.4683 7.18698C12.4421 7.24833 12.4039 7.30382 12.356 7.35019L7.14915 12.6446C7.10253 12.6908 7.06548 12.7458 7.04011 12.8064C7.01473 12.8669 7.00154 12.9319 7.00128 12.9976C7.00102 13.0632 7.01369 13.1283 7.03858 13.1891C7.06347 13.2499 7.10009 13.3051 7.14634 13.3518C7.19259 13.3984 7.24757 13.4354 7.30814 13.4608C7.36871 13.4862 7.43368 13.4994 7.49935 13.4996C7.56502 13.4999 7.63009 13.4872 7.69086 13.4623C7.75163 13.4374 7.80691 13.4008 7.85352 13.3546L14.0579 7.06269C14.3397 6.78148 14.4982 6.39985 14.4986 6.00174C14.4991 5.60364 14.3413 5.22167 14.0601 4.93988C13.7789 4.65809 13.3972 4.49955 12.9991 4.49914C12.601 4.49873 12.2191 4.65648 11.9373 4.93769L5.73477 11.2302C5.50242 11.4622 5.31803 11.7377 5.19214 12.0409C5.06624 12.3442 5.00131 12.6692 5.00105 12.9976C5.00079 13.3259 5.0652 13.6511 5.19061 13.9545C5.31602 14.258 5.49997 14.5338 5.73196 14.7661C5.96395 14.9985 6.23943 15.1829 6.54268 15.3088C6.84593 15.4347 7.17101 15.4996 7.49935 15.4999C7.82769 15.5001 8.15287 15.4357 8.45632 15.3103C8.75977 15.1849 9.03554 15.0009 9.2679 14.7689L14.3967 9.64394C14.4907 9.55058 14.6181 9.49839 14.7506 9.49886C14.8832 9.49933 15.0101 9.55241 15.1035 9.64644Z"
    fill="#576077" />
</svg>`, F4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g id="icon">
    <path id="splash"
      d="M14 8C14 8.79113 13.7654 9.56448 13.3259 10.2223C12.8864 10.8801 12.2616 11.3928 11.5307 11.6955C10.7998 11.9983 9.99556 12.0775 9.21964 11.9231C8.44372 11.7688 7.73098 11.3878 7.17157 10.8284C6.61216 10.269 6.2312 9.55629 6.07686 8.78036C5.92252 8.00444 6.00173 7.20017 6.30448 6.46927C6.60723 5.73836 7.11992 5.11365 7.77772 4.67412C8.43552 4.2346 9.20888 4 10 4C11.0609 4 12.0783 4.42143 12.8284 5.17157C13.5786 5.92172 14 6.93913 14 8Z"
      fill="#576077" fill-opacity="0.05" />
    <path id="icon_2"
      d="M16.4329 15.2517C15.481 13.6061 14.0142 12.4261 12.3023 11.8667C13.1491 11.3626 13.8069 10.5945 14.1749 9.68032C14.5429 8.76614 14.6006 7.75645 14.3392 6.8063C14.0778 5.85615 13.5117 5.01807 12.7279 4.42078C11.9441 3.82349 10.9859 3.5 10.0004 3.5C9.01496 3.5 8.05674 3.82349 7.27293 4.42078C6.48911 5.01807 5.92304 5.85615 5.66163 6.8063C5.40022 7.75645 5.45793 8.76614 5.82591 9.68032C6.19388 10.5945 6.85177 11.3626 7.69854 11.8667C5.98666 12.4255 4.51979 13.6055 3.56791 15.2517C3.53301 15.3086 3.50985 15.372 3.49982 15.438C3.48978 15.504 3.49307 15.5713 3.50949 15.636C3.52591 15.7008 3.55512 15.7615 3.59541 15.8148C3.63569 15.868 3.68624 15.9127 3.74405 15.9461C3.80187 15.9795 3.86579 16.0009 3.93204 16.0092C3.9983 16.0175 4.06554 16.0125 4.1298 15.9943C4.19407 15.9762 4.25405 15.9454 4.30622 15.9038C4.35838 15.8621 4.40168 15.8104 4.43354 15.7517C5.61104 13.7167 7.69229 12.5017 10.0004 12.5017C12.3085 12.5017 14.3898 13.7167 15.5673 15.7517C15.5992 15.8104 15.6424 15.8621 15.6946 15.9038C15.7468 15.9454 15.8068 15.9762 15.871 15.9943C15.9353 16.0125 16.0025 16.0175 16.0688 16.0092C16.135 16.0009 16.199 15.9795 16.2568 15.9461C16.3146 15.9127 16.3651 15.868 16.4054 15.8148C16.4457 15.7615 16.4749 15.7008 16.4913 15.636C16.5078 15.5713 16.511 15.504 16.501 15.438C16.491 15.372 16.4678 15.3086 16.4329 15.2517ZM6.50041 8.0017C6.50041 7.30947 6.70569 6.63278 7.09027 6.05721C7.47485 5.48163 8.02148 5.03303 8.66102 4.76812C9.30056 4.50322 10.0043 4.4339 10.6832 4.56895C11.3622 4.704 11.9858 5.03734 12.4753 5.52683C12.9648 6.01631 13.2981 6.63995 13.4332 7.31888C13.5682 7.99782 13.4989 8.70155 13.234 9.34109C12.9691 9.98063 12.5205 10.5273 11.9449 10.9118C11.3693 11.2964 10.6926 11.5017 10.0004 11.5017C9.07246 11.5007 8.1828 11.1316 7.52664 10.4755C6.87047 9.81932 6.50141 8.92965 6.50041 8.0017Z"
      fill="#576077" />
  </g>
</svg>`, B4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M15.25 7C14.9039 7 14.5655 7.10264 14.2778 7.29493C13.99 7.48722 13.7657 7.76053 13.6332 8.0803C13.5008 8.40008 13.4661 8.75194 13.5336 9.09141C13.6012 9.43088 13.7678 9.7427 14.0126 9.98744C14.2573 10.2322 14.5691 10.3989 14.9086 10.4664C15.2481 10.5339 15.5999 10.4992 15.9197 10.3668C16.2395 10.2343 16.5128 10.01 16.7051 9.72225C16.8974 9.43446 17 9.09612 17 8.75C17 8.28587 16.8156 7.84075 16.4874 7.51256C16.1592 7.18438 15.7141 7 15.25 7ZM15.25 9.5C15.1017 9.5 14.9567 9.45601 14.8333 9.3736C14.71 9.29119 14.6139 9.17406 14.5571 9.03701C14.5003 8.89997 14.4855 8.74917 14.5144 8.60368C14.5434 8.4582 14.6148 8.32456 14.7197 8.21967C14.8246 8.11478 14.9582 8.04335 15.1037 8.01441C15.2492 7.98547 15.4 8.00033 15.537 8.05709C15.6741 8.11386 15.7912 8.20999 15.8736 8.33332C15.956 8.45666 16 8.60166 16 8.75C16 8.94891 15.921 9.13968 15.7803 9.28033C15.6397 9.42098 15.4489 9.5 15.25 9.5ZM6.5 8.75C6.5 8.40388 6.39737 8.06554 6.20507 7.77775C6.01278 7.48997 5.73947 7.26566 5.4197 7.13321C5.09993 7.00076 4.74806 6.9661 4.40859 7.03363C4.06913 7.10115 3.75731 7.26782 3.51256 7.51256C3.26782 7.75731 3.10115 8.06913 3.03363 8.40859C2.9661 8.74806 3.00076 9.09993 3.13321 9.4197C3.26566 9.73947 3.48997 10.0128 3.77775 10.2051C4.06554 10.3974 4.40388 10.5 4.75 10.5C5.21413 10.5 5.65925 10.3156 5.98744 9.98744C6.31563 9.65925 6.5 9.21413 6.5 8.75ZM4.75 9.5C4.60166 9.5 4.45666 9.45601 4.33332 9.3736C4.20999 9.29119 4.11386 9.17406 4.05709 9.03701C4.00033 8.89997 3.98547 8.74917 4.01441 8.60368C4.04335 8.4582 4.11478 8.32456 4.21967 8.21967C4.32456 8.11478 4.4582 8.04335 4.60368 8.01441C4.74917 7.98547 4.89997 8.00033 5.03701 8.05709C5.17406 8.11386 5.29119 8.20999 5.3736 8.33332C5.45601 8.45666 5.5 8.60166 5.5 8.75C5.5 8.94891 5.42098 9.13968 5.28033 9.28033C5.13968 9.42098 4.94891 9.5 4.75 9.5ZM7.75 7.5C8.09612 7.5 8.43446 7.39737 8.72225 7.20507C9.01004 7.01278 9.23434 6.73947 9.36679 6.4197C9.49924 6.09993 9.5339 5.74806 9.46638 5.40859C9.39885 5.06913 9.23218 4.75731 8.98744 4.51256C8.7427 4.26782 8.43088 4.10115 8.09141 4.03363C7.75194 3.9661 7.40008 4.00076 7.08031 4.13321C6.76053 4.26566 6.48722 4.48997 6.29493 4.77775C6.10264 5.06554 6 5.40388 6 5.75C6 6.21413 6.18438 6.65925 6.51256 6.98744C6.84075 7.31563 7.28587 7.5 7.75 7.5ZM7.75 5C7.89834 5 8.04334 5.04399 8.16668 5.1264C8.29002 5.20881 8.38615 5.32594 8.44291 5.46299C8.49968 5.60003 8.51453 5.75083 8.48559 5.89632C8.45665 6.0418 8.38522 6.17544 8.28033 6.28033C8.17544 6.38522 8.0418 6.45665 7.89632 6.48559C7.75083 6.51453 7.60003 6.49968 7.46299 6.44291C7.32594 6.38614 7.20881 6.29001 7.1264 6.16668C7.04399 6.04334 7 5.89834 7 5.75C7 5.55109 7.07902 5.36032 7.21967 5.21967C7.36032 5.07902 7.55109 5 7.75 5ZM12.25 7.5C12.5961 7.5 12.9345 7.39737 13.2222 7.20507C13.51 7.01278 13.7343 6.73947 13.8668 6.4197C13.9992 6.09993 14.0339 5.74806 13.9664 5.40859C13.8989 5.06913 13.7322 4.75731 13.4874 4.51256C13.2427 4.26782 12.9309 4.10115 12.5914 4.03363C12.2519 3.9661 11.9001 4.00076 11.5803 4.13321C11.2605 4.26566 10.9872 4.48997 10.7949 4.77775C10.6026 5.06554 10.5 5.40388 10.5 5.75C10.5 6.21413 10.6844 6.65925 11.0126 6.98744C11.3408 7.31563 11.7859 7.5 12.25 7.5ZM12.25 5C12.3983 5 12.5433 5.04399 12.6667 5.1264C12.79 5.20881 12.8861 5.32594 12.9429 5.46299C12.9997 5.60003 13.0145 5.75083 12.9856 5.89632C12.9567 6.0418 12.8852 6.17544 12.7803 6.28033C12.6754 6.38522 12.5418 6.45665 12.3963 6.48559C12.2508 6.51453 12.1 6.49968 11.963 6.44291C11.8259 6.38614 11.7088 6.29001 11.6264 6.16668C11.544 6.04334 11.5 5.89834 11.5 5.75C11.5 5.55109 11.579 5.36032 11.7197 5.21967C11.8603 5.07902 12.0511 5 12.25 5ZM13.695 11.3038C13.441 11.1636 13.2172 10.9748 13.0363 10.7481C12.8553 10.5214 12.7209 10.2612 12.6406 9.9825C12.4744 9.41078 12.1271 8.90846 11.6509 8.55102C11.1747 8.19359 10.5954 8.00035 10 8.00035C9.4046 8.00035 8.82528 8.19359 8.34911 8.55102C7.87293 8.90846 7.52562 9.41078 7.35938 9.9825C7.19878 10.5434 6.8223 11.0176 6.3125 11.3013C5.82345 11.5659 5.43658 11.986 5.21308 12.4952C4.98958 13.0043 4.94221 13.5735 5.07845 14.1126C5.2147 14.6517 5.52679 15.13 5.96536 15.4718C6.40393 15.8136 6.94395 15.9995 7.5 16C7.83323 16.001 8.16319 15.9344 8.47 15.8044C9.44817 15.401 10.5462 15.401 11.5244 15.8044C12.1168 16.0621 12.7861 16.0804 13.3917 15.8554C13.9974 15.6305 14.4925 15.1799 14.7732 14.598C15.0539 14.016 15.0984 13.3481 14.8974 12.734C14.6964 12.12 14.2655 11.6077 13.695 11.3044V11.3038ZM12.5 15C12.297 15.0002 12.0961 14.9591 11.9094 14.8794C10.6848 14.3735 9.30961 14.3735 8.085 14.8794C7.72913 15.0326 7.32776 15.0422 6.96498 14.9061C6.6022 14.77 6.30615 14.4988 6.13885 14.1494C5.97154 13.7999 5.94595 13.3992 6.06745 13.0313C6.18895 12.6634 6.4481 12.3567 6.79063 12.1756C7.1589 11.9722 7.48347 11.6983 7.74579 11.3693C8.0081 11.0404 8.20301 10.663 8.31938 10.2588C8.42504 9.89475 8.64603 9.57489 8.94911 9.34727C9.25219 9.11966 9.62097 8.9966 10 8.9966C10.379 8.9966 10.7478 9.11966 11.0509 9.34727C11.354 9.57489 11.575 9.89475 11.6806 10.2588C11.7974 10.6638 11.9929 11.0418 12.256 11.3712C12.519 11.7005 12.8445 11.9748 13.2138 12.1781C13.5086 12.3363 13.7422 12.5885 13.8772 12.8947C14.0123 13.2009 14.041 13.5434 13.959 13.8678C13.8769 14.1922 13.6888 14.4799 13.4244 14.6851C13.16 14.8902 12.8346 15.0011 12.5 15Z"
    fill="#576077" />
</svg>`, H4 = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#576077" viewBox="0 0 256 256"><path d="M222.37,158.46l-47.11-21.11-.13-.06a16,16,0,0,0-15.17,1.4,8.12,8.12,0,0,0-.75.56L134.87,160c-15.42-7.49-31.34-23.29-38.83-38.51l20.78-24.71c.2-.25.39-.5.57-.77a16,16,0,0,0,1.32-15.06l0-.12L97.54,33.64a16,16,0,0,0-16.62-9.52A56.26,56.26,0,0,0,32,80c0,79.4,64.6,144,144,144a56.26,56.26,0,0,0,55.88-48.92A16,16,0,0,0,222.37,158.46ZM176,208A128.14,128.14,0,0,1,48,80,40.2,40.2,0,0,1,82.87,40a.61.61,0,0,0,0,.12l21,47L83.2,111.86a6.13,6.13,0,0,0-.57.77,16,16,0,0,0-1,15.7c9.06,18.53,27.73,37.06,46.46,46.11a16,16,0,0,0,15.75-1.14,8.44,8.44,0,0,0,.74-.56L168.89,152l47,21.05h0s.08,0,.11,0A40.21,40.21,0,0,1,176,208Z"></path></svg>', z4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g id="icon left">
    <path id="icon"
      d="M15.4169 6.5H14.5V4.5C14.5 4.36739 14.4473 4.24021 14.3536 4.14645C14.2598 4.05268 14.1326 4 14 4H6C5.86739 4 5.74021 4.05268 5.64645 4.14645C5.55268 4.24021 5.5 4.36739 5.5 4.5V6.5H4.58313C3.71 6.5 3 7.17313 3 8V13C3 13.1326 3.05268 13.2598 3.14645 13.3536C3.24021 13.4473 3.36739 13.5 3.5 13.5H5.5V15.5C5.5 15.6326 5.55268 15.7598 5.64645 15.8536C5.74021 15.9473 5.86739 16 6 16H14C14.1326 16 14.2598 15.9473 14.3536 15.8536C14.4473 15.7598 14.5 15.6326 14.5 15.5V13.5H16.5C16.6326 13.5 16.7598 13.4473 16.8536 13.3536C16.9473 13.2598 17 13.1326 17 13V8C17 7.17313 16.29 6.5 15.4169 6.5ZM6.5 5H13.5V6.5H6.5V5ZM13.5 15H6.5V12H13.5V15ZM16 12.5H14.5V11.5C14.5 11.3674 14.4473 11.2402 14.3536 11.1464C14.2598 11.0527 14.1326 11 14 11H6C5.86739 11 5.74021 11.0527 5.64645 11.1464C5.55268 11.2402 5.5 11.3674 5.5 11.5V12.5H4V8C4 7.72438 4.26188 7.5 4.58313 7.5H15.4169C15.7381 7.5 16 7.72438 16 8V12.5ZM14.5 9.25C14.5 9.39834 14.456 9.54334 14.3736 9.66668C14.2912 9.79001 14.1741 9.88614 14.037 9.94291C13.9 9.99968 13.7492 10.0145 13.6037 9.98559C13.4582 9.95665 13.3246 9.88522 13.2197 9.78033C13.1148 9.67544 13.0434 9.5418 13.0144 9.39632C12.9855 9.25083 13.0003 9.10003 13.0571 8.96299C13.1139 8.82594 13.21 8.70881 13.3333 8.6264C13.4567 8.54399 13.6017 8.5 13.75 8.5C13.9489 8.5 14.1397 8.57902 14.2803 8.71967C14.421 8.86032 14.5 9.05109 14.5 9.25Z"
      fill="#576077" />
  </g>
</svg>`, U4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M15 5V14.3496" stroke="#E2E4EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M10 8.34961V14.3496" stroke="#E2E4EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M5 12V14.3493" stroke="#E2E4EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg>`, K4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M15 5V14.3496" stroke="#576077" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M10 8.34961V14.3496" stroke="#576077" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M5 12V14.3493" stroke="#576077" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg>`, W4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M15 5V14.3496" stroke="#EB6666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M10 8.34961V14.3496" stroke="#EB6666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M5 12V14.3493" stroke="#EB6666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg>`, Z4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M15 5V14.3496" stroke="#E2E4EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M10 8.34961V14.3496" stroke="#E2E4EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M5 12V14.3493" stroke="#576077" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg>`, Q4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M15 5V14.3496" stroke="#E2E4EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M10 8.34961V14.3496" stroke="#E2E4EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M5 12V14.3493" stroke="#4DB878" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg>`, G4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M15 5V14.3496" stroke="#E2E4EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M10 8.34961V14.3496" stroke="#576077" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M5 12V14.3493" stroke="#576077" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg>`, $4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M15 5V14.3496" stroke="#E2E4EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M10 8.34961V14.3496" stroke="#D99734" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M5 12V14.3493" stroke="#D99734" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
</svg>`, q4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="10" cy="10" r="7" stroke="#969EB0" stroke-dasharray="2 2" />
  <path
    d="M10.5654 10L11.8828 8.68315C11.92 8.64599 11.9494 8.60187 11.9695 8.55332C11.9896 8.50477 12 8.45273 12 8.40018C12 8.34763 11.9896 8.29559 11.9695 8.24704C11.9494 8.19848 11.92 8.15437 11.8828 8.11721C11.8456 8.08005 11.8015 8.05057 11.753 8.03046C11.7044 8.01035 11.6524 8 11.5998 8C11.5473 8 11.4952 8.01035 11.4467 8.03046C11.3981 8.05057 11.354 8.08005 11.3169 8.11721L10 9.43456L8.68315 8.11721C8.6081 8.04216 8.50631 8 8.40018 8C8.29404 8 8.19226 8.04216 8.11721 8.11721C8.04216 8.19226 8 8.29404 8 8.40018C8 8.50631 8.04216 8.6081 8.11721 8.68315L9.43456 10L8.11721 11.3169C8.08005 11.354 8.05057 11.3981 8.03046 11.4467C8.01035 11.4952 8 11.5473 8 11.5998C8 11.6524 8.01035 11.7044 8.03046 11.753C8.05057 11.8015 8.08005 11.8456 8.11721 11.8828C8.15437 11.92 8.19848 11.9494 8.24704 11.9695C8.29559 11.9896 8.34763 12 8.40018 12C8.45273 12 8.50477 11.9896 8.55332 11.9695C8.60187 11.9494 8.64599 11.92 8.68315 11.8828L10 10.5654L11.3169 11.8828C11.354 11.92 11.3981 11.9494 11.4467 11.9695C11.4952 11.9896 11.5473 12 11.5998 12C11.6524 12 11.7044 11.9896 11.753 11.9695C11.8015 11.9494 11.8456 11.92 11.8828 11.8828C11.92 11.8456 11.9494 11.8015 11.9695 11.753C11.9896 11.7044 12 11.6524 12 11.5998C12 11.5473 11.9896 11.4952 11.9695 11.4467C11.9494 11.3981 11.92 11.354 11.8828 11.3169L10.5654 10Z"
    fill="#969EB0" />
</svg>`, X4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M16.236 14.1668C17.0601 12.9334 17.5 11.4834 17.5 10C17.5 9.01509 17.306 8.03982 16.9291 7.12988C16.5522 6.21993 15.9997 5.39314 15.3033 4.6967C14.6069 4.00026 13.7801 3.44781 12.8701 3.0709C11.9602 2.69399 10.9849 2.5 10 2.5C8.51664 2.5 7.0666 2.93987 5.83323 3.76398C4.59986 4.58809 3.63856 5.75943 3.07091 7.12987C2.50325 8.50032 2.35472 10.0083 2.64411 11.4632C2.9335 12.918 3.64781 14.2544 4.6967 15.3033C5.7456 16.3522 7.08197 17.0665 8.53683 17.3559C9.99168 17.6453 11.4997 17.4968 12.8701 16.9291C14.2406 16.3614 15.4119 15.4001 16.236 14.1668ZM16.2625 10C16.2625 9.1776 16.1005 8.36325 15.7858 7.60345C15.4711 6.84364 15.0098 6.15327 14.4283 5.57174C13.8467 4.99022 13.1564 4.52892 12.3966 4.2142C11.6368 3.89948 10.8224 3.7375 10 3.7375C8.7614 3.7375 7.55061 4.10479 6.52074 4.79292C5.49088 5.48105 4.6882 6.45912 4.21421 7.60345C3.74021 8.74777 3.6162 10.0069 3.85784 11.2218C4.09948 12.4366 4.69592 13.5524 5.57175 14.4283C6.44757 15.3041 7.56344 15.9005 8.77825 16.1422C9.99306 16.3838 11.2522 16.2598 12.3966 15.7858C13.5409 15.3118 14.5189 14.5091 15.2071 13.4793C15.8952 12.4494 16.2625 11.2386 16.2625 10Z"
    fill="#C4C9D5" />
  <path
    d="M10 2.5C10.9849 2.5 11.9602 2.69399 12.8701 3.0709C13.7801 3.44781 14.6069 4.00026 15.3033 4.6967C15.9997 5.39314 16.5522 6.21993 16.9291 7.12988C17.306 8.03982 17.5 9.01509 17.5 10L16.2625 10C16.2625 9.1776 16.1005 8.36325 15.7858 7.60345C15.4711 6.84364 15.0098 6.15327 14.4283 5.57174C13.8467 4.99022 13.1564 4.52892 12.3966 4.2142C11.6368 3.89948 10.8224 3.7375 10 3.7375V2.5Z"
    fill="#234DEC" />
  <path
    d="M17.5 10C17.5 10.9849 17.306 11.9602 16.9291 12.8701C16.5522 13.7801 15.9997 14.6069 15.3033 15.3033C14.6069 15.9997 13.7801 16.5522 12.8701 16.9291C11.9602 17.306 10.9849 17.5 10 17.5L10 16.2625C10.8224 16.2625 11.6368 16.1005 12.3966 15.7858C13.1564 15.4711 13.8467 15.0098 14.4283 14.4283C15.0098 13.8467 15.4711 13.1564 15.7858 12.3966C16.1005 11.6368 16.2625 10.8224 16.2625 10L17.5 10Z"
    fill="#234DEC" />
  <path
    d="M10 17.5C9.01509 17.5 8.03982 17.306 7.12987 16.9291C6.21993 16.5522 5.39314 15.9997 4.6967 15.3033C4.00026 14.6069 3.44781 13.7801 3.0709 12.8701C2.69399 11.9602 2.5 10.9849 2.5 10L3.7375 10C3.7375 10.8224 3.89949 11.6368 4.2142 12.3966C4.52892 13.1564 4.99022 13.8467 5.57174 14.4283C6.15327 15.0098 6.84364 15.4711 7.60345 15.7858C8.36325 16.1005 9.1776 16.2625 10 16.2625L10 17.5Z"
    fill="#234DEC" />
  <path
    d="M2.5 10C2.5 9.01509 2.69399 8.03982 3.0709 7.12987C3.44781 6.21993 4.00026 5.39314 4.6967 4.6967C5.39314 4.00026 6.21993 3.44781 7.12987 3.0709C8.03982 2.69399 9.01509 2.5 10 2.5L10 3.7375C9.1776 3.7375 8.36325 3.89948 7.60345 4.2142C6.84364 4.52892 6.15327 4.99022 5.57174 5.57174C4.99022 6.15327 4.52892 6.84364 4.2142 7.60344C3.89948 8.36325 3.7375 9.1776 3.7375 10L2.5 10Z"
    fill="#234DEC" />
</svg>`, Y4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M16.236 14.1668C17.0601 12.9334 17.5 11.4834 17.5 10C17.5 9.01509 17.306 8.03982 16.9291 7.12988C16.5522 6.21993 15.9997 5.39314 15.3033 4.6967C14.6069 4.00026 13.7801 3.44781 12.8701 3.0709C11.9602 2.69399 10.9849 2.5 10 2.5C8.51664 2.5 7.0666 2.93987 5.83323 3.76398C4.59986 4.58809 3.63856 5.75943 3.07091 7.12987C2.50325 8.50032 2.35472 10.0083 2.64411 11.4632C2.9335 12.918 3.64781 14.2544 4.6967 15.3033C5.7456 16.3522 7.08197 17.0665 8.53683 17.3559C9.99168 17.6453 11.4997 17.4968 12.8701 16.9291C14.2406 16.3614 15.4119 15.4001 16.236 14.1668ZM16.2625 10C16.2625 9.1776 16.1005 8.36325 15.7858 7.60345C15.4711 6.84364 15.0098 6.15327 14.4283 5.57174C13.8467 4.99022 13.1564 4.52892 12.3966 4.2142C11.6368 3.89948 10.8224 3.7375 10 3.7375C8.7614 3.7375 7.55061 4.10479 6.52074 4.79292C5.49088 5.48105 4.6882 6.45912 4.21421 7.60345C3.74021 8.74777 3.6162 10.0069 3.85784 11.2218C4.09948 12.4366 4.69592 13.5524 5.57175 14.4283C6.44757 15.3041 7.56344 15.9005 8.77825 16.1422C9.99306 16.3838 11.2522 16.2598 12.3966 15.7858C13.5409 15.3118 14.5189 14.5091 15.2071 13.4793C15.8952 12.4494 16.2625 11.2386 16.2625 10Z"
    fill="#C4C9D5" />
  <path
    d="M10 2.5C10.9849 2.5 11.9602 2.69399 12.8701 3.0709C13.7801 3.44781 14.6069 4.00026 15.3033 4.6967C15.9997 5.39314 16.5522 6.21993 16.9291 7.12988C17.306 8.03982 17.5 9.01509 17.5 10L16.2625 10C16.2625 9.1776 16.1005 8.36325 15.7858 7.60345C15.4711 6.84364 15.0098 6.15327 14.4283 5.57174C13.8467 4.99022 13.1564 4.52892 12.3966 4.2142C11.6368 3.89948 10.8224 3.7375 10 3.7375V2.5Z"
    fill="#234DEC" />
  <path
    d="M17.5 10C17.5 10.9849 17.306 11.9602 16.9291 12.8701C16.5522 13.7801 15.9997 14.6069 15.3033 15.3033C14.6069 15.9997 13.7801 16.5522 12.8701 16.9291C11.9602 17.306 10.9849 17.5 10 17.5L10 16.2625C10.8224 16.2625 11.6368 16.1005 12.3966 15.7858C13.1564 15.4711 13.8467 15.0098 14.4283 14.4283C15.0098 13.8467 15.4711 13.1564 15.7858 12.3966C16.1005 11.6368 16.2625 10.8224 16.2625 10L17.5 10Z"
    fill="#234DEC" />
  <path
    d="M10 17.5C9.01509 17.5 8.03982 17.306 7.12987 16.9291C6.21993 16.5522 5.39314 15.9997 4.6967 15.3033C4.00026 14.6069 3.44781 13.7801 3.0709 12.8701C2.69399 11.9602 2.5 10.9849 2.5 10L3.7375 10C3.7375 10.8224 3.89949 11.6368 4.2142 12.3966C4.52892 13.1564 4.99022 13.8467 5.57174 14.4283C6.15327 15.0098 6.84364 15.4711 7.60345 15.7858C8.36325 16.1005 9.1776 16.2625 10 16.2625L10 17.5Z"
    fill="#234DEC" />
  <path
    d="M2.5 10C2.5 9.01509 2.69399 8.03982 3.0709 7.12987C3.44781 6.21993 4.00026 5.39314 4.6967 4.6967C5.39314 4.00026 6.21993 3.44781 7.12987 3.0709C8.03982 2.69399 9.01509 2.5 10 2.5L10 3.7375C9.1776 3.7375 8.36325 3.89948 7.60345 4.2142C6.84364 4.52892 6.15327 4.99022 5.57174 5.57174C4.99022 6.15327 4.52892 6.84364 4.2142 7.60344C3.89948 8.36325 3.7375 9.1776 3.7375 10L2.5 10Z"
    fill="#234DEC" />
</svg>`, J4 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M16.236 14.1668C17.0601 12.9334 17.5 11.4834 17.5 10C17.5 9.01509 17.306 8.03982 16.9291 7.12988C16.5522 6.21993 15.9997 5.39314 15.3033 4.6967C14.6069 4.00026 13.7801 3.44781 12.8701 3.0709C11.9602 2.69399 10.9849 2.5 10 2.5C8.51664 2.5 7.0666 2.93987 5.83323 3.76398C4.59986 4.58809 3.63856 5.75943 3.07091 7.12987C2.50325 8.50032 2.35472 10.0083 2.64411 11.4632C2.9335 12.918 3.64781 14.2544 4.6967 15.3033C5.7456 16.3522 7.08197 17.0665 8.53683 17.3559C9.99168 17.6453 11.4997 17.4968 12.8701 16.9291C14.2406 16.3614 15.4119 15.4001 16.236 14.1668ZM16.2625 10C16.2625 9.1776 16.1005 8.36325 15.7858 7.60345C15.4711 6.84364 15.0098 6.15327 14.4283 5.57174C13.8467 4.99022 13.1564 4.52892 12.3966 4.2142C11.6368 3.89948 10.8224 3.7375 10 3.7375C8.7614 3.7375 7.55061 4.10479 6.52074 4.79292C5.49088 5.48105 4.6882 6.45912 4.21421 7.60345C3.74021 8.74777 3.6162 10.0069 3.85784 11.2218C4.09948 12.4366 4.69592 13.5524 5.57175 14.4283C6.44757 15.3041 7.56344 15.9005 8.77825 16.1422C9.99306 16.3838 11.2522 16.2598 12.3966 15.7858C13.5409 15.3118 14.5189 14.5091 15.2071 13.4793C15.8952 12.4494 16.2625 11.2386 16.2625 10Z"
    fill="#C4C9D5" />
  <path
    d="M17.5 10C17.5 9.01509 17.306 8.03982 16.9291 7.12987C16.5522 6.21993 15.9997 5.39314 15.3033 4.6967C14.6069 4.00026 13.7801 3.44781 12.8701 3.0709C11.9602 2.69399 10.9849 2.5 10 2.5L10 3.7375C10.8224 3.7375 11.6368 3.89948 12.3966 4.2142C13.1564 4.52892 13.8467 4.99022 14.4283 5.57174C15.0098 6.15327 15.4711 6.84364 15.7858 7.60344C16.1005 8.36325 16.2625 9.1776 16.2625 10L17.5 10Z"
    fill="#234DEC" />
</svg>`, e2 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M16.236 14.1668C17.0601 12.9334 17.5 11.4834 17.5 10C17.5 9.01509 17.306 8.03982 16.9291 7.12988C16.5522 6.21993 15.9997 5.39314 15.3033 4.6967C14.6069 4.00026 13.7801 3.44781 12.8701 3.0709C11.9602 2.69399 10.9849 2.5 10 2.5C8.51664 2.5 7.0666 2.93987 5.83323 3.76398C4.59986 4.58809 3.63856 5.75943 3.07091 7.12987C2.50325 8.50032 2.35472 10.0083 2.64411 11.4632C2.9335 12.918 3.64781 14.2544 4.6967 15.3033C5.7456 16.3522 7.08197 17.0665 8.53683 17.3559C9.99168 17.6453 11.4997 17.4968 12.8701 16.9291C14.2406 16.3614 15.4119 15.4001 16.236 14.1668ZM16.2625 10C16.2625 9.1776 16.1005 8.36325 15.7858 7.60345C15.4711 6.84364 15.0098 6.15327 14.4283 5.57174C13.8467 4.99022 13.1564 4.52892 12.3966 4.2142C11.6368 3.89948 10.8224 3.7375 10 3.7375C8.7614 3.7375 7.55061 4.10479 6.52074 4.79292C5.49088 5.48105 4.6882 6.45912 4.21421 7.60345C3.74021 8.74777 3.6162 10.0069 3.85784 11.2218C4.09948 12.4366 4.69592 13.5524 5.57175 14.4283C6.44757 15.3041 7.56344 15.9005 8.77825 16.1422C9.99306 16.3838 11.2522 16.2598 12.3966 15.7858C13.5409 15.3118 14.5189 14.5091 15.2071 13.4793C15.8952 12.4494 16.2625 11.2386 16.2625 10Z"
    fill="#C4C9D5" />
  <path
    d="M17.5 10C17.5 10.9849 17.306 11.9602 16.9291 12.8701C16.5522 13.7801 15.9997 14.6069 15.3033 15.3033C14.6069 15.9997 13.7801 16.5522 12.8701 16.9291C11.9602 17.306 10.9849 17.5 10 17.5L10 16.2625C10.8224 16.2625 11.6368 16.1005 12.3966 15.7858C13.1564 15.4711 13.8467 15.0098 14.4283 14.4283C15.0098 13.8467 15.4711 13.1564 15.7858 12.3966C16.1005 11.6368 16.2625 10.8224 16.2625 10L17.5 10Z"
    fill="#234DEC" />
  <path
    d="M10 17.5C9.01509 17.5 8.03982 17.306 7.12987 16.9291C6.21993 16.5522 5.39314 15.9997 4.6967 15.3033C4.00026 14.6069 3.44781 13.7801 3.0709 12.8701C2.69399 11.9602 2.5 10.9849 2.5 10L3.7375 10C3.7375 10.8224 3.89949 11.6368 4.2142 12.3966C4.52892 13.1564 4.99022 13.8467 5.57174 14.4283C6.15327 15.0098 6.84364 15.4711 7.60345 15.7858C8.36325 16.1005 9.1776 16.2625 10 16.2625L10 17.5Z"
    fill="#234DEC" />
  <path
    d="M17.5 10C17.5 9.01509 17.306 8.03982 16.9291 7.12987C16.5522 6.21993 15.9997 5.39314 15.3033 4.6967C14.6069 4.00026 13.7801 3.44781 12.8701 3.0709C11.9602 2.69399 10.9849 2.5 10 2.5L10 3.7375C10.8224 3.7375 11.6368 3.89948 12.3966 4.2142C13.1564 4.52892 13.8467 4.99022 14.4283 5.57174C15.0098 6.15327 15.4711 6.84364 15.7858 7.60344C16.1005 8.36325 16.2625 9.1776 16.2625 10L17.5 10Z"
    fill="#234DEC" />
</svg>`, t2 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M16.236 14.1668C17.0601 12.9334 17.5 11.4834 17.5 10C17.5 9.01509 17.306 8.03982 16.9291 7.12988C16.5522 6.21993 15.9997 5.39314 15.3033 4.6967C14.6069 4.00026 13.7801 3.44781 12.8701 3.0709C11.9602 2.69399 10.9849 2.5 10 2.5C8.51664 2.5 7.0666 2.93987 5.83323 3.76398C4.59986 4.58809 3.63856 5.75943 3.07091 7.12987C2.50325 8.50032 2.35472 10.0083 2.64411 11.4632C2.9335 12.918 3.64781 14.2544 4.6967 15.3033C5.7456 16.3522 7.08197 17.0665 8.53683 17.3559C9.99168 17.6453 11.4997 17.4968 12.8701 16.9291C14.2406 16.3614 15.4119 15.4001 16.236 14.1668ZM16.2625 10C16.2625 9.1776 16.1005 8.36325 15.7858 7.60345C15.4711 6.84364 15.0098 6.15327 14.4283 5.57174C13.8467 4.99022 13.1564 4.52892 12.3966 4.2142C11.6368 3.89948 10.8224 3.7375 10 3.7375C8.7614 3.7375 7.55061 4.10479 6.52074 4.79292C5.49088 5.48105 4.6882 6.45912 4.21421 7.60345C3.74021 8.74777 3.6162 10.0069 3.85784 11.2218C4.09948 12.4366 4.69592 13.5524 5.57175 14.4283C6.44757 15.3041 7.56344 15.9005 8.77825 16.1422C9.99306 16.3838 11.2522 16.2598 12.3966 15.7858C13.5409 15.3118 14.5189 14.5091 15.2071 13.4793C15.8952 12.4494 16.2625 11.2386 16.2625 10Z"
    fill="#C4C9D5" />
  <path
    d="M10 17.5C10.9849 17.5 11.9602 17.306 12.8701 16.9291C13.7801 16.5522 14.6069 15.9997 15.3033 15.3033C15.9997 14.6069 16.5522 13.7801 16.9291 12.8701C17.306 11.9602 17.5 10.9849 17.5 10L16.2625 10C16.2625 10.8224 16.1005 11.6368 15.7858 12.3966C15.4711 13.1564 15.0098 13.8467 14.4283 14.4283C13.8467 15.0098 13.1564 15.4711 12.3966 15.7858C11.6368 16.1005 10.8224 16.2625 10 16.2625L10 17.5Z"
    fill="#234DEC" />
  <path
    d="M17.5 10C17.5 9.01509 17.306 8.03982 16.9291 7.12987C16.5522 6.21993 15.9997 5.39314 15.3033 4.6967C14.6069 4.00026 13.7801 3.44781 12.8701 3.0709C11.9602 2.69399 10.9849 2.5 10 2.5L10 3.7375C10.8224 3.7375 11.6368 3.89948 12.3966 4.2142C13.1564 4.52892 13.8467 4.99022 14.4283 5.57174C15.0098 6.15327 15.4711 6.84364 15.7858 7.60344C16.1005 8.36325 16.2625 9.1776 16.2625 10L17.5 10Z"
    fill="#234DEC" />
</svg>`, n2 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M16.236 14.1668C17.0601 12.9334 17.5 11.4834 17.5 10C17.5 9.01509 17.306 8.03982 16.9291 7.12988C16.5522 6.21993 15.9997 5.39314 15.3033 4.6967C14.6069 4.00026 13.7801 3.44781 12.8701 3.0709C11.9602 2.69399 10.9849 2.5 10 2.5C8.51664 2.5 7.0666 2.93987 5.83323 3.76398C4.59986 4.58809 3.63856 5.75943 3.07091 7.12987C2.50325 8.50032 2.35472 10.0083 2.64411 11.4632C2.9335 12.918 3.64781 14.2544 4.6967 15.3033C5.7456 16.3522 7.08197 17.0665 8.53683 17.3559C9.99168 17.6453 11.4997 17.4968 12.8701 16.9291C14.2406 16.3614 15.4119 15.4001 16.236 14.1668ZM16.2625 10C16.2625 9.1776 16.1005 8.36325 15.7858 7.60345C15.4711 6.84364 15.0098 6.15327 14.4283 5.57174C13.8467 4.99022 13.1564 4.52892 12.3966 4.2142C11.6368 3.89948 10.8224 3.7375 10 3.7375C8.7614 3.7375 7.55061 4.10479 6.52074 4.79292C5.49088 5.48105 4.6882 6.45912 4.21421 7.60345C3.74021 8.74777 3.6162 10.0069 3.85784 11.2218C4.09948 12.4366 4.69592 13.5524 5.57175 14.4283C6.44757 15.3041 7.56344 15.9005 8.77825 16.1422C9.99306 16.3838 11.2522 16.2598 12.3966 15.7858C13.5409 15.3118 14.5189 14.5091 15.2071 13.4793C15.8952 12.4494 16.2625 11.2386 16.2625 10Z"
    fill="#C4C9D5" />
</svg>`, r2 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M15.5 5V8H12.5L15.5 5ZM4.5 15L7.5 12H4.5V15Z" fill="#576077" fill-opacity="0.05" />
  <path
    d="M15.6912 4.53813C15.5999 4.50023 15.4994 4.49027 15.4023 4.50952C15.3053 4.52876 15.2162 4.57635 15.1462 4.64625L14.1425 5.65062C12.8831 4.56875 11.46 4 10 4C7.32375 4 5.71375 5.57938 5.64625 5.64625C5.55243 5.74007 5.49972 5.86732 5.49972 6C5.49972 6.13268 5.55243 6.25993 5.64625 6.35375C5.74007 6.44757 5.86732 6.50028 6 6.50028C6.13268 6.50028 6.25993 6.44757 6.35375 6.35375C6.36688 6.34 7.73312 5 10 5C11.4481 5 12.62 5.67813 13.4325 6.36L12.1462 7.64625C12.0762 7.71618 12.0286 7.8053 12.0092 7.90235C11.9899 7.99939 11.9998 8.09998 12.0377 8.1914C12.0756 8.28281 12.1397 8.36092 12.222 8.41586C12.3043 8.4708 12.4011 8.50008 12.5 8.5H15.5C15.6326 8.5 15.7598 8.44732 15.8536 8.35355C15.9473 8.25979 16 8.13261 16 8V5C16 4.90111 15.9706 4.80445 15.9157 4.72223C15.8607 4.64002 15.7826 4.57595 15.6912 4.53813ZM15 7.5H13.7069L15 6.20687V7.5ZM13.6462 13.6462C13.6331 13.66 12.2669 15 10 15C8.55188 15 7.38 14.3219 6.5675 13.64L7.85375 12.3538C7.92376 12.2838 7.97144 12.1947 7.99076 12.0977C8.01009 12.0006 8.00019 11.9 7.96231 11.8086C7.92444 11.7172 7.86029 11.6391 7.77799 11.5841C7.69569 11.5292 7.59895 11.4999 7.5 11.5H4.5C4.36739 11.5 4.24022 11.5527 4.14645 11.6464C4.05268 11.7402 4 11.8674 4 12V15C3.99992 15.0989 4.0292 15.1957 4.08414 15.278C4.13908 15.3603 4.21719 15.4244 4.30861 15.4623C4.40002 15.5002 4.50061 15.5101 4.59765 15.4908C4.6947 15.4714 4.78382 15.4238 4.85375 15.3538L5.8575 14.3494C7.11688 15.4312 8.54 16 10 16C12.6763 16 14.2863 14.4206 14.3538 14.3538C14.4476 14.2599 14.5003 14.1327 14.5003 14C14.5003 13.8673 14.4476 13.7401 14.3538 13.6462C14.2599 13.5524 14.1327 13.4997 14 13.4997C13.8673 13.4997 13.7401 13.5524 13.6462 13.6462ZM5 12.5H6.29313L5 13.7931V12.5Z"
    fill="#576077" />
</svg>`, o2 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M10 10C10 10.1658 9.93415 10.3247 9.81694 10.4419C9.69973 10.5592 9.54076 10.625 9.375 10.625H3.75C3.58424 10.625 3.42527 10.5592 3.30806 10.4419C3.19085 10.3247 3.125 10.1658 3.125 10C3.125 9.83424 3.19085 9.67527 3.30806 9.55806C3.42527 9.44085 3.58424 9.375 3.75 9.375H9.375C9.54076 9.375 9.69973 9.44085 9.81694 9.55806C9.93415 9.67527 10 9.83424 10 10ZM3.75 5.625H14.375C14.5408 5.625 14.6997 5.55915 14.8169 5.44194C14.9342 5.32473 15 5.16576 15 5C15 4.83424 14.9342 4.67527 14.8169 4.55806C14.6997 4.44085 14.5408 4.375 14.375 4.375H3.75C3.58424 4.375 3.42527 4.44085 3.30806 4.55806C3.19085 4.67527 3.125 4.83424 3.125 5C3.125 5.16576 3.19085 5.32473 3.30806 5.44194C3.42527 5.55915 3.58424 5.625 3.75 5.625ZM8.125 14.375H3.75C3.58424 14.375 3.42527 14.4408 3.30806 14.5581C3.19085 14.6753 3.125 14.8342 3.125 15C3.125 15.1658 3.19085 15.3247 3.30806 15.4419C3.42527 15.5592 3.58424 15.625 3.75 15.625H8.125C8.29076 15.625 8.44973 15.5592 8.56694 15.4419C8.68415 15.3247 8.75 15.1658 8.75 15C8.75 14.8342 8.68415 14.6753 8.56694 14.5581C8.44973 14.4408 8.29076 14.375 8.125 14.375ZM17.9422 12.6828C17.8841 12.6247 17.8152 12.5786 17.7393 12.5471C17.6635 12.5157 17.5821 12.4995 17.5 12.4995C17.4179 12.4995 17.3365 12.5157 17.2607 12.5471C17.1848 12.5786 17.1159 12.6247 17.0578 12.6828L15 14.7414V8.75C15 8.58424 14.9342 8.42527 14.8169 8.30806C14.6997 8.19085 14.5408 8.125 14.375 8.125C14.2092 8.125 14.0503 8.19085 13.9331 8.30806C13.8158 8.42527 13.75 8.58424 13.75 8.75V14.7414L11.6922 12.6828C11.5749 12.5655 11.4159 12.4997 11.25 12.4997C11.0841 12.4997 10.9251 12.5655 10.8078 12.6828C10.6905 12.8001 10.6247 12.9591 10.6247 13.125C10.6247 13.2909 10.6905 13.4499 10.8078 13.5672L13.9328 16.6922C13.9909 16.7503 14.0598 16.7964 14.1357 16.8279C14.2115 16.8593 14.2929 16.8755 14.375 16.8755C14.4571 16.8755 14.5385 16.8593 14.6143 16.8279C14.6902 16.7964 14.7591 16.7503 14.8172 16.6922L17.9422 13.5672C18.0003 13.5091 18.0464 13.4402 18.0779 13.3643C18.1093 13.2885 18.1255 13.2071 18.1255 13.125C18.1255 13.0429 18.1093 12.9615 18.0779 12.8857C18.0464 12.8098 18.0003 12.7409 17.9422 12.6828Z"
    fill="#576077" />
</svg>`, i2 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M3.125 9.99952C3.125 9.83376 3.19085 9.67478 3.30806 9.55757C3.42527 9.44036 3.58424 9.37452 3.75 9.37452H9.375C9.54076 9.37452 9.69973 9.44036 9.81694 9.55757C9.93415 9.67478 10 9.83376 10 9.99952C10 10.1653 9.93415 10.3242 9.81694 10.4415C9.69973 10.5587 9.54076 10.6245 9.375 10.6245H3.75C3.58424 10.6245 3.42527 10.5587 3.30806 10.4415C3.19085 10.3242 3.125 10.1653 3.125 9.99952ZM3.75 5.62452H8.125C8.29076 5.62452 8.44973 5.55867 8.56694 5.44146C8.68415 5.32425 8.75 5.16528 8.75 4.99952C8.75 4.83375 8.68415 4.67478 8.56694 4.55757C8.44973 4.44036 8.29076 4.37452 8.125 4.37452H3.75C3.58424 4.37452 3.42527 4.44036 3.30806 4.55757C3.19085 4.67478 3.125 4.83375 3.125 4.99952C3.125 5.16528 3.19085 5.32425 3.30806 5.44146C3.42527 5.55867 3.58424 5.62452 3.75 5.62452ZM14.375 14.3745H3.75C3.58424 14.3745 3.42527 14.4404 3.30806 14.5576C3.19085 14.6748 3.125 14.8338 3.125 14.9995C3.125 15.1653 3.19085 15.3242 3.30806 15.4415C3.42527 15.5587 3.58424 15.6245 3.75 15.6245H14.375C14.5408 15.6245 14.6997 15.5587 14.8169 15.4415C14.9342 15.3242 15 15.1653 15 14.9995C15 14.8338 14.9342 14.6748 14.8169 14.5576C14.6997 14.4404 14.5408 14.3745 14.375 14.3745ZM17.9422 6.43233L14.8172 3.30733C14.7591 3.24922 14.6902 3.20312 14.6143 3.17167C14.5385 3.14021 14.4571 3.12402 14.375 3.12402C14.2929 3.12402 14.2115 3.14021 14.1357 3.17167C14.0598 3.20312 13.9909 3.24922 13.9328 3.30733L10.8078 6.43233C10.6905 6.5496 10.6247 6.70866 10.6247 6.87452C10.6247 7.04037 10.6905 7.19943 10.8078 7.3167C10.9251 7.43398 11.0841 7.49986 11.25 7.49986C11.4159 7.49986 11.5749 7.43398 11.6922 7.3167L13.75 5.25811V11.2495C13.75 11.4153 13.8158 11.5742 13.9331 11.6915C14.0503 11.8087 14.2092 11.8745 14.375 11.8745C14.5408 11.8745 14.6997 11.8087 14.8169 11.6915C14.9342 11.5742 15 11.4153 15 11.2495V5.25811L17.0578 7.3167C17.1159 7.37477 17.1848 7.42083 17.2607 7.45226C17.3366 7.48369 17.4179 7.49986 17.5 7.49986C17.5821 7.49986 17.6634 7.48369 17.7393 7.45226C17.8152 7.42083 17.8841 7.37477 17.9422 7.3167C18.0003 7.25863 18.0463 7.1897 18.0777 7.11383C18.1092 7.03795 18.1253 6.95664 18.1253 6.87452C18.1253 6.79239 18.1092 6.71108 18.0777 6.6352C18.0463 6.55933 18.0003 6.4904 17.9422 6.43233Z"
    fill="#576077" />
</svg>`, s2 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M15.625 10.625C15.625 10.7908 15.5592 10.9497 15.4419 11.0669C15.3247 11.1842 15.1658 11.25 15 11.25H5C4.83424 11.25 4.67527 11.1842 4.55806 11.0669C4.44085 10.9497 4.375 10.7908 4.375 10.625C4.375 10.4592 4.44085 10.3003 4.55806 10.1831C4.67527 10.0658 4.83424 10 5 10H15C15.1658 10 15.3247 10.0658 15.4419 10.1831C15.5592 10.3003 15.625 10.4592 15.625 10.625ZM18.125 6.25H1.875C1.70924 6.25 1.55027 6.31585 1.43306 6.43306C1.31585 6.55027 1.25 6.70924 1.25 6.875C1.25 7.04076 1.31585 7.19973 1.43306 7.31694C1.55027 7.43415 1.70924 7.5 1.875 7.5H18.125C18.2908 7.5 18.4497 7.43415 18.5669 7.31694C18.6842 7.19973 18.75 7.04076 18.75 6.875C18.75 6.70924 18.6842 6.55027 18.5669 6.43306C18.4497 6.31585 18.2908 6.25 18.125 6.25ZM11.875 13.75H8.125C7.95924 13.75 7.80027 13.8158 7.68306 13.9331C7.56585 14.0503 7.5 14.2092 7.5 14.375C7.5 14.5408 7.56585 14.6997 7.68306 14.8169C7.80027 14.9342 7.95924 15 8.125 15H11.875C12.0408 15 12.1997 14.9342 12.3169 14.8169C12.4342 14.6997 12.5 14.5408 12.5 14.375C12.5 14.2092 12.4342 14.0503 12.3169 13.9331C12.1997 13.8158 12.0408 13.75 11.875 13.75Z"
    fill="#576077" />
</svg>`, a2 = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
  <g stroke="#000" stroke-linecap="round" stroke-linejoin="round" clip-path="url(#a)">
    <path
      d="M10.625 9.375H3.75v6.875h6.875V9.375ZM16.25 14.375v1.25c0 .1658-.0658.3247-.1831.4419-.1172.1173-.2761.1831-.4419.1831H13.75M16.25 8.75v2.5M14.375 3.75h1.25c.1658 0 .3247.06585.4419.18306.1173.11721.1831.27618.1831.44194v1.25M8.75 3.75h2.5M3.75 6.25V4.375c0-.16576.06585-.32473.18306-.44194.11721-.11721.27618-.18306.44194-.18306h1.25" />
  </g>
  <defs>
    <clipPath id="a">
      <path fill="#576077" d="M0 0h20v20H0z" />
    </clipPath>
  </defs>
</svg>`, l2 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M7.69277 4.75488L7.79277 4.80488C8.19694 5.01322 8.52611 5.34238 8.73444 5.74655L8.78444 5.84655C8.98444 6.24238 9.55111 6.24238 9.75527 5.84655L9.80527 5.74655C10.0136 5.34238 10.3428 5.01322 10.7469 4.80488L10.8469 4.75488C11.2428 4.55488 11.2428 3.98822 10.8469 3.78405L10.7469 3.73405C10.3428 3.52572 10.0136 3.19655 9.80527 2.79238L9.75527 2.69238C9.55527 2.29655 8.98861 2.29655 8.78444 2.69238L8.73444 2.79238C8.52611 3.19655 8.19694 3.52572 7.79277 3.73405L7.69277 3.78405C7.29694 3.98405 7.29694 4.55072 7.69277 4.75488Z"
    fill="#576077" />
  <path
    d="M8.48027 8.65905C8.88861 8.45072 8.88861 7.87155 8.48027 7.66322L7.87194 7.35072C7.33027 7.07155 6.88861 6.62988 6.60944 6.08822L6.29694 5.47988C6.08861 5.07155 5.50944 5.07155 5.30111 5.47988L4.98861 6.08822C4.70944 6.62988 4.26777 7.07155 3.72611 7.35072L3.11777 7.66322C2.70944 7.87155 2.70944 8.45072 3.11777 8.65905L3.72611 8.97155C4.26777 9.25072 4.70944 9.69238 4.98861 10.234L5.30111 10.8424C5.50944 11.2507 6.08861 11.2507 6.29694 10.8424L6.60944 10.234C6.88861 9.69238 7.33027 9.25072 7.87194 8.97155L8.48027 8.65905Z"
    fill="#576077" />
  <path
    d="M16.2969 11.1507L15.6803 10.834C14.9344 10.4549 14.3386 9.85905 13.9594 9.11322L13.6428 8.49655C13.3636 7.94655 12.8053 7.60488 12.1886 7.60488C11.5719 7.60488 11.0136 7.94655 10.7344 8.49655L10.4178 9.11322C10.0386 9.85905 9.44277 10.4549 8.69694 10.834L8.08027 11.1507C7.53027 11.4299 7.18861 11.9882 7.18861 12.6049C7.18861 13.2215 7.53027 13.7799 8.08027 14.0591L8.69694 14.3757C9.44277 14.7549 10.0386 15.3507 10.4178 16.0966L10.7344 16.7132C11.0136 17.2632 11.5719 17.6049 12.1886 17.6049C12.8053 17.6049 13.3636 17.2632 13.6428 16.7132L13.9594 16.0966C14.3386 15.3507 14.9344 14.7549 15.6803 14.3757L16.2969 14.0591C16.8469 13.7799 17.1886 13.2215 17.1886 12.6049C17.1886 11.9882 16.8469 11.4299 16.2969 11.1507ZM15.7303 12.9465L15.1136 13.2632C14.1303 13.7632 13.3469 14.5465 12.8469 15.5299L12.5303 16.1466C12.4344 16.3341 12.2594 16.3549 12.1886 16.3549C12.1178 16.3549 11.9428 16.3341 11.8469 16.1466L11.5303 15.5299C11.0303 14.5465 10.2469 13.7632 9.26361 13.2632L8.64694 12.9465C8.45944 12.8507 8.43861 12.6757 8.43861 12.6049C8.43861 12.534 8.45944 12.359 8.64694 12.2632L9.26361 11.9465C10.2469 11.4465 11.0303 10.6632 11.5303 9.67988L11.8469 9.06322C11.9428 8.87572 12.1178 8.85488 12.1886 8.85488C12.2594 8.85488 12.4344 8.87572 12.5303 9.06322L12.8469 9.67988C13.3469 10.6632 14.1303 11.4465 15.1136 11.9465L15.7303 12.2632C15.9178 12.359 15.9386 12.534 15.9386 12.6049C15.9386 12.6757 15.9178 12.8507 15.7303 12.9465Z"
    fill="#576077" />
</svg>`, c2 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="10" cy="10" r="7" stroke="#234DEC" />
</svg>`, u2 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="10" cy="10" r="7" stroke="#969EB0" stroke-dasharray="2 2" />
  <path
    d="M10.5654 10L11.8828 8.68315C11.92 8.64599 11.9494 8.60187 11.9695 8.55332C11.9896 8.50477 12 8.45273 12 8.40018C12 8.34763 11.9896 8.29559 11.9695 8.24704C11.9494 8.19848 11.92 8.15437 11.8828 8.11721C11.8456 8.08005 11.8015 8.05057 11.753 8.03046C11.7044 8.01035 11.6524 8 11.5998 8C11.5473 8 11.4952 8.01035 11.4467 8.03046C11.3981 8.05057 11.354 8.08005 11.3169 8.11721L10 9.43456L8.68315 8.11721C8.6081 8.04216 8.50631 8 8.40018 8C8.29404 8 8.19226 8.04216 8.11721 8.11721C8.04216 8.19226 8 8.29404 8 8.40018C8 8.50631 8.04216 8.6081 8.11721 8.68315L9.43456 10L8.11721 11.3169C8.08005 11.354 8.05057 11.3981 8.03046 11.4467C8.01035 11.4952 8 11.5473 8 11.5998C8 11.6524 8.01035 11.7044 8.03046 11.753C8.05057 11.8015 8.08005 11.8456 8.11721 11.8828C8.15437 11.92 8.19848 11.9494 8.24704 11.9695C8.29559 11.9896 8.34763 12 8.40018 12C8.45273 12 8.50477 11.9896 8.55332 11.9695C8.60187 11.9494 8.64599 11.92 8.68315 11.8828L10 10.5654L11.3169 11.8828C11.354 11.92 11.3981 11.9494 11.4467 11.9695C11.4952 11.9896 11.5473 12 11.5998 12C11.6524 12 11.7044 11.9896 11.753 11.9695C11.8015 11.9494 11.8456 11.92 11.8828 11.8828C11.92 11.8456 11.9494 11.8015 11.9695 11.753C11.9896 11.7044 12 11.6524 12 11.5998C12 11.5473 11.9896 11.4952 11.9695 11.4467C11.9494 11.3981 11.92 11.354 11.8828 11.3169L10.5654 10Z"
    fill="#969EB0" />
</svg>`, d2 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="10" cy="10" r="7" stroke="#D99734" />
</svg>`, f2 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M10 3.5C8.71442 3.5 7.45772 3.88122 6.3888 4.59545C5.31988 5.30968 4.48676 6.32484 3.99479 7.51256C3.50282 8.70028 3.37409 10.0072 3.6249 11.2681C3.8757 12.529 4.49477 13.6872 5.40381 14.5962C6.31285 15.5052 7.47104 16.1243 8.73192 16.3751C9.99279 16.6259 11.2997 16.4972 12.4874 16.0052C13.6752 15.5132 14.6903 14.6801 15.4046 13.6112C16.1188 12.5423 16.5 11.2856 16.5 10C16.4982 8.27665 15.8128 6.62441 14.5942 5.40582C13.3756 4.18722 11.7234 3.50182 10 3.5ZM15.5 10C15.5013 11.286 15.0497 12.5313 14.2244 13.5175L6.4825 5.775C7.28563 5.10686 8.26243 4.68128 9.29861 4.54805C10.3348 4.41482 11.3875 4.57946 12.3335 5.0227C13.2795 5.46595 14.0797 6.16946 14.6405 7.05091C15.2013 7.93236 15.4994 8.95529 15.5 10ZM4.5 10C4.49872 8.71404 4.95035 7.46871 5.77563 6.4825L13.5175 14.225C12.7144 14.8931 11.7376 15.3187 10.7014 15.452C9.66521 15.5852 8.61252 15.4205 7.6665 14.9773C6.72048 14.5341 5.92026 13.8305 5.3595 12.9491C4.79873 12.0676 4.5006 11.0447 4.5 10Z"
    fill="#A7AEBF" />
</svg>`, h2 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="10" cy="10" r="7" stroke="#C4C9D5" stroke-dasharray="2 2" />
  <path
    d="M10 17.5C10.9849 17.5 11.9602 17.306 12.8701 16.9291C13.7801 16.5522 14.6069 15.9997 15.3033 15.3033C15.9997 14.6069 16.5522 13.7801 16.9291 12.8701C17.306 11.9602 17.5 10.9849 17.5 10L16.2625 10C16.2625 10.8224 16.1005 11.6368 15.7858 12.3966C15.4711 13.1564 15.0098 13.8467 14.4283 14.4283C13.8467 15.0098 13.1564 15.4711 12.3966 15.7858C11.6368 16.1005 10.8224 16.2625 10 16.2625L10 17.5Z"
    fill="#D99734" />
  <path
    d="M17.5 10C17.5 9.01509 17.306 8.03982 16.9291 7.12987C16.5522 6.21993 15.9997 5.39314 15.3033 4.6967C14.6069 4.00026 13.7801 3.44781 12.8701 3.0709C11.9602 2.69399 10.9849 2.5 10 2.5L10 3.7375C10.8224 3.7375 11.6368 3.89948 12.3966 4.2142C13.1564 4.52892 13.8467 4.99022 14.4283 5.57174C15.0098 6.15327 15.4711 6.84364 15.7858 7.60344C16.1005 8.36325 16.2625 9.1776 16.2625 10L17.5 10Z"
    fill="#D99734" />
</svg>`, p2 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M10 16.0667C13.3505 16.0667 16.0667 13.3505 16.0667 10C16.0667 6.64947 13.3505 3.93333 10 3.93333C6.64947 3.93333 3.93333 6.64947 3.93333 10C3.93333 13.3505 6.64947 16.0667 10 16.0667ZM10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z"
    fill="#234DEC" />
  <path
    d="M12.854 8.14664C12.9005 8.19308 12.9374 8.24822 12.9626 8.30892C12.9877 8.36962 13.0007 8.43469 13.0007 8.50039C13.0007 8.5661 12.9877 8.63116 12.9626 8.69186C12.9374 8.75256 12.9005 8.80771 12.854 8.85414L9.35403 12.3541C9.30759 12.4006 9.25245 12.4375 9.19175 12.4627C9.13105 12.4878 9.06599 12.5008 9.00028 12.5008C8.93457 12.5008 8.86951 12.4878 8.80881 12.4627C8.74811 12.4375 8.69296 12.4006 8.64653 12.3541L7.14653 10.8541C7.05271 10.7603 7 10.6331 7 10.5004C7 10.3677 7.05271 10.2405 7.14653 10.1466C7.24035 10.0528 7.3676 10.0001 7.50028 10.0001C7.63296 10.0001 7.76021 10.0528 7.85403 10.1466L9.00028 11.2935L12.1465 8.14664C12.193 8.10015 12.2481 8.06327 12.3088 8.03811C12.3695 8.01295 12.4346 8 12.5003 8C12.566 8 12.631 8.01295 12.6917 8.03811C12.7524 8.06327 12.8076 8.10015 12.854 8.14664Z"
    fill="#234DEC" />
</svg>`, m2 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M10 16.0667C13.3505 16.0667 16.0667 13.3505 16.0667 10C16.0667 6.64947 13.3505 3.93333 10 3.93333C6.64947 3.93333 3.93333 6.64947 3.93333 10C3.93333 13.3505 6.64947 16.0667 10 16.0667ZM10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z"
    fill="#C4C9D5" />
</svg>`, g2 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.5 8.5V14.5H4V8.5H7.5Z" fill="#576077" fill-opacity="0.05" />
  <path
    d="M16 5H4C3.86739 5 3.74021 5.05268 3.64645 5.14645C3.55268 5.24021 3.5 5.36739 3.5 5.5V14C3.5 14.2652 3.60536 14.5196 3.79289 14.7071C3.98043 14.8946 4.23478 15 4.5 15H15.5C15.7652 15 16.0196 14.8946 16.2071 14.7071C16.3946 14.5196 16.5 14.2652 16.5 14V5.5C16.5 5.36739 16.4473 5.24021 16.3536 5.14645C16.2598 5.05268 16.1326 5 16 5ZM4.5 9H7V11H4.5V9ZM8 9H15.5V11H8V9ZM15.5 6V8H4.5V6H15.5ZM4.5 12H7V14H4.5V12ZM15.5 14H8V12H15.5V14Z"
    fill="#576077" />
</svg>`, v2 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g id="icon">
    <path id="splash" d="M13.5 4.29857L14 16L10 15.4783H6V9.73913L6.5 4L10.5001 4.29857H13.5Z" fill="#576077"
      fill-opacity="0.05" />
    <path id="icon_2" fill-rule="evenodd" clip-rule="evenodd"
      d="M7.33333 4.5C7.11232 4.5 6.90036 4.5878 6.74408 4.74408C6.5878 4.90036 6.5 5.11232 6.5 5.33333V15.5H13.5V5.33333C13.5 5.11232 13.4122 4.90036 13.2559 4.74408C13.0996 4.5878 12.8877 4.5 12.6667 4.5H7.33333ZM14.5 15.5V5.33333C14.5 4.8471 14.3068 4.38079 13.963 4.03697C13.6192 3.69315 13.1529 3.5 12.6667 3.5H7.33333C6.8471 3.5 6.38079 3.69315 6.03697 4.03697C5.69315 4.38079 5.5 4.8471 5.5 5.33333V15.5H4C3.72386 15.5 3.5 15.7239 3.5 16C3.5 16.2761 3.72386 16.5 4 16.5H16C16.2761 16.5 16.5 16.2761 16.5 16C16.5 15.7239 16.2761 15.5 16 15.5H14.5ZM11.3333 9.5C11.6095 9.5 11.8333 9.72386 11.8333 10V10.0067C11.8333 10.2828 11.6095 10.5067 11.3333 10.5067C11.0572 10.5067 10.8333 10.2828 10.8333 10.0067V10C10.8333 9.72386 11.0572 9.5 11.3333 9.5Z"
      fill="#576077" />
  </g>
</svg>`, C2 = /* @__PURE__ */ Object.assign({ "./applications.svg": n4, "./archived.svg": r4, "./bathroom.svg": o4, "./bedroom.svg": i4, "./billing.svg": s4, "./car.svg": a4, "./checkmark.svg": l4, "./chevron-down-circle.svg": c4, "./chevron-down.svg": u4, "./chevron-right-circle.svg": d4, "./chevron-right.svg": f4, "./chevron-up-circle.svg": h4, "./chevron-up.svg": p4, "./child.svg": m4, "./clock.svg": g4, "./close.svg": v4, "./collapse.svg": C4, "./document.svg": y4, "./download.svg": x4, "./entrata.svg": w4, "./exit.svg": b4, "./expand.svg": A4, "./external-link.svg": E4, "./google-color.svg": S4, "./google-mono.svg": k4, "./icon-status.svg": R4, "./loading.svg": P4, "./logo-header.svg": T4, "./logo-icon-blue.svg": M4, "./logo-icon-grey.svg": I4, "./mail.svg": _4, "./mechanical.svg": L4, "./microsoft-logo.svg": N4, "./mobile.svg": D4, "./move-in.svg": O4, "./move-out.svg": j4, "./paper-clip.svg": V4, "./person.svg": F4, "./pet.svg": B4, "./phone.svg": H4, "./print.svg": z4, "./priority-archive.svg": U4, "./priority-high-skeleton.svg": K4, "./priority-high.svg": W4, "./priority-low-skeleton.svg": Z4, "./priority-low.svg": Q4, "./priority-medium-skeleton.svg": G4, "./priority-medium.svg": $4, "./progress-canceled.svg": q4, "./progress-done.svg": X4, "./progress-four.svg": Y4, "./progress-one.svg": J4, "./progress-three.svg": e2, "./progress-two.svg": t2, "./progress-zero.svg": n2, "./renewals.svg": r2, "./sort-ascending.svg": o2, "./sort-descending.svg": i2, "./sort.svg": s2, "./square-footage.svg": a2, "./stars.svg": l2, "./status-approved.svg": c2, "./status-cancelled.svg": u2, "./status-completed.svg": d2, "./status-declined.svg": f2, "./status-partially-completed.svg": h2, "./subtask-complete.svg": p2, "./subtask-incomplete.svg": m2, "./table.svg": g2, "./unit.svg": v2 }), Du = C2;
Object.keys(Du).map(
  (e) => e.replace("./", "").replace(".svg", "")
);
const y2 = (e) => Du[`./${e}.svg`], he = ({ icon: e, title: t, className: n, fill: r }) => {
  let o = y2(e);
  r && (o = o.replace(/<path/g, `<path fill="${r}"`));
  const i = t ? { "aria-label": t } : { "aria-hidden": !0 };
  return /* @__PURE__ */ p.jsx(
    "div",
    {
      role: "img",
      className: n,
      ...i,
      dangerouslySetInnerHTML: { __html: o }
    }
  );
};
var dn = /* @__PURE__ */ ((e) => (e.PartiallyCompleted = "Partially Completed", e.Completed = "Completed", e.Approved = "Approved", e.Cancelled = "Cancelled", e.Declined = "Declined", e.Archived = "Archived", e))(dn || {});
const Mn = ({ status: e }) => {
  switch (e) {
    case "Partially Completed":
      return /* @__PURE__ */ p.jsx(he, { icon: "status-partially-completed" });
    case "Completed":
      return /* @__PURE__ */ p.jsx(he, { icon: "status-completed" });
    case "Approved":
      return /* @__PURE__ */ p.jsx(he, { icon: "status-approved" });
    case "Cancelled":
      return /* @__PURE__ */ p.jsx(he, { icon: "status-cancelled" });
    case "Declined":
      return /* @__PURE__ */ p.jsx(he, { icon: "status-declined" });
    case "Archived":
      return /* @__PURE__ */ p.jsx(he, { icon: "archived" });
    default:
      return null;
  }
};
function x2(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Or(...e) {
  return (t) => e.forEach((n) => x2(n, t));
}
function fe(...e) {
  return g.useCallback(Or(...e), e);
}
var Zt = g.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = g.Children.toArray(n), i = o.find(b2);
  if (i) {
    const s = i.props.children, a = o.map((l) => l === i ? g.Children.count(s) > 1 ? g.Children.only(null) : g.isValidElement(s) ? s.props.children : null : l);
    return /* @__PURE__ */ p.jsx(cs, { ...r, ref: t, children: g.isValidElement(s) ? g.cloneElement(s, void 0, a) : null });
  }
  return /* @__PURE__ */ p.jsx(cs, { ...r, ref: t, children: n });
});
Zt.displayName = "Slot";
var cs = g.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (g.isValidElement(n)) {
    const o = E2(n);
    return g.cloneElement(n, {
      ...A2(r, n.props),
      // @ts-ignore
      ref: t ? Or(t, o) : o
    });
  }
  return g.Children.count(n) > 1 ? g.Children.only(null) : null;
});
cs.displayName = "SlotClone";
var w2 = ({ children: e }) => /* @__PURE__ */ p.jsx(p.Fragment, { children: e });
function b2(e) {
  return g.isValidElement(e) && e.type === w2;
}
function A2(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      i(...a), o(...a);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function E2(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Ou(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (n = Ou(e[t])) && (r && (r += " "), r += n);
  else for (t in e) e[t] && (r && (r += " "), r += t);
  return r;
}
function S2() {
  for (var e, t, n = 0, r = ""; n < arguments.length; ) (e = arguments[n++]) && (t = Ou(e)) && (r && (r += " "), r += t);
  return r;
}
const Wl = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, Zl = S2, na = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null) return Zl(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: i } = t, s = Object.keys(o).map((c) => {
    const u = n == null ? void 0 : n[c], d = i == null ? void 0 : i[c];
    if (u === null) return null;
    const f = Wl(u) || Wl(d);
    return o[c][f];
  }), a = n && Object.entries(n).reduce((c, u) => {
    let [d, f] = u;
    return f === void 0 || (c[d] = f), c;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, u) => {
    let { class: d, className: f, ...h } = u;
    return Object.entries(h).every((v) => {
      let [m, y] = v;
      return Array.isArray(y) ? y.includes({
        ...i,
        ...a
      }[m]) : {
        ...i,
        ...a
      }[m] === y;
    }) ? [
      ...c,
      d,
      f
    ] : c;
  }, []);
  return Zl(e, s, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
function ju(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = ju(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function pn() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = ju(e)) && (r && (r += " "), r += t);
  return r;
}
const ra = "-", k2 = (e) => {
  const t = P2(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (s) => {
      const a = s.split(ra);
      return a[0] === "" && a.length !== 1 && a.shift(), Vu(a, t) || R2(s);
    },
    getConflictingClassGroupIds: (s, a) => {
      const l = n[s] || [];
      return a && r[s] ? [...l, ...r[s]] : l;
    }
  };
}, Vu = (e, t) => {
  var s;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), o = r ? Vu(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const i = e.join(ra);
  return (s = t.validators.find(({
    validator: a
  }) => a(i))) == null ? void 0 : s.classGroupId;
}, Ql = /^\[(.+)\]$/, R2 = (e) => {
  if (Ql.test(e)) {
    const t = Ql.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, P2 = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return M2(Object.entries(e.classGroups), n).forEach(([i, s]) => {
    us(s, r, i, t);
  }), r;
}, us = (e, t, n, r) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const i = o === "" ? t : Gl(t, o);
      i.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (T2(o)) {
        us(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(([i, s]) => {
      us(s, Gl(t, i), n, r);
    });
  });
}, Gl = (e, t) => {
  let n = e;
  return t.split(ra).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, T2 = (e) => e.isThemeGetter, M2 = (e, t) => t ? e.map(([n, r]) => {
  const o = r.map((i) => typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([s, a]) => [t + s, a])) : i);
  return [n, o];
}) : e, I2 = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const o = (i, s) => {
    n.set(i, s), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let s = n.get(i);
      if (s !== void 0)
        return s;
      if ((s = r.get(i)) !== void 0)
        return o(i, s), s;
    },
    set(i, s) {
      n.has(i) ? n.set(i, s) : o(i, s);
    }
  };
}, Fu = "!", _2 = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, o = t[0], i = t.length, s = (a) => {
    const l = [];
    let c = 0, u = 0, d;
    for (let y = 0; y < a.length; y++) {
      let C = a[y];
      if (c === 0) {
        if (C === o && (r || a.slice(y, y + i) === t)) {
          l.push(a.slice(u, y)), u = y + i;
          continue;
        }
        if (C === "/") {
          d = y;
          continue;
        }
      }
      C === "[" ? c++ : C === "]" && c--;
    }
    const f = l.length === 0 ? a : a.substring(u), h = f.startsWith(Fu), v = h ? f.substring(1) : f, m = d && d > u ? d - u : void 0;
    return {
      modifiers: l,
      hasImportantModifier: h,
      baseClassName: v,
      maybePostfixModifierPosition: m
    };
  };
  return n ? (a) => n({
    className: a,
    parseClassName: s
  }) : s;
}, L2 = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, N2 = (e) => ({
  cache: I2(e.cacheSize),
  parseClassName: _2(e),
  ...k2(e)
}), D2 = /\s+/, O2 = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: o
  } = t, i = [], s = e.trim().split(D2);
  let a = "";
  for (let l = s.length - 1; l >= 0; l -= 1) {
    const c = s[l], {
      modifiers: u,
      hasImportantModifier: d,
      baseClassName: f,
      maybePostfixModifierPosition: h
    } = n(c);
    let v = !!h, m = r(v ? f.substring(0, h) : f);
    if (!m) {
      if (!v) {
        a = c + (a.length > 0 ? " " + a : a);
        continue;
      }
      if (m = r(f), !m) {
        a = c + (a.length > 0 ? " " + a : a);
        continue;
      }
      v = !1;
    }
    const y = L2(u).join(":"), C = d ? y + Fu : y, x = C + m;
    if (i.includes(x))
      continue;
    i.push(x);
    const w = o(m, v);
    for (let S = 0; S < w.length; ++S) {
      const R = w[S];
      i.push(C + R);
    }
    a = c + (a.length > 0 ? " " + a : a);
  }
  return a;
};
function j2() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = Bu(t)) && (r && (r += " "), r += n);
  return r;
}
const Bu = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = Bu(e[r])) && (n && (n += " "), n += t);
  return n;
};
function V2(e, ...t) {
  let n, r, o, i = s;
  function s(l) {
    const c = t.reduce((u, d) => d(u), e());
    return n = N2(c), r = n.cache.get, o = n.cache.set, i = a, a(l);
  }
  function a(l) {
    const c = r(l);
    if (c)
      return c;
    const u = O2(l, n);
    return o(l, u), u;
  }
  return function() {
    return i(j2.apply(null, arguments));
  };
}
const Ae = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, Hu = /^\[(?:([a-z-]+):)?(.+)\]$/i, F2 = /^\d+\/\d+$/, B2 = /* @__PURE__ */ new Set(["px", "full", "screen"]), H2 = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, z2 = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, U2 = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, K2 = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, W2 = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Pt = (e) => Bn(e) || B2.has(e) || F2.test(e), Vt = (e) => Xn(e, "length", J2), Bn = (e) => !!e && !Number.isNaN(Number(e)), Si = (e) => Xn(e, "number", Bn), dr = (e) => !!e && Number.isInteger(Number(e)), Z2 = (e) => e.endsWith("%") && Bn(e.slice(0, -1)), oe = (e) => Hu.test(e), Ft = (e) => H2.test(e), Q2 = /* @__PURE__ */ new Set(["length", "size", "percentage"]), G2 = (e) => Xn(e, Q2, zu), $2 = (e) => Xn(e, "position", zu), q2 = /* @__PURE__ */ new Set(["image", "url"]), X2 = (e) => Xn(e, q2, t3), Y2 = (e) => Xn(e, "", e3), fr = () => !0, Xn = (e, t, n) => {
  const r = Hu.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, J2 = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  z2.test(e) && !U2.test(e)
), zu = () => !1, e3 = (e) => K2.test(e), t3 = (e) => W2.test(e), n3 = () => {
  const e = Ae("colors"), t = Ae("spacing"), n = Ae("blur"), r = Ae("brightness"), o = Ae("borderColor"), i = Ae("borderRadius"), s = Ae("borderSpacing"), a = Ae("borderWidth"), l = Ae("contrast"), c = Ae("grayscale"), u = Ae("hueRotate"), d = Ae("invert"), f = Ae("gap"), h = Ae("gradientColorStops"), v = Ae("gradientColorStopPositions"), m = Ae("inset"), y = Ae("margin"), C = Ae("opacity"), x = Ae("padding"), w = Ae("saturate"), S = Ae("scale"), R = Ae("sepia"), k = Ae("skew"), P = Ae("space"), T = Ae("translate"), _ = () => ["auto", "contain", "none"], O = () => ["auto", "hidden", "clip", "visible", "scroll"], L = () => ["auto", oe, t], I = () => [oe, t], H = () => ["", Pt, Vt], z = () => ["auto", Bn, oe], W = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], Z = () => ["solid", "dashed", "dotted", "double", "none"], U = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], B = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], j = () => ["", "0", oe], b = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], Y = () => [Bn, oe];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [fr],
      spacing: [Pt, Vt],
      blur: ["none", "", Ft, oe],
      brightness: Y(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Ft, oe],
      borderSpacing: I(),
      borderWidth: H(),
      contrast: Y(),
      grayscale: j(),
      hueRotate: Y(),
      invert: j(),
      gap: I(),
      gradientColorStops: [e],
      gradientColorStopPositions: [Z2, Vt],
      inset: L(),
      margin: L(),
      opacity: Y(),
      padding: I(),
      saturate: Y(),
      scale: Y(),
      sepia: j(),
      skew: Y(),
      space: I(),
      translate: I()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", oe]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Ft]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": b()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": b()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...W(), oe]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: O()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": O()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": O()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: _()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": _()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": _()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [m]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [m]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [m]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [m]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [m]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [m]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [m]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [m]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [m]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", dr, oe]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: L()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", oe]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: j()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: j()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", dr, oe]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [fr]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", dr, oe]
        }, oe]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": z()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": z()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [fr]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [dr, oe]
        }, oe]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": z()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": z()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", oe]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", oe]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...B()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...B(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...B(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [x]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [x]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [x]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [x]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [x]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [x]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [x]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [x]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [x]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [y]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [y]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [y]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [y]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [y]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [y]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [y]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [y]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [y]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [P]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [P]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", oe, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [oe, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [oe, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Ft]
        }, Ft]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [oe, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [oe, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [oe, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [oe, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Ft, Vt]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Si]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [fr]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", oe]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Bn, Si]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Pt, oe]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", oe]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", oe]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [C]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [C]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...Z(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Pt, Vt]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Pt, oe]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: I()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", oe]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", oe]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [C]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...W(), $2]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", G2]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, X2]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [v]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [v]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [v]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [a]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [a]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [a]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [a]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [a]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [a]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [a]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [a]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [a]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [C]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...Z(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [a]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [a]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [C]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: Z()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [o]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...Z()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Pt, oe]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Pt, Vt]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: H()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [C]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Pt, Vt]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Ft, Y2]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [fr]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [C]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...U(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": U()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Ft, oe]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [R]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [C]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [R]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [s]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [s]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [s]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", oe]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: Y()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", oe]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: Y()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", oe]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [S]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [S]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [S]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [dr, oe]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [T]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [T]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [k]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [k]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", oe]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", oe]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": I()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": I()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": I()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": I()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": I()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": I()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": I()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": I()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": I()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": I()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": I()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": I()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": I()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": I()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": I()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": I()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": I()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": I()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", oe]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Pt, Vt, Si]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, r3 = /* @__PURE__ */ V2(n3);
function ee(...e) {
  return r3(pn(e));
}
const o3 = (e) => {
  const t = new Date(e), n = {
    month: "long",
    day: "numeric",
    timeZone: "UTC",
    ...t.getFullYear() !== (/* @__PURE__ */ new Date()).getFullYear() && { year: "numeric" }
  };
  return t.toLocaleDateString("en-US", n);
}, Uu = (e, t) => {
  if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
  for (const n in e)
    if (typeof e[n] == "object" && e[n] !== null) {
      const r = Uu(e[n], t);
      if (r !== void 0) return r;
    }
}, i3 = na(
  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-all focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary-700",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border border-solid border-border bg-background hover:shadow-md",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "text-muted-foreground hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
        askBranded: "text-white bg-gradient-to-br from-blue-700 to-sky-400 shadow-lg border-2 border-gray-50 hover:from-blue-700 hover:shadow-xl hover:to-blue-500 disabled:from-gray-600 disabled:to-gray-600 disabled:shadow-none disabled:opacity-100"
      },
      size: {
        default: "h-10 px-4 py-2 rounded-xl text-base",
        sm: "h-8 px-3 rounded-xl text-sm",
        xs: "h-5 px-1 rounded-md text-sm",
        lg: "h-12 px-4 rounded-xl",
        icon: "h-8 w-8 rounded-xl"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), ho = g.forwardRef(
  ({ className: e, variant: t, size: n, asChild: r = !1, ...o }, i) => {
    const s = r ? Zt : "button";
    return /* @__PURE__ */ p.jsx(
      s,
      {
        className: ee(i3({ variant: t, size: n, className: e })),
        ref: i,
        ...o
      }
    );
  }
);
ho.displayName = "Button";
const Ku = g.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  "div",
  {
    ref: n,
    className: ee(
      "rounded-lg border bg-gray-50 text-card-foreground",
      e
    ),
    ...t
  }
));
Ku.displayName = "Card";
const s3 = g.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  "div",
  {
    ref: n,
    className: ee("flex flex-col space-y-1.5 p-6", e),
    ...t
  }
));
s3.displayName = "CardHeader";
const a3 = g.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  "h3",
  {
    ref: n,
    className: ee(
      "text-2xl font-semibold leading-none tracking-tight",
      e
    ),
    ...t
  }
));
a3.displayName = "CardTitle";
const l3 = g.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  "p",
  {
    ref: n,
    className: ee("text-sm text-muted-foreground", e),
    ...t
  }
));
l3.displayName = "CardDescription";
const Wu = g.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx("div", { ref: n, className: ee("p-6 pt-0 pb-0", e), ...t }));
Wu.displayName = "CardContent";
const c3 = g.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  "div",
  {
    ref: n,
    className: ee("flex items-center p-6 pt-0 pb-0", e),
    ...t
  }
));
c3.displayName = "CardFooter";
function F(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function u3(e, t) {
  const n = g.createContext(t), r = (i) => {
    const { children: s, ...a } = i, l = g.useMemo(() => a, Object.values(a));
    return /* @__PURE__ */ p.jsx(n.Provider, { value: l, children: s });
  };
  r.displayName = e + "Provider";
  function o(i) {
    const s = g.useContext(n);
    if (s) return s;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return [r, o];
}
function En(e, t = []) {
  let n = [];
  function r(i, s) {
    const a = g.createContext(s), l = n.length;
    n = [...n, s];
    const c = (d) => {
      var C;
      const { scope: f, children: h, ...v } = d, m = ((C = f == null ? void 0 : f[e]) == null ? void 0 : C[l]) || a, y = g.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ p.jsx(m.Provider, { value: y, children: h });
    };
    c.displayName = i + "Provider";
    function u(d, f) {
      var m;
      const h = ((m = f == null ? void 0 : f[e]) == null ? void 0 : m[l]) || a, v = g.useContext(h);
      if (v) return v;
      if (s !== void 0) return s;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return [c, u];
  }
  const o = () => {
    const i = n.map((s) => g.createContext(s));
    return function(a) {
      const l = (a == null ? void 0 : a[e]) || i;
      return g.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: l } }),
        [a, l]
      );
    };
  };
  return o.scopeName = e, [r, d3(o, ...t)];
}
function d3(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((a, { useScope: l, scopeName: c }) => {
        const d = l(i)[`__scope${c}`];
        return { ...a, ...d };
      }, {});
      return g.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Te(e) {
  const t = g.useRef(e);
  return g.useEffect(() => {
    t.current = e;
  }), g.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function Et({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = f3({ defaultProp: t, onChange: n }), i = e !== void 0, s = i ? e : r, a = Te(n), l = g.useCallback(
    (c) => {
      if (i) {
        const d = typeof c == "function" ? c(e) : c;
        d !== e && a(d);
      } else
        o(c);
    },
    [i, e, o, a]
  );
  return [s, l];
}
function f3({
  defaultProp: e,
  onChange: t
}) {
  const n = g.useState(e), [r] = n, o = g.useRef(r), i = Te(t);
  return g.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [r, o, i]), n;
}
const h3 = ["top", "right", "bottom", "left"], Qt = Math.min, Je = Math.max, Ao = Math.round, Yr = Math.floor, Gt = (e) => ({
  x: e,
  y: e
}), p3 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, m3 = {
  start: "end",
  end: "start"
};
function ds(e, t, n) {
  return Je(e, Qt(t, n));
}
function Lt(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Nt(e) {
  return e.split("-")[0];
}
function Yn(e) {
  return e.split("-")[1];
}
function oa(e) {
  return e === "x" ? "y" : "x";
}
function ia(e) {
  return e === "y" ? "height" : "width";
}
function $t(e) {
  return ["top", "bottom"].includes(Nt(e)) ? "y" : "x";
}
function sa(e) {
  return oa($t(e));
}
function g3(e, t, n) {
  n === void 0 && (n = !1);
  const r = Yn(e), o = sa(e), i = ia(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (s = Eo(s)), [s, Eo(s)];
}
function v3(e) {
  const t = Eo(e);
  return [fs(e), t, fs(t)];
}
function fs(e) {
  return e.replace(/start|end/g, (t) => m3[t]);
}
function C3(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? i : s;
    default:
      return [];
  }
}
function y3(e, t, n, r) {
  const o = Yn(e);
  let i = C3(Nt(e), n === "start", r);
  return o && (i = i.map((s) => s + "-" + o), t && (i = i.concat(i.map(fs)))), i;
}
function Eo(e) {
  return e.replace(/left|right|bottom|top/g, (t) => p3[t]);
}
function x3(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Zu(e) {
  return typeof e != "number" ? x3(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function So(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function $l(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = $t(t), s = sa(t), a = ia(s), l = Nt(t), c = i === "y", u = r.x + r.width / 2 - o.width / 2, d = r.y + r.height / 2 - o.height / 2, f = r[a] / 2 - o[a] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: u,
        y: r.y - o.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: r.x - o.width,
        y: d
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (Yn(t)) {
    case "start":
      h[s] -= f * (n && c ? -1 : 1);
      break;
    case "end":
      h[s] += f * (n && c ? -1 : 1);
      break;
  }
  return h;
}
const w3 = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: s
  } = n, a = i.filter(Boolean), l = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let c = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: d
  } = $l(c, r, l), f = r, h = {}, v = 0;
  for (let m = 0; m < a.length; m++) {
    const {
      name: y,
      fn: C
    } = a[m], {
      x,
      y: w,
      data: S,
      reset: R
    } = await C({
      x: u,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: o,
      middlewareData: h,
      rects: c,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = x ?? u, d = w ?? d, h = {
      ...h,
      [y]: {
        ...h[y],
        ...S
      }
    }, R && v <= 50 && (v++, typeof R == "object" && (R.placement && (f = R.placement), R.rects && (c = R.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : R.rects), {
      x: u,
      y: d
    } = $l(c, f, l)), m = -1);
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: o,
    middlewareData: h
  };
};
async function kr(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: s,
    elements: a,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = Lt(t, e), v = Zu(h), y = a[f ? d === "floating" ? "reference" : "floating" : d], C = So(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(y))) == null || n ? y : y.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(a.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), x = d === "floating" ? {
    x: r,
    y: o,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, w = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(a.floating)), S = await (i.isElement == null ? void 0 : i.isElement(w)) ? await (i.getScale == null ? void 0 : i.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, R = So(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: x,
    offsetParent: w,
    strategy: l
  }) : x);
  return {
    top: (C.top - R.top + v.top) / S.y,
    bottom: (R.bottom - C.bottom + v.bottom) / S.y,
    left: (C.left - R.left + v.left) / S.x,
    right: (R.right - C.right + v.right) / S.x
  };
}
const b3 = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: s,
      elements: a,
      middlewareData: l
    } = t, {
      element: c,
      padding: u = 0
    } = Lt(e, t) || {};
    if (c == null)
      return {};
    const d = Zu(u), f = {
      x: n,
      y: r
    }, h = sa(o), v = ia(h), m = await s.getDimensions(c), y = h === "y", C = y ? "top" : "left", x = y ? "bottom" : "right", w = y ? "clientHeight" : "clientWidth", S = i.reference[v] + i.reference[h] - f[h] - i.floating[v], R = f[h] - i.reference[h], k = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(c));
    let P = k ? k[w] : 0;
    (!P || !await (s.isElement == null ? void 0 : s.isElement(k))) && (P = a.floating[w] || i.floating[v]);
    const T = S / 2 - R / 2, _ = P / 2 - m[v] / 2 - 1, O = Qt(d[C], _), L = Qt(d[x], _), I = O, H = P - m[v] - L, z = P / 2 - m[v] / 2 + T, W = ds(I, z, H), Z = !l.arrow && Yn(o) != null && z !== W && i.reference[v] / 2 - (z < I ? O : L) - m[v] / 2 < 0, U = Z ? z < I ? z - I : z - H : 0;
    return {
      [h]: f[h] + U,
      data: {
        [h]: W,
        centerOffset: z - W - U,
        ...Z && {
          alignmentOffset: U
        }
      },
      reset: Z
    };
  }
}), A3 = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: s,
        initialPlacement: a,
        platform: l,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: v = "none",
        flipAlignment: m = !0,
        ...y
      } = Lt(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const C = Nt(o), x = $t(a), w = Nt(a) === a, S = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), R = f || (w || !m ? [Eo(a)] : v3(a)), k = v !== "none";
      !f && k && R.push(...y3(a, m, v, S));
      const P = [a, ...R], T = await kr(t, y), _ = [];
      let O = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (u && _.push(T[C]), d) {
        const z = g3(o, s, S);
        _.push(T[z[0]], T[z[1]]);
      }
      if (O = [...O, {
        placement: o,
        overflows: _
      }], !_.every((z) => z <= 0)) {
        var L, I;
        const z = (((L = i.flip) == null ? void 0 : L.index) || 0) + 1, W = P[z];
        if (W)
          return {
            data: {
              index: z,
              overflows: O
            },
            reset: {
              placement: W
            }
          };
        let Z = (I = O.filter((U) => U.overflows[0] <= 0).sort((U, B) => U.overflows[1] - B.overflows[1])[0]) == null ? void 0 : I.placement;
        if (!Z)
          switch (h) {
            case "bestFit": {
              var H;
              const U = (H = O.filter((B) => {
                if (k) {
                  const j = $t(B.placement);
                  return j === x || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  j === "y";
                }
                return !0;
              }).map((B) => [B.placement, B.overflows.filter((j) => j > 0).reduce((j, b) => j + b, 0)]).sort((B, j) => B[1] - j[1])[0]) == null ? void 0 : H[0];
              U && (Z = U);
              break;
            }
            case "initialPlacement":
              Z = a;
              break;
          }
        if (o !== Z)
          return {
            reset: {
              placement: Z
            }
          };
      }
      return {};
    }
  };
};
function ql(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Xl(e) {
  return h3.some((t) => e[t] >= 0);
}
const E3 = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = Lt(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await kr(t, {
            ...o,
            elementContext: "reference"
          }), s = ql(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: Xl(s)
            }
          };
        }
        case "escaped": {
          const i = await kr(t, {
            ...o,
            altBoundary: !0
          }), s = ql(i, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: Xl(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function S3(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = Nt(n), a = Yn(n), l = $t(n) === "y", c = ["left", "top"].includes(s) ? -1 : 1, u = i && l ? -1 : 1, d = Lt(t, e);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: v
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return a && typeof v == "number" && (h = a === "end" ? v * -1 : v), l ? {
    x: h * u,
    y: f * c
  } : {
    x: f * c,
    y: h * u
  };
}
const k3 = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: s,
        middlewareData: a
      } = t, l = await S3(t, e);
      return s === ((n = a.offset) == null ? void 0 : n.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: s
        }
      };
    }
  };
}, R3 = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (y) => {
            let {
              x: C,
              y: x
            } = y;
            return {
              x: C,
              y: x
            };
          }
        },
        ...l
      } = Lt(e, t), c = {
        x: n,
        y: r
      }, u = await kr(t, l), d = $t(Nt(o)), f = oa(d);
      let h = c[f], v = c[d];
      if (i) {
        const y = f === "y" ? "top" : "left", C = f === "y" ? "bottom" : "right", x = h + u[y], w = h - u[C];
        h = ds(x, h, w);
      }
      if (s) {
        const y = d === "y" ? "top" : "left", C = d === "y" ? "bottom" : "right", x = v + u[y], w = v - u[C];
        v = ds(x, v, w);
      }
      const m = a.fn({
        ...t,
        [f]: h,
        [d]: v
      });
      return {
        ...m,
        data: {
          x: m.x - n,
          y: m.y - r,
          enabled: {
            [f]: i,
            [d]: s
          }
        }
      };
    }
  };
}, P3 = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: i,
        middlewareData: s
      } = t, {
        offset: a = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = Lt(e, t), u = {
        x: n,
        y: r
      }, d = $t(o), f = oa(d);
      let h = u[f], v = u[d];
      const m = Lt(a, t), y = typeof m == "number" ? {
        mainAxis: m,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...m
      };
      if (l) {
        const w = f === "y" ? "height" : "width", S = i.reference[f] - i.floating[w] + y.mainAxis, R = i.reference[f] + i.reference[w] - y.mainAxis;
        h < S ? h = S : h > R && (h = R);
      }
      if (c) {
        var C, x;
        const w = f === "y" ? "width" : "height", S = ["top", "left"].includes(Nt(o)), R = i.reference[d] - i.floating[w] + (S && ((C = s.offset) == null ? void 0 : C[d]) || 0) + (S ? 0 : y.crossAxis), k = i.reference[d] + i.reference[w] + (S ? 0 : ((x = s.offset) == null ? void 0 : x[d]) || 0) - (S ? y.crossAxis : 0);
        v < R ? v = R : v > k && (v = k);
      }
      return {
        [f]: h,
        [d]: v
      };
    }
  };
}, T3 = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: i,
        platform: s,
        elements: a
      } = t, {
        apply: l = () => {
        },
        ...c
      } = Lt(e, t), u = await kr(t, c), d = Nt(o), f = Yn(o), h = $t(o) === "y", {
        width: v,
        height: m
      } = i.floating;
      let y, C;
      d === "top" || d === "bottom" ? (y = d, C = f === (await (s.isRTL == null ? void 0 : s.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (C = d, y = f === "end" ? "top" : "bottom");
      const x = m - u.top - u.bottom, w = v - u.left - u.right, S = Qt(m - u[y], x), R = Qt(v - u[C], w), k = !t.middlewareData.shift;
      let P = S, T = R;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (T = w), (r = t.middlewareData.shift) != null && r.enabled.y && (P = x), k && !f) {
        const O = Je(u.left, 0), L = Je(u.right, 0), I = Je(u.top, 0), H = Je(u.bottom, 0);
        h ? T = v - 2 * (O !== 0 || L !== 0 ? O + L : Je(u.left, u.right)) : P = m - 2 * (I !== 0 || H !== 0 ? I + H : Je(u.top, u.bottom));
      }
      await l({
        ...t,
        availableWidth: T,
        availableHeight: P
      });
      const _ = await s.getDimensions(a.floating);
      return v !== _.width || m !== _.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Zo() {
  return typeof window < "u";
}
function Jn(e) {
  return Qu(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function tt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function kt(e) {
  var t;
  return (t = (Qu(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Qu(e) {
  return Zo() ? e instanceof Node || e instanceof tt(e).Node : !1;
}
function mt(e) {
  return Zo() ? e instanceof Element || e instanceof tt(e).Element : !1;
}
function St(e) {
  return Zo() ? e instanceof HTMLElement || e instanceof tt(e).HTMLElement : !1;
}
function Yl(e) {
  return !Zo() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof tt(e).ShadowRoot;
}
function jr(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = gt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function M3(e) {
  return ["table", "td", "th"].includes(Jn(e));
}
function Qo(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function aa(e) {
  const t = la(), n = mt(e) ? gt(e) : e;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function I3(e) {
  let t = qt(e);
  for (; St(t) && !Zn(t); ) {
    if (aa(t))
      return t;
    if (Qo(t))
      return null;
    t = qt(t);
  }
  return null;
}
function la() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Zn(e) {
  return ["html", "body", "#document"].includes(Jn(e));
}
function gt(e) {
  return tt(e).getComputedStyle(e);
}
function Go(e) {
  return mt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function qt(e) {
  if (Jn(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Yl(e) && e.host || // Fallback.
    kt(e)
  );
  return Yl(t) ? t.host : t;
}
function Gu(e) {
  const t = qt(e);
  return Zn(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : St(t) && jr(t) ? t : Gu(t);
}
function Rr(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = Gu(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), s = tt(o);
  if (i) {
    const a = hs(s);
    return t.concat(s, s.visualViewport || [], jr(o) ? o : [], a && n ? Rr(a) : []);
  }
  return t.concat(o, Rr(o, [], n));
}
function hs(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function $u(e) {
  const t = gt(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = St(e), i = o ? e.offsetWidth : n, s = o ? e.offsetHeight : r, a = Ao(n) !== i || Ao(r) !== s;
  return a && (n = i, r = s), {
    width: n,
    height: r,
    $: a
  };
}
function ca(e) {
  return mt(e) ? e : e.contextElement;
}
function Hn(e) {
  const t = ca(e);
  if (!St(t))
    return Gt(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = $u(t);
  let s = (i ? Ao(n.width) : n.width) / r, a = (i ? Ao(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const _3 = /* @__PURE__ */ Gt(0);
function qu(e) {
  const t = tt(e);
  return !la() || !t.visualViewport ? _3 : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function L3(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== tt(e) ? !1 : t;
}
function yn(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = ca(e);
  let s = Gt(1);
  t && (r ? mt(r) && (s = Hn(r)) : s = Hn(e));
  const a = L3(i, n, r) ? qu(i) : Gt(0);
  let l = (o.left + a.x) / s.x, c = (o.top + a.y) / s.y, u = o.width / s.x, d = o.height / s.y;
  if (i) {
    const f = tt(i), h = r && mt(r) ? tt(r) : r;
    let v = f, m = hs(v);
    for (; m && r && h !== v; ) {
      const y = Hn(m), C = m.getBoundingClientRect(), x = gt(m), w = C.left + (m.clientLeft + parseFloat(x.paddingLeft)) * y.x, S = C.top + (m.clientTop + parseFloat(x.paddingTop)) * y.y;
      l *= y.x, c *= y.y, u *= y.x, d *= y.y, l += w, c += S, v = tt(m), m = hs(v);
    }
  }
  return So({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function N3(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", s = kt(r), a = t ? Qo(t.floating) : !1;
  if (r === s || a && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = Gt(1);
  const u = Gt(0), d = St(r);
  if ((d || !d && !i) && ((Jn(r) !== "body" || jr(s)) && (l = Go(r)), St(r))) {
    const f = yn(r);
    c = Hn(r), u.x = f.x + r.clientLeft, u.y = f.y + r.clientTop;
  }
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + u.x,
    y: n.y * c.y - l.scrollTop * c.y + u.y
  };
}
function D3(e) {
  return Array.from(e.getClientRects());
}
function ps(e, t) {
  const n = Go(e).scrollLeft;
  return t ? t.left + n : yn(kt(e)).left + n;
}
function O3(e) {
  const t = kt(e), n = Go(e), r = e.ownerDocument.body, o = Je(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = Je(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + ps(e);
  const a = -n.scrollTop;
  return gt(r).direction === "rtl" && (s += Je(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: s,
    y: a
  };
}
function j3(e, t) {
  const n = tt(e), r = kt(e), o = n.visualViewport;
  let i = r.clientWidth, s = r.clientHeight, a = 0, l = 0;
  if (o) {
    i = o.width, s = o.height;
    const c = la();
    (!c || c && t === "fixed") && (a = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: a,
    y: l
  };
}
function V3(e, t) {
  const n = yn(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = St(e) ? Hn(e) : Gt(1), s = e.clientWidth * i.x, a = e.clientHeight * i.y, l = o * i.x, c = r * i.y;
  return {
    width: s,
    height: a,
    x: l,
    y: c
  };
}
function Jl(e, t, n) {
  let r;
  if (t === "viewport")
    r = j3(e, n);
  else if (t === "document")
    r = O3(kt(e));
  else if (mt(t))
    r = V3(t, n);
  else {
    const o = qu(e);
    r = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return So(r);
}
function Xu(e, t) {
  const n = qt(e);
  return n === t || !mt(n) || Zn(n) ? !1 : gt(n).position === "fixed" || Xu(n, t);
}
function F3(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Rr(e, [], !1).filter((a) => mt(a) && Jn(a) !== "body"), o = null;
  const i = gt(e).position === "fixed";
  let s = i ? qt(e) : e;
  for (; mt(s) && !Zn(s); ) {
    const a = gt(s), l = aa(s);
    !l && a.position === "fixed" && (o = null), (i ? !l && !o : !l && a.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || jr(s) && !l && Xu(e, s)) ? r = r.filter((u) => u !== s) : o = a, s = qt(s);
  }
  return t.set(e, r), r;
}
function B3(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? Qo(t) ? [] : F3(t, this._c) : [].concat(n), r], a = s[0], l = s.reduce((c, u) => {
    const d = Jl(t, u, o);
    return c.top = Je(d.top, c.top), c.right = Qt(d.right, c.right), c.bottom = Qt(d.bottom, c.bottom), c.left = Je(d.left, c.left), c;
  }, Jl(t, a, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function H3(e) {
  const {
    width: t,
    height: n
  } = $u(e);
  return {
    width: t,
    height: n
  };
}
function z3(e, t, n) {
  const r = St(t), o = kt(t), i = n === "fixed", s = yn(e, !0, i, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Gt(0);
  if (r || !r && !i)
    if ((Jn(t) !== "body" || jr(o)) && (a = Go(t)), r) {
      const h = yn(t, !0, i, t);
      l.x = h.x + t.clientLeft, l.y = h.y + t.clientTop;
    } else o && (l.x = ps(o));
  let c = 0, u = 0;
  if (o && !r && !i) {
    const h = o.getBoundingClientRect();
    u = h.top + a.scrollTop, c = h.left + a.scrollLeft - // RTL <body> scrollbar.
    ps(o, h);
  }
  const d = s.left + a.scrollLeft - l.x - c, f = s.top + a.scrollTop - l.y - u;
  return {
    x: d,
    y: f,
    width: s.width,
    height: s.height
  };
}
function ki(e) {
  return gt(e).position === "static";
}
function ec(e, t) {
  if (!St(e) || gt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return kt(e) === n && (n = n.ownerDocument.body), n;
}
function Yu(e, t) {
  const n = tt(e);
  if (Qo(e))
    return n;
  if (!St(e)) {
    let o = qt(e);
    for (; o && !Zn(o); ) {
      if (mt(o) && !ki(o))
        return o;
      o = qt(o);
    }
    return n;
  }
  let r = ec(e, t);
  for (; r && M3(r) && ki(r); )
    r = ec(r, t);
  return r && Zn(r) && ki(r) && !aa(r) ? n : r || I3(e) || n;
}
const U3 = async function(e) {
  const t = this.getOffsetParent || Yu, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: z3(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function K3(e) {
  return gt(e).direction === "rtl";
}
const W3 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: N3,
  getDocumentElement: kt,
  getClippingRect: B3,
  getOffsetParent: Yu,
  getElementRects: U3,
  getClientRects: D3,
  getDimensions: H3,
  getScale: Hn,
  isElement: mt,
  isRTL: K3
};
function Z3(e, t) {
  let n = null, r;
  const o = kt(e);
  function i() {
    var a;
    clearTimeout(r), (a = n) == null || a.disconnect(), n = null;
  }
  function s(a, l) {
    a === void 0 && (a = !1), l === void 0 && (l = 1), i();
    const {
      left: c,
      top: u,
      width: d,
      height: f
    } = e.getBoundingClientRect();
    if (a || t(), !d || !f)
      return;
    const h = Yr(u), v = Yr(o.clientWidth - (c + d)), m = Yr(o.clientHeight - (u + f)), y = Yr(c), x = {
      rootMargin: -h + "px " + -v + "px " + -m + "px " + -y + "px",
      threshold: Je(0, Qt(1, l)) || 1
    };
    let w = !0;
    function S(R) {
      const k = R[0].intersectionRatio;
      if (k !== l) {
        if (!w)
          return s();
        k ? s(!1, k) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      w = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...x,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, x);
    }
    n.observe(e);
  }
  return s(!0), i;
}
function Q3(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = ca(e), u = o || i ? [...c ? Rr(c) : [], ...Rr(t)] : [];
  u.forEach((C) => {
    o && C.addEventListener("scroll", n, {
      passive: !0
    }), i && C.addEventListener("resize", n);
  });
  const d = c && a ? Z3(c, n) : null;
  let f = -1, h = null;
  s && (h = new ResizeObserver((C) => {
    let [x] = C;
    x && x.target === c && h && (h.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var w;
      (w = h) == null || w.observe(t);
    })), n();
  }), c && !l && h.observe(c), h.observe(t));
  let v, m = l ? yn(e) : null;
  l && y();
  function y() {
    const C = yn(e);
    m && (C.x !== m.x || C.y !== m.y || C.width !== m.width || C.height !== m.height) && n(), m = C, v = requestAnimationFrame(y);
  }
  return n(), () => {
    var C;
    u.forEach((x) => {
      o && x.removeEventListener("scroll", n), i && x.removeEventListener("resize", n);
    }), d == null || d(), (C = h) == null || C.disconnect(), h = null, l && cancelAnimationFrame(v);
  };
}
const G3 = k3, $3 = R3, q3 = A3, X3 = T3, Y3 = E3, tc = b3, J3 = P3, e6 = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: W3,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return w3(e, t, {
    ...o,
    platform: i
  });
};
var po = typeof document < "u" ? Mu : bn;
function ko(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!ko(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !ko(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Ju(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function nc(e, t) {
  const n = Ju(e);
  return Math.round(t * n) / n;
}
function Ri(e) {
  const t = g.useRef(e);
  return po(() => {
    t.current = e;
  }), t;
}
function t6(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: a = !0,
    whileElementsMounted: l,
    open: c
  } = e, [u, d] = g.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [f, h] = g.useState(r);
  ko(f, r) || h(r);
  const [v, m] = g.useState(null), [y, C] = g.useState(null), x = g.useCallback((B) => {
    B !== k.current && (k.current = B, m(B));
  }, []), w = g.useCallback((B) => {
    B !== P.current && (P.current = B, C(B));
  }, []), S = i || v, R = s || y, k = g.useRef(null), P = g.useRef(null), T = g.useRef(u), _ = l != null, O = Ri(l), L = Ri(o), I = Ri(c), H = g.useCallback(() => {
    if (!k.current || !P.current)
      return;
    const B = {
      placement: t,
      strategy: n,
      middleware: f
    };
    L.current && (B.platform = L.current), e6(k.current, P.current, B).then((j) => {
      const b = {
        ...j,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: I.current !== !1
      };
      z.current && !ko(T.current, b) && (T.current = b, Wo.flushSync(() => {
        d(b);
      }));
    });
  }, [f, t, n, L, I]);
  po(() => {
    c === !1 && T.current.isPositioned && (T.current.isPositioned = !1, d((B) => ({
      ...B,
      isPositioned: !1
    })));
  }, [c]);
  const z = g.useRef(!1);
  po(() => (z.current = !0, () => {
    z.current = !1;
  }), []), po(() => {
    if (S && (k.current = S), R && (P.current = R), S && R) {
      if (O.current)
        return O.current(S, R, H);
      H();
    }
  }, [S, R, H, O, _]);
  const W = g.useMemo(() => ({
    reference: k,
    floating: P,
    setReference: x,
    setFloating: w
  }), [x, w]), Z = g.useMemo(() => ({
    reference: S,
    floating: R
  }), [S, R]), U = g.useMemo(() => {
    const B = {
      position: n,
      left: 0,
      top: 0
    };
    if (!Z.floating)
      return B;
    const j = nc(Z.floating, u.x), b = nc(Z.floating, u.y);
    return a ? {
      ...B,
      transform: "translate(" + j + "px, " + b + "px)",
      ...Ju(Z.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: j,
      top: b
    };
  }, [n, a, Z.floating, u.x, u.y]);
  return g.useMemo(() => ({
    ...u,
    update: H,
    refs: W,
    elements: Z,
    floatingStyles: U
  }), [u, H, W, Z, U]);
}
const n6 = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? tc({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? tc({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, r6 = (e, t) => ({
  ...G3(e),
  options: [e, t]
}), o6 = (e, t) => ({
  ...$3(e),
  options: [e, t]
}), i6 = (e, t) => ({
  ...J3(e),
  options: [e, t]
}), s6 = (e, t) => ({
  ...q3(e),
  options: [e, t]
}), a6 = (e, t) => ({
  ...X3(e),
  options: [e, t]
}), l6 = (e, t) => ({
  ...Y3(e),
  options: [e, t]
}), c6 = (e, t) => ({
  ...n6(e),
  options: [e, t]
});
var u6 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], $ = u6.reduce((e, t) => {
  const n = g.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, a = i ? Zt : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p.jsx(a, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Ro(e, t) {
  e && Wo.flushSync(() => e.dispatchEvent(t));
}
var d6 = "Arrow", ed = g.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ p.jsx(
    $.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ p.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
ed.displayName = d6;
var f6 = ed;
function ua(e, t = []) {
  let n = [];
  function r(i, s) {
    const a = g.createContext(s), l = n.length;
    n = [...n, s];
    function c(d) {
      const { scope: f, children: h, ...v } = d, m = (f == null ? void 0 : f[e][l]) || a, y = g.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ p.jsx(m.Provider, { value: y, children: h });
    }
    function u(d, f) {
      const h = (f == null ? void 0 : f[e][l]) || a, v = g.useContext(h);
      if (v) return v;
      if (s !== void 0) return s;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return c.displayName = i + "Provider", [c, u];
  }
  const o = () => {
    const i = n.map((s) => g.createContext(s));
    return function(a) {
      const l = (a == null ? void 0 : a[e]) || i;
      return g.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: l } }),
        [a, l]
      );
    };
  };
  return o.scopeName = e, [r, h6(o, ...t)];
}
function h6(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((a, { useScope: l, scopeName: c }) => {
        const d = l(i)[`__scope${c}`];
        return { ...a, ...d };
      }, {});
      return g.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var Ie = globalThis != null && globalThis.document ? g.useLayoutEffect : () => {
};
function p6(e) {
  const [t, n] = g.useState(void 0);
  return Ie(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let s, a;
        if ("borderBoxSize" in i) {
          const l = i.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          s = c.inlineSize, a = c.blockSize;
        } else
          s = e.offsetWidth, a = e.offsetHeight;
        n({ width: s, height: a });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var da = "Popper", [td, er] = ua(da), [m6, nd] = td(da), rd = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = g.useState(null);
  return /* @__PURE__ */ p.jsx(m6, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
rd.displayName = da;
var od = "PopperAnchor", id = g.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, i = nd(od, n), s = g.useRef(null), a = fe(t, s);
    return g.useEffect(() => {
      i.onAnchorChange((r == null ? void 0 : r.current) || s.current);
    }), r ? null : /* @__PURE__ */ p.jsx($.div, { ...o, ref: a });
  }
);
id.displayName = od;
var fa = "PopperContent", [g6, v6] = td(fa), sd = g.forwardRef(
  (e, t) => {
    var Q, te, se, re, ce, de;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: s = 0,
      arrowPadding: a = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: u = 0,
      sticky: d = "partial",
      hideWhenDetached: f = !1,
      updatePositionStrategy: h = "optimized",
      onPlaced: v,
      ...m
    } = e, y = nd(fa, n), [C, x] = g.useState(null), w = fe(t, (_e) => x(_e)), [S, R] = g.useState(null), k = p6(S), P = (k == null ? void 0 : k.width) ?? 0, T = (k == null ? void 0 : k.height) ?? 0, _ = r + (i !== "center" ? "-" + i : ""), O = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, L = Array.isArray(c) ? c : [c], I = L.length > 0, H = {
      padding: O,
      boundary: L.filter(y6),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: I
    }, { refs: z, floatingStyles: W, placement: Z, isPositioned: U, middlewareData: B } = t6({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: _,
      whileElementsMounted: (..._e) => Q3(..._e, {
        animationFrame: h === "always"
      }),
      elements: {
        reference: y.anchor
      },
      middleware: [
        r6({ mainAxis: o + T, alignmentAxis: s }),
        l && o6({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? i6() : void 0,
          ...H
        }),
        l && s6({ ...H }),
        a6({
          ...H,
          apply: ({ elements: _e, rects: Ue, availableWidth: qe, availableHeight: Ke }) => {
            const { width: dt, height: Rn } = Ue.reference, rt = _e.floating.style;
            rt.setProperty("--radix-popper-available-width", `${qe}px`), rt.setProperty("--radix-popper-available-height", `${Ke}px`), rt.setProperty("--radix-popper-anchor-width", `${dt}px`), rt.setProperty("--radix-popper-anchor-height", `${Rn}px`);
          }
        }),
        S && c6({ element: S, padding: a }),
        x6({ arrowWidth: P, arrowHeight: T }),
        f && l6({ strategy: "referenceHidden", ...H })
      ]
    }), [j, b] = cd(Z), Y = Te(v);
    Ie(() => {
      U && (Y == null || Y());
    }, [U, Y]);
    const Ce = (Q = B.arrow) == null ? void 0 : Q.x, E = (te = B.arrow) == null ? void 0 : te.y, xe = ((se = B.arrow) == null ? void 0 : se.centerOffset) !== 0, [Me, le] = g.useState();
    return Ie(() => {
      C && le(window.getComputedStyle(C).zIndex);
    }, [C]), /* @__PURE__ */ p.jsx(
      "div",
      {
        ref: z.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...W,
          transform: U ? W.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Me,
          "--radix-popper-transform-origin": [
            (re = B.transformOrigin) == null ? void 0 : re.x,
            (ce = B.transformOrigin) == null ? void 0 : ce.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((de = B.hide) == null ? void 0 : de.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ p.jsx(
          g6,
          {
            scope: n,
            placedSide: j,
            onArrowChange: R,
            arrowX: Ce,
            arrowY: E,
            shouldHideArrow: xe,
            children: /* @__PURE__ */ p.jsx(
              $.div,
              {
                "data-side": j,
                "data-align": b,
                ...m,
                ref: w,
                style: {
                  ...m.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: U ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
sd.displayName = fa;
var ad = "PopperArrow", C6 = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, ld = g.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, i = v6(ad, r), s = C6[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ p.jsx(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ p.jsx(
          f6,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
ld.displayName = ad;
function y6(e) {
  return e !== null;
}
var x6 = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var y, C, x;
    const { placement: n, rects: r, middlewareData: o } = t, s = ((y = o.arrow) == null ? void 0 : y.centerOffset) !== 0, a = s ? 0 : e.arrowWidth, l = s ? 0 : e.arrowHeight, [c, u] = cd(n), d = { start: "0%", center: "50%", end: "100%" }[u], f = (((C = o.arrow) == null ? void 0 : C.x) ?? 0) + a / 2, h = (((x = o.arrow) == null ? void 0 : x.y) ?? 0) + l / 2;
    let v = "", m = "";
    return c === "bottom" ? (v = s ? d : `${f}px`, m = `${-l}px`) : c === "top" ? (v = s ? d : `${f}px`, m = `${r.floating.height + l}px`) : c === "right" ? (v = `${-l}px`, m = s ? d : `${h}px`) : c === "left" && (v = `${r.floating.width + l}px`, m = s ? d : `${h}px`), { data: { x: v, y: m } };
  }
});
function cd(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var $o = rd, ha = id, pa = sd, ma = ld, w6 = "Portal", qo = g.forwardRef((e, t) => {
  var a;
  const { container: n, ...r } = e, [o, i] = g.useState(!1);
  Ie(() => i(!0), []);
  const s = n || o && ((a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : a.body);
  return s ? Nu.createPortal(/* @__PURE__ */ p.jsx($.div, { ...r, ref: t }), s) : null;
});
qo.displayName = w6;
function b6(e, t) {
  return g.useReducer((n, r) => t[n][r] ?? n, e);
}
var $e = (e) => {
  const { present: t, children: n } = e, r = A6(t), o = typeof n == "function" ? n({ present: r.isPresent }) : g.Children.only(n), i = fe(r.ref, E6(o));
  return typeof n == "function" || r.isPresent ? g.cloneElement(o, { ref: i }) : null;
};
$e.displayName = "Presence";
function A6(e) {
  const [t, n] = g.useState(), r = g.useRef({}), o = g.useRef(e), i = g.useRef("none"), s = e ? "mounted" : "unmounted", [a, l] = b6(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return g.useEffect(() => {
    const c = Jr(r.current);
    i.current = a === "mounted" ? c : "none";
  }, [a]), Ie(() => {
    const c = r.current, u = o.current;
    if (u !== e) {
      const f = i.current, h = Jr(c);
      e ? l("MOUNT") : h === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && f !== h ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, l]), Ie(() => {
    if (t) {
      let c;
      const u = t.ownerDocument.defaultView ?? window, d = (h) => {
        const m = Jr(r.current).includes(h.animationName);
        if (h.target === t && m && (l("ANIMATION_END"), !o.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, f = (h) => {
        h.target === t && (i.current = Jr(r.current));
      };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(c), t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: g.useCallback((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function Jr(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function E6(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function S6(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Te(e);
  g.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var k6 = "DismissableLayer", ms = "dismissableLayer.update", R6 = "dismissableLayer.pointerDownOutside", P6 = "dismissableLayer.focusOutside", rc, ud = g.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), tr = g.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: s,
      onDismiss: a,
      ...l
    } = e, c = g.useContext(ud), [u, d] = g.useState(null), f = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = g.useState({}), v = fe(t, (P) => d(P)), m = Array.from(c.layers), [y] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), C = m.indexOf(y), x = u ? m.indexOf(u) : -1, w = c.layersWithOutsidePointerEventsDisabled.size > 0, S = x >= C, R = I6((P) => {
      const T = P.target, _ = [...c.branches].some((O) => O.contains(T));
      !S || _ || (o == null || o(P), s == null || s(P), P.defaultPrevented || a == null || a());
    }, f), k = _6((P) => {
      const T = P.target;
      [...c.branches].some((O) => O.contains(T)) || (i == null || i(P), s == null || s(P), P.defaultPrevented || a == null || a());
    }, f);
    return S6((P) => {
      x === c.layers.size - 1 && (r == null || r(P), !P.defaultPrevented && a && (P.preventDefault(), a()));
    }, f), g.useEffect(() => {
      if (u)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (rc = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), oc(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = rc);
        };
    }, [u, f, n, c]), g.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), oc());
    }, [u, c]), g.useEffect(() => {
      const P = () => h({});
      return document.addEventListener(ms, P), () => document.removeEventListener(ms, P);
    }, []), /* @__PURE__ */ p.jsx(
      $.div,
      {
        ...l,
        ref: v,
        style: {
          pointerEvents: w ? S ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: F(e.onFocusCapture, k.onFocusCapture),
        onBlurCapture: F(e.onBlurCapture, k.onBlurCapture),
        onPointerDownCapture: F(
          e.onPointerDownCapture,
          R.onPointerDownCapture
        )
      }
    );
  }
);
tr.displayName = k6;
var T6 = "DismissableLayerBranch", M6 = g.forwardRef((e, t) => {
  const n = g.useContext(ud), r = g.useRef(null), o = fe(t, r);
  return g.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ p.jsx($.div, { ...e, ref: o });
});
M6.displayName = T6;
function I6(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Te(e), r = g.useRef(!1), o = g.useRef(() => {
  });
  return g.useEffect(() => {
    const i = (a) => {
      if (a.target && !r.current) {
        let l = function() {
          dd(
            R6,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: a };
        a.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function _6(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Te(e), r = g.useRef(!1);
  return g.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && dd(P6, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function oc() {
  const e = new CustomEvent(ms);
  document.dispatchEvent(e);
}
function dd(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Ro(o, i) : o.dispatchEvent(i);
}
var Pi, ga = "HoverCard", [fd, RS] = En(ga, [
  er
]), Xo = er(), [L6, va] = fd(ga), hd = (e) => {
  const {
    __scopeHoverCard: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    openDelay: s = 700,
    closeDelay: a = 300
  } = e, l = Xo(t), c = g.useRef(0), u = g.useRef(0), d = g.useRef(!1), f = g.useRef(!1), [h = !1, v] = Et({
    prop: r,
    defaultProp: o,
    onChange: i
  }), m = g.useCallback(() => {
    clearTimeout(u.current), c.current = window.setTimeout(() => v(!0), s);
  }, [s, v]), y = g.useCallback(() => {
    clearTimeout(c.current), !d.current && !f.current && (u.current = window.setTimeout(() => v(!1), a));
  }, [a, v]), C = g.useCallback(() => v(!1), [v]);
  return g.useEffect(() => () => {
    clearTimeout(c.current), clearTimeout(u.current);
  }, []), /* @__PURE__ */ p.jsx(
    L6,
    {
      scope: t,
      open: h,
      onOpenChange: v,
      onOpen: m,
      onClose: y,
      onDismiss: C,
      hasSelectionRef: d,
      isPointerDownOnContentRef: f,
      children: /* @__PURE__ */ p.jsx($o, { ...l, children: n })
    }
  );
};
hd.displayName = ga;
var pd = "HoverCardTrigger", md = g.forwardRef(
  (e, t) => {
    const { __scopeHoverCard: n, ...r } = e, o = va(pd, n), i = Xo(n);
    return /* @__PURE__ */ p.jsx(ha, { asChild: !0, ...i, children: /* @__PURE__ */ p.jsx(
      $.a,
      {
        "data-state": o.open ? "open" : "closed",
        ...r,
        ref: t,
        onPointerEnter: F(e.onPointerEnter, To(o.onOpen)),
        onPointerLeave: F(e.onPointerLeave, To(o.onClose)),
        onFocus: F(e.onFocus, o.onOpen),
        onBlur: F(e.onBlur, o.onClose),
        onTouchStart: F(e.onTouchStart, (s) => s.preventDefault())
      }
    ) });
  }
);
md.displayName = pd;
var N6 = "HoverCardPortal", [PS, D6] = fd(N6, {
  forceMount: void 0
}), Po = "HoverCardContent", gd = g.forwardRef(
  (e, t) => {
    const n = D6(Po, e.__scopeHoverCard), { forceMount: r = n.forceMount, ...o } = e, i = va(Po, e.__scopeHoverCard);
    return /* @__PURE__ */ p.jsx($e, { present: r || i.open, children: /* @__PURE__ */ p.jsx(
      O6,
      {
        "data-state": i.open ? "open" : "closed",
        ...o,
        onPointerEnter: F(e.onPointerEnter, To(i.onOpen)),
        onPointerLeave: F(e.onPointerLeave, To(i.onClose)),
        ref: t
      }
    ) });
  }
);
gd.displayName = Po;
var O6 = g.forwardRef((e, t) => {
  const {
    __scopeHoverCard: n,
    onEscapeKeyDown: r,
    onPointerDownOutside: o,
    onFocusOutside: i,
    onInteractOutside: s,
    ...a
  } = e, l = va(Po, n), c = Xo(n), u = g.useRef(null), d = fe(t, u), [f, h] = g.useState(!1);
  return g.useEffect(() => {
    if (f) {
      const v = document.body;
      return Pi = v.style.userSelect || v.style.webkitUserSelect, v.style.userSelect = "none", v.style.webkitUserSelect = "none", () => {
        v.style.userSelect = Pi, v.style.webkitUserSelect = Pi;
      };
    }
  }, [f]), g.useEffect(() => {
    if (u.current) {
      const v = () => {
        h(!1), l.isPointerDownOnContentRef.current = !1, setTimeout(() => {
          var y;
          ((y = document.getSelection()) == null ? void 0 : y.toString()) !== "" && (l.hasSelectionRef.current = !0);
        });
      };
      return document.addEventListener("pointerup", v), () => {
        document.removeEventListener("pointerup", v), l.hasSelectionRef.current = !1, l.isPointerDownOnContentRef.current = !1;
      };
    }
  }, [l.isPointerDownOnContentRef, l.hasSelectionRef]), g.useEffect(() => {
    u.current && F6(u.current).forEach((m) => m.setAttribute("tabindex", "-1"));
  }), /* @__PURE__ */ p.jsx(
    tr,
    {
      asChild: !0,
      disableOutsidePointerEvents: !1,
      onInteractOutside: s,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: F(i, (v) => {
        v.preventDefault();
      }),
      onDismiss: l.onDismiss,
      children: /* @__PURE__ */ p.jsx(
        pa,
        {
          ...c,
          ...a,
          onPointerDown: F(a.onPointerDown, (v) => {
            v.currentTarget.contains(v.target) && h(!0), l.hasSelectionRef.current = !1, l.isPointerDownOnContentRef.current = !0;
          }),
          ref: d,
          style: {
            ...a.style,
            userSelect: f ? "text" : void 0,
            // Safari requires prefix
            WebkitUserSelect: f ? "text" : void 0,
            "--radix-hover-card-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-hover-card-content-available-width": "var(--radix-popper-available-width)",
            "--radix-hover-card-content-available-height": "var(--radix-popper-available-height)",
            "--radix-hover-card-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-hover-card-trigger-height": "var(--radix-popper-anchor-height)"
          }
        }
      )
    }
  );
}), j6 = "HoverCardArrow", V6 = g.forwardRef(
  (e, t) => {
    const { __scopeHoverCard: n, ...r } = e, o = Xo(n);
    return /* @__PURE__ */ p.jsx(ma, { ...o, ...r, ref: t });
  }
);
V6.displayName = j6;
function To(e) {
  return (t) => t.pointerType === "touch" ? void 0 : e();
}
function F6(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
var B6 = hd, H6 = md, vd = gd;
const z6 = B6, U6 = H6, Cd = g.forwardRef(({ className: e, align: t = "center", sideOffset: n = 4, ...r }, o) => /* @__PURE__ */ p.jsx(
  vd,
  {
    ref: o,
    align: t,
    sideOffset: n,
    className: ee(
      "bg-white z-50 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...r
  }
));
Cd.displayName = vd.displayName;
function Vr(e) {
  const t = e + "CollectionProvider", [n, r] = ua(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (h) => {
    const { scope: v, children: m } = h, y = Ye.useRef(null), C = Ye.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ p.jsx(o, { scope: v, itemMap: C, collectionRef: y, children: m });
  };
  s.displayName = t;
  const a = e + "CollectionSlot", l = Ye.forwardRef(
    (h, v) => {
      const { scope: m, children: y } = h, C = i(a, m), x = fe(v, C.collectionRef);
      return /* @__PURE__ */ p.jsx(Zt, { ref: x, children: y });
    }
  );
  l.displayName = a;
  const c = e + "CollectionItemSlot", u = "data-radix-collection-item", d = Ye.forwardRef(
    (h, v) => {
      const { scope: m, children: y, ...C } = h, x = Ye.useRef(null), w = fe(v, x), S = i(c, m);
      return Ye.useEffect(() => (S.itemMap.set(x, { ref: x, ...C }), () => void S.itemMap.delete(x))), /* @__PURE__ */ p.jsx(Zt, { [u]: "", ref: w, children: y });
    }
  );
  d.displayName = c;
  function f(h) {
    const v = i(e + "CollectionConsumer", h);
    return Ye.useCallback(() => {
      const y = v.collectionRef.current;
      if (!y) return [];
      const C = Array.from(y.querySelectorAll(`[${u}]`));
      return Array.from(v.itemMap.values()).sort(
        (S, R) => C.indexOf(S.ref.current) - C.indexOf(R.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: s, Slot: l, ItemSlot: d },
    f,
    r
  ];
}
var K6 = g.createContext(void 0);
function Fr(e) {
  const t = g.useContext(K6);
  return e || t || "ltr";
}
var Ti = 0;
function Ca() {
  g.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? ic()), document.body.insertAdjacentElement("beforeend", e[1] ?? ic()), Ti++, () => {
      Ti === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Ti--;
    };
  }, []);
}
function ic() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Mi = "focusScope.autoFocusOnMount", Ii = "focusScope.autoFocusOnUnmount", sc = { bubbles: !1, cancelable: !0 }, W6 = "FocusScope", Yo = g.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...s
  } = e, [a, l] = g.useState(null), c = Te(o), u = Te(i), d = g.useRef(null), f = fe(t, (m) => l(m)), h = g.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  g.useEffect(() => {
    if (r) {
      let m = function(w) {
        if (h.paused || !a) return;
        const S = w.target;
        a.contains(S) ? d.current = S : Ht(d.current, { select: !0 });
      }, y = function(w) {
        if (h.paused || !a) return;
        const S = w.relatedTarget;
        S !== null && (a.contains(S) || Ht(d.current, { select: !0 }));
      }, C = function(w) {
        if (document.activeElement === document.body)
          for (const R of w)
            R.removedNodes.length > 0 && Ht(a);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", y);
      const x = new MutationObserver(C);
      return a && x.observe(a, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", y), x.disconnect();
      };
    }
  }, [r, a, h.paused]), g.useEffect(() => {
    if (a) {
      lc.add(h);
      const m = document.activeElement;
      if (!a.contains(m)) {
        const C = new CustomEvent(Mi, sc);
        a.addEventListener(Mi, c), a.dispatchEvent(C), C.defaultPrevented || (Z6(X6(yd(a)), { select: !0 }), document.activeElement === m && Ht(a));
      }
      return () => {
        a.removeEventListener(Mi, c), setTimeout(() => {
          const C = new CustomEvent(Ii, sc);
          a.addEventListener(Ii, u), a.dispatchEvent(C), C.defaultPrevented || Ht(m ?? document.body, { select: !0 }), a.removeEventListener(Ii, u), lc.remove(h);
        }, 0);
      };
    }
  }, [a, c, u, h]);
  const v = g.useCallback(
    (m) => {
      if (!n && !r || h.paused) return;
      const y = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, C = document.activeElement;
      if (y && C) {
        const x = m.currentTarget, [w, S] = Q6(x);
        w && S ? !m.shiftKey && C === S ? (m.preventDefault(), n && Ht(w, { select: !0 })) : m.shiftKey && C === w && (m.preventDefault(), n && Ht(S, { select: !0 })) : C === x && m.preventDefault();
      }
    },
    [n, r, h.paused]
  );
  return /* @__PURE__ */ p.jsx($.div, { tabIndex: -1, ...s, ref: f, onKeyDown: v });
});
Yo.displayName = W6;
function Z6(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Ht(r, { select: t }), document.activeElement !== n) return;
}
function Q6(e) {
  const t = yd(e), n = ac(t, e), r = ac(t.reverse(), e);
  return [n, r];
}
function yd(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function ac(e, t) {
  for (const n of e)
    if (!G6(n, { upTo: t })) return n;
}
function G6(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function $6(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Ht(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && $6(e) && t && e.select();
  }
}
var lc = q6();
function q6() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = cc(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = cc(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function cc(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function X6(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Y6 = g.useId || (() => {
}), J6 = 0;
function Qe(e) {
  const [t, n] = g.useState(Y6());
  return Ie(() => {
    e || n((r) => r ?? String(J6++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var _i = "rovingFocusGroup.onEntryFocus", em = { bubbles: !1, cancelable: !0 }, Jo = "RovingFocusGroup", [gs, xd, tm] = Vr(Jo), [nm, ei] = ua(
  Jo,
  [tm]
), [rm, om] = nm(Jo), wd = g.forwardRef(
  (e, t) => /* @__PURE__ */ p.jsx(gs.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ p.jsx(gs.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ p.jsx(im, { ...e, ref: t }) }) })
);
wd.displayName = Jo;
var im = g.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: i,
    currentTabStopId: s,
    defaultCurrentTabStopId: a,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...d
  } = e, f = g.useRef(null), h = fe(t, f), v = Fr(i), [m = null, y] = Et({
    prop: s,
    defaultProp: a,
    onChange: l
  }), [C, x] = g.useState(!1), w = Te(c), S = xd(n), R = g.useRef(!1), [k, P] = g.useState(0);
  return g.useEffect(() => {
    const T = f.current;
    if (T)
      return T.addEventListener(_i, w), () => T.removeEventListener(_i, w);
  }, [w]), /* @__PURE__ */ p.jsx(
    rm,
    {
      scope: n,
      orientation: r,
      dir: v,
      loop: o,
      currentTabStopId: m,
      onItemFocus: g.useCallback(
        (T) => y(T),
        [y]
      ),
      onItemShiftTab: g.useCallback(() => x(!0), []),
      onFocusableItemAdd: g.useCallback(
        () => P((T) => T + 1),
        []
      ),
      onFocusableItemRemove: g.useCallback(
        () => P((T) => T - 1),
        []
      ),
      children: /* @__PURE__ */ p.jsx(
        $.div,
        {
          tabIndex: C || k === 0 ? -1 : 0,
          "data-orientation": r,
          ...d,
          ref: h,
          style: { outline: "none", ...e.style },
          onMouseDown: F(e.onMouseDown, () => {
            R.current = !0;
          }),
          onFocus: F(e.onFocus, (T) => {
            const _ = !R.current;
            if (T.target === T.currentTarget && _ && !C) {
              const O = new CustomEvent(_i, em);
              if (T.currentTarget.dispatchEvent(O), !O.defaultPrevented) {
                const L = S().filter((Z) => Z.focusable), I = L.find((Z) => Z.active), H = L.find((Z) => Z.id === m), W = [I, H, ...L].filter(
                  Boolean
                ).map((Z) => Z.ref.current);
                Ed(W, u);
              }
            }
            R.current = !1;
          }),
          onBlur: F(e.onBlur, () => x(!1))
        }
      )
    }
  );
}), bd = "RovingFocusGroupItem", Ad = g.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: i,
      ...s
    } = e, a = Qe(), l = i || a, c = om(bd, n), u = c.currentTabStopId === l, d = xd(n), { onFocusableItemAdd: f, onFocusableItemRemove: h } = c;
    return g.useEffect(() => {
      if (r)
        return f(), () => h();
    }, [r, f, h]), /* @__PURE__ */ p.jsx(
      gs.ItemSlot,
      {
        scope: n,
        id: l,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ p.jsx(
          $.span,
          {
            tabIndex: u ? 0 : -1,
            "data-orientation": c.orientation,
            ...s,
            ref: t,
            onMouseDown: F(e.onMouseDown, (v) => {
              r ? c.onItemFocus(l) : v.preventDefault();
            }),
            onFocus: F(e.onFocus, () => c.onItemFocus(l)),
            onKeyDown: F(e.onKeyDown, (v) => {
              if (v.key === "Tab" && v.shiftKey) {
                c.onItemShiftTab();
                return;
              }
              if (v.target !== v.currentTarget) return;
              const m = lm(v, c.orientation, c.dir);
              if (m !== void 0) {
                if (v.metaKey || v.ctrlKey || v.altKey || v.shiftKey) return;
                v.preventDefault();
                let C = d().filter((x) => x.focusable).map((x) => x.ref.current);
                if (m === "last") C.reverse();
                else if (m === "prev" || m === "next") {
                  m === "prev" && C.reverse();
                  const x = C.indexOf(v.currentTarget);
                  C = c.loop ? cm(C, x + 1) : C.slice(x + 1);
                }
                setTimeout(() => Ed(C));
              }
            })
          }
        )
      }
    );
  }
);
Ad.displayName = bd;
var sm = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function am(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function lm(e, t, n) {
  const r = am(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return sm[r];
}
function Ed(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function cm(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var Sd = wd, kd = Ad, um = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, In = /* @__PURE__ */ new WeakMap(), eo = /* @__PURE__ */ new WeakMap(), to = {}, Li = 0, Rd = function(e) {
  return e && (e.host || Rd(e.parentNode));
}, dm = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Rd(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, fm = function(e, t, n, r) {
  var o = dm(t, Array.isArray(e) ? e : [e]);
  to[n] || (to[n] = /* @__PURE__ */ new WeakMap());
  var i = to[n], s = [], a = /* @__PURE__ */ new Set(), l = new Set(o), c = function(d) {
    !d || a.has(d) || (a.add(d), c(d.parentNode));
  };
  o.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(f) {
      if (a.has(f))
        u(f);
      else
        try {
          var h = f.getAttribute(r), v = h !== null && h !== "false", m = (In.get(f) || 0) + 1, y = (i.get(f) || 0) + 1;
          In.set(f, m), i.set(f, y), s.push(f), m === 1 && v && eo.set(f, !0), y === 1 && f.setAttribute(n, "true"), v || f.setAttribute(r, "true");
        } catch (C) {
          console.error("aria-hidden: cannot operate on ", f, C);
        }
    });
  };
  return u(t), a.clear(), Li++, function() {
    s.forEach(function(d) {
      var f = In.get(d) - 1, h = i.get(d) - 1;
      In.set(d, f), i.set(d, h), f || (eo.has(d) || d.removeAttribute(r), eo.delete(d)), h || d.removeAttribute(n);
    }), Li--, Li || (In = /* @__PURE__ */ new WeakMap(), In = /* @__PURE__ */ new WeakMap(), eo = /* @__PURE__ */ new WeakMap(), to = {});
  };
}, ya = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = um(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), fm(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, yt = function() {
  return yt = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, yt.apply(this, arguments);
};
function Pd(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function hm(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, i; r < o; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var mo = "right-scroll-bar-position", go = "width-before-scroll-bar", pm = "with-scroll-bars-hidden", mm = "--removed-body-scroll-bar-size";
function Ni(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function gm(e, t) {
  var n = Sr(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var vm = typeof window < "u" ? g.useLayoutEffect : g.useEffect, uc = /* @__PURE__ */ new WeakMap();
function Cm(e, t) {
  var n = gm(null, function(r) {
    return e.forEach(function(o) {
      return Ni(o, r);
    });
  });
  return vm(function() {
    var r = uc.get(n);
    if (r) {
      var o = new Set(r), i = new Set(e), s = n.current;
      o.forEach(function(a) {
        i.has(a) || Ni(a, null);
      }), i.forEach(function(a) {
        o.has(a) || Ni(a, s);
      });
    }
    uc.set(n, e);
  }, [e]), n;
}
function ym(e) {
  return e;
}
function xm(e, t) {
  t === void 0 && (t = ym);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var s = t(i, r);
      return n.push(s), function() {
        n = n.filter(function(a) {
          return a !== s;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(i);
      }
      n = {
        push: function(a) {
          return i(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var s = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(i), s = n;
      }
      var l = function() {
        var u = s;
        s = [], u.forEach(i);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(u) {
          s.push(u), c();
        },
        filter: function(u) {
          return s = s.filter(u), n;
        }
      };
    }
  };
  return o;
}
function wm(e) {
  e === void 0 && (e = {});
  var t = xm(null);
  return t.options = yt({ async: !0, ssr: !1 }, e), t;
}
var Td = function(e) {
  var t = e.sideCar, n = Pd(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return g.createElement(r, yt({}, n));
};
Td.isSideCarExport = !0;
function bm(e, t) {
  return e.useMedium(t), Td;
}
var Md = wm(), Di = function() {
}, ti = g.forwardRef(function(e, t) {
  var n = g.useRef(null), r = g.useState({
    onScrollCapture: Di,
    onWheelCapture: Di,
    onTouchMoveCapture: Di
  }), o = r[0], i = r[1], s = e.forwardProps, a = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, h = e.noIsolation, v = e.inert, m = e.allowPinchZoom, y = e.as, C = y === void 0 ? "div" : y, x = e.gapMode, w = Pd(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), S = f, R = Cm([n, t]), k = yt(yt({}, w), o);
  return g.createElement(
    g.Fragment,
    null,
    u && g.createElement(S, { sideCar: Md, removeScrollBar: c, shards: d, noIsolation: h, inert: v, setCallbacks: i, allowPinchZoom: !!m, lockRef: n, gapMode: x }),
    s ? g.cloneElement(g.Children.only(a), yt(yt({}, k), { ref: R })) : g.createElement(C, yt({}, k, { className: l, ref: R }), a)
  );
});
ti.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
ti.classNames = {
  fullWidth: go,
  zeroRight: mo
};
var Am = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Em() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Am();
  return t && e.setAttribute("nonce", t), e;
}
function Sm(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function km(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Rm = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Em()) && (Sm(t, n), km(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Pm = function() {
  var e = Rm();
  return function(t, n) {
    g.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Id = function() {
  var e = Pm(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, Tm = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Oi = function(e) {
  return parseInt(e || "", 10) || 0;
}, Mm = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Oi(n), Oi(r), Oi(o)];
}, Im = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Tm;
  var t = Mm(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, _m = Id(), zn = "data-scroll-locked", Lm = function(e, t, n, r) {
  var o = e.left, i = e.top, s = e.right, a = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(pm, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(a, "px ").concat(r, `;
  }
  body[`).concat(zn, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(mo, ` {
    right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(go, ` {
    margin-right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(mo, " .").concat(mo, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(go, " .").concat(go, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(zn, `] {
    `).concat(mm, ": ").concat(a, `px;
  }
`);
}, dc = function() {
  var e = parseInt(document.body.getAttribute(zn) || "0", 10);
  return isFinite(e) ? e : 0;
}, Nm = function() {
  g.useEffect(function() {
    return document.body.setAttribute(zn, (dc() + 1).toString()), function() {
      var e = dc() - 1;
      e <= 0 ? document.body.removeAttribute(zn) : document.body.setAttribute(zn, e.toString());
    };
  }, []);
}, Dm = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  Nm();
  var i = g.useMemo(function() {
    return Im(o);
  }, [o]);
  return g.createElement(_m, { styles: Lm(i, !t, o, n ? "" : "!important") });
}, vs = !1;
if (typeof window < "u")
  try {
    var no = Object.defineProperty({}, "passive", {
      get: function() {
        return vs = !0, !0;
      }
    });
    window.addEventListener("test", no, no), window.removeEventListener("test", no, no);
  } catch {
    vs = !1;
  }
var _n = vs ? { passive: !1 } : !1, Om = function(e) {
  return e.tagName === "TEXTAREA";
}, _d = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Om(e) && n[t] === "visible")
  );
}, jm = function(e) {
  return _d(e, "overflowY");
}, Vm = function(e) {
  return _d(e, "overflowX");
}, fc = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = Ld(e, r);
    if (o) {
      var i = Nd(e, r), s = i[1], a = i[2];
      if (s > a)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, Fm = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Bm = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Ld = function(e, t) {
  return e === "v" ? jm(t) : Vm(t);
}, Nd = function(e, t) {
  return e === "v" ? Fm(t) : Bm(t);
}, Hm = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, zm = function(e, t, n, r, o) {
  var i = Hm(e, window.getComputedStyle(t).direction), s = i * r, a = n.target, l = t.contains(a), c = !1, u = s > 0, d = 0, f = 0;
  do {
    var h = Nd(e, a), v = h[0], m = h[1], y = h[2], C = m - y - i * v;
    (v || C) && Ld(e, a) && (d += C, f += v), a instanceof ShadowRoot ? a = a.host : a = a.parentNode;
  } while (
    // portaled content
    !l && a !== document.body || // self content
    l && (t.contains(a) || t === a)
  );
  return (u && (Math.abs(d) < 1 || !o) || !u && (Math.abs(f) < 1 || !o)) && (c = !0), c;
}, ro = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, hc = function(e) {
  return [e.deltaX, e.deltaY];
}, pc = function(e) {
  return e && "current" in e ? e.current : e;
}, Um = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Km = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Wm = 0, Ln = [];
function Zm(e) {
  var t = g.useRef([]), n = g.useRef([0, 0]), r = g.useRef(), o = g.useState(Wm++)[0], i = g.useState(Id)[0], s = g.useRef(e);
  g.useEffect(function() {
    s.current = e;
  }, [e]), g.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var m = hm([e.lockRef.current], (e.shards || []).map(pc), !0).filter(Boolean);
      return m.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), m.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = g.useCallback(function(m, y) {
    if ("touches" in m && m.touches.length === 2 || m.type === "wheel" && m.ctrlKey)
      return !s.current.allowPinchZoom;
    var C = ro(m), x = n.current, w = "deltaX" in m ? m.deltaX : x[0] - C[0], S = "deltaY" in m ? m.deltaY : x[1] - C[1], R, k = m.target, P = Math.abs(w) > Math.abs(S) ? "h" : "v";
    if ("touches" in m && P === "h" && k.type === "range")
      return !1;
    var T = fc(P, k);
    if (!T)
      return !0;
    if (T ? R = P : (R = P === "v" ? "h" : "v", T = fc(P, k)), !T)
      return !1;
    if (!r.current && "changedTouches" in m && (w || S) && (r.current = R), !R)
      return !0;
    var _ = r.current || R;
    return zm(_, y, m, _ === "h" ? w : S, !0);
  }, []), l = g.useCallback(function(m) {
    var y = m;
    if (!(!Ln.length || Ln[Ln.length - 1] !== i)) {
      var C = "deltaY" in y ? hc(y) : ro(y), x = t.current.filter(function(R) {
        return R.name === y.type && (R.target === y.target || y.target === R.shadowParent) && Um(R.delta, C);
      })[0];
      if (x && x.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!x) {
        var w = (s.current.shards || []).map(pc).filter(Boolean).filter(function(R) {
          return R.contains(y.target);
        }), S = w.length > 0 ? a(y, w[0]) : !s.current.noIsolation;
        S && y.cancelable && y.preventDefault();
      }
    }
  }, []), c = g.useCallback(function(m, y, C, x) {
    var w = { name: m, delta: y, target: C, should: x, shadowParent: Qm(C) };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(S) {
        return S !== w;
      });
    }, 1);
  }, []), u = g.useCallback(function(m) {
    n.current = ro(m), r.current = void 0;
  }, []), d = g.useCallback(function(m) {
    c(m.type, hc(m), m.target, a(m, e.lockRef.current));
  }, []), f = g.useCallback(function(m) {
    c(m.type, ro(m), m.target, a(m, e.lockRef.current));
  }, []);
  g.useEffect(function() {
    return Ln.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", l, _n), document.addEventListener("touchmove", l, _n), document.addEventListener("touchstart", u, _n), function() {
      Ln = Ln.filter(function(m) {
        return m !== i;
      }), document.removeEventListener("wheel", l, _n), document.removeEventListener("touchmove", l, _n), document.removeEventListener("touchstart", u, _n);
    };
  }, []);
  var h = e.removeScrollBar, v = e.inert;
  return g.createElement(
    g.Fragment,
    null,
    v ? g.createElement(i, { styles: Km(o) }) : null,
    h ? g.createElement(Dm, { gapMode: e.gapMode }) : null
  );
}
function Qm(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Gm = bm(Md, Zm);
var ni = g.forwardRef(function(e, t) {
  return g.createElement(ti, yt({}, e, { ref: t, sideCar: Gm }));
});
ni.classNames = ti.classNames;
var Cs = ["Enter", " "], $m = ["ArrowDown", "PageUp", "Home"], Dd = ["ArrowUp", "PageDown", "End"], qm = [...$m, ...Dd], Xm = {
  ltr: [...Cs, "ArrowRight"],
  rtl: [...Cs, "ArrowLeft"]
}, Ym = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Br = "Menu", [Pr, Jm, e9] = Vr(Br), [Sn, Od] = En(Br, [
  e9,
  er,
  ei
]), Hr = er(), jd = ei(), [Vd, en] = Sn(Br), [t9, zr] = Sn(Br), Fd = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: o, onOpenChange: i, modal: s = !0 } = e, a = Hr(t), [l, c] = g.useState(null), u = g.useRef(!1), d = Te(i), f = Fr(o);
  return g.useEffect(() => {
    const h = () => {
      u.current = !0, document.addEventListener("pointerdown", v, { capture: !0, once: !0 }), document.addEventListener("pointermove", v, { capture: !0, once: !0 });
    }, v = () => u.current = !1;
    return document.addEventListener("keydown", h, { capture: !0 }), () => {
      document.removeEventListener("keydown", h, { capture: !0 }), document.removeEventListener("pointerdown", v, { capture: !0 }), document.removeEventListener("pointermove", v, { capture: !0 });
    };
  }, []), /* @__PURE__ */ p.jsx($o, { ...a, children: /* @__PURE__ */ p.jsx(
    Vd,
    {
      scope: t,
      open: n,
      onOpenChange: d,
      content: l,
      onContentChange: c,
      children: /* @__PURE__ */ p.jsx(
        t9,
        {
          scope: t,
          onClose: g.useCallback(() => d(!1), [d]),
          isUsingKeyboardRef: u,
          dir: f,
          modal: s,
          children: r
        }
      )
    }
  ) });
};
Fd.displayName = Br;
var n9 = "MenuAnchor", xa = g.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Hr(n);
    return /* @__PURE__ */ p.jsx(ha, { ...o, ...r, ref: t });
  }
);
xa.displayName = n9;
var wa = "MenuPortal", [r9, Bd] = Sn(wa, {
  forceMount: void 0
}), Hd = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: o } = e, i = en(wa, t);
  return /* @__PURE__ */ p.jsx(r9, { scope: t, forceMount: n, children: /* @__PURE__ */ p.jsx($e, { present: n || i.open, children: /* @__PURE__ */ p.jsx(qo, { asChild: !0, container: o, children: r }) }) });
};
Hd.displayName = wa;
var lt = "MenuContent", [o9, ba] = Sn(lt), zd = g.forwardRef(
  (e, t) => {
    const n = Bd(lt, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = en(lt, e.__scopeMenu), s = zr(lt, e.__scopeMenu);
    return /* @__PURE__ */ p.jsx(Pr.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ p.jsx($e, { present: r || i.open, children: /* @__PURE__ */ p.jsx(Pr.Slot, { scope: e.__scopeMenu, children: s.modal ? /* @__PURE__ */ p.jsx(i9, { ...o, ref: t }) : /* @__PURE__ */ p.jsx(s9, { ...o, ref: t }) }) }) });
  }
), i9 = g.forwardRef(
  (e, t) => {
    const n = en(lt, e.__scopeMenu), r = g.useRef(null), o = fe(t, r);
    return g.useEffect(() => {
      const i = r.current;
      if (i) return ya(i);
    }, []), /* @__PURE__ */ p.jsx(
      Aa,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: F(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), s9 = g.forwardRef((e, t) => {
  const n = en(lt, e.__scopeMenu);
  return /* @__PURE__ */ p.jsx(
    Aa,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), Aa = g.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: o,
      onOpenAutoFocus: i,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: a,
      onEntryFocus: l,
      onEscapeKeyDown: c,
      onPointerDownOutside: u,
      onFocusOutside: d,
      onInteractOutside: f,
      onDismiss: h,
      disableOutsideScroll: v,
      ...m
    } = e, y = en(lt, n), C = zr(lt, n), x = Hr(n), w = jd(n), S = Jm(n), [R, k] = g.useState(null), P = g.useRef(null), T = fe(t, P, y.onContentChange), _ = g.useRef(0), O = g.useRef(""), L = g.useRef(0), I = g.useRef(null), H = g.useRef("right"), z = g.useRef(0), W = v ? ni : g.Fragment, Z = v ? { as: Zt, allowPinchZoom: !0 } : void 0, U = (j) => {
      var Q, te;
      const b = O.current + j, Y = S().filter((se) => !se.disabled), Ce = document.activeElement, E = (Q = Y.find((se) => se.ref.current === Ce)) == null ? void 0 : Q.textValue, xe = Y.map((se) => se.textValue), Me = C9(xe, b, E), le = (te = Y.find((se) => se.textValue === Me)) == null ? void 0 : te.ref.current;
      (function se(re) {
        O.current = re, window.clearTimeout(_.current), re !== "" && (_.current = window.setTimeout(() => se(""), 1e3));
      })(b), le && setTimeout(() => le.focus());
    };
    g.useEffect(() => () => window.clearTimeout(_.current), []), Ca();
    const B = g.useCallback((j) => {
      var Y, Ce;
      return H.current === ((Y = I.current) == null ? void 0 : Y.side) && x9(j, (Ce = I.current) == null ? void 0 : Ce.area);
    }, []);
    return /* @__PURE__ */ p.jsx(
      o9,
      {
        scope: n,
        searchRef: O,
        onItemEnter: g.useCallback(
          (j) => {
            B(j) && j.preventDefault();
          },
          [B]
        ),
        onItemLeave: g.useCallback(
          (j) => {
            var b;
            B(j) || ((b = P.current) == null || b.focus(), k(null));
          },
          [B]
        ),
        onTriggerLeave: g.useCallback(
          (j) => {
            B(j) && j.preventDefault();
          },
          [B]
        ),
        pointerGraceTimerRef: L,
        onPointerGraceIntentChange: g.useCallback((j) => {
          I.current = j;
        }, []),
        children: /* @__PURE__ */ p.jsx(W, { ...Z, children: /* @__PURE__ */ p.jsx(
          Yo,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: F(i, (j) => {
              var b;
              j.preventDefault(), (b = P.current) == null || b.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: s,
            children: /* @__PURE__ */ p.jsx(
              tr,
              {
                asChild: !0,
                disableOutsidePointerEvents: a,
                onEscapeKeyDown: c,
                onPointerDownOutside: u,
                onFocusOutside: d,
                onInteractOutside: f,
                onDismiss: h,
                children: /* @__PURE__ */ p.jsx(
                  Sd,
                  {
                    asChild: !0,
                    ...w,
                    dir: C.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: R,
                    onCurrentTabStopIdChange: k,
                    onEntryFocus: F(l, (j) => {
                      C.isUsingKeyboardRef.current || j.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ p.jsx(
                      pa,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": sf(y.open),
                        "data-radix-menu-content": "",
                        dir: C.dir,
                        ...x,
                        ...m,
                        ref: T,
                        style: { outline: "none", ...m.style },
                        onKeyDown: F(m.onKeyDown, (j) => {
                          const Y = j.target.closest("[data-radix-menu-content]") === j.currentTarget, Ce = j.ctrlKey || j.altKey || j.metaKey, E = j.key.length === 1;
                          Y && (j.key === "Tab" && j.preventDefault(), !Ce && E && U(j.key));
                          const xe = P.current;
                          if (j.target !== xe || !qm.includes(j.key)) return;
                          j.preventDefault();
                          const le = S().filter((Q) => !Q.disabled).map((Q) => Q.ref.current);
                          Dd.includes(j.key) && le.reverse(), g9(le);
                        }),
                        onBlur: F(e.onBlur, (j) => {
                          j.currentTarget.contains(j.target) || (window.clearTimeout(_.current), O.current = "");
                        }),
                        onPointerMove: F(
                          e.onPointerMove,
                          Tr((j) => {
                            const b = j.target, Y = z.current !== j.clientX;
                            if (j.currentTarget.contains(b) && Y) {
                              const Ce = j.clientX > z.current ? "right" : "left";
                              H.current = Ce, z.current = j.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
zd.displayName = lt;
var a9 = "MenuGroup", Ea = g.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ p.jsx($.div, { role: "group", ...r, ref: t });
  }
);
Ea.displayName = a9;
var l9 = "MenuLabel", Ud = g.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ p.jsx($.div, { ...r, ref: t });
  }
);
Ud.displayName = l9;
var Mo = "MenuItem", mc = "menu.itemSelect", ri = g.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...o } = e, i = g.useRef(null), s = zr(Mo, e.__scopeMenu), a = ba(Mo, e.__scopeMenu), l = fe(t, i), c = g.useRef(!1), u = () => {
      const d = i.current;
      if (!n && d) {
        const f = new CustomEvent(mc, { bubbles: !0, cancelable: !0 });
        d.addEventListener(mc, (h) => r == null ? void 0 : r(h), { once: !0 }), Ro(d, f), f.defaultPrevented ? c.current = !1 : s.onClose();
      }
    };
    return /* @__PURE__ */ p.jsx(
      Kd,
      {
        ...o,
        ref: l,
        disabled: n,
        onClick: F(e.onClick, u),
        onPointerDown: (d) => {
          var f;
          (f = e.onPointerDown) == null || f.call(e, d), c.current = !0;
        },
        onPointerUp: F(e.onPointerUp, (d) => {
          var f;
          c.current || (f = d.currentTarget) == null || f.click();
        }),
        onKeyDown: F(e.onKeyDown, (d) => {
          const f = a.searchRef.current !== "";
          n || f && d.key === " " || Cs.includes(d.key) && (d.currentTarget.click(), d.preventDefault());
        })
      }
    );
  }
);
ri.displayName = Mo;
var Kd = g.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: o, ...i } = e, s = ba(Mo, n), a = jd(n), l = g.useRef(null), c = fe(t, l), [u, d] = g.useState(!1), [f, h] = g.useState("");
    return g.useEffect(() => {
      const v = l.current;
      v && h((v.textContent ?? "").trim());
    }, [i.children]), /* @__PURE__ */ p.jsx(
      Pr.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: o ?? f,
        children: /* @__PURE__ */ p.jsx(kd, { asChild: !0, ...a, focusable: !r, children: /* @__PURE__ */ p.jsx(
          $.div,
          {
            role: "menuitem",
            "data-highlighted": u ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...i,
            ref: c,
            onPointerMove: F(
              e.onPointerMove,
              Tr((v) => {
                r ? s.onItemLeave(v) : (s.onItemEnter(v), v.defaultPrevented || v.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: F(
              e.onPointerLeave,
              Tr((v) => s.onItemLeave(v))
            ),
            onFocus: F(e.onFocus, () => d(!0)),
            onBlur: F(e.onBlur, () => d(!1))
          }
        ) })
      }
    );
  }
), c9 = "MenuCheckboxItem", Wd = g.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...o } = e;
    return /* @__PURE__ */ p.jsx(qd, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ p.jsx(
      ri,
      {
        role: "menuitemcheckbox",
        "aria-checked": Io(n) ? "mixed" : n,
        ...o,
        ref: t,
        "data-state": Ra(n),
        onSelect: F(
          o.onSelect,
          () => r == null ? void 0 : r(Io(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Wd.displayName = c9;
var Zd = "MenuRadioGroup", [u9, d9] = Sn(
  Zd,
  { value: void 0, onValueChange: () => {
  } }
), Qd = g.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...o } = e, i = Te(r);
    return /* @__PURE__ */ p.jsx(u9, { scope: e.__scopeMenu, value: n, onValueChange: i, children: /* @__PURE__ */ p.jsx(Ea, { ...o, ref: t }) });
  }
);
Qd.displayName = Zd;
var Gd = "MenuRadioItem", $d = g.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = d9(Gd, e.__scopeMenu), i = n === o.value;
    return /* @__PURE__ */ p.jsx(qd, { scope: e.__scopeMenu, checked: i, children: /* @__PURE__ */ p.jsx(
      ri,
      {
        role: "menuitemradio",
        "aria-checked": i,
        ...r,
        ref: t,
        "data-state": Ra(i),
        onSelect: F(
          r.onSelect,
          () => {
            var s;
            return (s = o.onValueChange) == null ? void 0 : s.call(o, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
$d.displayName = Gd;
var Sa = "MenuItemIndicator", [qd, f9] = Sn(
  Sa,
  { checked: !1 }
), Xd = g.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...o } = e, i = f9(Sa, n);
    return /* @__PURE__ */ p.jsx(
      $e,
      {
        present: r || Io(i.checked) || i.checked === !0,
        children: /* @__PURE__ */ p.jsx(
          $.span,
          {
            ...o,
            ref: t,
            "data-state": Ra(i.checked)
          }
        )
      }
    );
  }
);
Xd.displayName = Sa;
var h9 = "MenuSeparator", Yd = g.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ p.jsx(
      $.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
Yd.displayName = h9;
var p9 = "MenuArrow", Jd = g.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Hr(n);
    return /* @__PURE__ */ p.jsx(ma, { ...o, ...r, ref: t });
  }
);
Jd.displayName = p9;
var ka = "MenuSub", [m9, ef] = Sn(ka), tf = (e) => {
  const { __scopeMenu: t, children: n, open: r = !1, onOpenChange: o } = e, i = en(ka, t), s = Hr(t), [a, l] = g.useState(null), [c, u] = g.useState(null), d = Te(o);
  return g.useEffect(() => (i.open === !1 && d(!1), () => d(!1)), [i.open, d]), /* @__PURE__ */ p.jsx($o, { ...s, children: /* @__PURE__ */ p.jsx(
    Vd,
    {
      scope: t,
      open: r,
      onOpenChange: d,
      content: c,
      onContentChange: u,
      children: /* @__PURE__ */ p.jsx(
        m9,
        {
          scope: t,
          contentId: Qe(),
          triggerId: Qe(),
          trigger: a,
          onTriggerChange: l,
          children: n
        }
      )
    }
  ) });
};
tf.displayName = ka;
var gr = "MenuSubTrigger", nf = g.forwardRef(
  (e, t) => {
    const n = en(gr, e.__scopeMenu), r = zr(gr, e.__scopeMenu), o = ef(gr, e.__scopeMenu), i = ba(gr, e.__scopeMenu), s = g.useRef(null), { pointerGraceTimerRef: a, onPointerGraceIntentChange: l } = i, c = { __scopeMenu: e.__scopeMenu }, u = g.useCallback(() => {
      s.current && window.clearTimeout(s.current), s.current = null;
    }, []);
    return g.useEffect(() => u, [u]), g.useEffect(() => {
      const d = a.current;
      return () => {
        window.clearTimeout(d), l(null);
      };
    }, [a, l]), /* @__PURE__ */ p.jsx(xa, { asChild: !0, ...c, children: /* @__PURE__ */ p.jsx(
      Kd,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": o.contentId,
        "data-state": sf(n.open),
        ...e,
        ref: Or(t, o.onTriggerChange),
        onClick: (d) => {
          var f;
          (f = e.onClick) == null || f.call(e, d), !(e.disabled || d.defaultPrevented) && (d.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: F(
          e.onPointerMove,
          Tr((d) => {
            i.onItemEnter(d), !d.defaultPrevented && !e.disabled && !n.open && !s.current && (i.onPointerGraceIntentChange(null), s.current = window.setTimeout(() => {
              n.onOpenChange(!0), u();
            }, 100));
          })
        ),
        onPointerLeave: F(
          e.onPointerLeave,
          Tr((d) => {
            var h, v;
            u();
            const f = (h = n.content) == null ? void 0 : h.getBoundingClientRect();
            if (f) {
              const m = (v = n.content) == null ? void 0 : v.dataset.side, y = m === "right", C = y ? -5 : 5, x = f[y ? "left" : "right"], w = f[y ? "right" : "left"];
              i.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: d.clientX + C, y: d.clientY },
                  { x, y: f.top },
                  { x: w, y: f.top },
                  { x: w, y: f.bottom },
                  { x, y: f.bottom }
                ],
                side: m
              }), window.clearTimeout(a.current), a.current = window.setTimeout(
                () => i.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (i.onTriggerLeave(d), d.defaultPrevented) return;
              i.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: F(e.onKeyDown, (d) => {
          var h;
          const f = i.searchRef.current !== "";
          e.disabled || f && d.key === " " || Xm[r.dir].includes(d.key) && (n.onOpenChange(!0), (h = n.content) == null || h.focus(), d.preventDefault());
        })
      }
    ) });
  }
);
nf.displayName = gr;
var rf = "MenuSubContent", of = g.forwardRef(
  (e, t) => {
    const n = Bd(lt, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = en(lt, e.__scopeMenu), s = zr(lt, e.__scopeMenu), a = ef(rf, e.__scopeMenu), l = g.useRef(null), c = fe(t, l);
    return /* @__PURE__ */ p.jsx(Pr.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ p.jsx($e, { present: r || i.open, children: /* @__PURE__ */ p.jsx(Pr.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ p.jsx(
      Aa,
      {
        id: a.contentId,
        "aria-labelledby": a.triggerId,
        ...o,
        ref: c,
        align: "start",
        side: s.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (u) => {
          var d;
          s.isUsingKeyboardRef.current && ((d = l.current) == null || d.focus()), u.preventDefault();
        },
        onCloseAutoFocus: (u) => u.preventDefault(),
        onFocusOutside: F(e.onFocusOutside, (u) => {
          u.target !== a.trigger && i.onOpenChange(!1);
        }),
        onEscapeKeyDown: F(e.onEscapeKeyDown, (u) => {
          s.onClose(), u.preventDefault();
        }),
        onKeyDown: F(e.onKeyDown, (u) => {
          var h;
          const d = u.currentTarget.contains(u.target), f = Ym[s.dir].includes(u.key);
          d && f && (i.onOpenChange(!1), (h = a.trigger) == null || h.focus(), u.preventDefault());
        })
      }
    ) }) }) });
  }
);
of.displayName = rf;
function sf(e) {
  return e ? "open" : "closed";
}
function Io(e) {
  return e === "indeterminate";
}
function Ra(e) {
  return Io(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function g9(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function v9(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function C9(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let s = v9(e, Math.max(i, 0));
  o.length === 1 && (s = s.filter((c) => c !== n));
  const l = s.find(
    (c) => c.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function y9(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, s = t.length - 1; i < t.length; s = i++) {
    const a = t[i].x, l = t[i].y, c = t[s].x, u = t[s].y;
    l > r != u > r && n < (c - a) * (r - l) / (u - l) + a && (o = !o);
  }
  return o;
}
function x9(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return y9(n, t);
}
function Tr(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var w9 = Fd, b9 = xa, A9 = Hd, E9 = zd, S9 = Ea, k9 = Ud, R9 = ri, P9 = Wd, T9 = Qd, M9 = $d, I9 = Xd, _9 = Yd, L9 = Jd, N9 = tf, D9 = nf, O9 = of, Pa = "DropdownMenu", [j9, TS] = En(
  Pa,
  [Od]
), Ve = Od(), [V9, af] = j9(Pa), lf = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: o,
    defaultOpen: i,
    onOpenChange: s,
    modal: a = !0
  } = e, l = Ve(t), c = g.useRef(null), [u = !1, d] = Et({
    prop: o,
    defaultProp: i,
    onChange: s
  });
  return /* @__PURE__ */ p.jsx(
    V9,
    {
      scope: t,
      triggerId: Qe(),
      triggerRef: c,
      contentId: Qe(),
      open: u,
      onOpenChange: d,
      onOpenToggle: g.useCallback(() => d((f) => !f), [d]),
      modal: a,
      children: /* @__PURE__ */ p.jsx(w9, { ...l, open: u, onOpenChange: d, dir: r, modal: a, children: n })
    }
  );
};
lf.displayName = Pa;
var cf = "DropdownMenuTrigger", uf = g.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, i = af(cf, n), s = Ve(n);
    return /* @__PURE__ */ p.jsx(b9, { asChild: !0, ...s, children: /* @__PURE__ */ p.jsx(
      $.button,
      {
        type: "button",
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": i.open,
        "aria-controls": i.open ? i.contentId : void 0,
        "data-state": i.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...o,
        ref: Or(t, i.triggerRef),
        onPointerDown: F(e.onPointerDown, (a) => {
          !r && a.button === 0 && a.ctrlKey === !1 && (i.onOpenToggle(), i.open || a.preventDefault());
        }),
        onKeyDown: F(e.onKeyDown, (a) => {
          r || (["Enter", " "].includes(a.key) && i.onOpenToggle(), a.key === "ArrowDown" && i.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(a.key) && a.preventDefault());
        })
      }
    ) });
  }
);
uf.displayName = cf;
var F9 = "DropdownMenuPortal", df = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = Ve(t);
  return /* @__PURE__ */ p.jsx(A9, { ...r, ...n });
};
df.displayName = F9;
var ff = "DropdownMenuContent", hf = g.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = af(ff, n), i = Ve(n), s = g.useRef(!1);
    return /* @__PURE__ */ p.jsx(
      E9,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...i,
        ...r,
        ref: t,
        onCloseAutoFocus: F(e.onCloseAutoFocus, (a) => {
          var l;
          s.current || (l = o.triggerRef.current) == null || l.focus(), s.current = !1, a.preventDefault();
        }),
        onInteractOutside: F(e.onInteractOutside, (a) => {
          const l = a.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0, u = l.button === 2 || c;
          (!o.modal || u) && (s.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
hf.displayName = ff;
var B9 = "DropdownMenuGroup", pf = g.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Ve(n);
    return /* @__PURE__ */ p.jsx(S9, { ...o, ...r, ref: t });
  }
);
pf.displayName = B9;
var H9 = "DropdownMenuLabel", mf = g.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Ve(n);
    return /* @__PURE__ */ p.jsx(k9, { ...o, ...r, ref: t });
  }
);
mf.displayName = H9;
var z9 = "DropdownMenuItem", gf = g.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Ve(n);
    return /* @__PURE__ */ p.jsx(R9, { ...o, ...r, ref: t });
  }
);
gf.displayName = z9;
var U9 = "DropdownMenuCheckboxItem", vf = g.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Ve(n);
  return /* @__PURE__ */ p.jsx(P9, { ...o, ...r, ref: t });
});
vf.displayName = U9;
var K9 = "DropdownMenuRadioGroup", Cf = g.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Ve(n);
  return /* @__PURE__ */ p.jsx(T9, { ...o, ...r, ref: t });
});
Cf.displayName = K9;
var W9 = "DropdownMenuRadioItem", yf = g.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Ve(n);
  return /* @__PURE__ */ p.jsx(M9, { ...o, ...r, ref: t });
});
yf.displayName = W9;
var Z9 = "DropdownMenuItemIndicator", xf = g.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Ve(n);
  return /* @__PURE__ */ p.jsx(I9, { ...o, ...r, ref: t });
});
xf.displayName = Z9;
var Q9 = "DropdownMenuSeparator", wf = g.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Ve(n);
  return /* @__PURE__ */ p.jsx(_9, { ...o, ...r, ref: t });
});
wf.displayName = Q9;
var G9 = "DropdownMenuArrow", $9 = g.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Ve(n);
    return /* @__PURE__ */ p.jsx(L9, { ...o, ...r, ref: t });
  }
);
$9.displayName = G9;
var q9 = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: o, defaultOpen: i } = e, s = Ve(t), [a = !1, l] = Et({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ p.jsx(N9, { ...s, open: a, onOpenChange: l, children: n });
}, X9 = "DropdownMenuSubTrigger", bf = g.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Ve(n);
  return /* @__PURE__ */ p.jsx(D9, { ...o, ...r, ref: t });
});
bf.displayName = X9;
var Y9 = "DropdownMenuSubContent", Af = g.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Ve(n);
  return /* @__PURE__ */ p.jsx(
    O9,
    {
      ...o,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Af.displayName = Y9;
var J9 = lf, e7 = uf, t7 = df, Ef = hf, n7 = pf, Sf = mf, kf = gf, Rf = vf, r7 = Cf, Pf = yf, Tf = xf, Mf = wf, o7 = q9, If = bf, _f = Af;
/**
 * @license lucide-react v0.396.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i7 = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Lf = (...e) => e.filter((t, n, r) => !!t && r.indexOf(t) === n).join(" ");
/**
 * @license lucide-react v0.396.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var s7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.396.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a7 = Js(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: o = "",
    children: i,
    iconNode: s,
    ...a
  }, l) => Wn(
    "svg",
    {
      ref: l,
      ...s7,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: r ? Number(n) * 24 / Number(t) : n,
      className: Lf("lucide", o),
      ...a
    },
    [
      ...s.map(([c, u]) => Wn(c, u)),
      ...Array.isArray(i) ? i : [i]
    ]
  )
);
/**
 * @license lucide-react v0.396.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ur = (e, t) => {
  const n = Js(
    ({ className: r, ...o }, i) => Wn(a7, {
      ref: i,
      iconNode: t,
      className: Lf(`lucide-${i7(e)}`, r),
      ...o
    })
  );
  return n.displayName = `${e}`, n;
};
/**
 * @license lucide-react v0.396.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l7 = Ur("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.396.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c7 = Ur("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.396.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u7 = Ur("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
/**
 * @license lucide-react v0.396.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d7 = Ur("Circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.396.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f7 = Ur("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]), h7 = J9, p7 = e7, MS = n7, IS = t7, _S = o7, LS = r7, m7 = g.forwardRef(({ className: e, inset: t, children: n, ...r }, o) => /* @__PURE__ */ p.jsxs(
  If,
  {
    ref: o,
    className: ee(
      "flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent",
      t && "pl-8",
      e
    ),
    ...r,
    children: [
      n,
      /* @__PURE__ */ p.jsx(u7, { className: "ml-auto h-4 w-4" })
    ]
  }
));
m7.displayName = If.displayName;
const g7 = g.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  _f,
  {
    ref: n,
    className: ee(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
g7.displayName = _f.displayName;
const Nf = g.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ p.jsx(
  Ef,
  {
    ref: r,
    sideOffset: t,
    className: ee(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...n
  }
));
Nf.displayName = Ef.displayName;
const ys = g.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ p.jsx(
  kf,
  {
    ref: r,
    className: ee(
      "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t && "pl-8",
      e
    ),
    ...n
  }
));
ys.displayName = kf.displayName;
const v7 = g.forwardRef(({ className: e, children: t, checked: n, ...r }, o) => /* @__PURE__ */ p.jsxs(
  Rf,
  {
    ref: o,
    className: ee(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    checked: n,
    ...r,
    children: [
      /* @__PURE__ */ p.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ p.jsx(Tf, { children: /* @__PURE__ */ p.jsx(l7, { className: "h-4 w-4" }) }) }),
      t
    ]
  }
));
v7.displayName = Rf.displayName;
const C7 = g.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ p.jsxs(
  Pf,
  {
    ref: r,
    className: ee(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ p.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ p.jsx(Tf, { children: /* @__PURE__ */ p.jsx(d7, { className: "h-2 w-2 fill-current" }) }) }),
      t
    ]
  }
));
C7.displayName = Pf.displayName;
const y7 = g.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ p.jsx(
  Sf,
  {
    ref: r,
    className: ee(
      "px-2 py-1.5 text-sm font-semibold",
      t && "pl-8",
      e
    ),
    ...n
  }
));
y7.displayName = Sf.displayName;
const x7 = g.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  Mf,
  {
    ref: n,
    className: ee("-mx-1 my-1 h-px bg-muted", e),
    ...t
  }
));
x7.displayName = Mf.displayName;
const w7 = ({
  className: e,
  ...t
}) => /* @__PURE__ */ p.jsx(
  "span",
  {
    className: ee("ml-auto text-xs tracking-widest opacity-60", e),
    ...t
  }
);
w7.displayName = "DropdownMenuShortcut";
function Df(e) {
  const t = g.useRef({ value: e, previous: e });
  return g.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var b7 = "VisuallyHidden", Ta = g.forwardRef(
  (e, t) => /* @__PURE__ */ p.jsx(
    $.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
Ta.displayName = b7;
var A7 = Ta, nr = "NavigationMenu", [Ma, Of, E7] = Vr(nr), [xs, S7, k7] = Vr(nr), [Ia, NS] = En(
  nr,
  [E7, k7]
), [R7, ct] = Ia(nr), [P7, T7] = Ia(nr), jf = g.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: n,
      value: r,
      onValueChange: o,
      defaultValue: i,
      delayDuration: s = 200,
      skipDelayDuration: a = 300,
      orientation: l = "horizontal",
      dir: c,
      ...u
    } = e, [d, f] = g.useState(null), h = fe(t, (_) => f(_)), v = Fr(c), m = g.useRef(0), y = g.useRef(0), C = g.useRef(0), [x, w] = g.useState(!0), [S = "", R] = Et({
      prop: r,
      onChange: (_) => {
        const O = _ !== "", L = a > 0;
        O ? (window.clearTimeout(C.current), L && w(!1)) : (window.clearTimeout(C.current), C.current = window.setTimeout(
          () => w(!0),
          a
        )), o == null || o(_);
      },
      defaultProp: i
    }), k = g.useCallback(() => {
      window.clearTimeout(y.current), y.current = window.setTimeout(() => R(""), 150);
    }, [R]), P = g.useCallback(
      (_) => {
        window.clearTimeout(y.current), R(_);
      },
      [R]
    ), T = g.useCallback(
      (_) => {
        S === _ ? window.clearTimeout(y.current) : m.current = window.setTimeout(() => {
          window.clearTimeout(y.current), R(_);
        }, s);
      },
      [S, R, s]
    );
    return g.useEffect(() => () => {
      window.clearTimeout(m.current), window.clearTimeout(y.current), window.clearTimeout(C.current);
    }, []), /* @__PURE__ */ p.jsx(
      Ff,
      {
        scope: n,
        isRootMenu: !0,
        value: S,
        dir: v,
        orientation: l,
        rootNavigationMenu: d,
        onTriggerEnter: (_) => {
          window.clearTimeout(m.current), x ? T(_) : P(_);
        },
        onTriggerLeave: () => {
          window.clearTimeout(m.current), k();
        },
        onContentEnter: () => window.clearTimeout(y.current),
        onContentLeave: k,
        onItemSelect: (_) => {
          R((O) => O === _ ? "" : _);
        },
        onItemDismiss: () => R(""),
        children: /* @__PURE__ */ p.jsx(
          $.nav,
          {
            "aria-label": "Main",
            "data-orientation": l,
            dir: v,
            ...u,
            ref: h
          }
        )
      }
    );
  }
);
jf.displayName = nr;
var Vf = "NavigationMenuSub", M7 = g.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: n,
      value: r,
      onValueChange: o,
      defaultValue: i,
      orientation: s = "horizontal",
      ...a
    } = e, l = ct(Vf, n), [c = "", u] = Et({
      prop: r,
      onChange: o,
      defaultProp: i
    });
    return /* @__PURE__ */ p.jsx(
      Ff,
      {
        scope: n,
        isRootMenu: !1,
        value: c,
        dir: l.dir,
        orientation: s,
        rootNavigationMenu: l.rootNavigationMenu,
        onTriggerEnter: (d) => u(d),
        onItemSelect: (d) => u(d),
        onItemDismiss: () => u(""),
        children: /* @__PURE__ */ p.jsx($.div, { "data-orientation": s, ...a, ref: t })
      }
    );
  }
);
M7.displayName = Vf;
var Ff = (e) => {
  const {
    scope: t,
    isRootMenu: n,
    rootNavigationMenu: r,
    dir: o,
    orientation: i,
    children: s,
    value: a,
    onItemSelect: l,
    onItemDismiss: c,
    onTriggerEnter: u,
    onTriggerLeave: d,
    onContentEnter: f,
    onContentLeave: h
  } = e, [v, m] = g.useState(null), [y, C] = g.useState(/* @__PURE__ */ new Map()), [x, w] = g.useState(null);
  return /* @__PURE__ */ p.jsx(
    R7,
    {
      scope: t,
      isRootMenu: n,
      rootNavigationMenu: r,
      value: a,
      previousValue: Df(a),
      baseId: Qe(),
      dir: o,
      orientation: i,
      viewport: v,
      onViewportChange: m,
      indicatorTrack: x,
      onIndicatorTrackChange: w,
      onTriggerEnter: Te(u),
      onTriggerLeave: Te(d),
      onContentEnter: Te(f),
      onContentLeave: Te(h),
      onItemSelect: Te(l),
      onItemDismiss: Te(c),
      onViewportContentChange: g.useCallback((S, R) => {
        C((k) => (k.set(S, R), new Map(k)));
      }, []),
      onViewportContentRemove: g.useCallback((S) => {
        C((R) => R.has(S) ? (R.delete(S), new Map(R)) : R);
      }, []),
      children: /* @__PURE__ */ p.jsx(Ma.Provider, { scope: t, children: /* @__PURE__ */ p.jsx(P7, { scope: t, items: y, children: s }) })
    }
  );
}, Bf = "NavigationMenuList", Hf = g.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...r } = e, o = ct(Bf, n), i = /* @__PURE__ */ p.jsx($.ul, { "data-orientation": o.orientation, ...r, ref: t });
    return /* @__PURE__ */ p.jsx($.div, { style: { position: "relative" }, ref: o.onIndicatorTrackChange, children: /* @__PURE__ */ p.jsx(Ma.Slot, { scope: n, children: o.isRootMenu ? /* @__PURE__ */ p.jsx(Xf, { asChild: !0, children: i }) : i }) });
  }
);
Hf.displayName = Bf;
var zf = "NavigationMenuItem", [I7, Uf] = Ia(zf), Kf = g.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, value: r, ...o } = e, i = Qe(), s = r || i || "LEGACY_REACT_AUTO_VALUE", a = g.useRef(null), l = g.useRef(null), c = g.useRef(null), u = g.useRef(() => {
    }), d = g.useRef(!1), f = g.useCallback((v = "start") => {
      if (a.current) {
        u.current();
        const m = bs(a.current);
        m.length && Na(v === "start" ? m : m.reverse());
      }
    }, []), h = g.useCallback(() => {
      if (a.current) {
        const v = bs(a.current);
        v.length && (u.current = V7(v));
      }
    }, []);
    return /* @__PURE__ */ p.jsx(
      I7,
      {
        scope: n,
        value: s,
        triggerRef: l,
        contentRef: a,
        focusProxyRef: c,
        wasEscapeCloseRef: d,
        onEntryKeyDown: f,
        onFocusProxyEnter: f,
        onRootContentClose: h,
        onContentFocusOutside: h,
        children: /* @__PURE__ */ p.jsx($.li, { ...o, ref: t })
      }
    );
  }
);
Kf.displayName = zf;
var ws = "NavigationMenuTrigger", Wf = g.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, disabled: r, ...o } = e, i = ct(ws, e.__scopeNavigationMenu), s = Uf(ws, e.__scopeNavigationMenu), a = g.useRef(null), l = fe(a, s.triggerRef, t), c = Jf(i.baseId, s.value), u = e0(i.baseId, s.value), d = g.useRef(!1), f = g.useRef(!1), h = s.value === i.value;
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(Ma.ItemSlot, { scope: n, value: s.value, children: /* @__PURE__ */ p.jsx(Yf, { asChild: !0, children: /* @__PURE__ */ p.jsx(
      $.button,
      {
        id: c,
        disabled: r,
        "data-disabled": r ? "" : void 0,
        "data-state": Da(h),
        "aria-expanded": h,
        "aria-controls": u,
        ...o,
        ref: l,
        onPointerEnter: F(e.onPointerEnter, () => {
          f.current = !1, s.wasEscapeCloseRef.current = !1;
        }),
        onPointerMove: F(
          e.onPointerMove,
          _o(() => {
            r || f.current || s.wasEscapeCloseRef.current || d.current || (i.onTriggerEnter(s.value), d.current = !0);
          })
        ),
        onPointerLeave: F(
          e.onPointerLeave,
          _o(() => {
            r || (i.onTriggerLeave(), d.current = !1);
          })
        ),
        onClick: F(e.onClick, () => {
          i.onItemSelect(s.value), f.current = h;
        }),
        onKeyDown: F(e.onKeyDown, (v) => {
          const y = { horizontal: "ArrowDown", vertical: i.dir === "rtl" ? "ArrowLeft" : "ArrowRight" }[i.orientation];
          h && v.key === y && (s.onEntryKeyDown(), v.preventDefault());
        })
      }
    ) }) }),
    h && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
      /* @__PURE__ */ p.jsx(
        A7,
        {
          "aria-hidden": !0,
          tabIndex: 0,
          ref: s.focusProxyRef,
          onFocus: (v) => {
            const m = s.contentRef.current, y = v.relatedTarget, C = y === a.current, x = m == null ? void 0 : m.contains(y);
            (C || !x) && s.onFocusProxyEnter(C ? "start" : "end");
          }
        }
      ),
      i.viewport && /* @__PURE__ */ p.jsx("span", { "aria-owns": u })
    ] })
  ] });
});
Wf.displayName = ws;
var _7 = "NavigationMenuLink", gc = "navigationMenu.linkSelect", Zf = g.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, active: r, onSelect: o, ...i } = e;
    return /* @__PURE__ */ p.jsx(Yf, { asChild: !0, children: /* @__PURE__ */ p.jsx(
      $.a,
      {
        "data-active": r ? "" : void 0,
        "aria-current": r ? "page" : void 0,
        ...i,
        ref: t,
        onClick: F(
          e.onClick,
          (s) => {
            const a = s.target, l = new CustomEvent(gc, {
              bubbles: !0,
              cancelable: !0
            });
            if (a.addEventListener(gc, (c) => o == null ? void 0 : o(c), { once: !0 }), Ro(a, l), !l.defaultPrevented && !s.metaKey) {
              const c = new CustomEvent(vo, {
                bubbles: !0,
                cancelable: !0
              });
              Ro(a, c);
            }
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Zf.displayName = _7;
var _a = "NavigationMenuIndicator", Qf = g.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, o = ct(_a, e.__scopeNavigationMenu), i = !!o.value;
  return o.indicatorTrack ? Nu.createPortal(
    /* @__PURE__ */ p.jsx($e, { present: n || i, children: /* @__PURE__ */ p.jsx(L7, { ...r, ref: t }) }),
    o.indicatorTrack
  ) : null;
});
Qf.displayName = _a;
var L7 = g.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, ...r } = e, o = ct(_a, n), i = Of(n), [s, a] = g.useState(
    null
  ), [l, c] = g.useState(null), u = o.orientation === "horizontal", d = !!o.value;
  g.useEffect(() => {
    var m;
    const v = (m = i().find((y) => y.value === o.value)) == null ? void 0 : m.ref.current;
    v && a(v);
  }, [i, o.value]);
  const f = () => {
    s && c({
      size: u ? s.offsetWidth : s.offsetHeight,
      offset: u ? s.offsetLeft : s.offsetTop
    });
  };
  return As(s, f), As(o.indicatorTrack, f), l ? /* @__PURE__ */ p.jsx(
    $.div,
    {
      "aria-hidden": !0,
      "data-state": d ? "visible" : "hidden",
      "data-orientation": o.orientation,
      ...r,
      ref: t,
      style: {
        position: "absolute",
        ...u ? {
          left: 0,
          width: l.size + "px",
          transform: `translateX(${l.offset}px)`
        } : {
          top: 0,
          height: l.size + "px",
          transform: `translateY(${l.offset}px)`
        },
        ...r.style
      }
    }
  ) : null;
}), Qn = "NavigationMenuContent", Gf = g.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, o = ct(Qn, e.__scopeNavigationMenu), i = Uf(Qn, e.__scopeNavigationMenu), s = fe(i.contentRef, t), a = i.value === o.value, l = {
    value: i.value,
    triggerRef: i.triggerRef,
    focusProxyRef: i.focusProxyRef,
    wasEscapeCloseRef: i.wasEscapeCloseRef,
    onContentFocusOutside: i.onContentFocusOutside,
    onRootContentClose: i.onRootContentClose,
    ...r
  };
  return o.viewport ? /* @__PURE__ */ p.jsx(N7, { forceMount: n, ...l, ref: s }) : /* @__PURE__ */ p.jsx($e, { present: n || a, children: /* @__PURE__ */ p.jsx(
    $f,
    {
      "data-state": Da(a),
      ...l,
      ref: s,
      onPointerEnter: F(e.onPointerEnter, o.onContentEnter),
      onPointerLeave: F(
        e.onPointerLeave,
        _o(o.onContentLeave)
      ),
      style: {
        // Prevent interaction when animating out
        pointerEvents: !a && o.isRootMenu ? "none" : void 0,
        ...l.style
      }
    }
  ) });
});
Gf.displayName = Qn;
var N7 = g.forwardRef((e, t) => {
  const n = ct(Qn, e.__scopeNavigationMenu), { onViewportContentChange: r, onViewportContentRemove: o } = n;
  return Ie(() => {
    r(e.value, {
      ref: t,
      ...e
    });
  }, [e, t, r]), Ie(() => () => o(e.value), [e.value, o]), null;
}), vo = "navigationMenu.rootContentDismiss", $f = g.forwardRef((e, t) => {
  const {
    __scopeNavigationMenu: n,
    value: r,
    triggerRef: o,
    focusProxyRef: i,
    wasEscapeCloseRef: s,
    onRootContentClose: a,
    onContentFocusOutside: l,
    ...c
  } = e, u = ct(Qn, n), d = g.useRef(null), f = fe(d, t), h = Jf(u.baseId, r), v = e0(u.baseId, r), m = Of(n), y = g.useRef(null), { onItemDismiss: C } = u;
  g.useEffect(() => {
    const w = d.current;
    if (u.isRootMenu && w) {
      const S = () => {
        var R;
        C(), a(), w.contains(document.activeElement) && ((R = o.current) == null || R.focus());
      };
      return w.addEventListener(vo, S), () => w.removeEventListener(vo, S);
    }
  }, [u.isRootMenu, e.value, o, C, a]);
  const x = g.useMemo(() => {
    const S = m().map((O) => O.value);
    u.dir === "rtl" && S.reverse();
    const R = S.indexOf(u.value), k = S.indexOf(u.previousValue), P = r === u.value, T = k === S.indexOf(r);
    if (!P && !T) return y.current;
    const _ = (() => {
      if (R !== k) {
        if (P && k !== -1) return R > k ? "from-end" : "from-start";
        if (T && R !== -1) return R > k ? "to-start" : "to-end";
      }
      return null;
    })();
    return y.current = _, _;
  }, [u.previousValue, u.value, u.dir, m, r]);
  return /* @__PURE__ */ p.jsx(Xf, { asChild: !0, children: /* @__PURE__ */ p.jsx(
    tr,
    {
      id: v,
      "aria-labelledby": h,
      "data-motion": x,
      "data-orientation": u.orientation,
      ...c,
      ref: f,
      disableOutsidePointerEvents: !1,
      onDismiss: () => {
        var S;
        const w = new Event(vo, {
          bubbles: !0,
          cancelable: !0
        });
        (S = d.current) == null || S.dispatchEvent(w);
      },
      onFocusOutside: F(e.onFocusOutside, (w) => {
        var R;
        l();
        const S = w.target;
        (R = u.rootNavigationMenu) != null && R.contains(S) && w.preventDefault();
      }),
      onPointerDownOutside: F(e.onPointerDownOutside, (w) => {
        var P;
        const S = w.target, R = m().some((T) => {
          var _;
          return (_ = T.ref.current) == null ? void 0 : _.contains(S);
        }), k = u.isRootMenu && ((P = u.viewport) == null ? void 0 : P.contains(S));
        (R || k || !u.isRootMenu) && w.preventDefault();
      }),
      onKeyDown: F(e.onKeyDown, (w) => {
        var k;
        const S = w.altKey || w.ctrlKey || w.metaKey;
        if (w.key === "Tab" && !S) {
          const P = bs(w.currentTarget), T = document.activeElement, _ = P.findIndex((I) => I === T), L = w.shiftKey ? P.slice(0, _).reverse() : P.slice(_ + 1, P.length);
          Na(L) ? w.preventDefault() : (k = i.current) == null || k.focus();
        }
      }),
      onEscapeKeyDown: F(e.onEscapeKeyDown, (w) => {
        s.current = !0;
      })
    }
  ) });
}), La = "NavigationMenuViewport", qf = g.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, i = !!ct(La, e.__scopeNavigationMenu).value;
  return /* @__PURE__ */ p.jsx($e, { present: n || i, children: /* @__PURE__ */ p.jsx(D7, { ...r, ref: t }) });
});
qf.displayName = La;
var D7 = g.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, children: r, ...o } = e, i = ct(La, n), s = fe(t, i.onViewportChange), a = T7(
    Qn,
    e.__scopeNavigationMenu
  ), [l, c] = g.useState(null), [u, d] = g.useState(null), f = l ? (l == null ? void 0 : l.width) + "px" : void 0, h = l ? (l == null ? void 0 : l.height) + "px" : void 0, v = !!i.value, m = v ? i.value : i.previousValue;
  return As(u, () => {
    u && c({ width: u.offsetWidth, height: u.offsetHeight });
  }), /* @__PURE__ */ p.jsx(
    $.div,
    {
      "data-state": Da(v),
      "data-orientation": i.orientation,
      ...o,
      ref: s,
      style: {
        // Prevent interaction when animating out
        pointerEvents: !v && i.isRootMenu ? "none" : void 0,
        "--radix-navigation-menu-viewport-width": f,
        "--radix-navigation-menu-viewport-height": h,
        ...o.style
      },
      onPointerEnter: F(e.onPointerEnter, i.onContentEnter),
      onPointerLeave: F(e.onPointerLeave, _o(i.onContentLeave)),
      children: Array.from(a.items).map(([C, { ref: x, forceMount: w, ...S }]) => {
        const R = m === C;
        return /* @__PURE__ */ p.jsx($e, { present: w || R, children: /* @__PURE__ */ p.jsx(
          $f,
          {
            ...S,
            ref: Or(x, (k) => {
              R && k && d(k);
            })
          }
        ) }, C);
      })
    }
  );
}), O7 = "FocusGroup", Xf = g.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...r } = e, o = ct(O7, n);
    return /* @__PURE__ */ p.jsx(xs.Provider, { scope: n, children: /* @__PURE__ */ p.jsx(xs.Slot, { scope: n, children: /* @__PURE__ */ p.jsx($.div, { dir: o.dir, ...r, ref: t }) }) });
  }
), vc = ["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"], j7 = "FocusGroupItem", Yf = g.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...r } = e, o = S7(n), i = ct(j7, n);
    return /* @__PURE__ */ p.jsx(xs.ItemSlot, { scope: n, children: /* @__PURE__ */ p.jsx(
      $.button,
      {
        ...r,
        ref: t,
        onKeyDown: F(e.onKeyDown, (s) => {
          if (["Home", "End", ...vc].includes(s.key)) {
            let l = o().map((d) => d.ref.current);
            if ([i.dir === "rtl" ? "ArrowRight" : "ArrowLeft", "ArrowUp", "End"].includes(s.key) && l.reverse(), vc.includes(s.key)) {
              const d = l.indexOf(s.currentTarget);
              l = l.slice(d + 1);
            }
            setTimeout(() => Na(l)), s.preventDefault();
          }
        })
      }
    ) });
  }
);
function bs(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function Na(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
function V7(e) {
  return e.forEach((t) => {
    t.dataset.tabindex = t.getAttribute("tabindex") || "", t.setAttribute("tabindex", "-1");
  }), () => {
    e.forEach((t) => {
      const n = t.dataset.tabindex;
      t.setAttribute("tabindex", n);
    });
  };
}
function As(e, t) {
  const n = Te(t);
  Ie(() => {
    let r = 0;
    if (e) {
      const o = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return o.observe(e), () => {
        window.cancelAnimationFrame(r), o.unobserve(e);
      };
    }
  }, [e, n]);
}
function Da(e) {
  return e ? "open" : "closed";
}
function Jf(e, t) {
  return `${e}-trigger-${t}`;
}
function e0(e, t) {
  return `${e}-content-${t}`;
}
function _o(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var t0 = jf, n0 = Hf, F7 = Kf, r0 = Wf, B7 = Zf, o0 = Qf, i0 = Gf, s0 = qf;
const H7 = g.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ p.jsxs(
  t0,
  {
    ref: r,
    className: ee(
      "relative z-10 flex max-w-max flex-1 items-center justify-center",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ p.jsx(a0, {})
    ]
  }
));
H7.displayName = t0.displayName;
const z7 = g.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  n0,
  {
    ref: n,
    className: ee(
      "group flex flex-1 list-none items-center justify-center space-x-1",
      e
    ),
    ...t
  }
));
z7.displayName = n0.displayName;
const DS = F7, U7 = na(
  "group inline-flex h-10 w-max items-center justify-center rounded-md bg-background px-4 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus:outline-none disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-accent/50 data-[state=open]:bg-accent/50"
), K7 = g.forwardRef(({ className: e, iconClassName: t, children: n, ...r }, o) => /* @__PURE__ */ p.jsxs(
  r0,
  {
    ref: o,
    className: ee(U7(), "group", e),
    ...r,
    children: [
      n,
      " ",
      /* @__PURE__ */ p.jsx(
        c7,
        {
          className: ee(
            "relative top-[1px] ml-1 h-3 w-3 transition duration-200 group-data-[state=open]:rotate-180",
            t
          ),
          "aria-hidden": "true"
        }
      )
    ]
  }
));
K7.displayName = r0.displayName;
const W7 = g.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  i0,
  {
    ref: n,
    className: ee(
      "left-0 top-0 w-full data-[motion^=from-]:animate-in data-[motion^=to-]:animate-out data-[motion^=from-]:fade-in data-[motion^=to-]:fade-out data-[motion=from-end]:slide-in-from-right-52 data-[motion=from-start]:slide-in-from-left-52 data-[motion=to-end]:slide-out-to-right-52 data-[motion=to-start]:slide-out-to-left-52 md:absolute md:w-auto ",
      e
    ),
    ...t
  }
));
W7.displayName = i0.displayName;
const OS = B7, a0 = g.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx("div", { className: ee("absolute left-0 top-full flex justify-center"), children: /* @__PURE__ */ p.jsx(
  s0,
  {
    className: ee(
      "origin-top-center relative mt-1.5 h-[var(--radix-navigation-menu-viewport-height)] w-full overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-90 md:w-[var(--radix-navigation-menu-viewport-width)]",
      e
    ),
    ref: n,
    ...t
  }
) }));
a0.displayName = s0.displayName;
const Z7 = g.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  o0,
  {
    ref: n,
    className: ee(
      "top-full z-[1] flex h-1.5 items-end justify-center overflow-hidden data-[state=visible]:animate-in data-[state=hidden]:animate-out data-[state=hidden]:fade-out data-[state=visible]:fade-in",
      e
    ),
    ...t,
    children: /* @__PURE__ */ p.jsx("div", { className: "relative top-[60%] h-2 w-2 rotate-45 rounded-tl-sm bg-border shadow-md" })
  }
));
Z7.displayName = o0.displayName;
function Cc(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
var Q7 = [" ", "Enter", "ArrowUp", "ArrowDown"], G7 = [" ", "Enter"], Kr = "Select", [oi, ii, $7] = Vr(Kr), [rr, jS] = En(Kr, [
  $7,
  er
]), si = er(), [q7, tn] = rr(Kr), [X7, Y7] = rr(Kr), l0 = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    value: s,
    defaultValue: a,
    onValueChange: l,
    dir: c,
    name: u,
    autoComplete: d,
    disabled: f,
    required: h,
    form: v
  } = e, m = si(t), [y, C] = g.useState(null), [x, w] = g.useState(null), [S, R] = g.useState(!1), k = Fr(c), [P = !1, T] = Et({
    prop: r,
    defaultProp: o,
    onChange: i
  }), [_, O] = Et({
    prop: s,
    defaultProp: a,
    onChange: l
  }), L = g.useRef(null), I = y ? v || !!y.closest("form") : !0, [H, z] = g.useState(/* @__PURE__ */ new Set()), W = Array.from(H).map((Z) => Z.props.value).join(";");
  return /* @__PURE__ */ p.jsx($o, { ...m, children: /* @__PURE__ */ p.jsxs(
    q7,
    {
      required: h,
      scope: t,
      trigger: y,
      onTriggerChange: C,
      valueNode: x,
      onValueNodeChange: w,
      valueNodeHasChildren: S,
      onValueNodeHasChildrenChange: R,
      contentId: Qe(),
      value: _,
      onValueChange: O,
      open: P,
      onOpenChange: T,
      dir: k,
      triggerPointerDownPosRef: L,
      disabled: f,
      children: [
        /* @__PURE__ */ p.jsx(oi.Provider, { scope: t, children: /* @__PURE__ */ p.jsx(
          X7,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: g.useCallback((Z) => {
              z((U) => new Set(U).add(Z));
            }, []),
            onNativeOptionRemove: g.useCallback((Z) => {
              z((U) => {
                const B = new Set(U);
                return B.delete(Z), B;
              });
            }, []),
            children: n
          }
        ) }),
        I ? /* @__PURE__ */ p.jsxs(
          N0,
          {
            "aria-hidden": !0,
            required: h,
            tabIndex: -1,
            name: u,
            autoComplete: d,
            value: _,
            onChange: (Z) => O(Z.target.value),
            disabled: f,
            form: v,
            children: [
              _ === void 0 ? /* @__PURE__ */ p.jsx("option", { value: "" }) : null,
              Array.from(H)
            ]
          },
          W
        ) : null
      ]
    }
  ) });
};
l0.displayName = Kr;
var c0 = "SelectTrigger", u0 = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...o } = e, i = si(n), s = tn(c0, n), a = s.disabled || r, l = fe(t, s.onTriggerChange), c = ii(n), u = g.useRef("touch"), [d, f, h] = D0((m) => {
      const y = c().filter((w) => !w.disabled), C = y.find((w) => w.value === s.value), x = O0(y, m, C);
      x !== void 0 && s.onValueChange(x.value);
    }), v = (m) => {
      a || (s.onOpenChange(!0), h()), m && (s.triggerPointerDownPosRef.current = {
        x: Math.round(m.pageX),
        y: Math.round(m.pageY)
      });
    };
    return /* @__PURE__ */ p.jsx(ha, { asChild: !0, ...i, children: /* @__PURE__ */ p.jsx(
      $.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": s.contentId,
        "aria-expanded": s.open,
        "aria-required": s.required,
        "aria-autocomplete": "none",
        dir: s.dir,
        "data-state": s.open ? "open" : "closed",
        disabled: a,
        "data-disabled": a ? "" : void 0,
        "data-placeholder": L0(s.value) ? "" : void 0,
        ...o,
        ref: l,
        onClick: F(o.onClick, (m) => {
          m.currentTarget.focus(), u.current !== "mouse" && v(m);
        }),
        onPointerDown: F(o.onPointerDown, (m) => {
          u.current = m.pointerType;
          const y = m.target;
          y.hasPointerCapture(m.pointerId) && y.releasePointerCapture(m.pointerId), m.button === 0 && m.ctrlKey === !1 && m.pointerType === "mouse" && (v(m), m.preventDefault());
        }),
        onKeyDown: F(o.onKeyDown, (m) => {
          const y = d.current !== "";
          !(m.ctrlKey || m.altKey || m.metaKey) && m.key.length === 1 && f(m.key), !(y && m.key === " ") && Q7.includes(m.key) && (v(), m.preventDefault());
        })
      }
    ) });
  }
);
u0.displayName = c0;
var d0 = "SelectValue", f0 = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, children: i, placeholder: s = "", ...a } = e, l = tn(d0, n), { onValueNodeHasChildrenChange: c } = l, u = i !== void 0, d = fe(t, l.onValueNodeChange);
    return Ie(() => {
      c(u);
    }, [c, u]), /* @__PURE__ */ p.jsx(
      $.span,
      {
        ...a,
        ref: d,
        style: { pointerEvents: "none" },
        children: L0(l.value) ? /* @__PURE__ */ p.jsx(p.Fragment, { children: s }) : i
      }
    );
  }
);
f0.displayName = d0;
var J7 = "SelectIcon", h0 = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...o } = e;
    return /* @__PURE__ */ p.jsx($.span, { "aria-hidden": !0, ...o, ref: t, children: r || "▼" });
  }
);
h0.displayName = J7;
var eg = "SelectPortal", p0 = (e) => /* @__PURE__ */ p.jsx(qo, { asChild: !0, ...e });
p0.displayName = eg;
var xn = "SelectContent", m0 = g.forwardRef(
  (e, t) => {
    const n = tn(xn, e.__scopeSelect), [r, o] = g.useState();
    if (Ie(() => {
      o(new DocumentFragment());
    }, []), !n.open) {
      const i = r;
      return i ? Wo.createPortal(
        /* @__PURE__ */ p.jsx(g0, { scope: e.__scopeSelect, children: /* @__PURE__ */ p.jsx(oi.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ p.jsx("div", { children: e.children }) }) }),
        i
      ) : null;
    }
    return /* @__PURE__ */ p.jsx(v0, { ...e, ref: t });
  }
);
m0.displayName = xn;
var pt = 10, [g0, nn] = rr(xn), tg = "SelectContentImpl", v0 = g.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: o,
      onEscapeKeyDown: i,
      onPointerDownOutside: s,
      //
      // PopperContent props
      side: a,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: f,
      collisionPadding: h,
      sticky: v,
      hideWhenDetached: m,
      avoidCollisions: y,
      //
      ...C
    } = e, x = tn(xn, n), [w, S] = g.useState(null), [R, k] = g.useState(null), P = fe(t, (Q) => S(Q)), [T, _] = g.useState(null), [O, L] = g.useState(
      null
    ), I = ii(n), [H, z] = g.useState(!1), W = g.useRef(!1);
    g.useEffect(() => {
      if (w) return ya(w);
    }, [w]), Ca();
    const Z = g.useCallback(
      (Q) => {
        const [te, ...se] = I().map((de) => de.ref.current), [re] = se.slice(-1), ce = document.activeElement;
        for (const de of Q)
          if (de === ce || (de == null || de.scrollIntoView({ block: "nearest" }), de === te && R && (R.scrollTop = 0), de === re && R && (R.scrollTop = R.scrollHeight), de == null || de.focus(), document.activeElement !== ce)) return;
      },
      [I, R]
    ), U = g.useCallback(
      () => Z([T, w]),
      [Z, T, w]
    );
    g.useEffect(() => {
      H && U();
    }, [H, U]);
    const { onOpenChange: B, triggerPointerDownPosRef: j } = x;
    g.useEffect(() => {
      if (w) {
        let Q = { x: 0, y: 0 };
        const te = (re) => {
          var ce, de;
          Q = {
            x: Math.abs(Math.round(re.pageX) - (((ce = j.current) == null ? void 0 : ce.x) ?? 0)),
            y: Math.abs(Math.round(re.pageY) - (((de = j.current) == null ? void 0 : de.y) ?? 0))
          };
        }, se = (re) => {
          Q.x <= 10 && Q.y <= 10 ? re.preventDefault() : w.contains(re.target) || B(!1), document.removeEventListener("pointermove", te), j.current = null;
        };
        return j.current !== null && (document.addEventListener("pointermove", te), document.addEventListener("pointerup", se, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", te), document.removeEventListener("pointerup", se, { capture: !0 });
        };
      }
    }, [w, B, j]), g.useEffect(() => {
      const Q = () => B(!1);
      return window.addEventListener("blur", Q), window.addEventListener("resize", Q), () => {
        window.removeEventListener("blur", Q), window.removeEventListener("resize", Q);
      };
    }, [B]);
    const [b, Y] = D0((Q) => {
      const te = I().filter((ce) => !ce.disabled), se = te.find((ce) => ce.ref.current === document.activeElement), re = O0(te, Q, se);
      re && setTimeout(() => re.ref.current.focus());
    }), Ce = g.useCallback(
      (Q, te, se) => {
        const re = !W.current && !se;
        (x.value !== void 0 && x.value === te || re) && (_(Q), re && (W.current = !0));
      },
      [x.value]
    ), E = g.useCallback(() => w == null ? void 0 : w.focus(), [w]), xe = g.useCallback(
      (Q, te, se) => {
        const re = !W.current && !se;
        (x.value !== void 0 && x.value === te || re) && L(Q);
      },
      [x.value]
    ), Me = r === "popper" ? Es : C0, le = Me === Es ? {
      side: a,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: f,
      collisionPadding: h,
      sticky: v,
      hideWhenDetached: m,
      avoidCollisions: y
    } : {};
    return /* @__PURE__ */ p.jsx(
      g0,
      {
        scope: n,
        content: w,
        viewport: R,
        onViewportChange: k,
        itemRefCallback: Ce,
        selectedItem: T,
        onItemLeave: E,
        itemTextRefCallback: xe,
        focusSelectedItem: U,
        selectedItemText: O,
        position: r,
        isPositioned: H,
        searchRef: b,
        children: /* @__PURE__ */ p.jsx(ni, { as: Zt, allowPinchZoom: !0, children: /* @__PURE__ */ p.jsx(
          Yo,
          {
            asChild: !0,
            trapped: x.open,
            onMountAutoFocus: (Q) => {
              Q.preventDefault();
            },
            onUnmountAutoFocus: F(o, (Q) => {
              var te;
              (te = x.trigger) == null || te.focus({ preventScroll: !0 }), Q.preventDefault();
            }),
            children: /* @__PURE__ */ p.jsx(
              tr,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: i,
                onPointerDownOutside: s,
                onFocusOutside: (Q) => Q.preventDefault(),
                onDismiss: () => x.onOpenChange(!1),
                children: /* @__PURE__ */ p.jsx(
                  Me,
                  {
                    role: "listbox",
                    id: x.contentId,
                    "data-state": x.open ? "open" : "closed",
                    dir: x.dir,
                    onContextMenu: (Q) => Q.preventDefault(),
                    ...C,
                    ...le,
                    onPlaced: () => z(!0),
                    ref: P,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...C.style
                    },
                    onKeyDown: F(C.onKeyDown, (Q) => {
                      const te = Q.ctrlKey || Q.altKey || Q.metaKey;
                      if (Q.key === "Tab" && Q.preventDefault(), !te && Q.key.length === 1 && Y(Q.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(Q.key)) {
                        let re = I().filter((ce) => !ce.disabled).map((ce) => ce.ref.current);
                        if (["ArrowUp", "End"].includes(Q.key) && (re = re.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(Q.key)) {
                          const ce = Q.target, de = re.indexOf(ce);
                          re = re.slice(de + 1);
                        }
                        setTimeout(() => Z(re)), Q.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
v0.displayName = tg;
var ng = "SelectItemAlignedPosition", C0 = g.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...o } = e, i = tn(xn, n), s = nn(xn, n), [a, l] = g.useState(null), [c, u] = g.useState(null), d = fe(t, (P) => u(P)), f = ii(n), h = g.useRef(!1), v = g.useRef(!0), { viewport: m, selectedItem: y, selectedItemText: C, focusSelectedItem: x } = s, w = g.useCallback(() => {
    if (i.trigger && i.valueNode && a && c && m && y && C) {
      const P = i.trigger.getBoundingClientRect(), T = c.getBoundingClientRect(), _ = i.valueNode.getBoundingClientRect(), O = C.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const ce = O.left - T.left, de = _.left - ce, _e = P.left - de, Ue = P.width + _e, qe = Math.max(Ue, T.width), Ke = window.innerWidth - pt, dt = Cc(de, [
          pt,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(pt, Ke - qe)
        ]);
        a.style.minWidth = Ue + "px", a.style.left = dt + "px";
      } else {
        const ce = T.right - O.right, de = window.innerWidth - _.right - ce, _e = window.innerWidth - P.right - de, Ue = P.width + _e, qe = Math.max(Ue, T.width), Ke = window.innerWidth - pt, dt = Cc(de, [
          pt,
          Math.max(pt, Ke - qe)
        ]);
        a.style.minWidth = Ue + "px", a.style.right = dt + "px";
      }
      const L = f(), I = window.innerHeight - pt * 2, H = m.scrollHeight, z = window.getComputedStyle(c), W = parseInt(z.borderTopWidth, 10), Z = parseInt(z.paddingTop, 10), U = parseInt(z.borderBottomWidth, 10), B = parseInt(z.paddingBottom, 10), j = W + Z + H + B + U, b = Math.min(y.offsetHeight * 5, j), Y = window.getComputedStyle(m), Ce = parseInt(Y.paddingTop, 10), E = parseInt(Y.paddingBottom, 10), xe = P.top + P.height / 2 - pt, Me = I - xe, le = y.offsetHeight / 2, Q = y.offsetTop + le, te = W + Z + Q, se = j - te;
      if (te <= xe) {
        const ce = L.length > 0 && y === L[L.length - 1].ref.current;
        a.style.bottom = "0px";
        const de = c.clientHeight - m.offsetTop - m.offsetHeight, _e = Math.max(
          Me,
          le + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (ce ? E : 0) + de + U
        ), Ue = te + _e;
        a.style.height = Ue + "px";
      } else {
        const ce = L.length > 0 && y === L[0].ref.current;
        a.style.top = "0px";
        const _e = Math.max(
          xe,
          W + m.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (ce ? Ce : 0) + le
        ) + se;
        a.style.height = _e + "px", m.scrollTop = te - xe + m.offsetTop;
      }
      a.style.margin = `${pt}px 0`, a.style.minHeight = b + "px", a.style.maxHeight = I + "px", r == null || r(), requestAnimationFrame(() => h.current = !0);
    }
  }, [
    f,
    i.trigger,
    i.valueNode,
    a,
    c,
    m,
    y,
    C,
    i.dir,
    r
  ]);
  Ie(() => w(), [w]);
  const [S, R] = g.useState();
  Ie(() => {
    c && R(window.getComputedStyle(c).zIndex);
  }, [c]);
  const k = g.useCallback(
    (P) => {
      P && v.current === !0 && (w(), x == null || x(), v.current = !1);
    },
    [w, x]
  );
  return /* @__PURE__ */ p.jsx(
    og,
    {
      scope: n,
      contentWrapper: a,
      shouldExpandOnScrollRef: h,
      onScrollButtonChange: k,
      children: /* @__PURE__ */ p.jsx(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: S
          },
          children: /* @__PURE__ */ p.jsx(
            $.div,
            {
              ...o,
              ref: d,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...o.style
              }
            }
          )
        }
      )
    }
  );
});
C0.displayName = ng;
var rg = "SelectPopperPosition", Es = g.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: o = pt,
    ...i
  } = e, s = si(n);
  return /* @__PURE__ */ p.jsx(
    pa,
    {
      ...s,
      ...i,
      ref: t,
      align: r,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...i.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Es.displayName = rg;
var [og, Oa] = rr(xn, {}), Ss = "SelectViewport", y0 = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...o } = e, i = nn(Ss, n), s = Oa(Ss, n), a = fe(t, i.onViewportChange), l = g.useRef(0);
    return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
      /* @__PURE__ */ p.jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ p.jsx(oi.Slot, { scope: n, children: /* @__PURE__ */ p.jsx(
        $.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: a,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...o.style
          },
          onScroll: F(o.onScroll, (c) => {
            const u = c.currentTarget, { contentWrapper: d, shouldExpandOnScrollRef: f } = s;
            if (f != null && f.current && d) {
              const h = Math.abs(l.current - u.scrollTop);
              if (h > 0) {
                const v = window.innerHeight - pt * 2, m = parseFloat(d.style.minHeight), y = parseFloat(d.style.height), C = Math.max(m, y);
                if (C < v) {
                  const x = C + h, w = Math.min(v, x), S = x - w;
                  d.style.height = w + "px", d.style.bottom === "0px" && (u.scrollTop = S > 0 ? S : 0, d.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = u.scrollTop;
          })
        }
      ) })
    ] });
  }
);
y0.displayName = Ss;
var x0 = "SelectGroup", [ig, sg] = rr(x0), w0 = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = Qe();
    return /* @__PURE__ */ p.jsx(ig, { scope: n, id: o, children: /* @__PURE__ */ p.jsx($.div, { role: "group", "aria-labelledby": o, ...r, ref: t }) });
  }
);
w0.displayName = x0;
var b0 = "SelectLabel", A0 = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = sg(b0, n);
    return /* @__PURE__ */ p.jsx($.div, { id: o.id, ...r, ref: t });
  }
);
A0.displayName = b0;
var Lo = "SelectItem", [ag, E0] = rr(Lo), S0 = g.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: o = !1,
      textValue: i,
      ...s
    } = e, a = tn(Lo, n), l = nn(Lo, n), c = a.value === r, [u, d] = g.useState(i ?? ""), [f, h] = g.useState(!1), v = fe(
      t,
      (x) => {
        var w;
        return (w = l.itemRefCallback) == null ? void 0 : w.call(l, x, r, o);
      }
    ), m = Qe(), y = g.useRef("touch"), C = () => {
      o || (a.onValueChange(r), a.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ p.jsx(
      ag,
      {
        scope: n,
        value: r,
        disabled: o,
        textId: m,
        isSelected: c,
        onItemTextChange: g.useCallback((x) => {
          d((w) => w || ((x == null ? void 0 : x.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ p.jsx(
          oi.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: o,
            textValue: u,
            children: /* @__PURE__ */ p.jsx(
              $.div,
              {
                role: "option",
                "aria-labelledby": m,
                "data-highlighted": f ? "" : void 0,
                "aria-selected": c && f,
                "data-state": c ? "checked" : "unchecked",
                "aria-disabled": o || void 0,
                "data-disabled": o ? "" : void 0,
                tabIndex: o ? void 0 : -1,
                ...s,
                ref: v,
                onFocus: F(s.onFocus, () => h(!0)),
                onBlur: F(s.onBlur, () => h(!1)),
                onClick: F(s.onClick, () => {
                  y.current !== "mouse" && C();
                }),
                onPointerUp: F(s.onPointerUp, () => {
                  y.current === "mouse" && C();
                }),
                onPointerDown: F(s.onPointerDown, (x) => {
                  y.current = x.pointerType;
                }),
                onPointerMove: F(s.onPointerMove, (x) => {
                  var w;
                  y.current = x.pointerType, o ? (w = l.onItemLeave) == null || w.call(l) : y.current === "mouse" && x.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: F(s.onPointerLeave, (x) => {
                  var w;
                  x.currentTarget === document.activeElement && ((w = l.onItemLeave) == null || w.call(l));
                }),
                onKeyDown: F(s.onKeyDown, (x) => {
                  var S;
                  ((S = l.searchRef) == null ? void 0 : S.current) !== "" && x.key === " " || (G7.includes(x.key) && C(), x.key === " " && x.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
S0.displayName = Lo;
var vr = "SelectItemText", k0 = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, ...i } = e, s = tn(vr, n), a = nn(vr, n), l = E0(vr, n), c = Y7(vr, n), [u, d] = g.useState(null), f = fe(
      t,
      (C) => d(C),
      l.onItemTextChange,
      (C) => {
        var x;
        return (x = a.itemTextRefCallback) == null ? void 0 : x.call(a, C, l.value, l.disabled);
      }
    ), h = u == null ? void 0 : u.textContent, v = g.useMemo(
      () => /* @__PURE__ */ p.jsx("option", { value: l.value, disabled: l.disabled, children: h }, l.value),
      [l.disabled, l.value, h]
    ), { onNativeOptionAdd: m, onNativeOptionRemove: y } = c;
    return Ie(() => (m(v), () => y(v)), [m, y, v]), /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
      /* @__PURE__ */ p.jsx($.span, { id: l.textId, ...i, ref: f }),
      l.isSelected && s.valueNode && !s.valueNodeHasChildren ? Wo.createPortal(i.children, s.valueNode) : null
    ] });
  }
);
k0.displayName = vr;
var R0 = "SelectItemIndicator", P0 = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return E0(R0, n).isSelected ? /* @__PURE__ */ p.jsx($.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
P0.displayName = R0;
var ks = "SelectScrollUpButton", T0 = g.forwardRef((e, t) => {
  const n = nn(ks, e.__scopeSelect), r = Oa(ks, e.__scopeSelect), [o, i] = g.useState(!1), s = fe(t, r.onScrollButtonChange);
  return Ie(() => {
    if (n.viewport && n.isPositioned) {
      let a = function() {
        const c = l.scrollTop > 0;
        i(c);
      };
      const l = n.viewport;
      return a(), l.addEventListener("scroll", a), () => l.removeEventListener("scroll", a);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ p.jsx(
    I0,
    {
      ...e,
      ref: s,
      onAutoScroll: () => {
        const { viewport: a, selectedItem: l } = n;
        a && l && (a.scrollTop = a.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
T0.displayName = ks;
var Rs = "SelectScrollDownButton", M0 = g.forwardRef((e, t) => {
  const n = nn(Rs, e.__scopeSelect), r = Oa(Rs, e.__scopeSelect), [o, i] = g.useState(!1), s = fe(t, r.onScrollButtonChange);
  return Ie(() => {
    if (n.viewport && n.isPositioned) {
      let a = function() {
        const c = l.scrollHeight - l.clientHeight, u = Math.ceil(l.scrollTop) < c;
        i(u);
      };
      const l = n.viewport;
      return a(), l.addEventListener("scroll", a), () => l.removeEventListener("scroll", a);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ p.jsx(
    I0,
    {
      ...e,
      ref: s,
      onAutoScroll: () => {
        const { viewport: a, selectedItem: l } = n;
        a && l && (a.scrollTop = a.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
M0.displayName = Rs;
var I0 = g.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...o } = e, i = nn("SelectScrollButton", n), s = g.useRef(null), a = ii(n), l = g.useCallback(() => {
    s.current !== null && (window.clearInterval(s.current), s.current = null);
  }, []);
  return g.useEffect(() => () => l(), [l]), Ie(() => {
    var u;
    const c = a().find((d) => d.ref.current === document.activeElement);
    (u = c == null ? void 0 : c.ref.current) == null || u.scrollIntoView({ block: "nearest" });
  }, [a]), /* @__PURE__ */ p.jsx(
    $.div,
    {
      "aria-hidden": !0,
      ...o,
      ref: t,
      style: { flexShrink: 0, ...o.style },
      onPointerDown: F(o.onPointerDown, () => {
        s.current === null && (s.current = window.setInterval(r, 50));
      }),
      onPointerMove: F(o.onPointerMove, () => {
        var c;
        (c = i.onItemLeave) == null || c.call(i), s.current === null && (s.current = window.setInterval(r, 50));
      }),
      onPointerLeave: F(o.onPointerLeave, () => {
        l();
      })
    }
  );
}), lg = "SelectSeparator", _0 = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ p.jsx($.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
_0.displayName = lg;
var Ps = "SelectArrow", cg = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = si(n), i = tn(Ps, n), s = nn(Ps, n);
    return i.open && s.position === "popper" ? /* @__PURE__ */ p.jsx(ma, { ...o, ...r, ref: t }) : null;
  }
);
cg.displayName = Ps;
function L0(e) {
  return e === "" || e === void 0;
}
var N0 = g.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = g.useRef(null), i = fe(t, o), s = Df(n);
    return g.useEffect(() => {
      const a = o.current, l = window.HTMLSelectElement.prototype, u = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (s !== n && u) {
        const d = new Event("change", { bubbles: !0 });
        u.call(a, n), a.dispatchEvent(d);
      }
    }, [s, n]), /* @__PURE__ */ p.jsx(Ta, { asChild: !0, children: /* @__PURE__ */ p.jsx("select", { ...r, ref: i, defaultValue: n }) });
  }
);
N0.displayName = "BubbleSelect";
function D0(e) {
  const t = Te(e), n = g.useRef(""), r = g.useRef(0), o = g.useCallback(
    (s) => {
      const a = n.current + s;
      t(a), function l(c) {
        n.current = c, window.clearTimeout(r.current), c !== "" && (r.current = window.setTimeout(() => l(""), 1e3));
      }(a);
    },
    [t]
  ), i = g.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return g.useEffect(() => () => window.clearTimeout(r.current), []), [n, o, i];
}
function O0(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let s = ug(e, Math.max(i, 0));
  o.length === 1 && (s = s.filter((c) => c !== n));
  const l = s.find(
    (c) => c.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function ug(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var dg = l0, j0 = u0, fg = f0, hg = h0, pg = p0, V0 = m0, mg = y0, gg = w0, F0 = A0, B0 = S0, vg = k0, Cg = P0, H0 = T0, z0 = M0, U0 = _0;
const VS = dg, FS = gg, BS = fg, yg = g.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ p.jsxs(
  j0,
  {
    ref: r,
    className: ee(
      "flex h-10 w-full items-center justify-between rounded-md border-input bg-background py-2 ring-offset-background placeholder:text-muted-foreground focus:outline-none text-gray-900 text-base font-sans disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1 hover:bg-accent hover:text-accent-foreground",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ p.jsx(hg, { asChild: !0, children: /* @__PURE__ */ p.jsx(he, { icon: "chevron-down" }) })
    ]
  }
));
yg.displayName = j0.displayName;
const K0 = g.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  H0,
  {
    ref: n,
    className: ee(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ p.jsx(he, { icon: "chevron-up" })
  }
));
K0.displayName = H0.displayName;
const W0 = g.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  z0,
  {
    ref: n,
    className: ee(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ p.jsx(he, { icon: "chevron-down" })
  }
));
W0.displayName = z0.displayName;
const xg = g.forwardRef(({ className: e, children: t, position: n = "popper", ...r }, o) => /* @__PURE__ */ p.jsx(pg, { children: /* @__PURE__ */ p.jsxs(
  V0,
  {
    ref: o,
    className: ee(
      "relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: n,
    ...r,
    children: [
      /* @__PURE__ */ p.jsx(K0, {}),
      /* @__PURE__ */ p.jsx(
        mg,
        {
          className: ee(
            "p-1",
            n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
          ),
          children: t
        }
      ),
      /* @__PURE__ */ p.jsx(W0, {})
    ]
  }
) }));
xg.displayName = V0.displayName;
const wg = g.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  F0,
  {
    ref: n,
    className: ee("py-1.5 pl-8 pr-2 text-sm font-semibold", e),
    ...t
  }
));
wg.displayName = F0.displayName;
const bg = g.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ p.jsxs(
  B0,
  {
    ref: r,
    className: ee(
      "relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ p.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ p.jsx(Cg, { children: /* @__PURE__ */ p.jsx(he, { icon: "checkmark" }) }) }),
      /* @__PURE__ */ p.jsx(vg, { children: t })
    ]
  }
));
bg.displayName = B0.displayName;
const Ag = g.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  U0,
  {
    ref: n,
    className: ee("-mx-1 my-1 h-px bg-muted", e),
    ...t
  }
));
Ag.displayName = U0.displayName;
var Eg = "Separator", yc = "horizontal", Sg = ["horizontal", "vertical"], Z0 = g.forwardRef((e, t) => {
  const { decorative: n, orientation: r = yc, ...o } = e, i = kg(r) ? r : yc, a = n ? { role: "none" } : { "aria-orientation": i === "vertical" ? i : void 0, role: "separator" };
  return /* @__PURE__ */ p.jsx(
    $.div,
    {
      "data-orientation": i,
      ...a,
      ...o,
      ref: t
    }
  );
});
Z0.displayName = Eg;
function kg(e) {
  return Sg.includes(e);
}
var Q0 = Z0;
const Rg = g.forwardRef(
  ({ className: e, orientation: t = "horizontal", decorative: n = !0, ...r }, o) => /* @__PURE__ */ p.jsx(
    Q0,
    {
      ref: o,
      decorative: n,
      orientation: t,
      className: ee(
        "shrink-0 bg-border",
        t === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
        e
      ),
      ...r
    }
  )
);
Rg.displayName = Q0.displayName;
var ja = "Tabs", [Pg, HS] = En(ja, [
  ei
]), G0 = ei(), [Tg, Va] = Pg(ja), $0 = g.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: r,
      onValueChange: o,
      defaultValue: i,
      orientation: s = "horizontal",
      dir: a,
      activationMode: l = "automatic",
      ...c
    } = e, u = Fr(a), [d, f] = Et({
      prop: r,
      onChange: o,
      defaultProp: i
    });
    return /* @__PURE__ */ p.jsx(
      Tg,
      {
        scope: n,
        baseId: Qe(),
        value: d,
        onValueChange: f,
        orientation: s,
        dir: u,
        activationMode: l,
        children: /* @__PURE__ */ p.jsx(
          $.div,
          {
            dir: u,
            "data-orientation": s,
            ...c,
            ref: t
          }
        )
      }
    );
  }
);
$0.displayName = ja;
var q0 = "TabsList", X0 = g.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: r = !0, ...o } = e, i = Va(q0, n), s = G0(n);
    return /* @__PURE__ */ p.jsx(
      Sd,
      {
        asChild: !0,
        ...s,
        orientation: i.orientation,
        dir: i.dir,
        loop: r,
        children: /* @__PURE__ */ p.jsx(
          $.div,
          {
            role: "tablist",
            "aria-orientation": i.orientation,
            ...o,
            ref: t
          }
        )
      }
    );
  }
);
X0.displayName = q0;
var Y0 = "TabsTrigger", J0 = g.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, disabled: o = !1, ...i } = e, s = Va(Y0, n), a = G0(n), l = n5(s.baseId, r), c = r5(s.baseId, r), u = r === s.value;
    return /* @__PURE__ */ p.jsx(
      kd,
      {
        asChild: !0,
        ...a,
        focusable: !o,
        active: u,
        children: /* @__PURE__ */ p.jsx(
          $.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": u,
            "aria-controls": c,
            "data-state": u ? "active" : "inactive",
            "data-disabled": o ? "" : void 0,
            disabled: o,
            id: l,
            ...i,
            ref: t,
            onMouseDown: F(e.onMouseDown, (d) => {
              !o && d.button === 0 && d.ctrlKey === !1 ? s.onValueChange(r) : d.preventDefault();
            }),
            onKeyDown: F(e.onKeyDown, (d) => {
              [" ", "Enter"].includes(d.key) && s.onValueChange(r);
            }),
            onFocus: F(e.onFocus, () => {
              const d = s.activationMode !== "manual";
              !u && !o && d && s.onValueChange(r);
            })
          }
        )
      }
    );
  }
);
J0.displayName = Y0;
var e5 = "TabsContent", t5 = g.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, forceMount: o, children: i, ...s } = e, a = Va(e5, n), l = n5(a.baseId, r), c = r5(a.baseId, r), u = r === a.value, d = g.useRef(u);
    return g.useEffect(() => {
      const f = requestAnimationFrame(() => d.current = !1);
      return () => cancelAnimationFrame(f);
    }, []), /* @__PURE__ */ p.jsx($e, { present: o || u, children: ({ present: f }) => /* @__PURE__ */ p.jsx(
      $.div,
      {
        "data-state": u ? "active" : "inactive",
        "data-orientation": a.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !f,
        id: c,
        tabIndex: 0,
        ...s,
        ref: t,
        style: {
          ...e.style,
          animationDuration: d.current ? "0s" : void 0
        },
        children: f && i
      }
    ) });
  }
);
t5.displayName = e5;
function n5(e, t) {
  return `${e}-trigger-${t}`;
}
function r5(e, t) {
  return `${e}-content-${t}`;
}
var Mg = $0, o5 = X0, i5 = J0, s5 = t5;
const zS = Mg, Ig = g.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  o5,
  {
    ref: n,
    className: ee(
      "inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground",
      e
    ),
    ...t
  }
));
Ig.displayName = o5.displayName;
const _g = g.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  i5,
  {
    ref: n,
    className: ee(
      "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm",
      e
    ),
    ...t
  }
));
_g.displayName = i5.displayName;
const Lg = g.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  s5,
  {
    ref: n,
    className: ee(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      e
    ),
    ...t
  }
));
Lg.displayName = s5.displayName;
function Ut({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p.jsx(
    "div",
    {
      className: ee("animate-pulse rounded-md bg-gray-100", e),
      ...t
    }
  );
}
var Fa = "Dialog", [a5, US] = En(Fa), [Ng, vt] = a5(Fa), l5 = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: s = !0
  } = e, a = g.useRef(null), l = g.useRef(null), [c = !1, u] = Et({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ p.jsx(
    Ng,
    {
      scope: t,
      triggerRef: a,
      contentRef: l,
      contentId: Qe(),
      titleId: Qe(),
      descriptionId: Qe(),
      open: c,
      onOpenChange: u,
      onOpenToggle: g.useCallback(() => u((d) => !d), [u]),
      modal: s,
      children: n
    }
  );
};
l5.displayName = Fa;
var c5 = "DialogTrigger", u5 = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = vt(c5, n), i = fe(t, o.triggerRef);
    return /* @__PURE__ */ p.jsx(
      $.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": za(o.open),
        ...r,
        ref: i,
        onClick: F(e.onClick, o.onOpenToggle)
      }
    );
  }
);
u5.displayName = c5;
var Ba = "DialogPortal", [Dg, d5] = a5(Ba, {
  forceMount: void 0
}), f5 = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, i = vt(Ba, t);
  return /* @__PURE__ */ p.jsx(Dg, { scope: t, forceMount: n, children: g.Children.map(r, (s) => /* @__PURE__ */ p.jsx($e, { present: n || i.open, children: /* @__PURE__ */ p.jsx(qo, { asChild: !0, container: o, children: s }) })) });
};
f5.displayName = Ba;
var No = "DialogOverlay", h5 = g.forwardRef(
  (e, t) => {
    const n = d5(No, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = vt(No, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ p.jsx($e, { present: r || i.open, children: /* @__PURE__ */ p.jsx(Og, { ...o, ref: t }) }) : null;
  }
);
h5.displayName = No;
var Og = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = vt(No, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ p.jsx(ni, { as: Zt, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ p.jsx(
        $.div,
        {
          "data-state": za(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), wn = "DialogContent", p5 = g.forwardRef(
  (e, t) => {
    const n = d5(wn, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = vt(wn, e.__scopeDialog);
    return /* @__PURE__ */ p.jsx($e, { present: r || i.open, children: i.modal ? /* @__PURE__ */ p.jsx(jg, { ...o, ref: t }) : /* @__PURE__ */ p.jsx(Vg, { ...o, ref: t }) });
  }
);
p5.displayName = wn;
var jg = g.forwardRef(
  (e, t) => {
    const n = vt(wn, e.__scopeDialog), r = g.useRef(null), o = fe(t, n.contentRef, r);
    return g.useEffect(() => {
      const i = r.current;
      if (i) return ya(i);
    }, []), /* @__PURE__ */ p.jsx(
      m5,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: F(e.onCloseAutoFocus, (i) => {
          var s;
          i.preventDefault(), (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: F(e.onPointerDownOutside, (i) => {
          const s = i.detail.originalEvent, a = s.button === 0 && s.ctrlKey === !0;
          (s.button === 2 || a) && i.preventDefault();
        }),
        onFocusOutside: F(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), Vg = g.forwardRef(
  (e, t) => {
    const n = vt(wn, e.__scopeDialog), r = g.useRef(!1), o = g.useRef(!1);
    return /* @__PURE__ */ p.jsx(
      m5,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var s, a;
          (s = e.onCloseAutoFocus) == null || s.call(e, i), i.defaultPrevented || (r.current || (a = n.triggerRef.current) == null || a.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          var l, c;
          (l = e.onInteractOutside) == null || l.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = i.target;
          ((c = n.triggerRef.current) == null ? void 0 : c.contains(s)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), m5 = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, ...s } = e, a = vt(wn, n), l = g.useRef(null), c = fe(t, l);
    return Ca(), /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
      /* @__PURE__ */ p.jsx(
        Yo,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ p.jsx(
            tr,
            {
              role: "dialog",
              id: a.contentId,
              "aria-describedby": a.descriptionId,
              "aria-labelledby": a.titleId,
              "data-state": za(a.open),
              ...s,
              ref: c,
              onDismiss: () => a.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
        /* @__PURE__ */ p.jsx(Fg, { titleId: a.titleId }),
        /* @__PURE__ */ p.jsx(Hg, { contentRef: l, descriptionId: a.descriptionId })
      ] })
    ] });
  }
), Ha = "DialogTitle", g5 = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = vt(Ha, n);
    return /* @__PURE__ */ p.jsx($.h2, { id: o.titleId, ...r, ref: t });
  }
);
g5.displayName = Ha;
var v5 = "DialogDescription", C5 = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = vt(v5, n);
    return /* @__PURE__ */ p.jsx($.p, { id: o.descriptionId, ...r, ref: t });
  }
);
C5.displayName = v5;
var y5 = "DialogClose", x5 = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = vt(y5, n);
    return /* @__PURE__ */ p.jsx(
      $.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: F(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
x5.displayName = y5;
function za(e) {
  return e ? "open" : "closed";
}
var w5 = "DialogTitleWarning", [KS, b5] = u3(w5, {
  contentName: wn,
  titleName: Ha,
  docsSlug: "dialog"
}), Fg = ({ titleId: e }) => {
  const t = b5(w5), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return g.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, Bg = "DialogDescriptionWarning", Hg = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${b5(Bg).contentName}}.`;
  return g.useEffect(() => {
    var i;
    const o = (i = e.current) == null ? void 0 : i.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, zg = l5, Ug = u5, Kg = f5, A5 = h5, E5 = p5, S5 = g5, k5 = C5, R5 = x5;
const WS = zg, ZS = Ug, Wg = Kg, QS = R5, P5 = g.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  A5,
  {
    ref: n,
    className: ee(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
P5.displayName = A5.displayName;
const Zg = g.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ p.jsxs(Wg, { children: [
  /* @__PURE__ */ p.jsx(P5, {}),
  /* @__PURE__ */ p.jsxs(
    E5,
    {
      ref: r,
      className: ee(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
        e
      ),
      ...n,
      children: [
        t,
        /* @__PURE__ */ p.jsxs(R5, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: [
          /* @__PURE__ */ p.jsx(f7, { className: "h-4 w-4" }),
          /* @__PURE__ */ p.jsx("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
Zg.displayName = E5.displayName;
const Qg = ({
  className: e,
  ...t
}) => /* @__PURE__ */ p.jsx(
  "div",
  {
    className: ee(
      "flex flex-col space-y-1.5 text-center sm:text-left",
      e
    ),
    ...t
  }
);
Qg.displayName = "DialogHeader";
const Gg = ({
  className: e,
  ...t
}) => /* @__PURE__ */ p.jsx(
  "div",
  {
    className: ee(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...t
  }
);
Gg.displayName = "DialogFooter";
const $g = g.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  S5,
  {
    ref: n,
    className: ee(
      "text-lg font-semibold leading-none tracking-tight",
      e
    ),
    ...t
  }
));
$g.displayName = S5.displayName;
const qg = g.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  k5,
  {
    ref: n,
    className: ee("text-sm text-muted-foreground", e),
    ...t
  }
));
qg.displayName = k5.displayName;
const Xg = na(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function GS({ className: e, variant: t, ...n }) {
  return /* @__PURE__ */ p.jsx("div", { className: ee(Xg({ variant: t }), e), ...n });
}
const Yg = ({ letter: e, size: t, variant: n }) => {
  const r = t === "large" ? "w-8 h-8" : "w-6 h-6", o = t === "large" ? "" : "text-sm", i = ["variant-7", "variant-8"].includes(n) ? "text-gray-800" : "text-white", s = e.toUpperCase(), l = {
    "variant-1": "bg-gradient-to-br from-blue-700 to-cyan-400",
    "variant-2": "bg-gradient-to-br from-blue-700 to-emerald-400",
    "variant-3": "bg-gradient-to-br from-blue-700 to-lime-500",
    "variant-4": "bg-gradient-to-br from-blue-700 to-red-500",
    "variant-5": "bg-gradient-to-br from-blue-700 to-fuchsia-600",
    "variant-6": "bg-gradient-to-br from-blue-700 to-rose-600",
    "variant-7": "bg-gradient-to-br from-zinc-100 to-slate-300",
    "variant-8": "bg-gradient-to-br from-slate-300 to-slate-400"
  }[n] || "bg-gradient-to-br from-blue-700 to-cyan-400";
  return /* @__PURE__ */ p.jsx(
    "div",
    {
      className: `rounded-full flex items-center justify-center ${r} ${l}`,
      children: /* @__PURE__ */ p.jsx("span", { className: `${i} ${o}`, children: s })
    }
  );
}, $S = ({ priority: e }) => /* @__PURE__ */ p.jsx(he, { icon: `priority-${e}`, title: `priority-${e}` }), qS = ({
  properties: e,
  selectedPropertyIds: t,
  updatePropertyIds: n,
  buttonClassName: r
}) => {
  var u;
  const o = e.filter(
    (d) => !(t != null && t.length) || (t == null ? void 0 : t.includes(d.id))
  ), [i, s] = Ye.useState(
    t || []
  );
  bn(() => {
    t && s(t);
  }, [t]);
  const a = () => t != null && t.length ? o.length === 1 ? o[0].name : `${o.length} Properties` : "All Properties", [l, c] = Ye.useState(!1);
  return e.length ? e.length === 1 ? /* @__PURE__ */ p.jsx("span", { className: pn("font-normal text-base", r), children: (u = e[0]) == null ? void 0 : u.name }) : /* @__PURE__ */ p.jsxs(h7, { open: l, onOpenChange: (d) => {
    c(d), d || s(t || []);
  }, children: [
    /* @__PURE__ */ p.jsx(p7, { className: "flex items-center", asChild: !0, children: /* @__PURE__ */ p.jsxs(
      ho,
      {
        className: pn(
          "flex items-center space-x-1 font-normal p-0 outline-none",
          r
        ),
        variant: "ghost",
        children: [
          /* @__PURE__ */ p.jsx("span", { children: a() }),
          /* @__PURE__ */ p.jsx(
            he,
            {
              icon: "chevron-down",
              className: pn(
                "transition-rotate duration-300",
                l && "rotate-180"
              )
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ p.jsx(
      Nf,
      {
        className: "bg-white relative p-2",
        align: "center",
        style: { zIndex: 2147483646 },
        children: /* @__PURE__ */ p.jsxs("div", { className: "bg-", children: [
          /* @__PURE__ */ p.jsxs("ul", { children: [
            /* @__PURE__ */ p.jsx("li", { className: "border-b min-w-[200px]", children: /* @__PURE__ */ p.jsxs(
              ys,
              {
                className: "w-full",
                onSelect: (d) => {
                  d.preventDefault(), s([]);
                },
                children: [
                  /* @__PURE__ */ p.jsx(
                    he,
                    {
                      icon: "checkmark",
                      className: pn("mr-2", {
                        invisible: i.length
                      })
                    }
                  ),
                  /* @__PURE__ */ p.jsx("span", { className: "w-full block font-normal text-base", children: "All Properties" })
                ]
              }
            ) }),
            e.map((d) => {
              const f = i.includes(d.id);
              return /* @__PURE__ */ p.jsx("li", { className: "min-w-[200px]", children: /* @__PURE__ */ p.jsxs(
                ys,
                {
                  className: "w-full",
                  onSelect: (h) => {
                    h.preventDefault(), s(
                      f ? i.filter((v) => v !== d.id) : [...i, d.id]
                    );
                  },
                  children: [
                    /* @__PURE__ */ p.jsx(
                      he,
                      {
                        icon: "checkmark",
                        className: pn("mr-2", f ? "" : "invisible")
                      }
                    ),
                    /* @__PURE__ */ p.jsx("span", { className: "w-full block font-normal text-base", children: d == null ? void 0 : d.name })
                  ]
                }
              ) }, d.id);
            })
          ] }),
          /* @__PURE__ */ p.jsxs("div", { className: "flex justify-between items-start", children: [
            /* @__PURE__ */ p.jsx(
              ho,
              {
                variant: "ghost",
                disabled: i.join() === (t == null ? void 0 : t.join()),
                onClick: () => {
                  s(t || []), c(!1);
                },
                children: "Cancel"
              }
            ),
            /* @__PURE__ */ p.jsx(
              ho,
              {
                variant: "default",
                disabled: i.join() === (t == null ? void 0 : t.join()),
                onClick: () => {
                  n == null || n(i), c(!1);
                },
                children: "Apply"
              }
            )
          ] })
        ] })
      }
    )
  ] }) : null;
}, Jg = (e) => {
  switch (Math.round(e * 4)) {
    case 0:
      return "progress-zero";
    case 1:
      return "progress-one";
    case 2:
      return "progress-two";
    case 3:
      return "progress-three";
    case 4:
      return "progress-done";
    default:
      return "progress-zero";
  }
}, XS = ({ workItems: e }) => {
  if (!e || e.length === 0)
    return /* @__PURE__ */ p.jsxs("span", { className: "inline-flex items-center border border-solid border-border rounded-xl px-2 py-1", children: [
      /* @__PURE__ */ p.jsx(he, { className: "pr-2", icon: "progress-zero" }),
      /* @__PURE__ */ p.jsx("p", { className: "text-base text-muted-foreground", children: "0/0" })
    ] });
  const t = e.length, n = e.filter((i) => i == null ? void 0 : i.is_complete).length, r = t === 0 ? 0 : n / t, o = Jg(r);
  return /* @__PURE__ */ p.jsxs("span", { className: "inline-flex items-center border border-solid border-border rounded-xl px-2 py-1", children: [
    /* @__PURE__ */ p.jsx(he, { className: "pr-2", icon: o }),
    /* @__PURE__ */ p.jsx("p", { className: "text-base text-muted-foreground", children: `${n}/${t}` })
  ] });
}, YS = ({ assignee: e, editable: t = !1 }) => {
  if (!e || !e.full_name)
    return null;
  const r = ((o) => {
    const i = o.trim().split(/\s+/);
    if (i.length === 1) return o;
    const s = i[0], a = i[i.length - 1][0];
    return `${s} ${a}.`;
  })(e.full_name);
  return /* @__PURE__ */ p.jsxs("div", { className: "inline-flex gap-1", children: [
    /* @__PURE__ */ p.jsx(
      Yg,
      {
        letter: e.full_name[0].toUpperCase(),
        variant: t ? "variant-1" : "variant-7",
        size: "small"
      }
    ),
    /* @__PURE__ */ p.jsx("p", { children: r })
  ] });
}, e8 = An(null), ji = {
  didCatch: !1,
  error: null
};
class t8 extends Iu {
  constructor(t) {
    super(t), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = ji;
  }
  static getDerivedStateFromError(t) {
    return {
      didCatch: !0,
      error: t
    };
  }
  resetErrorBoundary() {
    const {
      error: t
    } = this.state;
    if (t !== null) {
      for (var n, r, o = arguments.length, i = new Array(o), s = 0; s < o; s++)
        i[s] = arguments[s];
      (n = (r = this.props).onReset) === null || n === void 0 || n.call(r, {
        args: i,
        reason: "imperative-api"
      }), this.setState(ji);
    }
  }
  componentDidCatch(t, n) {
    var r, o;
    (r = (o = this.props).onError) === null || r === void 0 || r.call(o, t, n);
  }
  componentDidUpdate(t, n) {
    const {
      didCatch: r
    } = this.state, {
      resetKeys: o
    } = this.props;
    if (r && n.error !== null && n8(t.resetKeys, o)) {
      var i, s;
      (i = (s = this.props).onReset) === null || i === void 0 || i.call(s, {
        next: o,
        prev: t.resetKeys,
        reason: "keys"
      }), this.setState(ji);
    }
  }
  render() {
    const {
      children: t,
      fallbackRender: n,
      FallbackComponent: r,
      fallback: o
    } = this.props, {
      didCatch: i,
      error: s
    } = this.state;
    let a = t;
    if (i) {
      const l = {
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof n == "function")
        a = n(l);
      else if (r)
        a = Wn(r, l);
      else if (o !== void 0)
        a = o;
      else
        throw s;
    }
    return Wn(e8.Provider, {
      value: {
        didCatch: i,
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, a);
  }
}
function n8() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return e.length !== t.length || e.some((n, r) => !Object.is(n, t[r]));
}
const xc = {
  address1: !0,
  address2: !1,
  city: !0,
  state_or_province: !0,
  postal_code: !0,
  country: !1
}, r8 = (e) => typeof e != "object" || e === null ? !1 : "address1" in e && "city" in e && "state_or_province" in e && "postal_code" in e && "country" in e, wc = (e, t) => e.length > t ? e.substring(0, t) + "..." : e, o8 = (e, t = 30, n = xc) => {
  if (!e || typeof e != "object")
    return "";
  const { address1: r, address2: o, city: i, state_or_province: s, postal_code: a, country: l } = { ...xc, ...n }, c = [];
  return r && e.address1 && c.push(wc(e.address1, t)), o && e.address2 && c.push(wc(e.address2, t)), i && e.city && c.push(e.city), s && e.state_or_province && c.push(e.state_or_province), a && e.postal_code && c.push(e.postal_code), l && c.push(e.country || "US"), c.length > 0 ? c.join(", ") : "";
}, i8 = 4, bc = 3, s8 = {
  unit_number: /* @__PURE__ */ p.jsx(he, { icon: "unit", title: "unit" }),
  applicant_full_name: /* @__PURE__ */ p.jsx(he, { icon: "person", title: "person" }),
  full_name: /* @__PURE__ */ p.jsx(he, { icon: "person", title: "person" }),
  number_of_bedrooms: /* @__PURE__ */ p.jsx(he, { icon: "bedroom", title: "bedrooms", className: "pr-1" }),
  number_of_bathrooms: /* @__PURE__ */ p.jsx(he, { icon: "bathroom", title: "bathrooms", className: "pr-1" }),
  square_footage: /* @__PURE__ */ p.jsx(he, { icon: "square-footage", title: "square footage", className: "pr-1" }),
  policy_name: /* @__PURE__ */ p.jsx(he, { icon: "document", title: "policy document", className: "pr-1" })
}, a8 = {
  unit_number: /* @__PURE__ */ p.jsxs("div", { className: "flex items-center space-x-1", children: [
    /* @__PURE__ */ p.jsx(Ut, { className: "w-2 h-1" }),
    /* @__PURE__ */ p.jsx(Ut, { className: "w-1 h-1" }),
    /* @__PURE__ */ p.jsx(Ut, { className: "w-4 h-1" })
  ] }),
  name: /* @__PURE__ */ p.jsxs("div", { className: "flex items-center space-x-1", children: [
    /* @__PURE__ */ p.jsx(Ut, { className: "w-4 h-1" }),
    /* @__PURE__ */ p.jsx(Ut, { className: "w-5 h-1" })
  ] })
}, l8 = [
  { regex: /date/i, icon: /* @__PURE__ */ p.jsx(he, { icon: "clock", title: "clock" }) },
  { regex: /resident/i, icon: /* @__PURE__ */ p.jsx(he, { icon: "person", title: "person" }) }
], oo = (e) => e ? Array.isArray(e) ? e.length === 0 ? "" : e.length === 1 ? typeof e[0] == "string" ? e[0] : e[0].full_name : `${e[0]}${e.length > 1 ? ` + ${e.length - 1}` : ""}` : e : "", c8 = (e) => {
  const t = e.reduce(
    (n, r) => (n[r.type] = (n[r.type] || 0) + 1, n),
    {}
  );
  return Object.entries(t).map(([n, r]) => `${r} ${n}${r > 1 ? "s" : ""}`).join(", ");
}, u8 = {
  Application: {
    idField: "application_id",
    columns: [
      { column: "application_status", order: 1 },
      { column: "unit_number", order: 2 },
      { column: "applicant_full_name", order: 3 },
      { column: "application_started_date", order: 4 }
    ],
    iconKeyMapping: {
      application_status: (e, t) => ({
        Completed: /* @__PURE__ */ p.jsx(Mn, { status: dn.Completed }),
        "Partially Completed": /* @__PURE__ */ p.jsx(Mn, { status: dn.PartiallyCompleted }),
        Cancelled: /* @__PURE__ */ p.jsx(Mn, { status: dn.Cancelled }),
        Declined: /* @__PURE__ */ p.jsx(Mn, { status: dn.Declined }),
        Archived: /* @__PURE__ */ p.jsx(Mn, { status: dn.Archived }),
        Approved: /* @__PURE__ */ p.jsx(Mn, { status: dn.Approved }),
        Loading: /* @__PURE__ */ p.jsx(he, { icon: "progress-zero" })
      })[t ? "Loading" : e]
    },
    loaderMapping: {
      applicant_full_name: "name"
    }
  },
  Resident360: {
    idField: "id",
    columns: [
      { column: "unit_number", order: 1 },
      {
        column: "full_name",
        order: 2
      },
      {
        column: "email_address",
        order: 3
      },
      {
        column: "phone_number",
        order: 4
      }
    ]
  },
  Unit: {
    idField: "id",
    columns: [
      { column: "unit_number", order: 1 }
    ],
    formatting: {
      current_residents: oo,
      previous_residents: oo,
      pets: c8
    }
  },
  Lease: {
    idField: "id",
    columns: [
      { column: "unit_number", order: 1 },
      { column: "primary_resident", order: 2 },
      { column: "lease_start_date", order: 3 },
      { column: "lease_end_date", order: 4 }
    ],
    formatting: {
      primary_resident: (e) => e ? e.full_name : ""
    }
  },
  Policy: {
    idField: "name",
    columns: [{ column: "name", order: 1 }],
    iconKeyMapping: { name: "policy_name" },
    formatting: {
      name: (e) => {
        const n = e.replace(/^\d+/, "").replace(/[-_]/g, " ").trim(), r = n.charAt(0).toUpperCase() + n.slice(1).toLowerCase();
        return r.toLowerCase().includes("policy") ? r : r + " policy";
      }
    }
  },
  FloorPlan: {
    idField: "floor_plan_name",
    columns: []
  },
  MoveIn: {
    idField: "unit_number",
    formatting: {
      resident_full_names: oo
    },
    columns: [
      { column: "unit_number", order: 1 },
      { column: "resident_full_names", order: 2 },
      { column: "move_in_date", order: 3 }
    ]
  },
  MoveOut: {
    idField: "unit_number",
    formatting: {
      resident_full_names: oo
    },
    columns: [
      { column: "unit_number", order: 1 },
      { column: "resident_full_names", order: 2 },
      { column: "move_out_date", order: 3 },
      { column: "move_out_reason", order: 4 }
    ]
  },
  RenewalTask: {
    idField: "id",
    columns: [
      {
        column: "unit_number",
        order: 1,
        getValue: (e) => {
          var t;
          return (t = e.unit_summary) == null ? void 0 : t.unit_number;
        }
      },
      {
        column: "primary_resident_full_name",
        order: 2,
        getValue: (e) => {
          var t, n;
          return (n = (t = e.residents) == null ? void 0 : t[0]) == null ? void 0 : n.full_name;
        }
      },
      {
        column: "expiring_lease_end_date",
        order: 3,
        getValue: (e) => {
          var t;
          return (t = e.lease_summary) == null ? void 0 : t.end_date;
        }
      },
      {
        column: "status",
        order: 4,
        getValue: (e) => e.work_item_progress_summary
      }
    ]
  },
  ServiceRequestTask: {
    idField: "id",
    columns: [
      {
        column: "priority",
        order: 1,
        getValue: (e) => e.entity.priority
      },
      {
        column: "description",
        order: 2,
        getValue: (e) => e.entity.description
      },
      {
        column: "date_opened",
        order: 3,
        getValue: (e) => e.entity.created_date
      },
      {
        column: "unit_number",
        order: 4,
        getValue: (e) => {
          var t;
          return (t = e.unit_summary) == null ? void 0 : t.unit_number;
        }
      }
    ]
  }
}, d8 = (e, t) => {
  var r;
  const n = ((r = t.loaderMapping) == null ? void 0 : r[e]) || e;
  return a8[n] || null;
}, f8 = (e, t, n, r) => {
  var s;
  const o = ((s = n.iconKeyMapping) == null ? void 0 : s[e]) || e, i = typeof o == "function" ? o(t, r) : s8[o];
  if (i)
    return i;
  for (const { regex: a, icon: l } of l8)
    if (a.test(e)) return l;
  return null;
}, h8 = (e, t, n) => {
  var s;
  const r = (s = n == null ? void 0 : n.formatting) == null ? void 0 : s[e];
  if (r) return r(t);
  const o = /date/i, i = /address/i;
  return typeof t == "string" && o.test(e) ? o3(t) : i.test(e) && r8(t) ? o8(t) : Array.isArray(t) ? t.join(", ") : typeof t == "object" && t !== null ? JSON.stringify(t) : t;
}, p8 = ({
  item: e,
  isLoading: t,
  config: n,
  idField: r,
  fullPageUrl: o,
  preferredColumns: i,
  borderRadiusClass: s
}) => {
  const a = i.length === 1;
  return /* @__PURE__ */ p.jsx(
    "li",
    {
      className: `flex gap-6 border-b border-solid border-gray-100 items-center last:border-b-0 hover:bg-gray-50 transition-colors duration-200 ease-in-out cursor-pointer ${s}`,
      children: /* @__PURE__ */ p.jsxs(
        "a",
        {
          href: `${o}?source=${e.sourceId}&id=${e[r]}`,
          className: "flex gap-6 items-center w-full p-3",
          children: [
            i.map(
              ({
                column: l,
                getValue: c
              }, u) => {
                var m, y;
                const d = c ? c(e) : Uu(e, l), f = f8(l, d, n, !!t), h = d8(l, n), v = ((m = n.columnWidthMapping) == null ? void 0 : m[l]) || "";
                return /* @__PURE__ */ p.jsxs(z6, { children: [
                  /* @__PURE__ */ p.jsx(
                    U6,
                    {
                      asChild: !0,
                      className: `${i.length !== 1 && u === i.length - 1 ? "ml-auto" : ""}`,
                      children: /* @__PURE__ */ p.jsxs("div", { className: `flex items-center ${v}`, children: [
                        f && /* @__PURE__ */ p.jsx("span", { className: "pr-1 flex-shrink-0", children: f }),
                        /* @__PURE__ */ p.jsx(t8, { fallback: /* @__PURE__ */ p.jsx("span", { children: "-" }), children: t ? /* @__PURE__ */ p.jsx("div", { children: h || /* @__PURE__ */ p.jsx(Ut, { className: "w-8 h-1" }) }) : /* @__PURE__ */ p.jsx("span", { children: l === "applicant_full_name" && ((y = e.co_applicants) == null ? void 0 : y.length) > 0 ? `${d} + ${e.co_applicants.length}` : h8(l, d, n) }) })
                      ] })
                    }
                  ),
                  /* @__PURE__ */ p.jsx(Cd, { className: "bg-white rounded-2xl p-2 border-solid border border-border shadow-md", children: /* @__PURE__ */ p.jsx("p", { children: l.replace(/_/g, " ") }) })
                ] }, l);
              }
            ),
            /* @__PURE__ */ p.jsx(
              he,
              {
                icon: "chevron-right",
                className: `${a ? "ml-auto" : ""}`
              }
            )
          ]
        }
      )
    }
  );
}, m8 = ({
  isLoading: e,
  fullPageUrl: t,
  borderRadiusClass: n
}) => /* @__PURE__ */ p.jsx(
  "li",
  {
    className: `flex gap-6 border-b border-solid border-gray-200 items-center last:border-b-0 hover:bg-gray-50 transition-colors duration-200 ease-in-out cursor-pointer text-center ${n}`,
    children: /* @__PURE__ */ p.jsxs(
      "a",
      {
        href: t,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "w-full flex items-center justify-center text-sm text-muted-foreground p-2",
        children: [
          /* @__PURE__ */ p.jsx(he, { icon: "applications", className: "mr-1" }),
          e ? /* @__PURE__ */ p.jsxs("div", { className: "flex items-center space-x-1", children: [
            /* @__PURE__ */ p.jsx(Ut, { className: "w-6 h-1" }),
            /* @__PURE__ */ p.jsx(Ut, { className: "w-3 h-1" })
          ] }) : "View All",
          /* @__PURE__ */ p.jsx(he, { icon: "chevron-right" })
        ]
      }
    )
  }
), g8 = (e, t, n) => t === 1 ? "rounded-xl" : e === 0 ? "rounded-t-xl" : e === t - 1 && !n ? "rounded-b-xl" : "", JS = ({
  source: e,
  dialogueId: t,
  baseUrl: n,
  isLoading: r
}) => {
  const { data: o, id: i, priority_column_names: s } = e;
  if (!o || o.items.length === 0) return null;
  const a = o.items[0].type, l = u8[a];
  if (!l)
    return console.warn(`No configuration found for source: ${a}`), null;
  const c = o.items.slice(0, bc), u = o.items.length - bc, d = `${n}/ask/question/${t}`, f = l.idField, h = [
    ...l.columns,
    ...(Array.isArray(s) ? s : []).filter(
      (v) => !l.columns.some(
        ({ column: m }) => m === v
      )
    ).slice(0, i8 - l.columns.length).map((v, m) => ({
      column: v,
      order: l.columns.length + m + 1
    }))
  ].sort((v, m) => v.order - m.order);
  return /* @__PURE__ */ p.jsx(
    "div",
    {
      className: pn(
        "rounded-xl border border-solid border-border my-4 shadow",
        { "pointer-events-none": r }
      ),
      children: /* @__PURE__ */ p.jsxs("ol", { children: [
        c.map((v, m) => /* @__PURE__ */ p.jsx(
          p8,
          {
            isLoading: r,
            item: { ...v, sourceId: i },
            config: l,
            idField: f,
            fullPageUrl: d,
            preferredColumns: h,
            borderRadiusClass: g8(
              m,
              c.length,
              u > 0
            )
          },
          m
        )),
        u > 0 && /* @__PURE__ */ p.jsx(
          m8,
          {
            isLoading: r,
            fullPageUrl: d,
            remainingItemsCount: u,
            borderRadiusClass: "rounded-b-xl"
          }
        )
      ] })
    }
  );
}, v8 = "_heartBeat_15ik5_6", C8 = "_pulseAnimation_15ik5_1", y8 = {
  heartBeat: v8,
  pulseAnimation: C8
}, ek = () => {
  const [e, t] = Sr("");
  return bn(() => {
    const n = setInterval(() => {
      t((r) => r.length < 3 ? r + "." : "");
    }, 500);
    return () => clearInterval(n);
  }, []), /* @__PURE__ */ p.jsx("div", { className: "flex items-center space-x-2", children: /* @__PURE__ */ p.jsxs("div", { className: "flex items-center text-gray-900 text-base font-normal font-sans gap-2", children: [
    /* @__PURE__ */ p.jsx(he, { icon: "entrata", title: "entrata", className: y8.heartBeat }),
    /* @__PURE__ */ p.jsx("span", { children: `Reading source${e}` })
  ] }) });
}, Ac = /* @__PURE__ */ new Set();
function ai(e, t, n) {
  e || Ac.has(t) || (console.warn(t), Ac.add(t));
}
function x8(e) {
  if (typeof Proxy > "u")
    return e;
  const t = /* @__PURE__ */ new Map(), n = (...r) => (process.env.NODE_ENV !== "production" && ai(!1, "motion() is deprecated. Use motion.create() instead."), e(...r));
  return new Proxy(n, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (r, o) => o === "create" ? e : (t.has(o) || t.set(o, e(o)), t.get(o))
  });
}
function Mr(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
const Ts = (e) => Array.isArray(e);
function T5(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
function Ir(e) {
  return typeof e == "string" || Array.isArray(e);
}
function Ec(e) {
  const t = [{}, {}];
  return e == null || e.values.forEach((n, r) => {
    t[0][r] = n.get(), t[1][r] = n.getVelocity();
  }), t;
}
function Ua(e, t, n, r) {
  if (typeof t == "function") {
    const [o, i] = Ec(r);
    t = t(n !== void 0 ? n : e.custom, o, i);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [o, i] = Ec(r);
    t = t(n !== void 0 ? n : e.custom, o, i);
  }
  return t;
}
function li(e, t, n) {
  const r = e.getProps();
  return Ua(r, t, n !== void 0 ? n : r.custom, e);
}
const Ka = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], Wa = ["initial", ...Ka], Wr = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], rn = new Set(Wr), wt = (e) => e * 1e3, Mt = (e) => e / 1e3, w8 = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, b8 = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), A8 = {
  type: "keyframes",
  duration: 0.8
}, E8 = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, S8 = (e, { keyframes: t }) => t.length > 2 ? A8 : rn.has(e) ? e.startsWith("scale") ? b8(t[1]) : w8 : E8;
function Za(e, t) {
  return e ? e[t] || e.default || e : void 0;
}
const k8 = {
  skipAnimations: !1,
  useManualTiming: !1
}, R8 = (e) => e !== null;
function ci(e, { repeat: t, repeatType: n = "loop" }, r) {
  const o = e.filter(R8), i = t && n !== "loop" && t % 2 === 1 ? 0 : o.length - 1;
  return !i || r === void 0 ? o[i] : r;
}
const Ne = (e) => e;
function P8(e) {
  let t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = !1, o = !1;
  const i = /* @__PURE__ */ new WeakSet();
  let s = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function a(c) {
    i.has(c) && (l.schedule(c), e()), c(s);
  }
  const l = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (c, u = !1, d = !1) => {
      const h = d && r ? t : n;
      return u && i.add(c), h.has(c) || h.add(c), c;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (c) => {
      n.delete(c), i.delete(c);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (c) => {
      if (s = c, r) {
        o = !0;
        return;
      }
      r = !0, [t, n] = [n, t], n.clear(), t.forEach(a), r = !1, o && (o = !1, l.process(c));
    }
  };
  return l;
}
const io = [
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], T8 = 40;
function M5(e, t) {
  let n = !1, r = !0;
  const o = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, i = () => n = !0, s = io.reduce((C, x) => (C[x] = P8(i), C), {}), { read: a, resolveKeyframes: l, update: c, preRender: u, render: d, postRender: f } = s, h = () => {
    const C = performance.now();
    n = !1, o.delta = r ? 1e3 / 60 : Math.max(Math.min(C - o.timestamp, T8), 1), o.timestamp = C, o.isProcessing = !0, a.process(o), l.process(o), c.process(o), u.process(o), d.process(o), f.process(o), o.isProcessing = !1, n && t && (r = !1, e(h));
  }, v = () => {
    n = !0, r = !0, o.isProcessing || e(h);
  };
  return { schedule: io.reduce((C, x) => {
    const w = s[x];
    return C[x] = (S, R = !1, k = !1) => (n || v(), w.schedule(S, R, k)), C;
  }, {}), cancel: (C) => {
    for (let x = 0; x < io.length; x++)
      s[io[x]].cancel(C);
  }, state: o, steps: s };
}
const { schedule: ve, cancel: Xt, state: Le, steps: Vi } = M5(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Ne, !0), I5 = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, M8 = 1e-7, I8 = 12;
function _8(e, t, n, r, o) {
  let i, s, a = 0;
  do
    s = t + (n - t) / 2, i = I5(s, r, o) - e, i > 0 ? n = s : t = s;
  while (Math.abs(i) > M8 && ++a < I8);
  return s;
}
function Zr(e, t, n, r) {
  if (e === t && n === r)
    return Ne;
  const o = (i) => _8(i, 0, 1, e, n);
  return (i) => i === 0 || i === 1 ? i : I5(o(i), t, r);
}
const _5 = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, L5 = (e) => (t) => 1 - e(1 - t), N5 = /* @__PURE__ */ Zr(0.33, 1.53, 0.69, 0.99), Qa = /* @__PURE__ */ L5(N5), D5 = /* @__PURE__ */ _5(Qa), O5 = (e) => (e *= 2) < 1 ? 0.5 * Qa(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), Ga = (e) => 1 - Math.sin(Math.acos(e)), j5 = L5(Ga), V5 = _5(Ga), F5 = (e) => /^0[^.\s]+$/u.test(e);
function L8(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || F5(e) : !0;
}
let or = Ne, Dt = Ne;
process.env.NODE_ENV !== "production" && (or = (e, t) => {
  !e && typeof console < "u" && console.warn(t);
}, Dt = (e, t) => {
  if (!e)
    throw new Error(t);
});
const B5 = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e), H5 = (e) => (t) => typeof t == "string" && t.startsWith(e), z5 = /* @__PURE__ */ H5("--"), N8 = /* @__PURE__ */ H5("var(--"), $a = (e) => N8(e) ? D8.test(e.split("/*")[0].trim()) : !1, D8 = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, O8 = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function j8(e) {
  const t = O8.exec(e);
  if (!t)
    return [,];
  const [, n, r, o] = t;
  return [`--${n ?? r}`, o];
}
const V8 = 4;
function U5(e, t, n = 1) {
  Dt(n <= V8, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`);
  const [r, o] = j8(e);
  if (!r)
    return;
  const i = window.getComputedStyle(t).getPropertyValue(r);
  if (i) {
    const s = i.trim();
    return B5(s) ? parseFloat(s) : s;
  }
  return $a(o) ? U5(o, t, n + 1) : o;
}
const Yt = (e, t, n) => n > t ? t : n < e ? e : n, ir = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, _r = {
  ...ir,
  transform: (e) => Yt(0, 1, e)
}, so = {
  ...ir,
  default: 1
}, Qr = (e) => ({
  test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), zt = /* @__PURE__ */ Qr("deg"), bt = /* @__PURE__ */ Qr("%"), G = /* @__PURE__ */ Qr("px"), F8 = /* @__PURE__ */ Qr("vh"), B8 = /* @__PURE__ */ Qr("vw"), Sc = {
  ...bt,
  parse: (e) => bt.parse(e) / 100,
  transform: (e) => bt.transform(e * 100)
}, H8 = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]), kc = (e) => e === ir || e === G, Rc = (e, t) => parseFloat(e.split(", ")[t]), Pc = (e, t) => (n, { transform: r }) => {
  if (r === "none" || !r)
    return 0;
  const o = r.match(/^matrix3d\((.+)\)$/u);
  if (o)
    return Rc(o[1], t);
  {
    const i = r.match(/^matrix\((.+)\)$/u);
    return i ? Rc(i[1], e) : 0;
  }
}, z8 = /* @__PURE__ */ new Set(["x", "y", "z"]), U8 = Wr.filter((e) => !z8.has(e));
function K8(e) {
  const t = [];
  return U8.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t;
}
const Gn = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: Pc(4, 13),
  y: Pc(5, 14)
};
Gn.translateX = Gn.x;
Gn.translateY = Gn.y;
const K5 = (e) => (t) => t.test(e), W8 = {
  test: (e) => e === "auto",
  parse: (e) => e
}, W5 = [ir, G, bt, zt, B8, F8, W8], Tc = (e) => W5.find(K5(e)), Cn = /* @__PURE__ */ new Set();
let Ms = !1, Is = !1;
function Z5() {
  if (Is) {
    const e = Array.from(Cn).filter((r) => r.needsMeasurement), t = new Set(e.map((r) => r.element)), n = /* @__PURE__ */ new Map();
    t.forEach((r) => {
      const o = K8(r);
      o.length && (n.set(r, o), r.render());
    }), e.forEach((r) => r.measureInitialState()), t.forEach((r) => {
      r.render();
      const o = n.get(r);
      o && o.forEach(([i, s]) => {
        var a;
        (a = r.getValue(i)) === null || a === void 0 || a.set(s);
      });
    }), e.forEach((r) => r.measureEndState()), e.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  Is = !1, Ms = !1, Cn.forEach((e) => e.complete()), Cn.clear();
}
function Q5() {
  Cn.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (Is = !0);
  });
}
function Z8() {
  Q5(), Z5();
}
class qa {
  constructor(t, n, r, o, i, s = !1) {
    this.isComplete = !1, this.isAsync = !1, this.needsMeasurement = !1, this.isScheduled = !1, this.unresolvedKeyframes = [...t], this.onComplete = n, this.name = r, this.motionValue = o, this.element = i, this.isAsync = s;
  }
  scheduleResolve() {
    this.isScheduled = !0, this.isAsync ? (Cn.add(this), Ms || (Ms = !0, ve.read(Q5), ve.resolveKeyframes(Z5))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: n, element: r, motionValue: o } = this;
    for (let i = 0; i < t.length; i++)
      if (t[i] === null)
        if (i === 0) {
          const s = o == null ? void 0 : o.get(), a = t[t.length - 1];
          if (s !== void 0)
            t[0] = s;
          else if (r && n) {
            const l = r.readValue(n, a);
            l != null && (t[0] = l);
          }
          t[0] === void 0 && (t[0] = a), o && s === void 0 && o.set(t[0]);
        } else
          t[i] = t[i - 1];
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete() {
    this.isComplete = !0, this.onComplete(this.unresolvedKeyframes, this.finalKeyframe), Cn.delete(this);
  }
  cancel() {
    this.isComplete || (this.isScheduled = !1, Cn.delete(this));
  }
  resume() {
    this.isComplete || this.scheduleResolve();
  }
}
const xr = (e) => Math.round(e * 1e5) / 1e5, Xa = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function Q8(e) {
  return e == null;
}
const G8 = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, Ya = (e, t) => (n) => !!(typeof n == "string" && G8.test(n) && n.startsWith(e) || t && !Q8(n) && Object.prototype.hasOwnProperty.call(n, t)), G5 = (e, t, n) => (r) => {
  if (typeof r != "string")
    return r;
  const [o, i, s, a] = r.match(Xa);
  return {
    [e]: parseFloat(o),
    [t]: parseFloat(i),
    [n]: parseFloat(s),
    alpha: a !== void 0 ? parseFloat(a) : 1
  };
}, $8 = (e) => Yt(0, 255, e), Fi = {
  ...ir,
  transform: (e) => Math.round($8(e))
}, gn = {
  test: /* @__PURE__ */ Ya("rgb", "red"),
  parse: /* @__PURE__ */ G5("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + Fi.transform(e) + ", " + Fi.transform(t) + ", " + Fi.transform(n) + ", " + xr(_r.transform(r)) + ")"
};
function q8(e) {
  let t = "", n = "", r = "", o = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), o = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), o = e.substring(4, 5), t += t, n += n, r += r, o += o), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: o ? parseInt(o, 16) / 255 : 1
  };
}
const _s = {
  test: /* @__PURE__ */ Ya("#"),
  parse: q8,
  transform: gn.transform
}, Dn = {
  test: /* @__PURE__ */ Ya("hsl", "hue"),
  parse: /* @__PURE__ */ G5("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + bt.transform(xr(t)) + ", " + bt.transform(xr(n)) + ", " + xr(_r.transform(r)) + ")"
}, De = {
  test: (e) => gn.test(e) || _s.test(e) || Dn.test(e),
  parse: (e) => gn.test(e) ? gn.parse(e) : Dn.test(e) ? Dn.parse(e) : _s.parse(e),
  transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? gn.transform(e) : Dn.transform(e)
}, X8 = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function Y8(e) {
  var t, n;
  return isNaN(e) && typeof e == "string" && (((t = e.match(Xa)) === null || t === void 0 ? void 0 : t.length) || 0) + (((n = e.match(X8)) === null || n === void 0 ? void 0 : n.length) || 0) > 0;
}
const $5 = "number", q5 = "color", J8 = "var", ev = "var(", Mc = "${}", tv = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Lr(e) {
  const t = e.toString(), n = [], r = {
    color: [],
    number: [],
    var: []
  }, o = [];
  let i = 0;
  const a = t.replace(tv, (l) => (De.test(l) ? (r.color.push(i), o.push(q5), n.push(De.parse(l))) : l.startsWith(ev) ? (r.var.push(i), o.push(J8), n.push(l)) : (r.number.push(i), o.push($5), n.push(parseFloat(l))), ++i, Mc)).split(Mc);
  return { values: n, split: a, indexes: r, types: o };
}
function X5(e) {
  return Lr(e).values;
}
function Y5(e) {
  const { split: t, types: n } = Lr(e), r = t.length;
  return (o) => {
    let i = "";
    for (let s = 0; s < r; s++)
      if (i += t[s], o[s] !== void 0) {
        const a = n[s];
        a === $5 ? i += xr(o[s]) : a === q5 ? i += De.transform(o[s]) : i += o[s];
      }
    return i;
  };
}
const nv = (e) => typeof e == "number" ? 0 : e;
function rv(e) {
  const t = X5(e);
  return Y5(e)(t.map(nv));
}
const Jt = {
  test: Y8,
  parse: X5,
  createTransformer: Y5,
  getAnimatableNone: rv
}, ov = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function iv(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(Xa) || [];
  if (!r)
    return e;
  const o = n.replace(r, "");
  let i = ov.has(t) ? 1 : 0;
  return r !== n && (i *= 100), t + "(" + i + o + ")";
}
const sv = /\b([a-z-]*)\(.*?\)/gu, Ls = {
  ...Jt,
  getAnimatableNone: (e) => {
    const t = e.match(sv);
    return t ? t.map(iv).join(" ") : e;
  }
}, av = {
  // Border props
  borderWidth: G,
  borderTopWidth: G,
  borderRightWidth: G,
  borderBottomWidth: G,
  borderLeftWidth: G,
  borderRadius: G,
  radius: G,
  borderTopLeftRadius: G,
  borderTopRightRadius: G,
  borderBottomRightRadius: G,
  borderBottomLeftRadius: G,
  // Positioning props
  width: G,
  maxWidth: G,
  height: G,
  maxHeight: G,
  top: G,
  right: G,
  bottom: G,
  left: G,
  // Spacing props
  padding: G,
  paddingTop: G,
  paddingRight: G,
  paddingBottom: G,
  paddingLeft: G,
  margin: G,
  marginTop: G,
  marginRight: G,
  marginBottom: G,
  marginLeft: G,
  // Misc
  backgroundPositionX: G,
  backgroundPositionY: G
}, lv = {
  rotate: zt,
  rotateX: zt,
  rotateY: zt,
  rotateZ: zt,
  scale: so,
  scaleX: so,
  scaleY: so,
  scaleZ: so,
  skew: zt,
  skewX: zt,
  skewY: zt,
  distance: G,
  translateX: G,
  translateY: G,
  translateZ: G,
  x: G,
  y: G,
  z: G,
  perspective: G,
  transformPerspective: G,
  opacity: _r,
  originX: Sc,
  originY: Sc,
  originZ: G
}, Ic = {
  ...ir,
  transform: Math.round
}, Ja = {
  ...av,
  ...lv,
  zIndex: Ic,
  size: G,
  // SVG
  fillOpacity: _r,
  strokeOpacity: _r,
  numOctaves: Ic
}, cv = {
  ...Ja,
  // Color props
  color: De,
  backgroundColor: De,
  outlineColor: De,
  fill: De,
  stroke: De,
  // Border props
  borderColor: De,
  borderTopColor: De,
  borderRightColor: De,
  borderBottomColor: De,
  borderLeftColor: De,
  filter: Ls,
  WebkitFilter: Ls
}, el = (e) => cv[e];
function J5(e, t) {
  let n = el(e);
  return n !== Ls && (n = Jt), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const uv = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function dv(e, t, n) {
  let r = 0, o;
  for (; r < e.length && !o; ) {
    const i = e[r];
    typeof i == "string" && !uv.has(i) && Lr(i).values.length && (o = e[r]), r++;
  }
  if (o && n)
    for (const i of t)
      e[i] = J5(n, o);
}
class eh extends qa {
  constructor(t, n, r, o, i) {
    super(t, n, r, o, i, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: n, name: r } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let l = 0; l < t.length; l++) {
      let c = t[l];
      if (typeof c == "string" && (c = c.trim(), $a(c))) {
        const u = U5(c, n.current);
        u !== void 0 && (t[l] = u), l === t.length - 1 && (this.finalKeyframe = c);
      }
    }
    if (this.resolveNoneKeyframes(), !H8.has(r) || t.length !== 2)
      return;
    const [o, i] = t, s = Tc(o), a = Tc(i);
    if (s !== a)
      if (kc(s) && kc(a))
        for (let l = 0; l < t.length; l++) {
          const c = t[l];
          typeof c == "string" && (t[l] = parseFloat(c));
        }
      else
        this.needsMeasurement = !0;
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: n } = this, r = [];
    for (let o = 0; o < t.length; o++)
      L8(t[o]) && r.push(o);
    r.length && dv(t, r, n);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: n, name: r } = this;
    if (!t || !t.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = Gn[r](t.measureViewportBox(), window.getComputedStyle(t.current)), n[0] = this.measuredOrigin;
    const o = n[n.length - 1];
    o !== void 0 && t.getValue(r, o).jump(o, !1);
  }
  measureEndState() {
    var t;
    const { element: n, name: r, unresolvedKeyframes: o } = this;
    if (!n || !n.current)
      return;
    const i = n.getValue(r);
    i && i.jump(this.measuredOrigin, !1);
    const s = o.length - 1, a = o[s];
    o[s] = Gn[r](n.measureViewportBox(), window.getComputedStyle(n.current)), a !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = a), !((t = this.removedTransforms) === null || t === void 0) && t.length && this.removedTransforms.forEach(([l, c]) => {
      n.getValue(l).set(c);
    }), this.resolveNoneKeyframes();
  }
}
function tl(e) {
  return typeof e == "function";
}
let Co;
function fv() {
  Co = void 0;
}
const At = {
  now: () => (Co === void 0 && At.set(Le.isProcessing || k8.useManualTiming ? Le.timestamp : performance.now()), Co),
  set: (e) => {
    Co = e, queueMicrotask(fv);
  }
}, _c = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(Jt.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function hv(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t)
      return !0;
}
function pv(e, t, n, r) {
  const o = e[0];
  if (o === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const i = e[e.length - 1], s = _c(o, t), a = _c(i, t);
  return or(s === a, `You are trying to animate ${t} from "${o}" to "${i}". ${o} is not an animatable value - to enable this animation set ${o} to a value animatable to ${i} via the \`style\` property.`), !s || !a ? !1 : hv(e) || (n === "spring" || tl(n)) && r;
}
const mv = 40;
class th {
  constructor({ autoplay: t = !0, delay: n = 0, type: r = "keyframes", repeat: o = 0, repeatDelay: i = 0, repeatType: s = "loop", ...a }) {
    this.isStopped = !1, this.hasAttemptedResolve = !1, this.createdAt = At.now(), this.options = {
      autoplay: t,
      delay: n,
      type: r,
      repeat: o,
      repeatDelay: i,
      repeatType: s,
      ...a
    }, this.updateFinishedPromise();
  }
  /**
   * This method uses the createdAt and resolvedAt to calculate the
   * animation startTime. *Ideally*, we would use the createdAt time as t=0
   * as the following frame would then be the first frame of the animation in
   * progress, which would feel snappier.
   *
   * However, if there's a delay (main thread work) between the creation of
   * the animation and the first commited frame, we prefer to use resolvedAt
   * to avoid a sudden jump into the animation.
   */
  calcStartTime() {
    return this.resolvedAt ? this.resolvedAt - this.createdAt > mv ? this.resolvedAt : this.createdAt : this.createdAt;
  }
  /**
   * A getter for resolved data. If keyframes are not yet resolved, accessing
   * this.resolved will synchronously flush all pending keyframe resolvers.
   * This is a deoptimisation, but at its worst still batches read/writes.
   */
  get resolved() {
    return !this._resolved && !this.hasAttemptedResolve && Z8(), this._resolved;
  }
  /**
   * A method to be called when the keyframes resolver completes. This method
   * will check if its possible to run the animation and, if not, skip it.
   * Otherwise, it will call initPlayback on the implementing class.
   */
  onKeyframesResolved(t, n) {
    this.resolvedAt = At.now(), this.hasAttemptedResolve = !0;
    const { name: r, type: o, velocity: i, delay: s, onComplete: a, onUpdate: l, isGenerator: c } = this.options;
    if (!c && !pv(t, r, o, i))
      if (s)
        this.options.duration = 0;
      else {
        l == null || l(ci(t, this.options, n)), a == null || a(), this.resolveFinishedPromise();
        return;
      }
    const u = this.initPlayback(t, n);
    u !== !1 && (this._resolved = {
      keyframes: t,
      finalKeyframe: n,
      ...u
    }, this.onPostResolved());
  }
  onPostResolved() {
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, n) {
    return this.currentFinishedPromise.then(t, n);
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((t) => {
      this.resolveFinishedPromise = t;
    });
  }
}
function nh(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const gv = 5;
function rh(e, t, n) {
  const r = Math.max(t - gv, 0);
  return nh(n - e(r), t - r);
}
const Bi = 1e-3, vv = 0.01, Lc = 10, Cv = 0.05, yv = 1;
function xv({ duration: e = 800, bounce: t = 0.25, velocity: n = 0, mass: r = 1 }) {
  let o, i;
  or(e <= wt(Lc), "Spring duration must be 10 seconds or less");
  let s = 1 - t;
  s = Yt(Cv, yv, s), e = Yt(vv, Lc, Mt(e)), s < 1 ? (o = (c) => {
    const u = c * s, d = u * e, f = u - n, h = Ns(c, s), v = Math.exp(-d);
    return Bi - f / h * v;
  }, i = (c) => {
    const d = c * s * e, f = d * n + n, h = Math.pow(s, 2) * Math.pow(c, 2) * e, v = Math.exp(-d), m = Ns(Math.pow(c, 2), s);
    return (-o(c) + Bi > 0 ? -1 : 1) * ((f - h) * v) / m;
  }) : (o = (c) => {
    const u = Math.exp(-c * e), d = (c - n) * e + 1;
    return -Bi + u * d;
  }, i = (c) => {
    const u = Math.exp(-c * e), d = (n - c) * (e * e);
    return u * d;
  });
  const a = 5 / e, l = bv(o, i, a);
  if (e = wt(e), isNaN(l))
    return {
      stiffness: 100,
      damping: 10,
      duration: e
    };
  {
    const c = Math.pow(l, 2) * r;
    return {
      stiffness: c,
      damping: s * 2 * Math.sqrt(r * c),
      duration: e
    };
  }
}
const wv = 12;
function bv(e, t, n) {
  let r = n;
  for (let o = 1; o < wv; o++)
    r = r - e(r) / t(r);
  return r;
}
function Ns(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const Av = ["duration", "bounce"], Ev = ["stiffness", "damping", "mass"];
function Nc(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function Sv(e) {
  let t = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!Nc(e, Ev) && Nc(e, Av)) {
    const n = xv(e);
    t = {
      ...t,
      ...n,
      mass: 1
    }, t.isResolvedFromDuration = !0;
  }
  return t;
}
function oh({ keyframes: e, restDelta: t, restSpeed: n, ...r }) {
  const o = e[0], i = e[e.length - 1], s = { done: !1, value: o }, { stiffness: a, damping: l, mass: c, duration: u, velocity: d, isResolvedFromDuration: f } = Sv({
    ...r,
    velocity: -Mt(r.velocity || 0)
  }), h = d || 0, v = l / (2 * Math.sqrt(a * c)), m = i - o, y = Mt(Math.sqrt(a / c)), C = Math.abs(m) < 5;
  n || (n = C ? 0.01 : 2), t || (t = C ? 5e-3 : 0.5);
  let x;
  if (v < 1) {
    const w = Ns(y, v);
    x = (S) => {
      const R = Math.exp(-v * y * S);
      return i - R * ((h + v * y * m) / w * Math.sin(w * S) + m * Math.cos(w * S));
    };
  } else if (v === 1)
    x = (w) => i - Math.exp(-y * w) * (m + (h + y * m) * w);
  else {
    const w = y * Math.sqrt(v * v - 1);
    x = (S) => {
      const R = Math.exp(-v * y * S), k = Math.min(w * S, 300);
      return i - R * ((h + v * y * m) * Math.sinh(k) + w * m * Math.cosh(k)) / w;
    };
  }
  return {
    calculatedDuration: f && u || null,
    next: (w) => {
      const S = x(w);
      if (f)
        s.done = w >= u;
      else {
        let R = 0;
        v < 1 && (R = w === 0 ? wt(h) : rh(x, w, S));
        const k = Math.abs(R) <= n, P = Math.abs(i - S) <= t;
        s.done = k && P;
      }
      return s.value = s.done ? i : S, s;
    }
  };
}
function Dc({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: o = 10, bounceStiffness: i = 500, modifyTarget: s, min: a, max: l, restDelta: c = 0.5, restSpeed: u }) {
  const d = e[0], f = {
    done: !1,
    value: d
  }, h = (T) => a !== void 0 && T < a || l !== void 0 && T > l, v = (T) => a === void 0 ? l : l === void 0 || Math.abs(a - T) < Math.abs(l - T) ? a : l;
  let m = n * t;
  const y = d + m, C = s === void 0 ? y : s(y);
  C !== y && (m = C - d);
  const x = (T) => -m * Math.exp(-T / r), w = (T) => C + x(T), S = (T) => {
    const _ = x(T), O = w(T);
    f.done = Math.abs(_) <= c, f.value = f.done ? C : O;
  };
  let R, k;
  const P = (T) => {
    h(f.value) && (R = T, k = oh({
      keyframes: [f.value, v(f.value)],
      velocity: rh(w, T, f.value),
      // TODO: This should be passing * 1000
      damping: o,
      stiffness: i,
      restDelta: c,
      restSpeed: u
    }));
  };
  return P(0), {
    calculatedDuration: null,
    next: (T) => {
      let _ = !1;
      return !k && R === void 0 && (_ = !0, S(T), P(T)), R !== void 0 && T >= R ? k.next(T - R) : (!_ && S(T), f);
    }
  };
}
const kv = /* @__PURE__ */ Zr(0.42, 0, 1, 1), Rv = /* @__PURE__ */ Zr(0, 0, 0.58, 1), ih = /* @__PURE__ */ Zr(0.42, 0, 0.58, 1), Pv = (e) => Array.isArray(e) && typeof e[0] != "number", nl = (e) => Array.isArray(e) && typeof e[0] == "number", Oc = {
  linear: Ne,
  easeIn: kv,
  easeInOut: ih,
  easeOut: Rv,
  circIn: Ga,
  circInOut: V5,
  circOut: j5,
  backIn: Qa,
  backInOut: D5,
  backOut: N5,
  anticipate: O5
}, jc = (e) => {
  if (nl(e)) {
    Dt(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [t, n, r, o] = e;
    return Zr(t, n, r, o);
  } else if (typeof e == "string")
    return Dt(Oc[e] !== void 0, `Invalid easing type '${e}'`), Oc[e];
  return e;
}, Tv = (e, t) => (n) => t(e(n)), It = (...e) => e.reduce(Tv), $n = (e, t, n) => {
  const r = t - e;
  return r === 0 ? 1 : (n - e) / r;
}, Ee = (e, t, n) => e + (t - e) * n;
function Hi(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function Mv({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let o = 0, i = 0, s = 0;
  if (!t)
    o = i = s = n;
  else {
    const a = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - a;
    o = Hi(l, a, e + 1 / 3), i = Hi(l, a, e), s = Hi(l, a, e - 1 / 3);
  }
  return {
    red: Math.round(o * 255),
    green: Math.round(i * 255),
    blue: Math.round(s * 255),
    alpha: r
  };
}
function Do(e, t) {
  return (n) => n > 0 ? t : e;
}
const zi = (e, t, n) => {
  const r = e * e, o = n * (t * t - r) + r;
  return o < 0 ? 0 : Math.sqrt(o);
}, Iv = [_s, gn, Dn], _v = (e) => Iv.find((t) => t.test(e));
function Vc(e) {
  const t = _v(e);
  if (or(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`), !t)
    return !1;
  let n = t.parse(e);
  return t === Dn && (n = Mv(n)), n;
}
const Fc = (e, t) => {
  const n = Vc(e), r = Vc(t);
  if (!n || !r)
    return Do(e, t);
  const o = { ...n };
  return (i) => (o.red = zi(n.red, r.red, i), o.green = zi(n.green, r.green, i), o.blue = zi(n.blue, r.blue, i), o.alpha = Ee(n.alpha, r.alpha, i), gn.transform(o));
}, Ds = /* @__PURE__ */ new Set(["none", "hidden"]);
function Lv(e, t) {
  return Ds.has(e) ? (n) => n <= 0 ? e : t : (n) => n >= 1 ? t : e;
}
function Nv(e, t) {
  return (n) => Ee(e, t, n);
}
function rl(e) {
  return typeof e == "number" ? Nv : typeof e == "string" ? $a(e) ? Do : De.test(e) ? Fc : jv : Array.isArray(e) ? sh : typeof e == "object" ? De.test(e) ? Fc : Dv : Do;
}
function sh(e, t) {
  const n = [...e], r = n.length, o = e.map((i, s) => rl(i)(i, t[s]));
  return (i) => {
    for (let s = 0; s < r; s++)
      n[s] = o[s](i);
    return n;
  };
}
function Dv(e, t) {
  const n = { ...e, ...t }, r = {};
  for (const o in n)
    e[o] !== void 0 && t[o] !== void 0 && (r[o] = rl(e[o])(e[o], t[o]));
  return (o) => {
    for (const i in r)
      n[i] = r[i](o);
    return n;
  };
}
function Ov(e, t) {
  var n;
  const r = [], o = { color: 0, var: 0, number: 0 };
  for (let i = 0; i < t.values.length; i++) {
    const s = t.types[i], a = e.indexes[s][o[s]], l = (n = e.values[a]) !== null && n !== void 0 ? n : 0;
    r[i] = l, o[s]++;
  }
  return r;
}
const jv = (e, t) => {
  const n = Jt.createTransformer(t), r = Lr(e), o = Lr(t);
  return r.indexes.var.length === o.indexes.var.length && r.indexes.color.length === o.indexes.color.length && r.indexes.number.length >= o.indexes.number.length ? Ds.has(e) && !o.values.length || Ds.has(t) && !r.values.length ? Lv(e, t) : It(sh(Ov(r, o), o.values), n) : (or(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), Do(e, t));
};
function ah(e, t, n) {
  return typeof e == "number" && typeof t == "number" && typeof n == "number" ? Ee(e, t, n) : rl(e)(e, t);
}
function Vv(e, t, n) {
  const r = [], o = n || ah, i = e.length - 1;
  for (let s = 0; s < i; s++) {
    let a = o(e[s], e[s + 1]);
    if (t) {
      const l = Array.isArray(t) ? t[s] || Ne : t;
      a = It(l, a);
    }
    r.push(a);
  }
  return r;
}
function Fv(e, t, { clamp: n = !0, ease: r, mixer: o } = {}) {
  const i = e.length;
  if (Dt(i === t.length, "Both input and output ranges must be the same length"), i === 1)
    return () => t[0];
  if (i === 2 && e[0] === e[1])
    return () => t[1];
  e[0] > e[i - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const s = Vv(t, r, o), a = s.length, l = (c) => {
    let u = 0;
    if (a > 1)
      for (; u < e.length - 2 && !(c < e[u + 1]); u++)
        ;
    const d = $n(e[u], e[u + 1], c);
    return s[u](d);
  };
  return n ? (c) => l(Yt(e[0], e[i - 1], c)) : l;
}
function Bv(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const o = $n(0, t, r);
    e.push(Ee(n, 1, o));
  }
}
function Hv(e) {
  const t = [0];
  return Bv(t, e.length - 1), t;
}
function zv(e, t) {
  return e.map((n) => n * t);
}
function Uv(e, t) {
  return e.map(() => t || ih).splice(0, e.length - 1);
}
function Oo({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const o = Pv(r) ? r.map(jc) : jc(r), i = {
    done: !1,
    value: t[0]
  }, s = zv(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : Hv(t),
    e
  ), a = Fv(s, t, {
    ease: Array.isArray(o) ? o : Uv(t, o)
  });
  return {
    calculatedDuration: e,
    next: (l) => (i.value = a(l), i.done = l >= e, i)
  };
}
const Bc = 2e4;
function Kv(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < Bc; )
    t += n, r = e.next(t);
  return t >= Bc ? 1 / 0 : t;
}
const Wv = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: () => ve.update(t, !0),
    stop: () => Xt(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => Le.isProcessing ? Le.timestamp : At.now()
  };
}, Zv = {
  decay: Dc,
  inertia: Dc,
  tween: Oo,
  keyframes: Oo,
  spring: oh
}, Qv = (e) => e / 100;
class ol extends th {
  constructor(t) {
    super(t), this.holdTime = null, this.cancelTime = null, this.currentTime = 0, this.playbackSpeed = 1, this.pendingPlayState = "running", this.startTime = null, this.state = "idle", this.stop = () => {
      if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
        return;
      this.teardown();
      const { onStop: l } = this.options;
      l && l();
    };
    const { name: n, motionValue: r, element: o, keyframes: i } = this.options, s = (o == null ? void 0 : o.KeyframeResolver) || qa, a = (l, c) => this.onKeyframesResolved(l, c);
    this.resolver = new s(i, a, n, r, o), this.resolver.scheduleResolve();
  }
  initPlayback(t) {
    const { type: n = "keyframes", repeat: r = 0, repeatDelay: o = 0, repeatType: i, velocity: s = 0 } = this.options, a = tl(n) ? n : Zv[n] || Oo;
    let l, c;
    a !== Oo && typeof t[0] != "number" && (process.env.NODE_ENV !== "production" && Dt(t.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${t}`), l = It(Qv, ah(t[0], t[1])), t = [0, 100]);
    const u = a({ ...this.options, keyframes: t });
    i === "mirror" && (c = a({
      ...this.options,
      keyframes: [...t].reverse(),
      velocity: -s
    })), u.calculatedDuration === null && (u.calculatedDuration = Kv(u));
    const { calculatedDuration: d } = u, f = d + o, h = f * (r + 1) - o;
    return {
      generator: u,
      mirroredGenerator: c,
      mapPercentToKeyframes: l,
      calculatedDuration: d,
      resolvedDuration: f,
      totalDuration: h
    };
  }
  onPostResolved() {
    const { autoplay: t = !0 } = this.options;
    this.play(), this.pendingPlayState === "paused" || !t ? this.pause() : this.state = this.pendingPlayState;
  }
  tick(t, n = !1) {
    const { resolved: r } = this;
    if (!r) {
      const { keyframes: T } = this.options;
      return { done: !0, value: T[T.length - 1] };
    }
    const { finalKeyframe: o, generator: i, mirroredGenerator: s, mapPercentToKeyframes: a, keyframes: l, calculatedDuration: c, totalDuration: u, resolvedDuration: d } = r;
    if (this.startTime === null)
      return i.next(0);
    const { delay: f, repeat: h, repeatType: v, repeatDelay: m, onUpdate: y } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - u / this.speed, this.startTime)), n ? this.currentTime = t : this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = Math.round(t - this.startTime) * this.speed;
    const C = this.currentTime - f * (this.speed >= 0 ? 1 : -1), x = this.speed >= 0 ? C < 0 : C > u;
    this.currentTime = Math.max(C, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = u);
    let w = this.currentTime, S = i;
    if (h) {
      const T = Math.min(this.currentTime, u) / d;
      let _ = Math.floor(T), O = T % 1;
      !O && T >= 1 && (O = 1), O === 1 && _--, _ = Math.min(_, h + 1), !!(_ % 2) && (v === "reverse" ? (O = 1 - O, m && (O -= m / d)) : v === "mirror" && (S = s)), w = Yt(0, 1, O) * d;
    }
    const R = x ? { done: !1, value: l[0] } : S.next(w);
    a && (R.value = a(R.value));
    let { done: k } = R;
    !x && c !== null && (k = this.speed >= 0 ? this.currentTime >= u : this.currentTime <= 0);
    const P = this.holdTime === null && (this.state === "finished" || this.state === "running" && k);
    return P && o !== void 0 && (R.value = ci(l, this.options, o)), y && y(R.value), P && this.finish(), R;
  }
  get duration() {
    const { resolved: t } = this;
    return t ? Mt(t.calculatedDuration) : 0;
  }
  get time() {
    return Mt(this.currentTime);
  }
  set time(t) {
    t = wt(t), this.currentTime = t, this.holdTime !== null || this.speed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.speed);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    const n = this.playbackSpeed !== t;
    this.playbackSpeed = t, n && (this.time = Mt(this.currentTime));
  }
  play() {
    if (this.resolver.isScheduled || this.resolver.resume(), !this._resolved) {
      this.pendingPlayState = "running";
      return;
    }
    if (this.isStopped)
      return;
    const { driver: t = Wv, onPlay: n, startTime: r } = this.options;
    this.driver || (this.driver = t((i) => this.tick(i))), n && n();
    const o = this.driver.now();
    this.holdTime !== null ? this.startTime = o - this.holdTime : this.startTime ? this.state === "finished" && (this.startTime = o) : this.startTime = r ?? this.calcStartTime(), this.state === "finished" && this.updateFinishedPromise(), this.cancelTime = this.startTime, this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    var t;
    if (!this._resolved) {
      this.pendingPlayState = "paused";
      return;
    }
    this.state = "paused", this.holdTime = (t = this.currentTime) !== null && t !== void 0 ? t : 0;
  }
  complete() {
    this.state !== "running" && this.play(), this.pendingPlayState = this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.teardown(), this.state = "finished";
    const { onComplete: t } = this.options;
    t && t();
  }
  cancel() {
    this.cancelTime !== null && this.tick(this.cancelTime), this.teardown(), this.updateFinishedPromise();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.resolveFinishedPromise(), this.updateFinishedPromise(), this.startTime = this.cancelTime = null, this.resolver.cancel();
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
}
const lh = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]), Gv = 10, $v = (e, t) => {
  let n = "";
  const r = Math.max(Math.round(t / Gv), 2);
  for (let o = 0; o < r; o++)
    n += e($n(0, r - 1, o)) + ", ";
  return `linear(${n.substring(0, n.length - 2)})`;
};
function il(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const qv = {
  linearEasing: void 0
};
function Xv(e, t) {
  const n = il(e);
  return () => {
    var r;
    return (r = qv[t]) !== null && r !== void 0 ? r : n();
  };
}
const jo = /* @__PURE__ */ Xv(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing");
function ch(e) {
  return !!(typeof e == "function" && jo() || !e || typeof e == "string" && (e in Os || jo()) || nl(e) || Array.isArray(e) && e.every(ch));
}
const Cr = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, Os = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Cr([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Cr([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Cr([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Cr([0.33, 1.53, 0.69, 0.99])
};
function uh(e, t) {
  if (e)
    return typeof e == "function" && jo() ? $v(e, t) : nl(e) ? Cr(e) : Array.isArray(e) ? e.map((n) => uh(n, t) || Os.easeOut) : Os[e];
}
function Yv(e, t, n, { delay: r = 0, duration: o = 300, repeat: i = 0, repeatType: s = "loop", ease: a, times: l } = {}) {
  const c = { [t]: n };
  l && (c.offset = l);
  const u = uh(a, o);
  return Array.isArray(u) && (c.easing = u), e.animate(c, {
    delay: r,
    duration: o,
    easing: Array.isArray(u) ? "linear" : u,
    fill: "both",
    iterations: i + 1,
    direction: s === "reverse" ? "alternate" : "normal"
  });
}
function Hc(e, t) {
  e.timeline = t, e.onfinish = null;
}
const Jv = /* @__PURE__ */ il(() => Object.hasOwnProperty.call(Element.prototype, "animate")), Vo = 10, eC = 2e4;
function tC(e) {
  return tl(e.type) || e.type === "spring" || !ch(e.ease);
}
function nC(e, t) {
  const n = new ol({
    ...t,
    keyframes: e,
    repeat: 0,
    delay: 0,
    isGenerator: !0
  });
  let r = { done: !1, value: e[0] };
  const o = [];
  let i = 0;
  for (; !r.done && i < eC; )
    r = n.sample(i), o.push(r.value), i += Vo;
  return {
    times: void 0,
    keyframes: o,
    duration: i - Vo,
    ease: "linear"
  };
}
const dh = {
  anticipate: O5,
  backInOut: D5,
  circInOut: V5
};
function rC(e) {
  return e in dh;
}
class zc extends th {
  constructor(t) {
    super(t);
    const { name: n, motionValue: r, element: o, keyframes: i } = this.options;
    this.resolver = new eh(i, (s, a) => this.onKeyframesResolved(s, a), n, r, o), this.resolver.scheduleResolve();
  }
  initPlayback(t, n) {
    var r;
    let { duration: o = 300, times: i, ease: s, type: a, motionValue: l, name: c, startTime: u } = this.options;
    if (!(!((r = l.owner) === null || r === void 0) && r.current))
      return !1;
    if (typeof s == "string" && jo() && rC(s) && (s = dh[s]), tC(this.options)) {
      const { onComplete: f, onUpdate: h, motionValue: v, element: m, ...y } = this.options, C = nC(t, y);
      t = C.keyframes, t.length === 1 && (t[1] = t[0]), o = C.duration, i = C.times, s = C.ease, a = "keyframes";
    }
    const d = Yv(l.owner.current, c, t, { ...this.options, duration: o, times: i, ease: s });
    return d.startTime = u ?? this.calcStartTime(), this.pendingTimeline ? (Hc(d, this.pendingTimeline), this.pendingTimeline = void 0) : d.onfinish = () => {
      const { onComplete: f } = this.options;
      l.set(ci(t, this.options, n)), f && f(), this.cancel(), this.resolveFinishedPromise();
    }, {
      animation: d,
      duration: o,
      times: i,
      type: a,
      ease: s,
      keyframes: t
    };
  }
  get duration() {
    const { resolved: t } = this;
    if (!t)
      return 0;
    const { duration: n } = t;
    return Mt(n);
  }
  get time() {
    const { resolved: t } = this;
    if (!t)
      return 0;
    const { animation: n } = t;
    return Mt(n.currentTime || 0);
  }
  set time(t) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: r } = n;
    r.currentTime = wt(t);
  }
  get speed() {
    const { resolved: t } = this;
    if (!t)
      return 1;
    const { animation: n } = t;
    return n.playbackRate;
  }
  set speed(t) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: r } = n;
    r.playbackRate = t;
  }
  get state() {
    const { resolved: t } = this;
    if (!t)
      return "idle";
    const { animation: n } = t;
    return n.playState;
  }
  get startTime() {
    const { resolved: t } = this;
    if (!t)
      return null;
    const { animation: n } = t;
    return n.startTime;
  }
  /**
   * Replace the default DocumentTimeline with another AnimationTimeline.
   * Currently used for scroll animations.
   */
  attachTimeline(t) {
    if (!this._resolved)
      this.pendingTimeline = t;
    else {
      const { resolved: n } = this;
      if (!n)
        return Ne;
      const { animation: r } = n;
      Hc(r, t);
    }
    return Ne;
  }
  play() {
    if (this.isStopped)
      return;
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: n } = t;
    n.playState === "finished" && this.updateFinishedPromise(), n.play();
  }
  pause() {
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: n } = t;
    n.pause();
  }
  stop() {
    if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
      return;
    this.resolveFinishedPromise(), this.updateFinishedPromise();
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: n, keyframes: r, duration: o, type: i, ease: s, times: a } = t;
    if (n.playState === "idle" || n.playState === "finished")
      return;
    if (this.time) {
      const { motionValue: c, onUpdate: u, onComplete: d, element: f, ...h } = this.options, v = new ol({
        ...h,
        keyframes: r,
        duration: o,
        type: i,
        ease: s,
        times: a,
        isGenerator: !0
      }), m = wt(this.time);
      c.setWithVelocity(v.sample(m - Vo).value, v.sample(m).value, Vo);
    }
    const { onStop: l } = this.options;
    l && l(), this.cancel();
  }
  complete() {
    const { resolved: t } = this;
    t && t.animation.finish();
  }
  cancel() {
    const { resolved: t } = this;
    t && t.animation.cancel();
  }
  static supports(t) {
    const { motionValue: n, name: r, repeatDelay: o, repeatType: i, damping: s, type: a } = t;
    return Jv() && r && lh.has(r) && n && n.owner && n.owner.current instanceof HTMLElement && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !n.owner.getProps().onUpdate && !o && i !== "mirror" && s !== 0 && a !== "inertia";
  }
}
const oC = il(() => window.ScrollTimeline !== void 0);
class iC {
  constructor(t) {
    this.stop = () => this.runAll("stop"), this.animations = t.filter(Boolean);
  }
  then(t, n) {
    return Promise.all(this.animations).then(t).catch(n);
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(t) {
    return this.animations[0][t];
  }
  setAll(t, n) {
    for (let r = 0; r < this.animations.length; r++)
      this.animations[r][t] = n;
  }
  attachTimeline(t, n) {
    const r = this.animations.map((o) => oC() && o.attachTimeline ? o.attachTimeline(t) : n(o));
    return () => {
      r.forEach((o, i) => {
        o && o(), this.animations[i].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(t) {
    this.setAll("time", t);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(t) {
    this.setAll("speed", t);
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    let t = 0;
    for (let n = 0; n < this.animations.length; n++)
      t = Math.max(t, this.animations[n].duration);
    return t;
  }
  runAll(t) {
    this.animations.forEach((n) => n[t]());
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
function sC({ when: e, delay: t, delayChildren: n, staggerChildren: r, staggerDirection: o, repeat: i, repeatType: s, repeatDelay: a, from: l, elapsed: c, ...u }) {
  return !!Object.keys(u).length;
}
const sl = (e, t, n, r = {}, o, i) => (s) => {
  const a = Za(r, e) || {}, l = a.delay || r.delay || 0;
  let { elapsed: c = 0 } = r;
  c = c - wt(l);
  let u = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...a,
    delay: -c,
    onUpdate: (f) => {
      t.set(f), a.onUpdate && a.onUpdate(f);
    },
    onComplete: () => {
      s(), a.onComplete && a.onComplete();
    },
    name: e,
    motionValue: t,
    element: i ? void 0 : o
  };
  sC(a) || (u = {
    ...u,
    ...S8(e, u)
  }), u.duration && (u.duration = wt(u.duration)), u.repeatDelay && (u.repeatDelay = wt(u.repeatDelay)), u.from !== void 0 && (u.keyframes[0] = u.from);
  let d = !1;
  if ((u.type === !1 || u.duration === 0 && !u.repeatDelay) && (u.duration = 0, u.delay === 0 && (d = !0)), d && !i && t.get() !== void 0) {
    const f = ci(u.keyframes, a);
    if (f !== void 0)
      return ve.update(() => {
        u.onUpdate(f), u.onComplete();
      }), new iC([]);
  }
  return !i && zc.supports(u) ? new zc(u) : new ol(u);
}, aC = (e) => !!(e && typeof e == "object" && e.mix && e.toValue), lC = (e) => Ts(e) ? e[e.length - 1] || 0 : e;
function al(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function ll(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
class cl {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return al(this.subscriptions, t), () => ll(this.subscriptions, t);
  }
  notify(t, n, r) {
    const o = this.subscriptions.length;
    if (o)
      if (o === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let i = 0; i < o; i++) {
          const s = this.subscriptions[i];
          s && s(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const Uc = 30, cC = (e) => !isNaN(parseFloat(e));
class uC {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(t, n = {}) {
    this.version = "11.11.9", this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r, o = !0) => {
      const i = At.now();
      this.updatedAt !== i && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && this.events.change && this.events.change.notify(this.current), o && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = n.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = At.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = cC(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && ai(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new cl());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), ve.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(t, n) : this.passiveEffect(t, this.updateAndNotify);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, n = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = At.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > Uc)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, Uc);
    return nh(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Nr(e, t) {
  return new uC(e, t);
}
function dC(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Nr(n));
}
function fC(e, t) {
  const n = li(e, t);
  let { transitionEnd: r = {}, transition: o = {}, ...i } = n || {};
  i = { ...i, ...r };
  for (const s in i) {
    const a = lC(i[s]);
    dC(e, s, a);
  }
}
const ui = (e) => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), hC = "framerAppearId", fh = "data-" + ui(hC);
function hh(e) {
  return e.props[fh];
}
const je = (e) => !!(e && e.getVelocity);
function pC(e) {
  return !!(je(e) && e.add);
}
function js(e, t) {
  if (!e.applyWillChange)
    return;
  const n = e.getValue("willChange");
  if (pC(n))
    return n.add(t);
}
function mC({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function ph(e, t, { delay: n = 0, transitionOverride: r, type: o } = {}) {
  var i;
  let { transition: s = e.getDefaultTransition(), transitionEnd: a, ...l } = t;
  r && (s = r);
  const c = [], u = o && e.animationState && e.animationState.getState()[o];
  for (const d in l) {
    const f = e.getValue(d, (i = e.latestValues[d]) !== null && i !== void 0 ? i : null), h = l[d];
    if (h === void 0 || u && mC(u, d))
      continue;
    const v = {
      delay: n,
      ...Za(s || {}, d)
    };
    let m = !1;
    if (window.MotionHandoffAnimation) {
      const C = hh(e);
      if (C) {
        const x = window.MotionHandoffAnimation(C, d, ve);
        x !== null && (v.startTime = x, m = !0);
      }
    }
    js(e, d), f.start(sl(d, f, h, e.shouldReduceMotion && rn.has(d) ? { type: !1 } : v, e, m));
    const y = f.animation;
    y && c.push(y);
  }
  return a && Promise.all(c).then(() => {
    ve.update(() => {
      a && fC(e, a);
    });
  }), c;
}
function Vs(e, t, n = {}) {
  var r;
  const o = li(e, t, n.type === "exit" ? (r = e.presenceContext) === null || r === void 0 ? void 0 : r.custom : void 0);
  let { transition: i = e.getDefaultTransition() || {} } = o || {};
  n.transitionOverride && (i = n.transitionOverride);
  const s = o ? () => Promise.all(ph(e, o, n)) : () => Promise.resolve(), a = e.variantChildren && e.variantChildren.size ? (c = 0) => {
    const { delayChildren: u = 0, staggerChildren: d, staggerDirection: f } = i;
    return gC(e, t, u + c, d, f, n);
  } : () => Promise.resolve(), { when: l } = i;
  if (l) {
    const [c, u] = l === "beforeChildren" ? [s, a] : [a, s];
    return c().then(() => u());
  } else
    return Promise.all([s(), a(n.delay)]);
}
function gC(e, t, n = 0, r = 0, o = 1, i) {
  const s = [], a = (e.variantChildren.size - 1) * r, l = o === 1 ? (c = 0) => c * r : (c = 0) => a - c * r;
  return Array.from(e.variantChildren).sort(vC).forEach((c, u) => {
    c.notify("AnimationStart", t), s.push(Vs(c, t, {
      ...i,
      delay: n + l(u)
    }).then(() => c.notify("AnimationComplete", t)));
  }), Promise.all(s);
}
function vC(e, t) {
  return e.sortNodePosition(t);
}
function CC(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const o = t.map((i) => Vs(e, i, n));
    r = Promise.all(o);
  } else if (typeof t == "string")
    r = Vs(e, t, n);
  else {
    const o = typeof t == "function" ? li(e, t, n.custom) : t;
    r = Promise.all(ph(e, o, n));
  }
  return r.then(() => {
    e.notify("AnimationComplete", t);
  });
}
const yC = Wa.length;
function mh(e) {
  if (!e)
    return;
  if (!e.isControllingVariants) {
    const n = e.parent ? mh(e.parent) || {} : {};
    return e.props.initial !== void 0 && (n.initial = e.props.initial), n;
  }
  const t = {};
  for (let n = 0; n < yC; n++) {
    const r = Wa[n], o = e.props[r];
    (Ir(o) || o === !1) && (t[r] = o);
  }
  return t;
}
const xC = [...Ka].reverse(), wC = Ka.length;
function bC(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => CC(e, n, r)));
}
function AC(e) {
  let t = bC(e), n = Kc(), r = !0;
  const o = (l) => (c, u) => {
    var d;
    const f = li(e, u, l === "exit" ? (d = e.presenceContext) === null || d === void 0 ? void 0 : d.custom : void 0);
    if (f) {
      const { transition: h, transitionEnd: v, ...m } = f;
      c = { ...c, ...m, ...v };
    }
    return c;
  };
  function i(l) {
    t = l(e);
  }
  function s(l) {
    const { props: c } = e, u = mh(e.parent) || {}, d = [], f = /* @__PURE__ */ new Set();
    let h = {}, v = 1 / 0;
    for (let y = 0; y < wC; y++) {
      const C = xC[y], x = n[C], w = c[C] !== void 0 ? c[C] : u[C], S = Ir(w), R = C === l ? x.isActive : null;
      R === !1 && (v = y);
      let k = w === u[C] && w !== c[C] && S;
      if (k && r && e.manuallyAnimateOnMount && (k = !1), x.protectedKeys = { ...h }, // If it isn't active and hasn't *just* been set as inactive
      !x.isActive && R === null || // If we didn't and don't have any defined prop for this animation type
      !w && !x.prevProp || // Or if the prop doesn't define an animation
      Mr(w) || typeof w == "boolean")
        continue;
      const P = EC(x.prevProp, w);
      let T = P || // If we're making this variant active, we want to always make it active
      C === l && x.isActive && !k && S || // If we removed a higher-priority variant (i is in reverse order)
      y > v && S, _ = !1;
      const O = Array.isArray(w) ? w : [w];
      let L = O.reduce(o(C), {});
      R === !1 && (L = {});
      const { prevResolvedValues: I = {} } = x, H = {
        ...I,
        ...L
      }, z = (U) => {
        T = !0, f.has(U) && (_ = !0, f.delete(U)), x.needsAnimating[U] = !0;
        const B = e.getValue(U);
        B && (B.liveStyle = !1);
      };
      for (const U in H) {
        const B = L[U], j = I[U];
        if (h.hasOwnProperty(U))
          continue;
        let b = !1;
        Ts(B) && Ts(j) ? b = !T5(B, j) : b = B !== j, b ? B != null ? z(U) : f.add(U) : B !== void 0 && f.has(U) ? z(U) : x.protectedKeys[U] = !0;
      }
      x.prevProp = w, x.prevResolvedValues = L, x.isActive && (h = { ...h, ...L }), r && e.blockInitialAnimation && (T = !1), T && (!(k && P) || _) && d.push(...O.map((U) => ({
        animation: U,
        options: { type: C }
      })));
    }
    if (f.size) {
      const y = {};
      f.forEach((C) => {
        const x = e.getBaseTarget(C), w = e.getValue(C);
        w && (w.liveStyle = !0), y[C] = x ?? null;
      }), d.push({ animation: y });
    }
    let m = !!d.length;
    return r && (c.initial === !1 || c.initial === c.animate) && !e.manuallyAnimateOnMount && (m = !1), r = !1, m ? t(d) : Promise.resolve();
  }
  function a(l, c) {
    var u;
    if (n[l].isActive === c)
      return Promise.resolve();
    (u = e.variantChildren) === null || u === void 0 || u.forEach((f) => {
      var h;
      return (h = f.animationState) === null || h === void 0 ? void 0 : h.setActive(l, c);
    }), n[l].isActive = c;
    const d = s(l);
    for (const f in n)
      n[f].protectedKeys = {};
    return d;
  }
  return {
    animateChanges: s,
    setActive: a,
    setAnimateFunction: i,
    getState: () => n,
    reset: () => {
      n = Kc(), r = !0;
    }
  };
}
function EC(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !T5(t, e) : !1;
}
function un(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function Kc() {
  return {
    animate: un(!0),
    whileInView: un(),
    whileHover: un(),
    whileTap: un(),
    whileDrag: un(),
    whileFocus: un(),
    exit: un()
  };
}
class on {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
class SC extends on {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = AC(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    Mr(t) && (this.unmountControls = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var t;
    this.node.animationState.reset(), (t = this.unmountControls) === null || t === void 0 || t.call(this);
  }
}
let kC = 0;
class RC extends on {
  constructor() {
    super(...arguments), this.id = kC++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === r)
      return;
    const o = this.node.animationState.setActive("exit", !t);
    n && !t && o.then(() => n(this.id));
  }
  mount() {
    const { register: t } = this.node.presenceContext || {};
    t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const PC = {
  animation: {
    Feature: SC
  },
  exit: {
    Feature: RC
  }
}, gh = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1;
function di(e, t = "page") {
  return {
    point: {
      x: e[`${t}X`],
      y: e[`${t}Y`]
    }
  };
}
const TC = (e) => (t) => gh(t) && e(t, di(t));
function Tt(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n);
}
function _t(e, t, n, r) {
  return Tt(e, t, TC(n), r);
}
const Wc = (e, t) => Math.abs(e - t);
function MC(e, t) {
  const n = Wc(e.x, t.x), r = Wc(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
class vh {
  constructor(t, n, { transformPagePoint: r, contextWindow: o, dragSnapToOrigin: i = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const d = Ki(this.lastMoveEventInfo, this.history), f = this.startEvent !== null, h = MC(d.offset, { x: 0, y: 0 }) >= 3;
      if (!f && !h)
        return;
      const { point: v } = d, { timestamp: m } = Le;
      this.history.push({ ...v, timestamp: m });
      const { onStart: y, onMove: C } = this.handlers;
      f || (y && y(this.lastMoveEvent, d), this.startEvent = this.lastMoveEvent), C && C(this.lastMoveEvent, d);
    }, this.handlePointerMove = (d, f) => {
      this.lastMoveEvent = d, this.lastMoveEventInfo = Ui(f, this.transformPagePoint), ve.update(this.updatePoint, !0);
    }, this.handlePointerUp = (d, f) => {
      this.end();
      const { onEnd: h, onSessionEnd: v, resumeAnimation: m } = this.handlers;
      if (this.dragSnapToOrigin && m && m(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const y = Ki(d.type === "pointercancel" ? this.lastMoveEventInfo : Ui(f, this.transformPagePoint), this.history);
      this.startEvent && h && h(d, y), v && v(d, y);
    }, !gh(t))
      return;
    this.dragSnapToOrigin = i, this.handlers = n, this.transformPagePoint = r, this.contextWindow = o || window;
    const s = di(t), a = Ui(s, this.transformPagePoint), { point: l } = a, { timestamp: c } = Le;
    this.history = [{ ...l, timestamp: c }];
    const { onSessionStart: u } = n;
    u && u(t, Ki(a, this.history)), this.removeListeners = It(_t(this.contextWindow, "pointermove", this.handlePointerMove), _t(this.contextWindow, "pointerup", this.handlePointerUp), _t(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), Xt(this.updatePoint);
  }
}
function Ui(e, t) {
  return t ? { point: t(e.point) } : e;
}
function Zc(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function Ki({ point: e }, t) {
  return {
    point: e,
    delta: Zc(e, Ch(t)),
    offset: Zc(e, IC(t)),
    velocity: _C(t, 0.1)
  };
}
function IC(e) {
  return e[0];
}
function Ch(e) {
  return e[e.length - 1];
}
function _C(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const o = Ch(e);
  for (; n >= 0 && (r = e[n], !(o.timestamp - r.timestamp > wt(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  const i = Mt(o.timestamp - r.timestamp);
  if (i === 0)
    return { x: 0, y: 0 };
  const s = {
    x: (o.x - r.x) / i,
    y: (o.y - r.y) / i
  };
  return s.x === 1 / 0 && (s.x = 0), s.y === 1 / 0 && (s.y = 0), s;
}
function yh(e) {
  let t = null;
  return () => {
    const n = () => {
      t = null;
    };
    return t === null ? (t = e, n) : !1;
  };
}
const Qc = yh("dragHorizontal"), Gc = yh("dragVertical");
function xh(e) {
  let t = !1;
  if (e === "y")
    t = Gc();
  else if (e === "x")
    t = Qc();
  else {
    const n = Qc(), r = Gc();
    n && r ? t = () => {
      n(), r();
    } : (n && n(), r && r());
  }
  return t;
}
function wh() {
  const e = xh(!0);
  return e ? (e(), !1) : !0;
}
function On(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
const bh = 1e-4, LC = 1 - bh, NC = 1 + bh, Ah = 0.01, DC = 0 - Ah, OC = 0 + Ah;
function nt(e) {
  return e.max - e.min;
}
function jC(e, t, n) {
  return Math.abs(e - t) <= n;
}
function $c(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = Ee(t.min, t.max, e.origin), e.scale = nt(n) / nt(t), e.translate = Ee(n.min, n.max, e.origin) - e.originPoint, (e.scale >= LC && e.scale <= NC || isNaN(e.scale)) && (e.scale = 1), (e.translate >= DC && e.translate <= OC || isNaN(e.translate)) && (e.translate = 0);
}
function wr(e, t, n, r) {
  $c(e.x, t.x, n.x, r ? r.originX : void 0), $c(e.y, t.y, n.y, r ? r.originY : void 0);
}
function qc(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + nt(t);
}
function VC(e, t, n) {
  qc(e.x, t.x, n.x), qc(e.y, t.y, n.y);
}
function Xc(e, t, n) {
  e.min = t.min - n.min, e.max = e.min + nt(t);
}
function br(e, t, n) {
  Xc(e.x, t.x, n.x), Xc(e.y, t.y, n.y);
}
function FC(e, { min: t, max: n }, r) {
  return t !== void 0 && e < t ? e = r ? Ee(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? Ee(n, e, r.max) : Math.min(e, n)), e;
}
function Yc(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function BC(e, { top: t, left: n, bottom: r, right: o }) {
  return {
    x: Yc(e.x, n, o),
    y: Yc(e.y, t, r)
  };
}
function Jc(e, t) {
  let n = t.min - e.min, r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r };
}
function HC(e, t) {
  return {
    x: Jc(e.x, t.x),
    y: Jc(e.y, t.y)
  };
}
function zC(e, t) {
  let n = 0.5;
  const r = nt(e), o = nt(t);
  return o > r ? n = $n(t.min, t.max - r, e.min) : r > o && (n = $n(e.min, e.max - o, t.min)), Yt(0, 1, n);
}
function UC(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const Fs = 0.35;
function KC(e = Fs) {
  return e === !1 ? e = 0 : e === !0 && (e = Fs), {
    x: e1(e, "left", "right"),
    y: e1(e, "top", "bottom")
  };
}
function e1(e, t, n) {
  return {
    min: t1(e, t),
    max: t1(e, n)
  };
}
function t1(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const n1 = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), jn = () => ({
  x: n1(),
  y: n1()
}), r1 = () => ({ min: 0, max: 0 }), ke = () => ({
  x: r1(),
  y: r1()
});
function st(e) {
  return [e("x"), e("y")];
}
function Eh({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function WC({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function ZC(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function Wi(e) {
  return e === void 0 || e === 1;
}
function Bs({ scale: e, scaleX: t, scaleY: n }) {
  return !Wi(e) || !Wi(t) || !Wi(n);
}
function fn(e) {
  return Bs(e) || Sh(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function Sh(e) {
  return o1(e.x) || o1(e.y);
}
function o1(e) {
  return e && e !== "0%";
}
function Fo(e, t, n) {
  const r = e - n, o = t * r;
  return n + o;
}
function i1(e, t, n, r, o) {
  return o !== void 0 && (e = Fo(e, o, r)), Fo(e, n, r) + t;
}
function Hs(e, t = 0, n = 1, r, o) {
  e.min = i1(e.min, t, n, r, o), e.max = i1(e.max, t, n, r, o);
}
function kh(e, { x: t, y: n }) {
  Hs(e.x, t.translate, t.scale, t.originPoint), Hs(e.y, n.translate, n.scale, n.originPoint);
}
const s1 = 0.999999999999, a1 = 1.0000000000001;
function QC(e, t, n, r = !1) {
  const o = n.length;
  if (!o)
    return;
  t.x = t.y = 1;
  let i, s;
  for (let a = 0; a < o; a++) {
    i = n[a], s = i.projectionDelta;
    const { visualElement: l } = i.options;
    l && l.props.style && l.props.style.display === "contents" || (r && i.options.layoutScroll && i.scroll && i !== i.root && Fn(e, {
      x: -i.scroll.offset.x,
      y: -i.scroll.offset.y
    }), s && (t.x *= s.x.scale, t.y *= s.y.scale, kh(e, s)), r && fn(i.latestValues) && Fn(e, i.latestValues));
  }
  t.x < a1 && t.x > s1 && (t.x = 1), t.y < a1 && t.y > s1 && (t.y = 1);
}
function Vn(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function l1(e, t, n, r, o = 0.5) {
  const i = Ee(e.min, e.max, o);
  Hs(e, t, n, i, r);
}
function Fn(e, t) {
  l1(e.x, t.x, t.scaleX, t.scale, t.originX), l1(e.y, t.y, t.scaleY, t.scale, t.originY);
}
function Rh(e, t) {
  return Eh(ZC(e.getBoundingClientRect(), t));
}
function GC(e, t, n) {
  const r = Rh(e, n), { scroll: o } = t;
  return o && (Vn(r.x, o.offset.x), Vn(r.y, o.offset.y)), r;
}
const Ph = ({ current: e }) => e ? e.ownerDocument.defaultView : null, $C = /* @__PURE__ */ new WeakMap();
class qC {
  constructor(t) {
    this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = ke(), this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1 } = {}) {
    const { presenceContext: r } = this.visualElement;
    if (r && r.isPresent === !1)
      return;
    const o = (u) => {
      const { dragSnapToOrigin: d } = this.getProps();
      d ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(di(u, "page").point);
    }, i = (u, d) => {
      const { drag: f, dragPropagation: h, onDragStart: v } = this.getProps();
      if (f && !h && (this.openGlobalLock && this.openGlobalLock(), this.openGlobalLock = xh(f), !this.openGlobalLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), st((y) => {
        let C = this.getAxisMotionValue(y).get() || 0;
        if (bt.test(C)) {
          const { projection: x } = this.visualElement;
          if (x && x.layout) {
            const w = x.layout.layoutBox[y];
            w && (C = nt(w) * (parseFloat(C) / 100));
          }
        }
        this.originPoint[y] = C;
      }), v && ve.postRender(() => v(u, d)), js(this.visualElement, "transform");
      const { animationState: m } = this.visualElement;
      m && m.setActive("whileDrag", !0);
    }, s = (u, d) => {
      const { dragPropagation: f, dragDirectionLock: h, onDirectionLock: v, onDrag: m } = this.getProps();
      if (!f && !this.openGlobalLock)
        return;
      const { offset: y } = d;
      if (h && this.currentDirection === null) {
        this.currentDirection = XC(y), this.currentDirection !== null && v && v(this.currentDirection);
        return;
      }
      this.updateAxis("x", d.point, y), this.updateAxis("y", d.point, y), this.visualElement.render(), m && m(u, d);
    }, a = (u, d) => this.stop(u, d), l = () => st((u) => {
      var d;
      return this.getAnimationState(u) === "paused" && ((d = this.getAxisMotionValue(u).animation) === null || d === void 0 ? void 0 : d.play());
    }), { dragSnapToOrigin: c } = this.getProps();
    this.panSession = new vh(t, {
      onSessionStart: o,
      onStart: i,
      onMove: s,
      onSessionEnd: a,
      resumeAnimation: l
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: c,
      contextWindow: Ph(this.visualElement)
    });
  }
  stop(t, n) {
    const r = this.isDragging;
    if (this.cancel(), !r)
      return;
    const { velocity: o } = n;
    this.startAnimation(o);
    const { onDragEnd: i } = this.getProps();
    i && ve.postRender(() => i(t, n));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(t, n, r) {
    const { drag: o } = this.getProps();
    if (!r || !ao(t, o, this.currentDirection))
      return;
    const i = this.getAxisMotionValue(t);
    let s = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (s = FC(s, this.constraints[t], this.elastic[t])), i.set(s);
  }
  resolveConstraints() {
    var t;
    const { dragConstraints: n, dragElastic: r } = this.getProps(), o = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (t = this.visualElement.projection) === null || t === void 0 ? void 0 : t.layout, i = this.constraints;
    n && On(n) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : n && o ? this.constraints = BC(o.layoutBox, n) : this.constraints = !1, this.elastic = KC(r), i !== this.constraints && o && this.constraints && !this.hasMutatedConstraints && st((s) => {
      this.constraints !== !1 && this.getAxisMotionValue(s) && (this.constraints[s] = UC(o.layoutBox[s], this.constraints[s]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !On(t))
      return !1;
    const r = t.current;
    Dt(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: o } = this.visualElement;
    if (!o || !o.layout)
      return !1;
    const i = GC(r, o.root, this.visualElement.getTransformPagePoint());
    let s = HC(o.layout.layoutBox, i);
    if (n) {
      const a = n(WC(s));
      this.hasMutatedConstraints = !!a, a && (s = Eh(a));
    }
    return s;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: r, dragElastic: o, dragTransition: i, dragSnapToOrigin: s, onDragTransitionEnd: a } = this.getProps(), l = this.constraints || {}, c = st((u) => {
      if (!ao(u, n, this.currentDirection))
        return;
      let d = l && l[u] || {};
      s && (d = { min: 0, max: 0 });
      const f = o ? 200 : 1e6, h = o ? 40 : 1e7, v = {
        type: "inertia",
        velocity: r ? t[u] : 0,
        bounceStiffness: f,
        bounceDamping: h,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...i,
        ...d
      };
      return this.startAxisValueAnimation(u, v);
    });
    return Promise.all(c).then(a);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return js(this.visualElement, t), r.start(sl(t, r, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    st((t) => this.getAxisMotionValue(t).stop());
  }
  pauseAnimation() {
    st((t) => {
      var n;
      return (n = this.getAxisMotionValue(t).animation) === null || n === void 0 ? void 0 : n.pause();
    });
  }
  getAnimationState(t) {
    var n;
    return (n = this.getAxisMotionValue(t).animation) === null || n === void 0 ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = `_drag${t.toUpperCase()}`, r = this.visualElement.getProps(), o = r[n];
    return o || this.visualElement.getValue(t, (r.initial ? r.initial[t] : void 0) || 0);
  }
  snapToCursor(t) {
    st((n) => {
      const { drag: r } = this.getProps();
      if (!ao(n, r, this.currentDirection))
        return;
      const { projection: o } = this.visualElement, i = this.getAxisMotionValue(n);
      if (o && o.layout) {
        const { min: s, max: a } = o.layout.layoutBox[n];
        i.set(t[n] - Ee(s, a, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!On(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const o = { x: 0, y: 0 };
    st((s) => {
      const a = this.getAxisMotionValue(s);
      if (a && this.constraints !== !1) {
        const l = a.get();
        o[s] = zC({ min: l, max: l }, this.constraints[s]);
      }
    });
    const { transformTemplate: i } = this.visualElement.getProps();
    this.visualElement.current.style.transform = i ? i({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), st((s) => {
      if (!ao(s, t, null))
        return;
      const a = this.getAxisMotionValue(s), { min: l, max: c } = this.constraints[s];
      a.set(Ee(l, c, o[s]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    $C.set(this.visualElement, this);
    const t = this.visualElement.current, n = _t(t, "pointerdown", (l) => {
      const { drag: c, dragListener: u = !0 } = this.getProps();
      c && u && this.start(l);
    }), r = () => {
      const { dragConstraints: l } = this.getProps();
      On(l) && l.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: o } = this.visualElement, i = o.addEventListener("measure", r);
    o && !o.layout && (o.root && o.root.updateScroll(), o.updateLayout()), ve.read(r);
    const s = Tt(window, "resize", () => this.scalePositionWithinConstraints()), a = o.addEventListener("didUpdate", ({ delta: l, hasLayoutChanged: c }) => {
      this.isDragging && c && (st((u) => {
        const d = this.getAxisMotionValue(u);
        d && (this.originPoint[u] += l[u].translate, d.set(d.get() + l[u].translate));
      }), this.visualElement.render());
    });
    return () => {
      s(), n(), i(), a && a();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: o = !1, dragConstraints: i = !1, dragElastic: s = Fs, dragMomentum: a = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: o,
      dragConstraints: i,
      dragElastic: s,
      dragMomentum: a
    };
  }
}
function ao(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function XC(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class YC extends on {
  constructor(t) {
    super(t), this.removeGroupControls = Ne, this.removeListeners = Ne, this.controls = new qC(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Ne;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const c1 = (e) => (t, n) => {
  e && ve.postRender(() => e(t, n));
};
class JC extends on {
  constructor() {
    super(...arguments), this.removePointerDownListener = Ne;
  }
  onPointerDown(t) {
    this.session = new vh(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: Ph(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: r, onPanEnd: o } = this.node.getProps();
    return {
      onSessionStart: c1(t),
      onStart: c1(n),
      onMove: r,
      onEnd: (i, s) => {
        delete this.session, o && ve.postRender(() => o(i, s));
      }
    };
  }
  mount() {
    this.removePointerDownListener = _t(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const fi = An(null);
function ey() {
  const e = Oe(fi);
  if (e === null)
    return [!0, null];
  const { isPresent: t, onExitComplete: n, register: r } = e, o = ea();
  bn(() => r(o), []);
  const i = ta(() => n && n(o), [o, n]);
  return !t && n ? [!1, i] : [!0];
}
const ul = An({}), Th = An({}), yo = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function u1(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const hr = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (G.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = u1(e, t.target.x), r = u1(e, t.target.y);
    return `${n}% ${r}%`;
  }
}, ty = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const r = e, o = Jt.parse(e);
    if (o.length > 5)
      return r;
    const i = Jt.createTransformer(e), s = typeof o[0] != "number" ? 1 : 0, a = n.x.scale * t.x, l = n.y.scale * t.y;
    o[0 + s] /= a, o[1 + s] /= l;
    const c = Ee(a, l, 0.5);
    return typeof o[2 + s] == "number" && (o[2 + s] /= c), typeof o[3 + s] == "number" && (o[3 + s] /= c), i(o);
  }
}, Bo = {};
function ny(e) {
  Object.assign(Bo, e);
}
const { schedule: dl, cancel: tk } = M5(queueMicrotask, !1);
class ry extends Iu {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r, layoutId: o } = this.props, { projection: i } = t;
    ny(oy), i && (n.group && n.group.add(i), r && r.register && o && r.register(i), i.root.didUpdate(), i.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), i.setOptions({
      ...i.options,
      onExitComplete: () => this.safeToRemove()
    })), yo.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: r, drag: o, isPresent: i } = this.props, s = r.projection;
    return s && (s.isPresent = i, o || t.layoutDependency !== n || n === void 0 ? s.willUpdate() : this.safeToRemove(), t.isPresent !== i && (i ? s.promote() : s.relegate() || ve.postRender(() => {
      const a = s.getStack();
      (!a || !a.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: t } = this.props.visualElement;
    t && (t.root.didUpdate(), dl.postRender(() => {
      !t.currentAnimation && t.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: o } = t;
    o && (o.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(o), r && r.deregister && r.deregister(o));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function Mh(e) {
  const [t, n] = ey(), r = Oe(ul);
  return p.jsx(ry, { ...e, layoutGroup: r, switchLayoutGroup: Oe(Th), isPresent: t, safeToRemove: n });
}
const oy = {
  borderRadius: {
    ...hr,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: hr,
  borderTopRightRadius: hr,
  borderBottomLeftRadius: hr,
  borderBottomRightRadius: hr,
  boxShadow: ty
}, Ih = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], iy = Ih.length, d1 = (e) => typeof e == "string" ? parseFloat(e) : e, f1 = (e) => typeof e == "number" || G.test(e);
function sy(e, t, n, r, o, i) {
  o ? (e.opacity = Ee(
    0,
    // TODO Reinstate this if only child
    n.opacity !== void 0 ? n.opacity : 1,
    ay(r)
  ), e.opacityExit = Ee(t.opacity !== void 0 ? t.opacity : 1, 0, ly(r))) : i && (e.opacity = Ee(t.opacity !== void 0 ? t.opacity : 1, n.opacity !== void 0 ? n.opacity : 1, r));
  for (let s = 0; s < iy; s++) {
    const a = `border${Ih[s]}Radius`;
    let l = h1(t, a), c = h1(n, a);
    if (l === void 0 && c === void 0)
      continue;
    l || (l = 0), c || (c = 0), l === 0 || c === 0 || f1(l) === f1(c) ? (e[a] = Math.max(Ee(d1(l), d1(c), r), 0), (bt.test(c) || bt.test(l)) && (e[a] += "%")) : e[a] = c;
  }
  (t.rotate || n.rotate) && (e.rotate = Ee(t.rotate || 0, n.rotate || 0, r));
}
function h1(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const ay = /* @__PURE__ */ _h(0, 0.5, j5), ly = /* @__PURE__ */ _h(0.5, 0.95, Ne);
function _h(e, t, n) {
  return (r) => r < e ? 0 : r > t ? 1 : n($n(e, t, r));
}
function p1(e, t) {
  e.min = t.min, e.max = t.max;
}
function it(e, t) {
  p1(e.x, t.x), p1(e.y, t.y);
}
function m1(e, t) {
  e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin;
}
function g1(e, t, n, r, o) {
  return e -= t, e = Fo(e, 1 / n, r), o !== void 0 && (e = Fo(e, 1 / o, r)), e;
}
function cy(e, t = 0, n = 1, r = 0.5, o, i = e, s = e) {
  if (bt.test(t) && (t = parseFloat(t), t = Ee(s.min, s.max, t / 100) - s.min), typeof t != "number")
    return;
  let a = Ee(i.min, i.max, r);
  e === i && (a -= t), e.min = g1(e.min, t, n, a, o), e.max = g1(e.max, t, n, a, o);
}
function v1(e, t, [n, r, o], i, s) {
  cy(e, t[n], t[r], t[o], t.scale, i, s);
}
const uy = ["x", "scaleX", "originX"], dy = ["y", "scaleY", "originY"];
function C1(e, t, n, r) {
  v1(e.x, t, uy, n ? n.x : void 0, r ? r.x : void 0), v1(e.y, t, dy, n ? n.y : void 0, r ? r.y : void 0);
}
function y1(e) {
  return e.translate === 0 && e.scale === 1;
}
function Lh(e) {
  return y1(e.x) && y1(e.y);
}
function x1(e, t) {
  return e.min === t.min && e.max === t.max;
}
function fy(e, t) {
  return x1(e.x, t.x) && x1(e.y, t.y);
}
function w1(e, t) {
  return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max);
}
function Nh(e, t) {
  return w1(e.x, t.x) && w1(e.y, t.y);
}
function b1(e) {
  return nt(e.x) / nt(e.y);
}
function A1(e, t) {
  return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint;
}
class hy {
  constructor() {
    this.members = [];
  }
  add(t) {
    al(this.members, t), t.scheduleRender();
  }
  remove(t) {
    if (ll(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    const n = this.members.findIndex((o) => t === o);
    if (n === 0)
      return !1;
    let r;
    for (let o = n; o >= 0; o--) {
      const i = this.members[o];
      if (i.isPresent !== !1) {
        r = i;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(t, n) {
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.instance && r.scheduleRender(), t.scheduleRender(), t.resumeFrom = r, n && (t.resumeFrom.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), t.root && t.root.isUpdating && (t.isLayoutDirty = !0);
      const { crossfade: o } = t.options;
      o === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      const { options: n, resumingFrom: r } = t;
      n.onExitComplete && n.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => {
      t.instance && t.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function py(e, t, n) {
  let r = "";
  const o = e.x.translate / t.x, i = e.y.translate / t.y, s = (n == null ? void 0 : n.z) || 0;
  if ((o || i || s) && (r = `translate3d(${o}px, ${i}px, ${s}px) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { transformPerspective: c, rotate: u, rotateX: d, rotateY: f, skewX: h, skewY: v } = n;
    c && (r = `perspective(${c}px) ${r}`), u && (r += `rotate(${u}deg) `), d && (r += `rotateX(${d}deg) `), f && (r += `rotateY(${f}deg) `), h && (r += `skewX(${h}deg) `), v && (r += `skewY(${v}deg) `);
  }
  const a = e.x.scale * t.x, l = e.y.scale * t.y;
  return (a !== 1 || l !== 1) && (r += `scale(${a}, ${l})`), r || "none";
}
const my = (e, t) => e.depth - t.depth;
class gy {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    al(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    ll(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(my), this.isDirty = !1, this.children.forEach(t);
  }
}
function xo(e) {
  const t = je(e) ? e.get() : e;
  return aC(t) ? t.toValue() : t;
}
function vy(e, t) {
  const n = At.now(), r = ({ timestamp: o }) => {
    const i = o - n;
    i >= t && (Xt(r), e(i - t));
  };
  return ve.read(r, !0), () => Xt(r);
}
function Cy(e) {
  return e instanceof SVGElement && e.tagName !== "svg";
}
function yy(e, t, n) {
  const r = je(e) ? e : Nr(e);
  return r.start(sl("", r, t, n)), r.animation;
}
const hn = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
}, yr = typeof window < "u" && window.MotionDebug !== void 0, Zi = ["", "X", "Y", "Z"], xy = { visibility: "hidden" }, E1 = 1e3;
let wy = 0;
function Qi(e, t, n, r) {
  const { latestValues: o } = t;
  o[e] && (n[e] = o[e], t.setStaticValue(e, 0), r && (r[e] = 0));
}
function Dh(e) {
  if (e.hasCheckedOptimisedAppear = !0, e.root === e)
    return;
  const { visualElement: t } = e.options;
  if (!t)
    return;
  const n = hh(t);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: o, layoutId: i } = e.options;
    window.MotionCancelOptimisedAnimation(n, "transform", ve, !(o || i));
  }
  const { parent: r } = e;
  r && !r.hasCheckedOptimisedAppear && Dh(r);
}
function Oh({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: o }) {
  return class {
    constructor(s = {}, a = t == null ? void 0 : t()) {
      this.id = wy++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, yr && (hn.totalNodes = hn.resolvedTargetDeltas = hn.recalculatedProjection = 0), this.nodes.forEach(Ey), this.nodes.forEach(Ty), this.nodes.forEach(My), this.nodes.forEach(Sy), yr && window.MotionDebug.record(hn);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = s, this.root = a ? a.root || a : this, this.path = a ? [...a.path, a] : [], this.parent = a, this.depth = a ? a.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++)
        this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new gy());
    }
    addEventListener(s, a) {
      return this.eventHandlers.has(s) || this.eventHandlers.set(s, new cl()), this.eventHandlers.get(s).add(a);
    }
    notifyListeners(s, ...a) {
      const l = this.eventHandlers.get(s);
      l && l.notify(...a);
    }
    hasListeners(s) {
      return this.eventHandlers.has(s);
    }
    /**
     * Lifecycles
     */
    mount(s, a = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = Cy(s), this.instance = s;
      const { layoutId: l, layout: c, visualElement: u } = this.options;
      if (u && !u.current && u.mount(s), this.root.nodes.add(this), this.parent && this.parent.children.add(this), a && (c || l) && (this.isLayoutDirty = !0), e) {
        let d;
        const f = () => this.root.updateBlockedByResize = !1;
        e(s, () => {
          this.root.updateBlockedByResize = !0, d && d(), d = vy(f, 250), yo.hasAnimatedSinceResize && (yo.hasAnimatedSinceResize = !1, this.nodes.forEach(k1));
        });
      }
      l && this.root.registerSharedNode(l, this), this.options.animate !== !1 && u && (l || c) && this.addEventListener("didUpdate", ({ delta: d, hasLayoutChanged: f, hasRelativeTargetChanged: h, layout: v }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const m = this.options.transition || u.getDefaultTransition() || Dy, { onLayoutAnimationStart: y, onLayoutAnimationComplete: C } = u.getProps(), x = !this.targetLayout || !Nh(this.targetLayout, v) || h, w = !f && h;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || w || f && (x || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(d, w);
          const S = {
            ...Za(m, "layout"),
            onPlay: y,
            onComplete: C
          };
          (u.shouldReduceMotion || this.options.layoutRoot) && (S.delay = 0, S.type = !1), this.startAnimation(S);
        } else
          f || k1(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = v;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const s = this.getStack();
      s && s.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, Xt(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(Iy), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: s } = this.options;
      return s && s.getProps().transformTemplate;
    }
    willUpdate(s = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && Dh(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let u = 0; u < this.path.length; u++) {
        const d = this.path[u];
        d.shouldResetTransform = !0, d.updateScroll("snapshot"), d.options.layoutRoot && d.willUpdate(!1);
      }
      const { layoutId: a, layout: l } = this.options;
      if (a === void 0 && !l)
        return;
      const c = this.getTransformTemplate();
      this.prevTransformTemplateValue = c ? c(this.latestValues, "") : void 0, this.updateSnapshot(), s && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(S1);
        return;
      }
      this.isUpdating || this.nodes.forEach(Ry), this.isUpdating = !1, this.nodes.forEach(Py), this.nodes.forEach(by), this.nodes.forEach(Ay), this.clearAllSnapshots();
      const a = At.now();
      Le.delta = Yt(0, 1e3 / 60, a - Le.timestamp), Le.timestamp = a, Le.isProcessing = !0, Vi.update.process(Le), Vi.preRender.process(Le), Vi.render.process(Le), Le.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, dl.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(ky), this.sharedNodes.forEach(_y);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, ve.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      ve.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const s = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = ke(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: a } = this.options;
      a && a.notify("LayoutMeasure", this.layout.layoutBox, s ? s.layoutBox : void 0);
    }
    updateScroll(s = "measure") {
      let a = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === s && (a = !1), a) {
        const l = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: s,
          isRoot: l,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : l
        };
      }
    }
    resetTransform() {
      if (!o)
        return;
      const s = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, a = this.projectionDelta && !Lh(this.projectionDelta), l = this.getTransformTemplate(), c = l ? l(this.latestValues, "") : void 0, u = c !== this.prevTransformTemplateValue;
      s && (a || fn(this.latestValues) || u) && (o(this.instance, c), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(s = !0) {
      const a = this.measurePageBox();
      let l = this.removeElementScroll(a);
      return s && (l = this.removeTransform(l)), Oy(l), {
        animationId: this.root.animationId,
        measuredBox: a,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var s;
      const { visualElement: a } = this.options;
      if (!a)
        return ke();
      const l = a.measureViewportBox();
      if (!(((s = this.scroll) === null || s === void 0 ? void 0 : s.wasRoot) || this.path.some(jy))) {
        const { scroll: u } = this.root;
        u && (Vn(l.x, u.offset.x), Vn(l.y, u.offset.y));
      }
      return l;
    }
    removeElementScroll(s) {
      var a;
      const l = ke();
      if (it(l, s), !((a = this.scroll) === null || a === void 0) && a.wasRoot)
        return l;
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c], { scroll: d, options: f } = u;
        u !== this.root && d && f.layoutScroll && (d.wasRoot && it(l, s), Vn(l.x, d.offset.x), Vn(l.y, d.offset.y));
      }
      return l;
    }
    applyTransform(s, a = !1) {
      const l = ke();
      it(l, s);
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c];
        !a && u.options.layoutScroll && u.scroll && u !== u.root && Fn(l, {
          x: -u.scroll.offset.x,
          y: -u.scroll.offset.y
        }), fn(u.latestValues) && Fn(l, u.latestValues);
      }
      return fn(this.latestValues) && Fn(l, this.latestValues), l;
    }
    removeTransform(s) {
      const a = ke();
      it(a, s);
      for (let l = 0; l < this.path.length; l++) {
        const c = this.path[l];
        if (!c.instance || !fn(c.latestValues))
          continue;
        Bs(c.latestValues) && c.updateSnapshot();
        const u = ke(), d = c.measurePageBox();
        it(u, d), C1(a, c.latestValues, c.snapshot ? c.snapshot.layoutBox : void 0, u);
      }
      return fn(this.latestValues) && C1(a, this.latestValues), a;
    }
    setTargetDelta(s) {
      this.targetDelta = s, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(s) {
      this.options = {
        ...this.options,
        ...s,
        crossfade: s.crossfade !== void 0 ? s.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== Le.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(s = !1) {
      var a;
      const l = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = l.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = l.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = l.isSharedProjectionDirty);
      const c = !!this.resumingFrom || this !== l;
      if (!(s || c && this.isSharedProjectionDirty || this.isProjectionDirty || !((a = this.parent) === null || a === void 0) && a.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: d, layoutId: f } = this.options;
      if (!(!this.layout || !(d || f))) {
        if (this.resolvedRelativeTargetAt = Le.timestamp, !this.targetDelta && !this.relativeTarget) {
          const h = this.getClosestProjectingParent();
          h && h.layout && this.animationProgress !== 1 ? (this.relativeParent = h, this.forceRelativeParentToResolveTarget(), this.relativeTarget = ke(), this.relativeTargetOrigin = ke(), br(this.relativeTargetOrigin, this.layout.layoutBox, h.layout.layoutBox), it(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = ke(), this.targetWithTransforms = ke()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), VC(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : it(this.target, this.layout.layoutBox), kh(this.target, this.targetDelta)) : it(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const h = this.getClosestProjectingParent();
            h && !!h.resumingFrom == !!this.resumingFrom && !h.options.layoutScroll && h.target && this.animationProgress !== 1 ? (this.relativeParent = h, this.forceRelativeParentToResolveTarget(), this.relativeTarget = ke(), this.relativeTargetOrigin = ke(), br(this.relativeTargetOrigin, this.target, h.target), it(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          yr && hn.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Bs(this.parent.latestValues) || Sh(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var s;
      const a = this.getLead(), l = !!this.resumingFrom || this !== a;
      let c = !0;
      if ((this.isProjectionDirty || !((s = this.parent) === null || s === void 0) && s.isProjectionDirty) && (c = !1), l && (this.isSharedProjectionDirty || this.isTransformDirty) && (c = !1), this.resolvedRelativeTargetAt === Le.timestamp && (c = !1), c)
        return;
      const { layout: u, layoutId: d } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(u || d))
        return;
      it(this.layoutCorrected, this.layout.layoutBox);
      const f = this.treeScale.x, h = this.treeScale.y;
      QC(this.layoutCorrected, this.treeScale, this.path, l), a.layout && !a.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (a.target = a.layout.layoutBox, a.targetWithTransforms = ke());
      const { target: v } = a;
      if (!v) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (m1(this.prevProjectionDelta.x, this.projectionDelta.x), m1(this.prevProjectionDelta.y, this.projectionDelta.y)), wr(this.projectionDelta, this.layoutCorrected, v, this.latestValues), (this.treeScale.x !== f || this.treeScale.y !== h || !A1(this.projectionDelta.x, this.prevProjectionDelta.x) || !A1(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", v)), yr && hn.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(s = !0) {
      var a;
      if ((a = this.options.visualElement) === null || a === void 0 || a.scheduleRender(), s) {
        const l = this.getStack();
        l && l.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = jn(), this.projectionDelta = jn(), this.projectionDeltaWithTransform = jn();
    }
    setAnimationOrigin(s, a = !1) {
      const l = this.snapshot, c = l ? l.latestValues : {}, u = { ...this.latestValues }, d = jn();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !a;
      const f = ke(), h = l ? l.source : void 0, v = this.layout ? this.layout.source : void 0, m = h !== v, y = this.getStack(), C = !y || y.members.length <= 1, x = !!(m && !C && this.options.crossfade === !0 && !this.path.some(Ny));
      this.animationProgress = 0;
      let w;
      this.mixTargetDelta = (S) => {
        const R = S / 1e3;
        R1(d.x, s.x, R), R1(d.y, s.y, R), this.setTargetDelta(d), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (br(f, this.layout.layoutBox, this.relativeParent.layout.layoutBox), Ly(this.relativeTarget, this.relativeTargetOrigin, f, R), w && fy(this.relativeTarget, w) && (this.isProjectionDirty = !1), w || (w = ke()), it(w, this.relativeTarget)), m && (this.animationValues = u, sy(u, c, this.latestValues, R, x, C)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = R;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(s) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (Xt(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = ve.update(() => {
        yo.hasAnimatedSinceResize = !0, this.currentAnimation = yy(0, E1, {
          ...s,
          onUpdate: (a) => {
            this.mixTargetDelta(a), s.onUpdate && s.onUpdate(a);
          },
          onComplete: () => {
            s.onComplete && s.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const s = this.getStack();
      s && s.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(E1), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const s = this.getLead();
      let { targetWithTransforms: a, target: l, layout: c, latestValues: u } = s;
      if (!(!a || !l || !c)) {
        if (this !== s && this.layout && c && jh(this.options.animationType, this.layout.layoutBox, c.layoutBox)) {
          l = this.target || ke();
          const d = nt(this.layout.layoutBox.x);
          l.x.min = s.target.x.min, l.x.max = l.x.min + d;
          const f = nt(this.layout.layoutBox.y);
          l.y.min = s.target.y.min, l.y.max = l.y.min + f;
        }
        it(a, l), Fn(a, u), wr(this.projectionDeltaWithTransform, this.layoutCorrected, a, u);
      }
    }
    registerSharedNode(s, a) {
      this.sharedNodes.has(s) || this.sharedNodes.set(s, new hy()), this.sharedNodes.get(s).add(a);
      const c = a.options.initialPromotionConfig;
      a.promote({
        transition: c ? c.transition : void 0,
        preserveFollowOpacity: c && c.shouldPreserveFollowOpacity ? c.shouldPreserveFollowOpacity(a) : void 0
      });
    }
    isLead() {
      const s = this.getStack();
      return s ? s.lead === this : !0;
    }
    getLead() {
      var s;
      const { layoutId: a } = this.options;
      return a ? ((s = this.getStack()) === null || s === void 0 ? void 0 : s.lead) || this : this;
    }
    getPrevLead() {
      var s;
      const { layoutId: a } = this.options;
      return a ? (s = this.getStack()) === null || s === void 0 ? void 0 : s.prevLead : void 0;
    }
    getStack() {
      const { layoutId: s } = this.options;
      if (s)
        return this.root.sharedNodes.get(s);
    }
    promote({ needsReset: s, transition: a, preserveFollowOpacity: l } = {}) {
      const c = this.getStack();
      c && c.promote(this, l), s && (this.projectionDelta = void 0, this.needsReset = !0), a && this.setOptions({ transition: a });
    }
    relegate() {
      const s = this.getStack();
      return s ? s.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: s } = this.options;
      if (!s)
        return;
      let a = !1;
      const { latestValues: l } = s;
      if ((l.z || l.rotate || l.rotateX || l.rotateY || l.rotateZ || l.skewX || l.skewY) && (a = !0), !a)
        return;
      const c = {};
      l.z && Qi("z", s, c, this.animationValues);
      for (let u = 0; u < Zi.length; u++)
        Qi(`rotate${Zi[u]}`, s, c, this.animationValues), Qi(`skew${Zi[u]}`, s, c, this.animationValues);
      s.render();
      for (const u in c)
        s.setStaticValue(u, c[u]), this.animationValues && (this.animationValues[u] = c[u]);
      s.scheduleRender();
    }
    getProjectionStyles(s) {
      var a, l;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return xy;
      const c = {
        visibility: ""
      }, u = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, c.opacity = "", c.pointerEvents = xo(s == null ? void 0 : s.pointerEvents) || "", c.transform = u ? u(this.latestValues, "") : "none", c;
      const d = this.getLead();
      if (!this.projectionDelta || !this.layout || !d.target) {
        const m = {};
        return this.options.layoutId && (m.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, m.pointerEvents = xo(s == null ? void 0 : s.pointerEvents) || ""), this.hasProjected && !fn(this.latestValues) && (m.transform = u ? u({}, "") : "none", this.hasProjected = !1), m;
      }
      const f = d.animationValues || d.latestValues;
      this.applyTransformsToTarget(), c.transform = py(this.projectionDeltaWithTransform, this.treeScale, f), u && (c.transform = u(f, c.transform));
      const { x: h, y: v } = this.projectionDelta;
      c.transformOrigin = `${h.origin * 100}% ${v.origin * 100}% 0`, d.animationValues ? c.opacity = d === this ? (l = (a = f.opacity) !== null && a !== void 0 ? a : this.latestValues.opacity) !== null && l !== void 0 ? l : 1 : this.preserveOpacity ? this.latestValues.opacity : f.opacityExit : c.opacity = d === this ? f.opacity !== void 0 ? f.opacity : "" : f.opacityExit !== void 0 ? f.opacityExit : 0;
      for (const m in Bo) {
        if (f[m] === void 0)
          continue;
        const { correct: y, applyTo: C } = Bo[m], x = c.transform === "none" ? f[m] : y(f[m], d);
        if (C) {
          const w = C.length;
          for (let S = 0; S < w; S++)
            c[C[S]] = x;
        } else
          c[m] = x;
      }
      return this.options.layoutId && (c.pointerEvents = d === this ? xo(s == null ? void 0 : s.pointerEvents) || "" : "none"), c;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((s) => {
        var a;
        return (a = s.currentAnimation) === null || a === void 0 ? void 0 : a.stop();
      }), this.root.nodes.forEach(S1), this.root.sharedNodes.clear();
    }
  };
}
function by(e) {
  e.updateLayout();
}
function Ay(e) {
  var t;
  const n = ((t = e.resumeFrom) === null || t === void 0 ? void 0 : t.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && n && e.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: o } = e.layout, { animationType: i } = e.options, s = n.source !== e.layout.source;
    i === "size" ? st((d) => {
      const f = s ? n.measuredBox[d] : n.layoutBox[d], h = nt(f);
      f.min = r[d].min, f.max = f.min + h;
    }) : jh(i, n.layoutBox, r) && st((d) => {
      const f = s ? n.measuredBox[d] : n.layoutBox[d], h = nt(r[d]);
      f.max = f.min + h, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[d].max = e.relativeTarget[d].min + h);
    });
    const a = jn();
    wr(a, r, n.layoutBox);
    const l = jn();
    s ? wr(l, e.applyTransform(o, !0), n.measuredBox) : wr(l, r, n.layoutBox);
    const c = !Lh(a);
    let u = !1;
    if (!e.resumeFrom) {
      const d = e.getClosestProjectingParent();
      if (d && !d.resumeFrom) {
        const { snapshot: f, layout: h } = d;
        if (f && h) {
          const v = ke();
          br(v, n.layoutBox, f.layoutBox);
          const m = ke();
          br(m, r, h.layoutBox), Nh(v, m) || (u = !0), d.options.layoutRoot && (e.relativeTarget = m, e.relativeTargetOrigin = v, e.relativeParent = d);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: r,
      snapshot: n,
      delta: l,
      layoutDelta: a,
      hasLayoutChanged: c,
      hasRelativeTargetChanged: u
    });
  } else if (e.isLead()) {
    const { onExitComplete: r } = e.options;
    r && r();
  }
  e.options.transition = void 0;
}
function Ey(e) {
  yr && hn.totalNodes++, e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function Sy(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function ky(e) {
  e.clearSnapshot();
}
function S1(e) {
  e.clearMeasurements();
}
function Ry(e) {
  e.isLayoutDirty = !1;
}
function Py(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function k1(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function Ty(e) {
  e.resolveTargetDelta();
}
function My(e) {
  e.calcProjection();
}
function Iy(e) {
  e.resetSkewAndRotation();
}
function _y(e) {
  e.removeLeadSnapshot();
}
function R1(e, t, n) {
  e.translate = Ee(t.translate, 0, n), e.scale = Ee(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function P1(e, t, n, r) {
  e.min = Ee(t.min, n.min, r), e.max = Ee(t.max, n.max, r);
}
function Ly(e, t, n, r) {
  P1(e.x, t.x, n.x, r), P1(e.y, t.y, n.y, r);
}
function Ny(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const Dy = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, T1 = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), M1 = T1("applewebkit/") && !T1("chrome/") ? Math.round : Ne;
function I1(e) {
  e.min = M1(e.min), e.max = M1(e.max);
}
function Oy(e) {
  I1(e.x), I1(e.y);
}
function jh(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !jC(b1(t), b1(n), 0.2);
}
function jy(e) {
  var t;
  return e !== e.root && ((t = e.scroll) === null || t === void 0 ? void 0 : t.wasRoot);
}
const Vy = Oh({
  attachResizeListener: (e, t) => Tt(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), Gi = {
  current: void 0
}, Vh = Oh({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!Gi.current) {
      const e = new Vy({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), Gi.current = e;
    }
    return Gi.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), Fy = {
  pan: {
    Feature: JC
  },
  drag: {
    Feature: YC,
    ProjectionNode: Vh,
    MeasureLayout: Mh
  }
};
function _1(e, t) {
  const n = t ? "pointerenter" : "pointerleave", r = t ? "onHoverStart" : "onHoverEnd", o = (i, s) => {
    if (i.pointerType === "touch" || wh())
      return;
    const a = e.getProps();
    e.animationState && a.whileHover && e.animationState.setActive("whileHover", t);
    const l = a[r];
    l && ve.postRender(() => l(i, s));
  };
  return _t(e.current, n, o, {
    passive: !e.getProps()[r]
  });
}
class By extends on {
  mount() {
    this.unmount = It(_1(this.node, !0), _1(this.node, !1));
  }
  unmount() {
  }
}
class Hy extends on {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = It(Tt(this.node.current, "focus", () => this.onFocus()), Tt(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const Fh = (e, t) => t ? e === t ? !0 : Fh(e, t.parentElement) : !1;
function $i(e, t) {
  if (!t)
    return;
  const n = new PointerEvent("pointer" + e);
  t(n, di(n));
}
class zy extends on {
  constructor() {
    super(...arguments), this.removeStartListeners = Ne, this.removeEndListeners = Ne, this.removeAccessibleListeners = Ne, this.startPointerPress = (t, n) => {
      if (this.isPressing)
        return;
      this.removeEndListeners();
      const r = this.node.getProps(), i = _t(window, "pointerup", (a, l) => {
        if (!this.checkPressEnd())
          return;
        const { onTap: c, onTapCancel: u, globalTapTarget: d } = this.node.getProps(), f = !d && !Fh(this.node.current, a.target) ? u : c;
        f && ve.update(() => f(a, l));
      }, {
        passive: !(r.onTap || r.onPointerUp)
      }), s = _t(window, "pointercancel", (a, l) => this.cancelPress(a, l), {
        passive: !(r.onTapCancel || r.onPointerCancel)
      });
      this.removeEndListeners = It(i, s), this.startPress(t, n);
    }, this.startAccessiblePress = () => {
      const t = (i) => {
        if (i.key !== "Enter" || this.isPressing)
          return;
        const s = (a) => {
          a.key !== "Enter" || !this.checkPressEnd() || $i("up", (l, c) => {
            const { onTap: u } = this.node.getProps();
            u && ve.postRender(() => u(l, c));
          });
        };
        this.removeEndListeners(), this.removeEndListeners = Tt(this.node.current, "keyup", s), $i("down", (a, l) => {
          this.startPress(a, l);
        });
      }, n = Tt(this.node.current, "keydown", t), r = () => {
        this.isPressing && $i("cancel", (i, s) => this.cancelPress(i, s));
      }, o = Tt(this.node.current, "blur", r);
      this.removeAccessibleListeners = It(n, o);
    };
  }
  startPress(t, n) {
    this.isPressing = !0;
    const { onTapStart: r, whileTap: o } = this.node.getProps();
    o && this.node.animationState && this.node.animationState.setActive("whileTap", !0), r && ve.postRender(() => r(t, n));
  }
  checkPressEnd() {
    return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !wh();
  }
  cancelPress(t, n) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel: r } = this.node.getProps();
    r && ve.postRender(() => r(t, n));
  }
  mount() {
    const t = this.node.getProps(), n = _t(t.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
      passive: !(t.onTapStart || t.onPointerStart)
    }), r = Tt(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = It(n, r);
  }
  unmount() {
    this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
  }
}
const zs = /* @__PURE__ */ new WeakMap(), qi = /* @__PURE__ */ new WeakMap(), Uy = (e) => {
  const t = zs.get(e.target);
  t && t(e);
}, Ky = (e) => {
  e.forEach(Uy);
};
function Wy({ root: e, ...t }) {
  const n = e || document;
  qi.has(n) || qi.set(n, {});
  const r = qi.get(n), o = JSON.stringify(t);
  return r[o] || (r[o] = new IntersectionObserver(Ky, { root: e, ...t })), r[o];
}
function Zy(e, t, n) {
  const r = Wy(t);
  return zs.set(e, n), r.observe(e), () => {
    zs.delete(e), r.unobserve(e);
  };
}
const Qy = {
  some: 0,
  all: 1
};
class Gy extends on {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: o = "some", once: i } = t, s = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof o == "number" ? o : Qy[o]
    }, a = (l) => {
      const { isIntersecting: c } = l;
      if (this.isInView === c || (this.isInView = c, i && !c && this.hasEnteredView))
        return;
      c && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", c);
      const { onViewportEnter: u, onViewportLeave: d } = this.node.getProps(), f = c ? u : d;
      f && f(l);
    };
    return Zy(this.node.current, s, a);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some($y(t, n)) && this.startObserver();
  }
  unmount() {
  }
}
function $y({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const qy = {
  inView: {
    Feature: Gy
  },
  tap: {
    Feature: zy
  },
  focus: {
    Feature: Hy
  },
  hover: {
    Feature: By
  }
}, Xy = {
  layout: {
    ProjectionNode: Vh,
    MeasureLayout: Mh
  }
}, fl = An({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
}), hi = An({}), hl = typeof window < "u", Bh = hl ? Mu : bn, Hh = An({ strict: !1 });
function Yy(e, t, n, r, o) {
  var i, s;
  const { visualElement: a } = Oe(hi), l = Oe(Hh), c = Oe(fi), u = Oe(fl).reducedMotion, d = Kt();
  r = r || l.renderer, !d.current && r && (d.current = r(e, {
    visualState: t,
    parent: a,
    props: n,
    presenceContext: c,
    blockInitialAnimation: c ? c.initial === !1 : !1,
    reducedMotionConfig: u
  }));
  const f = d.current, h = Oe(Th);
  f && !f.projection && o && (f.type === "html" || f.type === "svg") && Jy(d.current, n, o, h), _u(() => {
    f && f.update(n, c);
  });
  const v = n[fh], m = Kt(!!v && !(!((i = window.MotionHandoffIsComplete) === null || i === void 0) && i.call(window, v)) && ((s = window.MotionHasOptimisedAnimation) === null || s === void 0 ? void 0 : s.call(window, v)));
  return Bh(() => {
    f && (window.MotionIsMounted = !0, f.updateFeatures(), dl.render(f.render), m.current && f.animationState && f.animationState.animateChanges());
  }), bn(() => {
    f && (!m.current && f.animationState && f.animationState.animateChanges(), m.current && (queueMicrotask(() => {
      var y;
      (y = window.MotionHandoffMarkAsComplete) === null || y === void 0 || y.call(window, v);
    }), m.current = !1));
  }), f;
}
function Jy(e, t, n, r) {
  const { layoutId: o, layout: i, drag: s, dragConstraints: a, layoutScroll: l, layoutRoot: c } = t;
  e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : zh(e.parent)), e.projection.setOptions({
    layoutId: o,
    layout: i,
    alwaysMeasureLayout: !!s || a && On(a),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof i == "string" ? i : "both",
    initialPromotionConfig: r,
    layoutScroll: l,
    layoutRoot: c
  });
}
function zh(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : zh(e.parent);
}
function ex(e, t, n) {
  return ta(
    (r) => {
      r && e.mount && e.mount(r), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : On(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
function pi(e) {
  return Mr(e.animate) || Wa.some((t) => Ir(e[t]));
}
function Uh(e) {
  return !!(pi(e) || e.variants);
}
function tx(e, t) {
  if (pi(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || Ir(n) ? n : void 0,
      animate: Ir(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function nx(e) {
  const { initial: t, animate: n } = tx(e, Oe(hi));
  return Wt(() => ({ initial: t, animate: n }), [L1(t), L1(n)]);
}
function L1(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const N1 = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, qn = {};
for (const e in N1)
  qn[e] = {
    isEnabled: (t) => N1[e].some((n) => !!t[n])
  };
function rx(e) {
  for (const t in e)
    qn[t] = {
      ...qn[t],
      ...e[t]
    };
}
const ox = Symbol.for("motionComponentSymbol");
function ix({ preloadedFeatures: e, createVisualElement: t, useRender: n, useVisualState: r, Component: o }) {
  e && rx(e);
  function i(a, l) {
    let c;
    const u = {
      ...Oe(fl),
      ...a,
      layoutId: sx(a)
    }, { isStatic: d } = u, f = nx(a), h = r(a, d);
    if (!d && hl) {
      ax(u, e);
      const v = lx(u);
      c = v.MeasureLayout, f.visualElement = Yy(o, h, u, t, v.ProjectionNode);
    }
    return p.jsxs(hi.Provider, { value: f, children: [c && f.visualElement ? p.jsx(c, { visualElement: f.visualElement, ...u }) : null, n(o, a, ex(h, f.visualElement, l), h, d, f.visualElement)] });
  }
  const s = Js(i);
  return s[ox] = o, s;
}
function sx({ layoutId: e }) {
  const t = Oe(ul).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function ax(e, t) {
  const n = Oe(Hh).strict;
  if (process.env.NODE_ENV !== "production" && t && n) {
    const r = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    e.ignoreStrict ? or(!1, r) : Dt(!1, r);
  }
}
function lx(e) {
  const { drag: t, layout: n } = qn;
  if (!t && !n)
    return {};
  const r = { ...t, ...n };
  return {
    MeasureLayout: t != null && t.isEnabled(e) || n != null && n.isEnabled(e) ? r.MeasureLayout : void 0,
    ProjectionNode: r.ProjectionNode
  };
}
const cx = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function pl(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(cx.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
function Kh(e, { style: t, vars: n }, r, o) {
  Object.assign(e.style, t, o && o.getProjectionStyles(r));
  for (const i in n)
    e.style.setProperty(i, n[i]);
}
const Wh = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function Zh(e, t, n, r) {
  Kh(e, t, void 0, r);
  for (const o in t.attrs)
    e.setAttribute(Wh.has(o) ? o : ui(o), t.attrs[o]);
}
function Qh(e, { layout: t, layoutId: n }) {
  return rn.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!Bo[e] || e === "opacity");
}
function ml(e, t, n) {
  var r;
  const { style: o } = e, i = {};
  for (const s in o)
    (je(o[s]) || t.style && je(t.style[s]) || Qh(s, e) || ((r = n == null ? void 0 : n.getValue(s)) === null || r === void 0 ? void 0 : r.liveStyle) !== void 0) && (i[s] = o[s]);
  return n && o && typeof o.willChange == "string" && (n.applyWillChange = !1), i;
}
function Gh(e, t, n) {
  const r = ml(e, t, n);
  for (const o in e)
    if (je(e[o]) || je(t[o])) {
      const i = Wr.indexOf(o) !== -1 ? "attr" + o.charAt(0).toUpperCase() + o.substring(1) : o;
      r[i] = e[o];
    }
  return r;
}
function gl(e) {
  const t = Kt(null);
  return t.current === null && (t.current = e()), t.current;
}
function ux(e) {
  if (rn.has(e))
    return "transform";
  if (lh.has(e))
    return ui(e);
}
function dx({ applyWillChange: e = !1, scrapeMotionValuesFromProps: t, createRenderState: n, onMount: r }, o, i, s, a) {
  const l = {
    latestValues: fx(o, i, s, a ? !1 : e, t),
    renderState: n()
  };
  return r && (l.mount = (c) => r(o, c, l)), l;
}
const $h = (e) => (t, n) => {
  const r = Oe(hi), o = Oe(fi), i = () => dx(e, t, r, o, n);
  return n ? i() : gl(i);
};
function D1(e, t, n) {
  const r = Array.isArray(t) ? t : [t];
  for (let o = 0; o < r.length; o++) {
    const i = Ua(e, r[o]);
    if (i) {
      const { transitionEnd: s, transition: a, ...l } = i;
      n(l, s);
    }
  }
}
function fx(e, t, n, r, o) {
  var i;
  const s = {}, a = /* @__PURE__ */ new Set(), l = r && ((i = e.style) === null || i === void 0 ? void 0 : i.willChange) === void 0, c = o(e, {});
  for (const y in c)
    s[y] = xo(c[y]);
  let { initial: u, animate: d } = e;
  const f = pi(e), h = Uh(e);
  t && h && !f && e.inherit !== !1 && (u === void 0 && (u = t.initial), d === void 0 && (d = t.animate));
  let v = n ? n.initial === !1 : !1;
  v = v || u === !1;
  const m = v ? d : u;
  return m && typeof m != "boolean" && !Mr(m) && D1(e, m, (y, C) => {
    for (const x in y) {
      let w = y[x];
      if (Array.isArray(w)) {
        const S = v ? w.length - 1 : 0;
        w = w[S];
      }
      w !== null && (s[x] = w);
    }
    for (const x in C)
      s[x] = C[x];
  }), l && (d && u !== !1 && !Mr(d) && D1(e, d, (y) => {
    for (const C in y) {
      const x = ux(C);
      x && a.add(x);
    }
  }), a.size && (s.willChange = Array.from(a).join(","))), s;
}
const vl = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
}), qh = () => ({
  ...vl(),
  attrs: {}
}), Xh = (e, t) => t && typeof e == "number" ? t.transform(e) : e, hx = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, px = Wr.length;
function mx(e, t, n) {
  let r = "", o = !0;
  for (let i = 0; i < px; i++) {
    const s = Wr[i], a = e[s];
    if (a === void 0)
      continue;
    let l = !0;
    if (typeof a == "number" ? l = a === (s.startsWith("scale") ? 1 : 0) : l = parseFloat(a) === 0, !l || n) {
      const c = Xh(a, Ja[s]);
      if (!l) {
        o = !1;
        const u = hx[s] || s;
        r += `${u}(${c}) `;
      }
      n && (t[s] = c);
    }
  }
  return r = r.trim(), n ? r = n(t, o ? "" : r) : o && (r = "none"), r;
}
function Cl(e, t, n) {
  const { style: r, vars: o, transformOrigin: i } = e;
  let s = !1, a = !1;
  for (const l in t) {
    const c = t[l];
    if (rn.has(l)) {
      s = !0;
      continue;
    } else if (z5(l)) {
      o[l] = c;
      continue;
    } else {
      const u = Xh(c, Ja[l]);
      l.startsWith("origin") ? (a = !0, i[l] = u) : r[l] = u;
    }
  }
  if (t.transform || (s || n ? r.transform = mx(t, e.transform, n) : r.transform && (r.transform = "none")), a) {
    const { originX: l = "50%", originY: c = "50%", originZ: u = 0 } = i;
    r.transformOrigin = `${l} ${c} ${u}`;
  }
}
function O1(e, t, n) {
  return typeof e == "string" ? e : G.transform(t + n * e);
}
function gx(e, t, n) {
  const r = O1(t, e.x, e.width), o = O1(n, e.y, e.height);
  return `${r} ${o}`;
}
const vx = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, Cx = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function yx(e, t, n = 1, r = 0, o = !0) {
  e.pathLength = 1;
  const i = o ? vx : Cx;
  e[i.offset] = G.transform(-r);
  const s = G.transform(t), a = G.transform(n);
  e[i.array] = `${s} ${a}`;
}
function yl(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  originX: o,
  originY: i,
  pathLength: s,
  pathSpacing: a = 1,
  pathOffset: l = 0,
  // This is object creation, which we try to avoid per-frame.
  ...c
}, u, d) {
  if (Cl(e, c, d), u) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: f, style: h, dimensions: v } = e;
  f.transform && (v && (h.transform = f.transform), delete f.transform), v && (o !== void 0 || i !== void 0 || h.transform) && (h.transformOrigin = gx(v, o !== void 0 ? o : 0.5, i !== void 0 ? i : 0.5)), t !== void 0 && (f.x = t), n !== void 0 && (f.y = n), r !== void 0 && (f.scale = r), s !== void 0 && yx(f, s, a, l, !1);
}
const xl = (e) => typeof e == "string" && e.toLowerCase() === "svg", xx = {
  useVisualState: $h({
    scrapeMotionValuesFromProps: Gh,
    createRenderState: qh,
    onMount: (e, t, { renderState: n, latestValues: r }) => {
      ve.read(() => {
        try {
          n.dimensions = typeof t.getBBox == "function" ? t.getBBox() : t.getBoundingClientRect();
        } catch {
          n.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      }), ve.render(() => {
        yl(n, r, xl(t.tagName), e.transformTemplate), Zh(t, n);
      });
    }
  })
}, wx = {
  useVisualState: $h({
    applyWillChange: !0,
    scrapeMotionValuesFromProps: ml,
    createRenderState: vl
  })
};
function Yh(e, t, n) {
  for (const r in t)
    !je(t[r]) && !Qh(r, n) && (e[r] = t[r]);
}
function bx({ transformTemplate: e }, t) {
  return Wt(() => {
    const n = vl();
    return Cl(n, t, e), Object.assign({}, n.vars, n.style);
  }, [t]);
}
function Ax(e, t) {
  const n = e.style || {}, r = {};
  return Yh(r, n, e), Object.assign(r, bx(e, t)), r;
}
function Ex(e, t) {
  const n = {}, r = Ax(e, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
const Sx = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function Ho(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || Sx.has(e);
}
let Jh = (e) => !Ho(e);
function kx(e) {
  e && (Jh = (t) => t.startsWith("on") ? !Ho(t) : e(t));
}
try {
  kx(require("@emotion/is-prop-valid").default);
} catch {
}
function Rx(e, t, n) {
  const r = {};
  for (const o in e)
    o === "values" && typeof e.values == "object" || (Jh(o) || n === !0 && Ho(o) || !t && !Ho(o) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && o.startsWith("onDrag")) && (r[o] = e[o]);
  return r;
}
function Px(e, t, n, r) {
  const o = Wt(() => {
    const i = qh();
    return yl(i, t, xl(r), e.transformTemplate), {
      ...i.attrs,
      style: { ...i.style }
    };
  }, [t]);
  if (e.style) {
    const i = {};
    Yh(i, e.style, e), o.style = { ...i, ...o.style };
  }
  return o;
}
function Tx(e = !1) {
  return (n, r, o, { latestValues: i }, s) => {
    const l = (pl(n) ? Px : Ex)(r, i, s, n), c = Rx(r, typeof n == "string", e), u = n !== Lu ? { ...c, ...l, ref: o } : {}, { children: d } = r, f = Wt(() => je(d) ? d.get() : d, [d]);
    return Wn(n, {
      ...u,
      children: f
    });
  };
}
function Mx(e, t) {
  return function(r, { forwardMotionProps: o } = { forwardMotionProps: !1 }) {
    const s = {
      ...pl(r) ? xx : wx,
      preloadedFeatures: e,
      useRender: Tx(o),
      createVisualElement: t,
      Component: r
    };
    return ix(s);
  };
}
const Us = { current: null }, ep = { current: !1 };
function Ix() {
  if (ep.current = !0, !!hl)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => Us.current = e.matches;
      e.addListener(t), t();
    } else
      Us.current = !1;
}
function _x(e, t, n) {
  for (const r in t) {
    const o = t[r], i = n[r];
    if (je(o))
      e.addValue(r, o), process.env.NODE_ENV === "development" && ai(o.version === "11.11.9", `Attempting to mix Framer Motion versions ${o.version} with 11.11.9 may not work as expected.`);
    else if (je(i))
      e.addValue(r, Nr(o, { owner: e }));
    else if (i !== o)
      if (e.hasValue(r)) {
        const s = e.getValue(r);
        s.liveStyle === !0 ? s.jump(o) : s.hasAnimated || s.set(o);
      } else {
        const s = e.getStaticValue(r);
        e.addValue(r, Nr(s !== void 0 ? s : o, { owner: e }));
      }
  }
  for (const r in n)
    t[r] === void 0 && e.removeValue(r);
  return t;
}
const j1 = /* @__PURE__ */ new WeakMap(), Lx = [...W5, De, Jt], Nx = (e) => Lx.find(K5(e)), V1 = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class Dx {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n, r) {
    return {};
  }
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: o, blockInitialAnimation: i, visualState: s }, a = {}) {
    this.applyWillChange = !1, this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = qa, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const f = At.now();
      this.renderScheduledAt < f && (this.renderScheduledAt = f, ve.render(this.render, !1, !0));
    };
    const { latestValues: l, renderState: c } = s;
    this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = n.initial ? { ...l } : {}, this.renderState = c, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = o, this.options = a, this.blockInitialAnimation = !!i, this.isControllingVariants = pi(n), this.isVariantNode = Uh(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: u, ...d } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const f in d) {
      const h = d[f];
      l[f] !== void 0 && je(h) && h.set(l[f], !1);
    }
  }
  mount(t) {
    this.current = t, j1.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), ep.current || Ix(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : Us.current, process.env.NODE_ENV !== "production" && ai(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    j1.delete(this.current), this.projection && this.projection.unmount(), Xt(this.notifyUpdate), Xt(this.render), this.valueSubscriptions.forEach((t) => t()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features) {
      const n = this.features[t];
      n && (n.unmount(), n.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(t, n) {
    this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)();
    const r = rn.has(t), o = n.on("change", (a) => {
      this.latestValues[t] = a, this.props.onUpdate && ve.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0);
    }), i = n.on("renderRequest", this.scheduleRender);
    let s;
    window.MotionCheckAppearSync && (s = window.MotionCheckAppearSync(this, t, n)), this.valueSubscriptions.set(t, () => {
      o(), i(), s && s(), n.owner && n.stop();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in qn) {
      const n = qn[t];
      if (!n)
        continue;
      const { isEnabled: r, Feature: o } = n;
      if (!this.features[t] && o && r(this.props) && (this.features[t] = new o(this)), this.features[t]) {
        const i = this.features[t];
        i.isMounted ? i.update() : (i.mount(), i.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : ke();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < V1.length; r++) {
      const o = V1[r];
      this.propEventSubscriptions[o] && (this.propEventSubscriptions[o](), delete this.propEventSubscriptions[o]);
      const i = "on" + o, s = t[i];
      s && (this.propEventSubscriptions[o] = this.on(o, s));
    }
    this.prevMotionValues = _x(this, this.scrapeMotionValuesFromProps(t, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    const r = this.values.get(t);
    n !== r && (r && this.removeValue(t), this.bindToMotionValue(t, n), this.values.set(t, n), this.latestValues[t] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = Nr(n === null ? void 0 : n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, n) {
    var r;
    let o = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : (r = this.getBaseTargetFromProps(this.props, t)) !== null && r !== void 0 ? r : this.readValueFromInstance(this.current, t, this.options);
    return o != null && (typeof o == "string" && (B5(o) || F5(o)) ? o = parseFloat(o) : !Nx(o) && Jt.test(n) && (o = J5(t, n)), this.setBaseTarget(t, je(o) ? o.get() : o)), je(o) ? o.get() : o;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var n;
    const { initial: r } = this.props;
    let o;
    if (typeof r == "string" || typeof r == "object") {
      const s = Ua(this.props, r, (n = this.presenceContext) === null || n === void 0 ? void 0 : n.custom);
      s && (o = s[t]);
    }
    if (r && o !== void 0)
      return o;
    const i = this.getBaseTargetFromProps(this.props, t);
    return i !== void 0 && !je(i) ? i : this.initialValues[t] !== void 0 && o === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new cl()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
}
class tp extends Dx {
  constructor() {
    super(...arguments), this.KeyframeResolver = eh;
  }
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    return t.style ? t.style[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
}
function Ox(e) {
  return window.getComputedStyle(e);
}
class jx extends tp {
  constructor() {
    super(...arguments), this.type = "html", this.applyWillChange = !0, this.renderInstance = Kh;
  }
  readValueFromInstance(t, n) {
    if (rn.has(n)) {
      const r = el(n);
      return r && r.default || 0;
    } else {
      const r = Ox(t), o = (z5(n) ? r.getPropertyValue(n) : r[n]) || 0;
      return typeof o == "string" ? o.trim() : o;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return Rh(t, n);
  }
  build(t, n, r) {
    Cl(t, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return ml(t, n, r);
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    je(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
class Vx extends tp {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = ke;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (rn.has(n)) {
      const r = el(n);
      return r && r.default || 0;
    }
    return n = Wh.has(n) ? n : ui(n), t.getAttribute(n);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return Gh(t, n, r);
  }
  build(t, n, r) {
    yl(t, n, this.isSVGTag, r.transformTemplate);
  }
  renderInstance(t, n, r, o) {
    Zh(t, n, r, o);
  }
  mount(t) {
    this.isSVGTag = xl(t.tagName), super.mount(t);
  }
}
const Fx = (e, t) => pl(e) ? new Vx(t) : new jx(t, {
  allowProjection: e !== Lu
}), Bx = /* @__PURE__ */ Mx({
  ...PC,
  ...qy,
  ...Fy,
  ...Xy
}, Fx), vn = /* @__PURE__ */ x8(Bx);
class Hx extends g.Component {
  getSnapshotBeforeUpdate(t) {
    const n = this.props.childRef.current;
    if (n && t.isPresent && !this.props.isPresent) {
      const r = this.props.sizeRef.current;
      r.height = n.offsetHeight || 0, r.width = n.offsetWidth || 0, r.top = n.offsetTop, r.left = n.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function zx({ children: e, isPresent: t }) {
  const n = ea(), r = Kt(null), o = Kt({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  }), { nonce: i } = Oe(fl);
  return _u(() => {
    const { width: s, height: a, top: l, left: c } = o.current;
    if (t || !r.current || !s || !a)
      return;
    r.current.dataset.motionPopId = n;
    const u = document.createElement("style");
    return i && (u.nonce = i), document.head.appendChild(u), u.sheet && u.sheet.insertRule(`
          [data-motion-pop-id="${n}"] {
            position: absolute !important;
            width: ${s}px !important;
            height: ${a}px !important;
            top: ${l}px !important;
            left: ${c}px !important;
          }
        `), () => {
      document.head.removeChild(u);
    };
  }, [t]), p.jsx(Hx, { isPresent: t, childRef: r, sizeRef: o, children: g.cloneElement(e, { ref: r }) });
}
const Ux = ({ children: e, initial: t, isPresent: n, onExitComplete: r, custom: o, presenceAffectsLayout: i, mode: s }) => {
  const a = gl(Kx), l = ea(), c = ta((d) => {
    a.set(d, !0);
    for (const f of a.values())
      if (!f)
        return;
    r && r();
  }, [a, r]), u = Wt(
    () => ({
      id: l,
      initial: t,
      isPresent: n,
      custom: o,
      onExitComplete: c,
      register: (d) => (a.set(d, !1), () => a.delete(d))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    i ? [Math.random(), c] : [n, c]
  );
  return Wt(() => {
    a.forEach((d, f) => a.set(f, !1));
  }, [n]), g.useEffect(() => {
    !n && !a.size && r && r();
  }, [n]), s === "popLayout" && (e = p.jsx(zx, { isPresent: n, children: e })), p.jsx(fi.Provider, { value: u, children: e });
};
function Kx() {
  return /* @__PURE__ */ new Map();
}
const lo = (e) => e.key || "";
function F1(e) {
  const t = [];
  return Xp.forEach(e, (n) => {
    Yp(n) && t.push(n);
  }), t;
}
const np = ({ children: e, exitBeforeEnter: t, custom: n, initial: r = !0, onExitComplete: o, presenceAffectsLayout: i = !0, mode: s = "sync" }) => {
  Dt(!t, "Replace exitBeforeEnter with mode='wait'");
  const a = Wt(() => F1(e), [e]), l = a.map(lo), c = Kt(!0), u = Kt(a), d = gl(() => /* @__PURE__ */ new Map()), [f, h] = Sr(a), [v, m] = Sr(a);
  Bh(() => {
    c.current = !1, u.current = a;
    for (let x = 0; x < v.length; x++) {
      const w = lo(v[x]);
      l.includes(w) ? d.delete(w) : d.get(w) !== !0 && d.set(w, !1);
    }
  }, [v, l.length, l.join("-")]);
  const y = [];
  if (a !== f) {
    let x = [...a];
    for (let w = 0; w < v.length; w++) {
      const S = v[w], R = lo(S);
      l.includes(R) || (x.splice(w, 0, S), y.push(S));
    }
    s === "wait" && y.length && (x = y), m(F1(x)), h(a);
    return;
  }
  process.env.NODE_ENV !== "production" && s === "wait" && v.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
  const { forceRender: C } = Oe(ul);
  return p.jsx(p.Fragment, { children: v.map((x) => {
    const w = lo(x), S = a === v || l.includes(w), R = () => {
      if (d.has(w))
        d.set(w, !0);
      else
        return;
      let k = !0;
      d.forEach((P) => {
        P || (k = !1);
      }), k && (C == null || C(), m(u.current), o && o());
    };
    return p.jsx(Ux, { isPresent: S, initial: !c.current || r ? void 0 : !1, custom: S ? void 0 : n, presenceAffectsLayout: i, mode: s, onExitComplete: S ? void 0 : R, children: x }, w);
  }) });
}, Wx = ({
  isVisible: e = !0
}) => /* @__PURE__ */ p.jsx(np, { children: e && /* @__PURE__ */ p.jsx(
  vn.div,
  {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.5 },
    className: "flex items-center space-x-2",
    children: /* @__PURE__ */ p.jsxs("div", { className: "flex items-center text-gray-900 text-base font-normal font-sans gap-2", children: [
      /* @__PURE__ */ p.jsx(
        vn.div,
        {
          animate: {
            rotate: [0, 540, 0, 540]
          },
          transition: {
            duration: 7,
            ease: "anticipate",
            repeat: 1 / 0,
            repeatType: "mirror"
          },
          children: /* @__PURE__ */ p.jsx(he, { icon: "icon-status" })
        }
      ),
      /* @__PURE__ */ p.jsx("span", { children: "Surfacing relevant information..." })
    ] })
  }
) }), rk = ({
  domain: e,
  query: t,
  onQuerySuggestionClick: n
}) => /* @__PURE__ */ p.jsxs(
  "button",
  {
    onClick: () => n(t),
    className: "px-4 py-2 mt-2 bg-white rounded-xl border border-solid border-border gap-4 grid w-full grid-cols-two-columns text-left hover:bg-gray-50 transition-colors duration-200 ease-in-out",
    children: [
      /* @__PURE__ */ p.jsxs("div", { children: [
        e && /* @__PURE__ */ p.jsx("div", { className: "text-sm font-normal font-sans leading-normal", children: e }),
        /* @__PURE__ */ p.jsx("div", { className: "text-gray-900 text-base font-normal font-sans", children: t })
      ] }),
      /* @__PURE__ */ p.jsx(
        he,
        {
          className: "w-5 h-5 relative cursor-pointer self-end",
          icon: "chevron-right"
        }
      )
    ]
  }
);
var Zx = /* @__PURE__ */ ((e) => (e.system = "system", e.default = "default", e))(Zx || {});
const ok = ({
  title: e,
  children: t,
  variant: n,
  isLoading: r = !1
}) => {
  const o = {
    answerCard: "answer-card bg-white",
    systemCard: "bg-gradient-to-br from-gray-50 to-white",
    base: "rounded-xl border-2 border-solid border-white py-6 m-4",
    loading: "relative overflow-hidden",
    shimmer: "absolute inset-0 bg-gradient-to-r from-blue-100 opacity-50 via-gray-50 to-blue-200 animate-shimmer",
    content: "relative z-10"
  };
  return /* @__PURE__ */ p.jsxs(
    Ku,
    {
      className: `${o.base} 
        ${n === "system" ? o.systemCard : o.answerCard}
        ${r ? o.loading : ""}
      `,
      children: [
        r && /* @__PURE__ */ p.jsx("div", { className: o.shimmer }),
        /* @__PURE__ */ p.jsxs(
          Wu,
          {
            className: `flex flex-col gap-2 last:-mb-2 px-6 ${o.content}`,
            children: [
              /* @__PURE__ */ p.jsx("p", { className: "text-gray-900 text-md font-medium", children: e }),
              t
            ]
          }
        )
      ]
    }
  );
};
function Qx(e, t) {
  const n = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const Gx = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, $x = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, qx = {};
function B1(e, t) {
  return (qx.jsx ? $x : Gx).test(e);
}
const Xx = /[ \t\n\f\r]/g;
function Yx(e) {
  return typeof e == "object" ? e.type === "text" ? H1(e.value) : !1 : H1(e);
}
function H1(e) {
  return e.replace(Xx, "") === "";
}
class Gr {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(t, n, r) {
    this.property = t, this.normal = n, r && (this.space = r);
  }
}
Gr.prototype.property = {};
Gr.prototype.normal = {};
Gr.prototype.space = null;
function rp(e, t) {
  const n = {}, r = {};
  let o = -1;
  for (; ++o < e.length; )
    Object.assign(n, e[o].property), Object.assign(r, e[o].normal);
  return new Gr(n, r, t);
}
function Ks(e) {
  return e.toLowerCase();
}
class ut {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(t, n) {
    this.property = t, this.attribute = n;
  }
}
ut.prototype.space = null;
ut.prototype.boolean = !1;
ut.prototype.booleanish = !1;
ut.prototype.overloadedBoolean = !1;
ut.prototype.number = !1;
ut.prototype.commaSeparated = !1;
ut.prototype.spaceSeparated = !1;
ut.prototype.commaOrSpaceSeparated = !1;
ut.prototype.mustUseProperty = !1;
ut.prototype.defined = !1;
let Jx = 0;
const ne = kn(), Pe = kn(), op = kn(), D = kn(), we = kn(), Un = kn(), Xe = kn();
function kn() {
  return 2 ** ++Jx;
}
const Ws = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: ne,
  booleanish: Pe,
  commaOrSpaceSeparated: Xe,
  commaSeparated: Un,
  number: D,
  overloadedBoolean: op,
  spaceSeparated: we
}, Symbol.toStringTag, { value: "Module" })), Xi = Object.keys(Ws);
class wl extends ut {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(t, n, r, o) {
    let i = -1;
    if (super(t, n), z1(this, "space", o), typeof r == "number")
      for (; ++i < Xi.length; ) {
        const s = Xi[i];
        z1(this, Xi[i], (r & Ws[s]) === Ws[s]);
      }
  }
}
wl.prototype.defined = !0;
function z1(e, t, n) {
  n && (e[t] = n);
}
const ew = {}.hasOwnProperty;
function sr(e) {
  const t = {}, n = {};
  let r;
  for (r in e.properties)
    if (ew.call(e.properties, r)) {
      const o = e.properties[r], i = new wl(
        r,
        e.transform(e.attributes || {}, r),
        o,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(r) && (i.mustUseProperty = !0), t[r] = i, n[Ks(r)] = r, n[Ks(i.attribute)] = r;
    }
  return new Gr(t, n, e.space);
}
const ip = sr({
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), sp = sr({
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function ap(e, t) {
  return t in e ? e[t] : t;
}
function lp(e, t) {
  return ap(e, t.toLowerCase());
}
const cp = sr({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: lp,
  properties: { xmlns: null, xmlnsXLink: null }
}), up = sr({
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Pe,
    ariaAutoComplete: null,
    ariaBusy: Pe,
    ariaChecked: Pe,
    ariaColCount: D,
    ariaColIndex: D,
    ariaColSpan: D,
    ariaControls: we,
    ariaCurrent: null,
    ariaDescribedBy: we,
    ariaDetails: null,
    ariaDisabled: Pe,
    ariaDropEffect: we,
    ariaErrorMessage: null,
    ariaExpanded: Pe,
    ariaFlowTo: we,
    ariaGrabbed: Pe,
    ariaHasPopup: null,
    ariaHidden: Pe,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: we,
    ariaLevel: D,
    ariaLive: null,
    ariaModal: Pe,
    ariaMultiLine: Pe,
    ariaMultiSelectable: Pe,
    ariaOrientation: null,
    ariaOwns: we,
    ariaPlaceholder: null,
    ariaPosInSet: D,
    ariaPressed: Pe,
    ariaReadOnly: Pe,
    ariaRelevant: null,
    ariaRequired: Pe,
    ariaRoleDescription: we,
    ariaRowCount: D,
    ariaRowIndex: D,
    ariaRowSpan: D,
    ariaSelected: Pe,
    ariaSetSize: D,
    ariaSort: null,
    ariaValueMax: D,
    ariaValueMin: D,
    ariaValueNow: D,
    ariaValueText: null,
    role: null
  }
}), tw = sr({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: lp,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Un,
    acceptCharset: we,
    accessKey: we,
    action: null,
    allow: null,
    allowFullScreen: ne,
    allowPaymentRequest: ne,
    allowUserMedia: ne,
    alt: null,
    as: null,
    async: ne,
    autoCapitalize: null,
    autoComplete: we,
    autoFocus: ne,
    autoPlay: ne,
    blocking: we,
    capture: null,
    charSet: null,
    checked: ne,
    cite: null,
    className: we,
    cols: D,
    colSpan: null,
    content: null,
    contentEditable: Pe,
    controls: ne,
    controlsList: we,
    coords: D | Un,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: ne,
    defer: ne,
    dir: null,
    dirName: null,
    disabled: ne,
    download: op,
    draggable: Pe,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: ne,
    formTarget: null,
    headers: we,
    height: D,
    hidden: ne,
    high: D,
    href: null,
    hrefLang: null,
    htmlFor: we,
    httpEquiv: we,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: ne,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: ne,
    itemId: null,
    itemProp: we,
    itemRef: we,
    itemScope: ne,
    itemType: we,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: ne,
    low: D,
    manifest: null,
    max: null,
    maxLength: D,
    media: null,
    method: null,
    min: null,
    minLength: D,
    multiple: ne,
    muted: ne,
    name: null,
    nonce: null,
    noModule: ne,
    noValidate: ne,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: ne,
    optimum: D,
    pattern: null,
    ping: we,
    placeholder: null,
    playsInline: ne,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: ne,
    referrerPolicy: null,
    rel: we,
    required: ne,
    reversed: ne,
    rows: D,
    rowSpan: D,
    sandbox: we,
    scope: null,
    scoped: ne,
    seamless: ne,
    selected: ne,
    shadowRootClonable: ne,
    shadowRootDelegatesFocus: ne,
    shadowRootMode: null,
    shape: null,
    size: D,
    sizes: null,
    slot: null,
    span: D,
    spellCheck: Pe,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: D,
    step: null,
    style: null,
    tabIndex: D,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: ne,
    useMap: null,
    value: Pe,
    width: D,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: we,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: D,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: D,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: ne,
    // Lists. Use CSS to reduce space between items instead
    declare: ne,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: D,
    // `<img>` and `<object>`
    leftMargin: D,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: D,
    // `<body>`
    marginWidth: D,
    // `<body>`
    noResize: ne,
    // `<frame>`
    noHref: ne,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: ne,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: ne,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: D,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: Pe,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: D,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: D,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: ne,
    disableRemotePlayback: ne,
    prefix: null,
    property: null,
    results: D,
    security: null,
    unselectable: null
  }
}), nw = sr({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: ap,
  properties: {
    about: Xe,
    accentHeight: D,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: D,
    amplitude: D,
    arabicForm: null,
    ascent: D,
    attributeName: null,
    attributeType: null,
    azimuth: D,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: D,
    by: null,
    calcMode: null,
    capHeight: D,
    className: we,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: D,
    diffuseConstant: D,
    direction: null,
    display: null,
    dur: null,
    divisor: D,
    dominantBaseline: null,
    download: ne,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: D,
    enableBackground: null,
    end: null,
    event: null,
    exponent: D,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: D,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Un,
    g2: Un,
    glyphName: Un,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: D,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: D,
    horizOriginX: D,
    horizOriginY: D,
    id: null,
    ideographic: D,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: D,
    k: D,
    k1: D,
    k2: D,
    k3: D,
    k4: D,
    kernelMatrix: Xe,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: D,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: D,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: D,
    overlineThickness: D,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: D,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: we,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: D,
    pointsAtY: D,
    pointsAtZ: D,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Xe,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Xe,
    rev: Xe,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Xe,
    requiredFeatures: Xe,
    requiredFonts: Xe,
    requiredFormats: Xe,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: D,
    specularExponent: D,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: D,
    strikethroughThickness: D,
    string: null,
    stroke: null,
    strokeDashArray: Xe,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: D,
    strokeOpacity: D,
    strokeWidth: null,
    style: null,
    surfaceScale: D,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Xe,
    tabIndex: D,
    tableValues: null,
    target: null,
    targetX: D,
    targetY: D,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Xe,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: D,
    underlineThickness: D,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: D,
    values: null,
    vAlphabetic: D,
    vMathematical: D,
    vectorEffect: null,
    vHanging: D,
    vIdeographic: D,
    version: null,
    vertAdvY: D,
    vertOriginX: D,
    vertOriginY: D,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: D,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), rw = /^data[-\w.:]+$/i, U1 = /-[a-z]/g, ow = /[A-Z]/g;
function iw(e, t) {
  const n = Ks(t);
  let r = t, o = ut;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && rw.test(t)) {
    if (t.charAt(4) === "-") {
      const i = t.slice(5).replace(U1, aw);
      r = "data" + i.charAt(0).toUpperCase() + i.slice(1);
    } else {
      const i = t.slice(4);
      if (!U1.test(i)) {
        let s = i.replace(ow, sw);
        s.charAt(0) !== "-" && (s = "-" + s), t = "data" + s;
      }
    }
    o = wl;
  }
  return new o(r, t);
}
function sw(e) {
  return "-" + e.toLowerCase();
}
function aw(e) {
  return e.charAt(1).toUpperCase();
}
const lw = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, cw = rp([sp, ip, cp, up, tw], "html"), bl = rp([sp, ip, cp, up, nw], "svg");
function uw(e) {
  return e.join(" ").trim();
}
var dp = {}, K1 = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, dw = /\n/g, fw = /^\s*/, hw = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, pw = /^:\s*/, mw = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, gw = /^[;\s]*/, vw = /^\s+|\s+$/g, Cw = `
`, W1 = "/", Z1 = "*", mn = "", yw = "comment", xw = "declaration", ww = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e) return [];
  t = t || {};
  var n = 1, r = 1;
  function o(v) {
    var m = v.match(dw);
    m && (n += m.length);
    var y = v.lastIndexOf(Cw);
    r = ~y ? v.length - y : r + v.length;
  }
  function i() {
    var v = { line: n, column: r };
    return function(m) {
      return m.position = new s(v), c(), m;
    };
  }
  function s(v) {
    this.start = v, this.end = { line: n, column: r }, this.source = t.source;
  }
  s.prototype.content = e;
  function a(v) {
    var m = new Error(
      t.source + ":" + n + ":" + r + ": " + v
    );
    if (m.reason = v, m.filename = t.source, m.line = n, m.column = r, m.source = e, !t.silent) throw m;
  }
  function l(v) {
    var m = v.exec(e);
    if (m) {
      var y = m[0];
      return o(y), e = e.slice(y.length), m;
    }
  }
  function c() {
    l(fw);
  }
  function u(v) {
    var m;
    for (v = v || []; m = d(); )
      m !== !1 && v.push(m);
    return v;
  }
  function d() {
    var v = i();
    if (!(W1 != e.charAt(0) || Z1 != e.charAt(1))) {
      for (var m = 2; mn != e.charAt(m) && (Z1 != e.charAt(m) || W1 != e.charAt(m + 1)); )
        ++m;
      if (m += 2, mn === e.charAt(m - 1))
        return a("End of comment missing");
      var y = e.slice(2, m - 2);
      return r += 2, o(y), e = e.slice(m), r += 2, v({
        type: yw,
        comment: y
      });
    }
  }
  function f() {
    var v = i(), m = l(hw);
    if (m) {
      if (d(), !l(pw)) return a("property missing ':'");
      var y = l(mw), C = v({
        type: xw,
        property: Q1(m[0].replace(K1, mn)),
        value: y ? Q1(y[0].replace(K1, mn)) : mn
      });
      return l(gw), C;
    }
  }
  function h() {
    var v = [];
    u(v);
    for (var m; m = f(); )
      m !== !1 && (v.push(m), u(v));
    return v;
  }
  return c(), h();
};
function Q1(e) {
  return e ? e.replace(vw, mn) : mn;
}
var bw = zl && zl.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(dp, "__esModule", { value: !0 });
var G1 = dp.default = Ew, Aw = bw(ww);
function Ew(e, t) {
  var n = null;
  if (!e || typeof e != "string")
    return n;
  var r = (0, Aw.default)(e), o = typeof t == "function";
  return r.forEach(function(i) {
    if (i.type === "declaration") {
      var s = i.property, a = i.value;
      o ? t(s, a, i) : a && (n = n || {}, n[s] = a);
    }
  }), n;
}
const Sw = G1.default || G1, fp = hp("end"), Al = hp("start");
function hp(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function kw(e) {
  const t = Al(e), n = fp(e);
  if (t && n)
    return { start: t, end: n };
}
function Ar(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? $1(e.position) : "start" in e || "end" in e ? $1(e) : "line" in e || "column" in e ? Zs(e) : "";
}
function Zs(e) {
  return q1(e && e.line) + ":" + q1(e && e.column);
}
function $1(e) {
  return Zs(e && e.start) + "-" + Zs(e && e.end);
}
function q1(e) {
  return e && typeof e == "number" ? e : 1;
}
class Fe extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, r) {
    super(), typeof n == "string" && (r = n, n = void 0);
    let o = "", i = {}, s = !1;
    if (n && ("line" in n && "column" in n ? i = { place: n } : "start" in n && "end" in n ? i = { place: n } : "type" in n ? i = {
      ancestors: [n],
      place: n.position
    } : i = { ...n }), typeof t == "string" ? o = t : !i.cause && t && (s = !0, o = t.message, i.cause = t), !i.ruleId && !i.source && typeof r == "string") {
      const l = r.indexOf(":");
      l === -1 ? i.ruleId = r : (i.source = r.slice(0, l), i.ruleId = r.slice(l + 1));
    }
    if (!i.place && i.ancestors && i.ancestors) {
      const l = i.ancestors[i.ancestors.length - 1];
      l && (i.place = l.position);
    }
    const a = i.place && "start" in i.place ? i.place.start : i.place;
    this.ancestors = i.ancestors || void 0, this.cause = i.cause || void 0, this.column = a ? a.column : void 0, this.fatal = void 0, this.file, this.message = o, this.line = a ? a.line : void 0, this.name = Ar(i.place) || "1:1", this.place = i.place || void 0, this.reason = this.message, this.ruleId = i.ruleId || void 0, this.source = i.source || void 0, this.stack = s && i.cause && typeof i.cause.stack == "string" ? i.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Fe.prototype.file = "";
Fe.prototype.name = "";
Fe.prototype.reason = "";
Fe.prototype.message = "";
Fe.prototype.stack = "";
Fe.prototype.column = void 0;
Fe.prototype.line = void 0;
Fe.prototype.ancestors = void 0;
Fe.prototype.cause = void 0;
Fe.prototype.fatal = void 0;
Fe.prototype.place = void 0;
Fe.prototype.ruleId = void 0;
Fe.prototype.source = void 0;
const El = {}.hasOwnProperty, Rw = /* @__PURE__ */ new Map(), Pw = /[A-Z]/g, Tw = /-([a-z])/g, Mw = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), Iw = /* @__PURE__ */ new Set(["td", "th"]), pp = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function _w(e, t) {
  if (!t || t.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const n = t.filePath || void 0;
  let r;
  if (t.development) {
    if (typeof t.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    r = Bw(n, t.jsxDEV);
  } else {
    if (typeof t.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof t.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    r = Fw(n, t.jsx, t.jsxs);
  }
  const o = {
    Fragment: t.Fragment,
    ancestors: [],
    components: t.components || {},
    create: r,
    elementAttributeNameCase: t.elementAttributeNameCase || "react",
    evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
    filePath: n,
    ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
    passKeys: t.passKeys !== !1,
    passNode: t.passNode || !1,
    schema: t.space === "svg" ? bl : cw,
    stylePropertyNameCase: t.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
  }, i = mp(o, e, void 0);
  return i && typeof i != "string" ? i : o.create(
    e,
    o.Fragment,
    { children: i || void 0 },
    void 0
  );
}
function mp(e, t, n) {
  if (t.type === "element")
    return Lw(e, t, n);
  if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression")
    return Nw(e, t);
  if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement")
    return Ow(e, t, n);
  if (t.type === "mdxjsEsm")
    return Dw(e, t);
  if (t.type === "root")
    return jw(e, t, n);
  if (t.type === "text")
    return Vw(e, t);
}
function Lw(e, t, n) {
  const r = e.schema;
  let o = r;
  t.tagName.toLowerCase() === "svg" && r.space === "html" && (o = bl, e.schema = o), e.ancestors.push(t);
  const i = vp(e, t.tagName, !1), s = Hw(e, t);
  let a = kl(e, t);
  return Mw.has(t.tagName) && (a = a.filter(function(l) {
    return typeof l == "string" ? !Yx(l) : !0;
  })), gp(e, s, i, t), Sl(s, a), e.ancestors.pop(), e.schema = r, e.create(t, i, s, n);
}
function Nw(e, t) {
  if (t.data && t.data.estree && e.evaluater) {
    const r = t.data.estree.body[0];
    return r.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(r.expression);
  }
  Dr(e, t.position);
}
function Dw(e, t) {
  if (t.data && t.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(t.data.estree)
    );
  Dr(e, t.position);
}
function Ow(e, t, n) {
  const r = e.schema;
  let o = r;
  t.name === "svg" && r.space === "html" && (o = bl, e.schema = o), e.ancestors.push(t);
  const i = t.name === null ? e.Fragment : vp(e, t.name, !0), s = zw(e, t), a = kl(e, t);
  return gp(e, s, i, t), Sl(s, a), e.ancestors.pop(), e.schema = r, e.create(t, i, s, n);
}
function jw(e, t, n) {
  const r = {};
  return Sl(r, kl(e, t)), e.create(t, e.Fragment, r, n);
}
function Vw(e, t) {
  return t.value;
}
function gp(e, t, n, r) {
  typeof n != "string" && n !== e.Fragment && e.passNode && (t.node = r);
}
function Sl(e, t) {
  if (t.length > 0) {
    const n = t.length > 1 ? t : t[0];
    n && (e.children = n);
  }
}
function Fw(e, t, n) {
  return r;
  function r(o, i, s, a) {
    const c = Array.isArray(s.children) ? n : t;
    return a ? c(i, s, a) : c(i, s);
  }
}
function Bw(e, t) {
  return n;
  function n(r, o, i, s) {
    const a = Array.isArray(i.children), l = Al(r);
    return t(
      o,
      i,
      s,
      a,
      {
        columnNumber: l ? l.column - 1 : void 0,
        fileName: e,
        lineNumber: l ? l.line : void 0
      },
      void 0
    );
  }
}
function Hw(e, t) {
  const n = {};
  let r, o;
  for (o in t.properties)
    if (o !== "children" && El.call(t.properties, o)) {
      const i = Uw(e, o, t.properties[o]);
      if (i) {
        const [s, a] = i;
        e.tableCellAlignToStyle && s === "align" && typeof a == "string" && Iw.has(t.tagName) ? r = a : n[s] = a;
      }
    }
  if (r) {
    const i = (
      /** @type {Style} */
      n.style || (n.style = {})
    );
    i[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return n;
}
function zw(e, t) {
  const n = {};
  for (const r of t.attributes)
    if (r.type === "mdxJsxExpressionAttribute")
      if (r.data && r.data.estree && e.evaluater) {
        const i = r.data.estree.body[0];
        i.type;
        const s = i.expression;
        s.type;
        const a = s.properties[0];
        a.type, Object.assign(
          n,
          e.evaluater.evaluateExpression(a.argument)
        );
      } else
        Dr(e, t.position);
    else {
      const o = r.name;
      let i;
      if (r.value && typeof r.value == "object")
        if (r.value.data && r.value.data.estree && e.evaluater) {
          const a = r.value.data.estree.body[0];
          a.type, i = e.evaluater.evaluateExpression(a.expression);
        } else
          Dr(e, t.position);
      else
        i = r.value === null ? !0 : r.value;
      n[o] = /** @type {Props[keyof Props]} */
      i;
    }
  return n;
}
function kl(e, t) {
  const n = [];
  let r = -1;
  const o = e.passKeys ? /* @__PURE__ */ new Map() : Rw;
  for (; ++r < t.children.length; ) {
    const i = t.children[r];
    let s;
    if (e.passKeys) {
      const l = i.type === "element" ? i.tagName : i.type === "mdxJsxFlowElement" || i.type === "mdxJsxTextElement" ? i.name : void 0;
      if (l) {
        const c = o.get(l) || 0;
        s = l + "-" + c, o.set(l, c + 1);
      }
    }
    const a = mp(e, i, s);
    a !== void 0 && n.push(a);
  }
  return n;
}
function Uw(e, t, n) {
  const r = iw(e.schema, t);
  if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
    if (Array.isArray(n) && (n = r.commaSeparated ? Qx(n) : uw(n)), r.property === "style") {
      let o = typeof n == "object" ? n : Kw(e, String(n));
      return e.stylePropertyNameCase === "css" && (o = Ww(o)), ["style", o];
    }
    return [
      e.elementAttributeNameCase === "react" && r.space ? lw[r.property] || r.property : r.attribute,
      n
    ];
  }
}
function Kw(e, t) {
  const n = {};
  try {
    Sw(t, r);
  } catch (o) {
    if (!e.ignoreInvalidStyle) {
      const i = (
        /** @type {Error} */
        o
      ), s = new Fe("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: i,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = pp + "#cannot-parse-style-attribute", s;
    }
  }
  return n;
  function r(o, i) {
    let s = o;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(Tw, Qw)), n[s] = i;
  }
}
function vp(e, t, n) {
  let r;
  if (!n)
    r = { type: "Literal", value: t };
  else if (t.includes(".")) {
    const o = t.split(".");
    let i = -1, s;
    for (; ++i < o.length; ) {
      const a = B1(o[i]) ? { type: "Identifier", name: o[i] } : { type: "Literal", value: o[i] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: a,
        computed: !!(i && a.type === "Literal"),
        optional: !1
      } : a;
    }
    r = s;
  } else
    r = B1(t) && !/^[a-z]/.test(t) ? { type: "Identifier", name: t } : { type: "Literal", value: t };
  if (r.type === "Literal") {
    const o = (
      /** @type {keyof JSX.IntrinsicElements} */
      r.value
    );
    return El.call(e.components, o) ? e.components[o] : o;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(r);
  Dr(e);
}
function Dr(e, t) {
  const n = new Fe(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: t,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw n.file = e.filePath || void 0, n.url = pp + "#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function Ww(e) {
  const t = {};
  let n;
  for (n in e)
    El.call(e, n) && (t[Zw(n)] = e[n]);
  return t;
}
function Zw(e) {
  let t = e.replace(Pw, Gw);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function Qw(e, t) {
  return t.toUpperCase();
}
function Gw(e) {
  return "-" + e.toLowerCase();
}
const Yi = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, $w = {};
function qw(e, t) {
  const n = $w, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, o = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return Cp(e, r, o);
}
function Cp(e, t, n) {
  if (Xw(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return X1(e.children, t, n);
  }
  return Array.isArray(e) ? X1(e, t, n) : "";
}
function X1(e, t, n) {
  const r = [];
  let o = -1;
  for (; ++o < e.length; )
    r[o] = Cp(e[o], t, n);
  return r.join("");
}
function Xw(e) {
  return !!(e && typeof e == "object");
}
const Y1 = document.createElement("i");
function Rl(e) {
  const t = "&" + e + ";";
  Y1.innerHTML = t;
  const n = Y1.textContent;
  return n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n;
}
function Ot(e, t, n, r) {
  const o = e.length;
  let i = 0, s;
  if (t < 0 ? t = -t > o ? 0 : o + t : t = t > o ? o : t, n = n > 0 ? n : 0, r.length < 1e4)
    s = Array.from(r), s.unshift(t, n), e.splice(...s);
  else
    for (n && e.splice(t, n); i < r.length; )
      s = r.slice(i, i + 1e4), s.unshift(t, 0), e.splice(...s), i += 1e4, t += 1e4;
}
function at(e, t) {
  return e.length > 0 ? (Ot(e, e.length, 0, t), e) : t;
}
const J1 = {}.hasOwnProperty;
function Yw(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    Jw(t, e[n]);
  return t;
}
function Jw(e, t) {
  let n;
  for (n in t) {
    const o = (J1.call(e, n) ? e[n] : void 0) || (e[n] = {}), i = t[n];
    let s;
    if (i)
      for (s in i) {
        J1.call(o, s) || (o[s] = []);
        const a = i[s];
        eb(
          // @ts-expect-error Looks like a list.
          o[s],
          Array.isArray(a) ? a : a ? [a] : []
        );
      }
  }
}
function eb(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  Ot(e, 0, 0, r);
}
function yp(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || /* eslint-disable no-bitwise */
    (n & 65535) === 65535 || (n & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    n > 1114111 ? "�" : String.fromCodePoint(n)
  );
}
function Kn(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const xt = sn(/[A-Za-z]/), et = sn(/[\dA-Za-z]/), tb = sn(/[#-'*+\--9=?A-Z^-~]/);
function Qs(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const Gs = sn(/\d/), nb = sn(/[\dA-Fa-f]/), rb = sn(/[!-/:-@[-`{-~]/);
function q(e) {
  return e !== null && e < -2;
}
function Ge(e) {
  return e !== null && (e < 0 || e === 32);
}
function pe(e) {
  return e === -2 || e === -1 || e === 32;
}
const ob = sn(new RegExp("\\p{P}|\\p{S}", "u")), ib = sn(/\s/);
function sn(e) {
  return t;
  function t(n) {
    return n !== null && n > -1 && e.test(String.fromCharCode(n));
  }
}
function ar(e) {
  const t = [];
  let n = -1, r = 0, o = 0;
  for (; ++n < e.length; ) {
    const i = e.charCodeAt(n);
    let s = "";
    if (i === 37 && et(e.charCodeAt(n + 1)) && et(e.charCodeAt(n + 2)))
      o = 2;
    else if (i < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(i)) || (s = String.fromCharCode(i));
    else if (i > 55295 && i < 57344) {
      const a = e.charCodeAt(n + 1);
      i < 56320 && a > 56319 && a < 57344 ? (s = String.fromCharCode(i, a), o = 1) : s = "�";
    } else
      s = String.fromCharCode(i);
    s && (t.push(e.slice(r, n), encodeURIComponent(s)), r = n + o + 1, s = ""), o && (n += o, o = 0);
  }
  return t.join("") + e.slice(r);
}
function be(e, t, n, r) {
  const o = r ? r - 1 : Number.POSITIVE_INFINITY;
  let i = 0;
  return s;
  function s(l) {
    return pe(l) ? (e.enter(n), a(l)) : t(l);
  }
  function a(l) {
    return pe(l) && i++ < o ? (e.consume(l), a) : (e.exit(n), t(l));
  }
}
const sb = {
  tokenize: ab
};
function ab(e) {
  const t = e.attempt(
    this.parser.constructs.contentInitial,
    r,
    o
  );
  let n;
  return t;
  function r(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), be(e, t, "linePrefix");
  }
  function o(a) {
    return e.enter("paragraph"), i(a);
  }
  function i(a) {
    const l = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = l), n = l, s(a);
  }
  function s(a) {
    if (a === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(a);
      return;
    }
    return q(a) ? (e.consume(a), e.exit("chunkText"), i) : (e.consume(a), s);
  }
}
const lb = {
  tokenize: cb
}, eu = {
  tokenize: ub
};
function cb(e) {
  const t = this, n = [];
  let r = 0, o, i, s;
  return a;
  function a(w) {
    if (r < n.length) {
      const S = n[r];
      return t.containerState = S[1], e.attempt(
        S[0].continuation,
        l,
        c
      )(w);
    }
    return c(w);
  }
  function l(w) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, o && x();
      const S = t.events.length;
      let R = S, k;
      for (; R--; )
        if (t.events[R][0] === "exit" && t.events[R][1].type === "chunkFlow") {
          k = t.events[R][1].end;
          break;
        }
      C(r);
      let P = S;
      for (; P < t.events.length; )
        t.events[P][1].end = Object.assign({}, k), P++;
      return Ot(
        t.events,
        R + 1,
        0,
        t.events.slice(S)
      ), t.events.length = P, c(w);
    }
    return a(w);
  }
  function c(w) {
    if (r === n.length) {
      if (!o)
        return f(w);
      if (o.currentConstruct && o.currentConstruct.concrete)
        return v(w);
      t.interrupt = !!(o.currentConstruct && !o._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(
      eu,
      u,
      d
    )(w);
  }
  function u(w) {
    return o && x(), C(r), f(w);
  }
  function d(w) {
    return t.parser.lazy[t.now().line] = r !== n.length, s = t.now().offset, v(w);
  }
  function f(w) {
    return t.containerState = {}, e.attempt(
      eu,
      h,
      v
    )(w);
  }
  function h(w) {
    return r++, n.push([t.currentConstruct, t.containerState]), f(w);
  }
  function v(w) {
    if (w === null) {
      o && x(), C(0), e.consume(w);
      return;
    }
    return o = o || t.parser.flow(t.now()), e.enter("chunkFlow", {
      contentType: "flow",
      previous: i,
      _tokenizer: o
    }), m(w);
  }
  function m(w) {
    if (w === null) {
      y(e.exit("chunkFlow"), !0), C(0), e.consume(w);
      return;
    }
    return q(w) ? (e.consume(w), y(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, a) : (e.consume(w), m);
  }
  function y(w, S) {
    const R = t.sliceStream(w);
    if (S && R.push(null), w.previous = i, i && (i.next = w), i = w, o.defineSkip(w.start), o.write(R), t.parser.lazy[w.start.line]) {
      let k = o.events.length;
      for (; k--; )
        if (
          // The token starts before the line ending…
          o.events[k][1].start.offset < s && // …and either is not ended yet…
          (!o.events[k][1].end || // …or ends after it.
          o.events[k][1].end.offset > s)
        )
          return;
      const P = t.events.length;
      let T = P, _, O;
      for (; T--; )
        if (t.events[T][0] === "exit" && t.events[T][1].type === "chunkFlow") {
          if (_) {
            O = t.events[T][1].end;
            break;
          }
          _ = !0;
        }
      for (C(r), k = P; k < t.events.length; )
        t.events[k][1].end = Object.assign({}, O), k++;
      Ot(
        t.events,
        T + 1,
        0,
        t.events.slice(P)
      ), t.events.length = k;
    }
  }
  function C(w) {
    let S = n.length;
    for (; S-- > w; ) {
      const R = n[S];
      t.containerState = R[1], R[0].exit.call(t, e);
    }
    n.length = w;
  }
  function x() {
    o.write([null]), i = void 0, o = void 0, t.containerState._closeFlow = void 0;
  }
}
function ub(e, t, n) {
  return be(
    e,
    e.attempt(this.parser.constructs.document, t, n),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function tu(e) {
  if (e === null || Ge(e) || ib(e))
    return 1;
  if (ob(e))
    return 2;
}
function Pl(e, t, n) {
  const r = [];
  let o = -1;
  for (; ++o < e.length; ) {
    const i = e[o].resolveAll;
    i && !r.includes(i) && (t = i(t, n), r.push(i));
  }
  return t;
}
const $s = {
  name: "attention",
  tokenize: fb,
  resolveAll: db
};
function db(e, t) {
  let n = -1, r, o, i, s, a, l, c, u;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          l = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const d = Object.assign({}, e[r][1].end), f = Object.assign({}, e[n][1].start);
          nu(d, -l), nu(f, l), s = {
            type: l > 1 ? "strongSequence" : "emphasisSequence",
            start: d,
            end: Object.assign({}, e[r][1].end)
          }, a = {
            type: l > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, e[n][1].start),
            end: f
          }, i = {
            type: l > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, e[r][1].end),
            end: Object.assign({}, e[n][1].start)
          }, o = {
            type: l > 1 ? "strong" : "emphasis",
            start: Object.assign({}, s.start),
            end: Object.assign({}, a.end)
          }, e[r][1].end = Object.assign({}, s.start), e[n][1].start = Object.assign({}, a.end), c = [], e[r][1].end.offset - e[r][1].start.offset && (c = at(c, [["enter", e[r][1], t], ["exit", e[r][1], t]])), c = at(c, [["enter", o, t], ["enter", s, t], ["exit", s, t], ["enter", i, t]]), c = at(c, Pl(t.parser.constructs.insideSpan.null, e.slice(r + 1, n), t)), c = at(c, [["exit", i, t], ["enter", a, t], ["exit", a, t], ["exit", o, t]]), e[n][1].end.offset - e[n][1].start.offset ? (u = 2, c = at(c, [["enter", e[n][1], t], ["exit", e[n][1], t]])) : u = 0, Ot(e, r - 1, n - r + 3, c), n = r + c.length - u - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function fb(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, o = tu(r);
  let i;
  return s;
  function s(l) {
    return i = l, e.enter("attentionSequence"), a(l);
  }
  function a(l) {
    if (l === i)
      return e.consume(l), a;
    const c = e.exit("attentionSequence"), u = tu(l), d = !u || u === 2 && o || n.includes(l), f = !o || o === 2 && u || n.includes(r);
    return c._open = !!(i === 42 ? d : d && (o || !f)), c._close = !!(i === 42 ? f : f && (u || !d)), t(l);
  }
}
function nu(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const hb = {
  name: "autolink",
  tokenize: pb
};
function pb(e, t, n) {
  let r = 0;
  return o;
  function o(h) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), i;
  }
  function i(h) {
    return xt(h) ? (e.consume(h), s) : h === 64 ? n(h) : c(h);
  }
  function s(h) {
    return h === 43 || h === 45 || h === 46 || et(h) ? (r = 1, a(h)) : c(h);
  }
  function a(h) {
    return h === 58 ? (e.consume(h), r = 0, l) : (h === 43 || h === 45 || h === 46 || et(h)) && r++ < 32 ? (e.consume(h), a) : (r = 0, c(h));
  }
  function l(h) {
    return h === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.exit("autolink"), t) : h === null || h === 32 || h === 60 || Qs(h) ? n(h) : (e.consume(h), l);
  }
  function c(h) {
    return h === 64 ? (e.consume(h), u) : tb(h) ? (e.consume(h), c) : n(h);
  }
  function u(h) {
    return et(h) ? d(h) : n(h);
  }
  function d(h) {
    return h === 46 ? (e.consume(h), r = 0, u) : h === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.exit("autolink"), t) : f(h);
  }
  function f(h) {
    if ((h === 45 || et(h)) && r++ < 63) {
      const v = h === 45 ? f : d;
      return e.consume(h), v;
    }
    return n(h);
  }
}
const mi = {
  tokenize: mb,
  partial: !0
};
function mb(e, t, n) {
  return r;
  function r(i) {
    return pe(i) ? be(e, o, "linePrefix")(i) : o(i);
  }
  function o(i) {
    return i === null || q(i) ? t(i) : n(i);
  }
}
const xp = {
  name: "blockQuote",
  tokenize: gb,
  continuation: {
    tokenize: vb
  },
  exit: Cb
};
function gb(e, t, n) {
  const r = this;
  return o;
  function o(s) {
    if (s === 62) {
      const a = r.containerState;
      return a.open || (e.enter("blockQuote", {
        _container: !0
      }), a.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), i;
    }
    return n(s);
  }
  function i(s) {
    return pe(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(s));
  }
}
function vb(e, t, n) {
  const r = this;
  return o;
  function o(s) {
    return pe(s) ? be(e, i, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : i(s);
  }
  function i(s) {
    return e.attempt(xp, t, n)(s);
  }
}
function Cb(e) {
  e.exit("blockQuote");
}
const wp = {
  name: "characterEscape",
  tokenize: yb
};
function yb(e, t, n) {
  return r;
  function r(i) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(i), e.exit("escapeMarker"), o;
  }
  function o(i) {
    return rb(i) ? (e.enter("characterEscapeValue"), e.consume(i), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(i);
  }
}
const bp = {
  name: "characterReference",
  tokenize: xb
};
function xb(e, t, n) {
  const r = this;
  let o = 0, i, s;
  return a;
  function a(d) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), l;
  }
  function l(d) {
    return d === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(d), e.exit("characterReferenceMarkerNumeric"), c) : (e.enter("characterReferenceValue"), i = 31, s = et, u(d));
  }
  function c(d) {
    return d === 88 || d === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(d), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), i = 6, s = nb, u) : (e.enter("characterReferenceValue"), i = 7, s = Gs, u(d));
  }
  function u(d) {
    if (d === 59 && o) {
      const f = e.exit("characterReferenceValue");
      return s === et && !Rl(r.sliceSerialize(f)) ? n(d) : (e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return s(d) && o++ < i ? (e.consume(d), u) : n(d);
  }
}
const ru = {
  tokenize: bb,
  partial: !0
}, ou = {
  name: "codeFenced",
  tokenize: wb,
  concrete: !0
};
function wb(e, t, n) {
  const r = this, o = {
    tokenize: R,
    partial: !0
  };
  let i = 0, s = 0, a;
  return l;
  function l(k) {
    return c(k);
  }
  function c(k) {
    const P = r.events[r.events.length - 1];
    return i = P && P[1].type === "linePrefix" ? P[2].sliceSerialize(P[1], !0).length : 0, a = k, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u(k);
  }
  function u(k) {
    return k === a ? (s++, e.consume(k), u) : s < 3 ? n(k) : (e.exit("codeFencedFenceSequence"), pe(k) ? be(e, d, "whitespace")(k) : d(k));
  }
  function d(k) {
    return k === null || q(k) ? (e.exit("codeFencedFence"), r.interrupt ? t(k) : e.check(ru, m, S)(k)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), f(k));
  }
  function f(k) {
    return k === null || q(k) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), d(k)) : pe(k) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), be(e, h, "whitespace")(k)) : k === 96 && k === a ? n(k) : (e.consume(k), f);
  }
  function h(k) {
    return k === null || q(k) ? d(k) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), v(k));
  }
  function v(k) {
    return k === null || q(k) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), d(k)) : k === 96 && k === a ? n(k) : (e.consume(k), v);
  }
  function m(k) {
    return e.attempt(o, S, y)(k);
  }
  function y(k) {
    return e.enter("lineEnding"), e.consume(k), e.exit("lineEnding"), C;
  }
  function C(k) {
    return i > 0 && pe(k) ? be(e, x, "linePrefix", i + 1)(k) : x(k);
  }
  function x(k) {
    return k === null || q(k) ? e.check(ru, m, S)(k) : (e.enter("codeFlowValue"), w(k));
  }
  function w(k) {
    return k === null || q(k) ? (e.exit("codeFlowValue"), x(k)) : (e.consume(k), w);
  }
  function S(k) {
    return e.exit("codeFenced"), t(k);
  }
  function R(k, P, T) {
    let _ = 0;
    return O;
    function O(W) {
      return k.enter("lineEnding"), k.consume(W), k.exit("lineEnding"), L;
    }
    function L(W) {
      return k.enter("codeFencedFence"), pe(W) ? be(k, I, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(W) : I(W);
    }
    function I(W) {
      return W === a ? (k.enter("codeFencedFenceSequence"), H(W)) : T(W);
    }
    function H(W) {
      return W === a ? (_++, k.consume(W), H) : _ >= s ? (k.exit("codeFencedFenceSequence"), pe(W) ? be(k, z, "whitespace")(W) : z(W)) : T(W);
    }
    function z(W) {
      return W === null || q(W) ? (k.exit("codeFencedFence"), P(W)) : T(W);
    }
  }
}
function bb(e, t, n) {
  const r = this;
  return o;
  function o(s) {
    return s === null ? n(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), i);
  }
  function i(s) {
    return r.parser.lazy[r.now().line] ? n(s) : t(s);
  }
}
const Ji = {
  name: "codeIndented",
  tokenize: Eb
}, Ab = {
  tokenize: Sb,
  partial: !0
};
function Eb(e, t, n) {
  const r = this;
  return o;
  function o(c) {
    return e.enter("codeIndented"), be(e, i, "linePrefix", 5)(c);
  }
  function i(c) {
    const u = r.events[r.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? s(c) : n(c);
  }
  function s(c) {
    return c === null ? l(c) : q(c) ? e.attempt(Ab, s, l)(c) : (e.enter("codeFlowValue"), a(c));
  }
  function a(c) {
    return c === null || q(c) ? (e.exit("codeFlowValue"), s(c)) : (e.consume(c), a);
  }
  function l(c) {
    return e.exit("codeIndented"), t(c);
  }
}
function Sb(e, t, n) {
  const r = this;
  return o;
  function o(s) {
    return r.parser.lazy[r.now().line] ? n(s) : q(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : be(e, i, "linePrefix", 5)(s);
  }
  function i(s) {
    const a = r.events[r.events.length - 1];
    return a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? t(s) : q(s) ? o(s) : n(s);
  }
}
const kb = {
  name: "codeText",
  tokenize: Tb,
  resolve: Rb,
  previous: Pb
};
function Rb(e) {
  let t = e.length - 4, n = 3, r, o;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    o === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (o = r) : (r === t || e[r][1].type === "lineEnding") && (e[o][1].type = "codeTextData", r !== o + 2 && (e[o][1].end = e[r - 1][1].end, e.splice(o + 2, r - o - 2), t -= r - o - 2, r = o + 2), o = void 0);
  return e;
}
function Pb(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function Tb(e, t, n) {
  let r = 0, o, i;
  return s;
  function s(d) {
    return e.enter("codeText"), e.enter("codeTextSequence"), a(d);
  }
  function a(d) {
    return d === 96 ? (e.consume(d), r++, a) : (e.exit("codeTextSequence"), l(d));
  }
  function l(d) {
    return d === null ? n(d) : d === 32 ? (e.enter("space"), e.consume(d), e.exit("space"), l) : d === 96 ? (i = e.enter("codeTextSequence"), o = 0, u(d)) : q(d) ? (e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), l) : (e.enter("codeTextData"), c(d));
  }
  function c(d) {
    return d === null || d === 32 || d === 96 || q(d) ? (e.exit("codeTextData"), l(d)) : (e.consume(d), c);
  }
  function u(d) {
    return d === 96 ? (e.consume(d), o++, u) : o === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(d)) : (i.type = "codeTextData", c(d));
  }
}
class Mb {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, n) {
    const r = n ?? Number.POSITIVE_INFINITY;
    return r < this.left.length ? this.left.slice(t, r) : t > this.left.length ? this.right.slice(this.right.length - r + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - r + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, n, r) {
    const o = n || 0;
    this.setCursor(Math.trunc(t));
    const i = this.right.splice(this.right.length - o, Number.POSITIVE_INFINITY);
    return r && pr(this.left, r), i.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), pr(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), pr(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const n = this.left.splice(t, Number.POSITIVE_INFINITY);
        pr(this.right, n.reverse());
      } else {
        const n = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        pr(this.left, n.reverse());
      }
  }
}
function pr(e, t) {
  let n = 0;
  if (t.length < 1e4)
    e.push(...t);
  else
    for (; n < t.length; )
      e.push(...t.slice(n, n + 1e4)), n += 1e4;
}
function Ap(e) {
  const t = {};
  let n = -1, r, o, i, s, a, l, c;
  const u = new Mb(e);
  for (; ++n < u.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = u.get(n), n && r[1].type === "chunkFlow" && u.get(n - 1)[1].type === "listItemPrefix" && (l = r[1]._tokenizer.events, i = 0, i < l.length && l[i][1].type === "lineEndingBlank" && (i += 2), i < l.length && l[i][1].type === "content"))
      for (; ++i < l.length && l[i][1].type !== "content"; )
        l[i][1].type === "chunkText" && (l[i][1]._isInFirstContentOfListItem = !0, i++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, Ib(u, n)), n = t[n], c = !0);
    else if (r[1]._container) {
      for (i = n, o = void 0; i-- && (s = u.get(i), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (o && (u.get(o)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", o = i);
      o && (r[1].end = Object.assign({}, u.get(o)[1].start), a = u.slice(o, n), a.unshift(r), u.splice(o, n - o + 1, a));
    }
  }
  return Ot(e, 0, Number.POSITIVE_INFINITY, u.slice(0)), !c;
}
function Ib(e, t) {
  const n = e.get(t)[1], r = e.get(t)[2];
  let o = t - 1;
  const i = [], s = n._tokenizer || r.parser[n.contentType](n.start), a = s.events, l = [], c = {};
  let u, d, f = -1, h = n, v = 0, m = 0;
  const y = [m];
  for (; h; ) {
    for (; e.get(++o)[1] !== h; )
      ;
    i.push(o), h._tokenizer || (u = r.sliceStream(h), h.next || u.push(null), d && s.defineSkip(h.start), h._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(u), h._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), d = h, h = h.next;
  }
  for (h = n; ++f < a.length; )
    // Find a void token that includes a break.
    a[f][0] === "exit" && a[f - 1][0] === "enter" && a[f][1].type === a[f - 1][1].type && a[f][1].start.line !== a[f][1].end.line && (m = f + 1, y.push(m), h._tokenizer = void 0, h.previous = void 0, h = h.next);
  for (s.events = [], h ? (h._tokenizer = void 0, h.previous = void 0) : y.pop(), f = y.length; f--; ) {
    const C = a.slice(y[f], y[f + 1]), x = i.pop();
    l.push([x, x + C.length - 1]), e.splice(x, 2, C);
  }
  for (l.reverse(), f = -1; ++f < l.length; )
    c[v + l[f][0]] = v + l[f][1], v += l[f][1] - l[f][0] - 1;
  return c;
}
const _b = {
  tokenize: Db,
  resolve: Nb
}, Lb = {
  tokenize: Ob,
  partial: !0
};
function Nb(e) {
  return Ap(e), e;
}
function Db(e, t) {
  let n;
  return r;
  function r(a) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), o(a);
  }
  function o(a) {
    return a === null ? i(a) : q(a) ? e.check(Lb, s, i)(a) : (e.consume(a), o);
  }
  function i(a) {
    return e.exit("chunkContent"), e.exit("content"), t(a);
  }
  function s(a) {
    return e.consume(a), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, o;
  }
}
function Ob(e, t, n) {
  const r = this;
  return o;
  function o(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), be(e, i, "linePrefix");
  }
  function i(s) {
    if (s === null || q(s))
      return n(s);
    const a = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? t(s) : e.interrupt(r.parser.constructs.flow, n, t)(s);
  }
}
function Ep(e, t, n, r, o, i, s, a, l) {
  const c = l || Number.POSITIVE_INFINITY;
  let u = 0;
  return d;
  function d(C) {
    return C === 60 ? (e.enter(r), e.enter(o), e.enter(i), e.consume(C), e.exit(i), f) : C === null || C === 32 || C === 41 || Qs(C) ? n(C) : (e.enter(r), e.enter(s), e.enter(a), e.enter("chunkString", {
      contentType: "string"
    }), m(C));
  }
  function f(C) {
    return C === 62 ? (e.enter(i), e.consume(C), e.exit(i), e.exit(o), e.exit(r), t) : (e.enter(a), e.enter("chunkString", {
      contentType: "string"
    }), h(C));
  }
  function h(C) {
    return C === 62 ? (e.exit("chunkString"), e.exit(a), f(C)) : C === null || C === 60 || q(C) ? n(C) : (e.consume(C), C === 92 ? v : h);
  }
  function v(C) {
    return C === 60 || C === 62 || C === 92 ? (e.consume(C), h) : h(C);
  }
  function m(C) {
    return !u && (C === null || C === 41 || Ge(C)) ? (e.exit("chunkString"), e.exit(a), e.exit(s), e.exit(r), t(C)) : u < c && C === 40 ? (e.consume(C), u++, m) : C === 41 ? (e.consume(C), u--, m) : C === null || C === 32 || C === 40 || Qs(C) ? n(C) : (e.consume(C), C === 92 ? y : m);
  }
  function y(C) {
    return C === 40 || C === 41 || C === 92 ? (e.consume(C), m) : m(C);
  }
}
function Sp(e, t, n, r, o, i) {
  const s = this;
  let a = 0, l;
  return c;
  function c(h) {
    return e.enter(r), e.enter(o), e.consume(h), e.exit(o), e.enter(i), u;
  }
  function u(h) {
    return a > 999 || h === null || h === 91 || h === 93 && !l || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    h === 94 && !a && "_hiddenFootnoteSupport" in s.parser.constructs ? n(h) : h === 93 ? (e.exit(i), e.enter(o), e.consume(h), e.exit(o), e.exit(r), t) : q(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), u) : (e.enter("chunkString", {
      contentType: "string"
    }), d(h));
  }
  function d(h) {
    return h === null || h === 91 || h === 93 || q(h) || a++ > 999 ? (e.exit("chunkString"), u(h)) : (e.consume(h), l || (l = !pe(h)), h === 92 ? f : d);
  }
  function f(h) {
    return h === 91 || h === 92 || h === 93 ? (e.consume(h), a++, d) : d(h);
  }
}
function kp(e, t, n, r, o, i) {
  let s;
  return a;
  function a(f) {
    return f === 34 || f === 39 || f === 40 ? (e.enter(r), e.enter(o), e.consume(f), e.exit(o), s = f === 40 ? 41 : f, l) : n(f);
  }
  function l(f) {
    return f === s ? (e.enter(o), e.consume(f), e.exit(o), e.exit(r), t) : (e.enter(i), c(f));
  }
  function c(f) {
    return f === s ? (e.exit(i), l(s)) : f === null ? n(f) : q(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), be(e, c, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), u(f));
  }
  function u(f) {
    return f === s || f === null || q(f) ? (e.exit("chunkString"), c(f)) : (e.consume(f), f === 92 ? d : u);
  }
  function d(f) {
    return f === s || f === 92 ? (e.consume(f), u) : u(f);
  }
}
function Er(e, t) {
  let n;
  return r;
  function r(o) {
    return q(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n = !0, r) : pe(o) ? be(
      e,
      r,
      n ? "linePrefix" : "lineSuffix"
    )(o) : t(o);
  }
}
const jb = {
  name: "definition",
  tokenize: Fb
}, Vb = {
  tokenize: Bb,
  partial: !0
};
function Fb(e, t, n) {
  const r = this;
  let o;
  return i;
  function i(h) {
    return e.enter("definition"), s(h);
  }
  function s(h) {
    return Sp.call(
      r,
      e,
      a,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(h);
  }
  function a(h) {
    return o = Kn(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), h === 58 ? (e.enter("definitionMarker"), e.consume(h), e.exit("definitionMarker"), l) : n(h);
  }
  function l(h) {
    return Ge(h) ? Er(e, c)(h) : c(h);
  }
  function c(h) {
    return Ep(
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(h);
  }
  function u(h) {
    return e.attempt(Vb, d, d)(h);
  }
  function d(h) {
    return pe(h) ? be(e, f, "whitespace")(h) : f(h);
  }
  function f(h) {
    return h === null || q(h) ? (e.exit("definition"), r.parser.defined.push(o), t(h)) : n(h);
  }
}
function Bb(e, t, n) {
  return r;
  function r(a) {
    return Ge(a) ? Er(e, o)(a) : n(a);
  }
  function o(a) {
    return kp(e, i, n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(a);
  }
  function i(a) {
    return pe(a) ? be(e, s, "whitespace")(a) : s(a);
  }
  function s(a) {
    return a === null || q(a) ? t(a) : n(a);
  }
}
const Hb = {
  name: "hardBreakEscape",
  tokenize: zb
};
function zb(e, t, n) {
  return r;
  function r(i) {
    return e.enter("hardBreakEscape"), e.consume(i), o;
  }
  function o(i) {
    return q(i) ? (e.exit("hardBreakEscape"), t(i)) : n(i);
  }
}
const Ub = {
  name: "headingAtx",
  tokenize: Wb,
  resolve: Kb
};
function Kb(e, t) {
  let n = e.length - 2, r = 3, o, i;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (o = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, i = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, Ot(e, r, n - r + 1, [["enter", o, t], ["enter", i, t], ["exit", i, t], ["exit", o, t]])), e;
}
function Wb(e, t, n) {
  let r = 0;
  return o;
  function o(u) {
    return e.enter("atxHeading"), i(u);
  }
  function i(u) {
    return e.enter("atxHeadingSequence"), s(u);
  }
  function s(u) {
    return u === 35 && r++ < 6 ? (e.consume(u), s) : u === null || Ge(u) ? (e.exit("atxHeadingSequence"), a(u)) : n(u);
  }
  function a(u) {
    return u === 35 ? (e.enter("atxHeadingSequence"), l(u)) : u === null || q(u) ? (e.exit("atxHeading"), t(u)) : pe(u) ? be(e, a, "whitespace")(u) : (e.enter("atxHeadingText"), c(u));
  }
  function l(u) {
    return u === 35 ? (e.consume(u), l) : (e.exit("atxHeadingSequence"), a(u));
  }
  function c(u) {
    return u === null || u === 35 || Ge(u) ? (e.exit("atxHeadingText"), a(u)) : (e.consume(u), c);
  }
}
const Zb = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], iu = ["pre", "script", "style", "textarea"], Qb = {
  name: "htmlFlow",
  tokenize: Xb,
  resolveTo: qb,
  concrete: !0
}, Gb = {
  tokenize: Jb,
  partial: !0
}, $b = {
  tokenize: Yb,
  partial: !0
};
function qb(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function Xb(e, t, n) {
  const r = this;
  let o, i, s, a, l;
  return c;
  function c(E) {
    return u(E);
  }
  function u(E) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(E), d;
  }
  function d(E) {
    return E === 33 ? (e.consume(E), f) : E === 47 ? (e.consume(E), i = !0, m) : E === 63 ? (e.consume(E), o = 3, r.interrupt ? t : b) : xt(E) ? (e.consume(E), s = String.fromCharCode(E), y) : n(E);
  }
  function f(E) {
    return E === 45 ? (e.consume(E), o = 2, h) : E === 91 ? (e.consume(E), o = 5, a = 0, v) : xt(E) ? (e.consume(E), o = 4, r.interrupt ? t : b) : n(E);
  }
  function h(E) {
    return E === 45 ? (e.consume(E), r.interrupt ? t : b) : n(E);
  }
  function v(E) {
    const xe = "CDATA[";
    return E === xe.charCodeAt(a++) ? (e.consume(E), a === xe.length ? r.interrupt ? t : I : v) : n(E);
  }
  function m(E) {
    return xt(E) ? (e.consume(E), s = String.fromCharCode(E), y) : n(E);
  }
  function y(E) {
    if (E === null || E === 47 || E === 62 || Ge(E)) {
      const xe = E === 47, Me = s.toLowerCase();
      return !xe && !i && iu.includes(Me) ? (o = 1, r.interrupt ? t(E) : I(E)) : Zb.includes(s.toLowerCase()) ? (o = 6, xe ? (e.consume(E), C) : r.interrupt ? t(E) : I(E)) : (o = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(E) : i ? x(E) : w(E));
    }
    return E === 45 || et(E) ? (e.consume(E), s += String.fromCharCode(E), y) : n(E);
  }
  function C(E) {
    return E === 62 ? (e.consume(E), r.interrupt ? t : I) : n(E);
  }
  function x(E) {
    return pe(E) ? (e.consume(E), x) : O(E);
  }
  function w(E) {
    return E === 47 ? (e.consume(E), O) : E === 58 || E === 95 || xt(E) ? (e.consume(E), S) : pe(E) ? (e.consume(E), w) : O(E);
  }
  function S(E) {
    return E === 45 || E === 46 || E === 58 || E === 95 || et(E) ? (e.consume(E), S) : R(E);
  }
  function R(E) {
    return E === 61 ? (e.consume(E), k) : pe(E) ? (e.consume(E), R) : w(E);
  }
  function k(E) {
    return E === null || E === 60 || E === 61 || E === 62 || E === 96 ? n(E) : E === 34 || E === 39 ? (e.consume(E), l = E, P) : pe(E) ? (e.consume(E), k) : T(E);
  }
  function P(E) {
    return E === l ? (e.consume(E), l = null, _) : E === null || q(E) ? n(E) : (e.consume(E), P);
  }
  function T(E) {
    return E === null || E === 34 || E === 39 || E === 47 || E === 60 || E === 61 || E === 62 || E === 96 || Ge(E) ? R(E) : (e.consume(E), T);
  }
  function _(E) {
    return E === 47 || E === 62 || pe(E) ? w(E) : n(E);
  }
  function O(E) {
    return E === 62 ? (e.consume(E), L) : n(E);
  }
  function L(E) {
    return E === null || q(E) ? I(E) : pe(E) ? (e.consume(E), L) : n(E);
  }
  function I(E) {
    return E === 45 && o === 2 ? (e.consume(E), Z) : E === 60 && o === 1 ? (e.consume(E), U) : E === 62 && o === 4 ? (e.consume(E), Y) : E === 63 && o === 3 ? (e.consume(E), b) : E === 93 && o === 5 ? (e.consume(E), j) : q(E) && (o === 6 || o === 7) ? (e.exit("htmlFlowData"), e.check(Gb, Ce, H)(E)) : E === null || q(E) ? (e.exit("htmlFlowData"), H(E)) : (e.consume(E), I);
  }
  function H(E) {
    return e.check($b, z, Ce)(E);
  }
  function z(E) {
    return e.enter("lineEnding"), e.consume(E), e.exit("lineEnding"), W;
  }
  function W(E) {
    return E === null || q(E) ? H(E) : (e.enter("htmlFlowData"), I(E));
  }
  function Z(E) {
    return E === 45 ? (e.consume(E), b) : I(E);
  }
  function U(E) {
    return E === 47 ? (e.consume(E), s = "", B) : I(E);
  }
  function B(E) {
    if (E === 62) {
      const xe = s.toLowerCase();
      return iu.includes(xe) ? (e.consume(E), Y) : I(E);
    }
    return xt(E) && s.length < 8 ? (e.consume(E), s += String.fromCharCode(E), B) : I(E);
  }
  function j(E) {
    return E === 93 ? (e.consume(E), b) : I(E);
  }
  function b(E) {
    return E === 62 ? (e.consume(E), Y) : E === 45 && o === 2 ? (e.consume(E), b) : I(E);
  }
  function Y(E) {
    return E === null || q(E) ? (e.exit("htmlFlowData"), Ce(E)) : (e.consume(E), Y);
  }
  function Ce(E) {
    return e.exit("htmlFlow"), t(E);
  }
}
function Yb(e, t, n) {
  const r = this;
  return o;
  function o(s) {
    return q(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), i) : n(s);
  }
  function i(s) {
    return r.parser.lazy[r.now().line] ? n(s) : t(s);
  }
}
function Jb(e, t, n) {
  return r;
  function r(o) {
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), e.attempt(mi, t, n);
  }
}
const eA = {
  name: "htmlText",
  tokenize: tA
};
function tA(e, t, n) {
  const r = this;
  let o, i, s;
  return a;
  function a(b) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(b), l;
  }
  function l(b) {
    return b === 33 ? (e.consume(b), c) : b === 47 ? (e.consume(b), R) : b === 63 ? (e.consume(b), w) : xt(b) ? (e.consume(b), T) : n(b);
  }
  function c(b) {
    return b === 45 ? (e.consume(b), u) : b === 91 ? (e.consume(b), i = 0, v) : xt(b) ? (e.consume(b), x) : n(b);
  }
  function u(b) {
    return b === 45 ? (e.consume(b), h) : n(b);
  }
  function d(b) {
    return b === null ? n(b) : b === 45 ? (e.consume(b), f) : q(b) ? (s = d, U(b)) : (e.consume(b), d);
  }
  function f(b) {
    return b === 45 ? (e.consume(b), h) : d(b);
  }
  function h(b) {
    return b === 62 ? Z(b) : b === 45 ? f(b) : d(b);
  }
  function v(b) {
    const Y = "CDATA[";
    return b === Y.charCodeAt(i++) ? (e.consume(b), i === Y.length ? m : v) : n(b);
  }
  function m(b) {
    return b === null ? n(b) : b === 93 ? (e.consume(b), y) : q(b) ? (s = m, U(b)) : (e.consume(b), m);
  }
  function y(b) {
    return b === 93 ? (e.consume(b), C) : m(b);
  }
  function C(b) {
    return b === 62 ? Z(b) : b === 93 ? (e.consume(b), C) : m(b);
  }
  function x(b) {
    return b === null || b === 62 ? Z(b) : q(b) ? (s = x, U(b)) : (e.consume(b), x);
  }
  function w(b) {
    return b === null ? n(b) : b === 63 ? (e.consume(b), S) : q(b) ? (s = w, U(b)) : (e.consume(b), w);
  }
  function S(b) {
    return b === 62 ? Z(b) : w(b);
  }
  function R(b) {
    return xt(b) ? (e.consume(b), k) : n(b);
  }
  function k(b) {
    return b === 45 || et(b) ? (e.consume(b), k) : P(b);
  }
  function P(b) {
    return q(b) ? (s = P, U(b)) : pe(b) ? (e.consume(b), P) : Z(b);
  }
  function T(b) {
    return b === 45 || et(b) ? (e.consume(b), T) : b === 47 || b === 62 || Ge(b) ? _(b) : n(b);
  }
  function _(b) {
    return b === 47 ? (e.consume(b), Z) : b === 58 || b === 95 || xt(b) ? (e.consume(b), O) : q(b) ? (s = _, U(b)) : pe(b) ? (e.consume(b), _) : Z(b);
  }
  function O(b) {
    return b === 45 || b === 46 || b === 58 || b === 95 || et(b) ? (e.consume(b), O) : L(b);
  }
  function L(b) {
    return b === 61 ? (e.consume(b), I) : q(b) ? (s = L, U(b)) : pe(b) ? (e.consume(b), L) : _(b);
  }
  function I(b) {
    return b === null || b === 60 || b === 61 || b === 62 || b === 96 ? n(b) : b === 34 || b === 39 ? (e.consume(b), o = b, H) : q(b) ? (s = I, U(b)) : pe(b) ? (e.consume(b), I) : (e.consume(b), z);
  }
  function H(b) {
    return b === o ? (e.consume(b), o = void 0, W) : b === null ? n(b) : q(b) ? (s = H, U(b)) : (e.consume(b), H);
  }
  function z(b) {
    return b === null || b === 34 || b === 39 || b === 60 || b === 61 || b === 96 ? n(b) : b === 47 || b === 62 || Ge(b) ? _(b) : (e.consume(b), z);
  }
  function W(b) {
    return b === 47 || b === 62 || Ge(b) ? _(b) : n(b);
  }
  function Z(b) {
    return b === 62 ? (e.consume(b), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(b);
  }
  function U(b) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(b), e.exit("lineEnding"), B;
  }
  function B(b) {
    return pe(b) ? be(e, j, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(b) : j(b);
  }
  function j(b) {
    return e.enter("htmlTextData"), s(b);
  }
}
const Tl = {
  name: "labelEnd",
  tokenize: aA,
  resolveTo: sA,
  resolveAll: iA
}, nA = {
  tokenize: lA
}, rA = {
  tokenize: cA
}, oA = {
  tokenize: uA
};
function iA(e) {
  let t = -1;
  for (; ++t < e.length; ) {
    const n = e[t][1];
    (n.type === "labelImage" || n.type === "labelLink" || n.type === "labelEnd") && (e.splice(t + 1, n.type === "labelImage" ? 4 : 2), n.type = "data", t++);
  }
  return e;
}
function sA(e, t) {
  let n = e.length, r = 0, o, i, s, a;
  for (; n--; )
    if (o = e[n][1], i) {
      if (o.type === "link" || o.type === "labelLink" && o._inactive)
        break;
      e[n][0] === "enter" && o.type === "labelLink" && (o._inactive = !0);
    } else if (s) {
      if (e[n][0] === "enter" && (o.type === "labelImage" || o.type === "labelLink") && !o._balanced && (i = n, o.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else o.type === "labelEnd" && (s = n);
  const l = {
    type: e[i][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, e[i][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, c = {
    type: "label",
    start: Object.assign({}, e[i][1].start),
    end: Object.assign({}, e[s][1].end)
  }, u = {
    type: "labelText",
    start: Object.assign({}, e[i + r + 2][1].end),
    end: Object.assign({}, e[s - 2][1].start)
  };
  return a = [["enter", l, t], ["enter", c, t]], a = at(a, e.slice(i + 1, i + r + 3)), a = at(a, [["enter", u, t]]), a = at(a, Pl(t.parser.constructs.insideSpan.null, e.slice(i + r + 4, s - 3), t)), a = at(a, [["exit", u, t], e[s - 2], e[s - 1], ["exit", c, t]]), a = at(a, e.slice(s + 1)), a = at(a, [["exit", l, t]]), Ot(e, i, e.length, a), e;
}
function aA(e, t, n) {
  const r = this;
  let o = r.events.length, i, s;
  for (; o--; )
    if ((r.events[o][1].type === "labelImage" || r.events[o][1].type === "labelLink") && !r.events[o][1]._balanced) {
      i = r.events[o][1];
      break;
    }
  return a;
  function a(f) {
    return i ? i._inactive ? d(f) : (s = r.parser.defined.includes(Kn(r.sliceSerialize({
      start: i.end,
      end: r.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(f), e.exit("labelMarker"), e.exit("labelEnd"), l) : n(f);
  }
  function l(f) {
    return f === 40 ? e.attempt(nA, u, s ? u : d)(f) : f === 91 ? e.attempt(rA, u, s ? c : d)(f) : s ? u(f) : d(f);
  }
  function c(f) {
    return e.attempt(oA, u, d)(f);
  }
  function u(f) {
    return t(f);
  }
  function d(f) {
    return i._balanced = !0, n(f);
  }
}
function lA(e, t, n) {
  return r;
  function r(d) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), o;
  }
  function o(d) {
    return Ge(d) ? Er(e, i)(d) : i(d);
  }
  function i(d) {
    return d === 41 ? u(d) : Ep(e, s, a, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(d);
  }
  function s(d) {
    return Ge(d) ? Er(e, l)(d) : u(d);
  }
  function a(d) {
    return n(d);
  }
  function l(d) {
    return d === 34 || d === 39 || d === 40 ? kp(e, c, n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(d) : u(d);
  }
  function c(d) {
    return Ge(d) ? Er(e, u)(d) : u(d);
  }
  function u(d) {
    return d === 41 ? (e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), e.exit("resource"), t) : n(d);
  }
}
function cA(e, t, n) {
  const r = this;
  return o;
  function o(a) {
    return Sp.call(r, e, i, s, "reference", "referenceMarker", "referenceString")(a);
  }
  function i(a) {
    return r.parser.defined.includes(Kn(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? t(a) : n(a);
  }
  function s(a) {
    return n(a);
  }
}
function uA(e, t, n) {
  return r;
  function r(i) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(i), e.exit("referenceMarker"), o;
  }
  function o(i) {
    return i === 93 ? (e.enter("referenceMarker"), e.consume(i), e.exit("referenceMarker"), e.exit("reference"), t) : n(i);
  }
}
const dA = {
  name: "labelStartImage",
  tokenize: fA,
  resolveAll: Tl.resolveAll
};
function fA(e, t, n) {
  const r = this;
  return o;
  function o(a) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(a), e.exit("labelImageMarker"), i;
  }
  function i(a) {
    return a === 91 ? (e.enter("labelMarker"), e.consume(a), e.exit("labelMarker"), e.exit("labelImage"), s) : n(a);
  }
  function s(a) {
    return a === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(a) : t(a);
  }
}
const hA = {
  name: "labelStartLink",
  tokenize: pA,
  resolveAll: Tl.resolveAll
};
function pA(e, t, n) {
  const r = this;
  return o;
  function o(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), i;
  }
  function i(s) {
    return s === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(s) : t(s);
  }
}
const es = {
  name: "lineEnding",
  tokenize: mA
};
function mA(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), be(e, t, "linePrefix");
  }
}
const wo = {
  name: "thematicBreak",
  tokenize: gA
};
function gA(e, t, n) {
  let r = 0, o;
  return i;
  function i(c) {
    return e.enter("thematicBreak"), s(c);
  }
  function s(c) {
    return o = c, a(c);
  }
  function a(c) {
    return c === o ? (e.enter("thematicBreakSequence"), l(c)) : r >= 3 && (c === null || q(c)) ? (e.exit("thematicBreak"), t(c)) : n(c);
  }
  function l(c) {
    return c === o ? (e.consume(c), r++, l) : (e.exit("thematicBreakSequence"), pe(c) ? be(e, a, "whitespace")(c) : a(c));
  }
}
const Ze = {
  name: "list",
  tokenize: yA,
  continuation: {
    tokenize: xA
  },
  exit: bA
}, vA = {
  tokenize: AA,
  partial: !0
}, CA = {
  tokenize: wA,
  partial: !0
};
function yA(e, t, n) {
  const r = this, o = r.events[r.events.length - 1];
  let i = o && o[1].type === "linePrefix" ? o[2].sliceSerialize(o[1], !0).length : 0, s = 0;
  return a;
  function a(h) {
    const v = r.containerState.type || (h === 42 || h === 43 || h === 45 ? "listUnordered" : "listOrdered");
    if (v === "listUnordered" ? !r.containerState.marker || h === r.containerState.marker : Gs(h)) {
      if (r.containerState.type || (r.containerState.type = v, e.enter(v, {
        _container: !0
      })), v === "listUnordered")
        return e.enter("listItemPrefix"), h === 42 || h === 45 ? e.check(wo, n, c)(h) : c(h);
      if (!r.interrupt || h === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), l(h);
    }
    return n(h);
  }
  function l(h) {
    return Gs(h) && ++s < 10 ? (e.consume(h), l) : (!r.interrupt || s < 2) && (r.containerState.marker ? h === r.containerState.marker : h === 41 || h === 46) ? (e.exit("listItemValue"), c(h)) : n(h);
  }
  function c(h) {
    return e.enter("listItemMarker"), e.consume(h), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || h, e.check(
      mi,
      // Can’t be empty when interrupting.
      r.interrupt ? n : u,
      e.attempt(vA, f, d)
    );
  }
  function u(h) {
    return r.containerState.initialBlankLine = !0, i++, f(h);
  }
  function d(h) {
    return pe(h) ? (e.enter("listItemPrefixWhitespace"), e.consume(h), e.exit("listItemPrefixWhitespace"), f) : n(h);
  }
  function f(h) {
    return r.containerState.size = i + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(h);
  }
}
function xA(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(mi, o, i);
  function o(a) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, be(e, t, "listItemIndent", r.containerState.size + 1)(a);
  }
  function i(a) {
    return r.containerState.furtherBlankLines || !pe(a) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, s(a)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(CA, t, s)(a));
  }
  function s(a) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, be(e, e.attempt(Ze, t, n), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(a);
  }
}
function wA(e, t, n) {
  const r = this;
  return be(e, o, "listItemIndent", r.containerState.size + 1);
  function o(i) {
    const s = r.events[r.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === r.containerState.size ? t(i) : n(i);
  }
}
function bA(e) {
  e.exit(this.containerState.type);
}
function AA(e, t, n) {
  const r = this;
  return be(e, o, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function o(i) {
    const s = r.events[r.events.length - 1];
    return !pe(i) && s && s[1].type === "listItemPrefixWhitespace" ? t(i) : n(i);
  }
}
const su = {
  name: "setextUnderline",
  tokenize: SA,
  resolveTo: EA
};
function EA(e, t) {
  let n = e.length, r, o, i;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (o = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !i && e[n][1].type === "definition" && (i = n);
  const s = {
    type: "setextHeading",
    start: Object.assign({}, e[o][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  };
  return e[o][1].type = "setextHeadingText", i ? (e.splice(o, 0, ["enter", s, t]), e.splice(i + 1, 0, ["exit", e[r][1], t]), e[r][1].end = Object.assign({}, e[i][1].end)) : e[r][1] = s, e.push(["exit", s, t]), e;
}
function SA(e, t, n) {
  const r = this;
  let o;
  return i;
  function i(c) {
    let u = r.events.length, d;
    for (; u--; )
      if (r.events[u][1].type !== "lineEnding" && r.events[u][1].type !== "linePrefix" && r.events[u][1].type !== "content") {
        d = r.events[u][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || d) ? (e.enter("setextHeadingLine"), o = c, s(c)) : n(c);
  }
  function s(c) {
    return e.enter("setextHeadingLineSequence"), a(c);
  }
  function a(c) {
    return c === o ? (e.consume(c), a) : (e.exit("setextHeadingLineSequence"), pe(c) ? be(e, l, "lineSuffix")(c) : l(c));
  }
  function l(c) {
    return c === null || q(c) ? (e.exit("setextHeadingLine"), t(c)) : n(c);
  }
}
const kA = {
  tokenize: RA
};
function RA(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    mi,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(
      this.parser.constructs.flowInitial,
      o,
      be(
        e,
        e.attempt(
          this.parser.constructs.flow,
          o,
          e.attempt(_b, o)
        ),
        "linePrefix"
      )
    )
  );
  return n;
  function r(i) {
    if (i === null) {
      e.consume(i);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(i), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function o(i) {
    if (i === null) {
      e.consume(i);
      return;
    }
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const PA = {
  resolveAll: Pp()
}, TA = Rp("string"), MA = Rp("text");
function Rp(e) {
  return {
    tokenize: t,
    resolveAll: Pp(
      e === "text" ? IA : void 0
    )
  };
  function t(n) {
    const r = this, o = this.parser.constructs[e], i = n.attempt(o, s, a);
    return s;
    function s(u) {
      return c(u) ? i(u) : a(u);
    }
    function a(u) {
      if (u === null) {
        n.consume(u);
        return;
      }
      return n.enter("data"), n.consume(u), l;
    }
    function l(u) {
      return c(u) ? (n.exit("data"), i(u)) : (n.consume(u), l);
    }
    function c(u) {
      if (u === null)
        return !0;
      const d = o[u];
      let f = -1;
      if (d)
        for (; ++f < d.length; ) {
          const h = d[f];
          if (!h.previous || h.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function Pp(e) {
  return t;
  function t(n, r) {
    let o = -1, i;
    for (; ++o <= n.length; )
      i === void 0 ? n[o] && n[o][1].type === "data" && (i = o, o++) : (!n[o] || n[o][1].type !== "data") && (o !== i + 2 && (n[i][1].end = n[o - 1][1].end, n.splice(i + 2, o - i - 2), o = i + 2), i = void 0);
    return e ? e(n, r) : n;
  }
}
function IA(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], o = t.sliceStream(r);
      let i = o.length, s = -1, a = 0, l;
      for (; i--; ) {
        const c = o[i];
        if (typeof c == "string") {
          for (s = c.length; c.charCodeAt(s - 1) === 32; )
            a++, s--;
          if (s) break;
          s = -1;
        } else if (c === -2)
          l = !0, a++;
        else if (c !== -1) {
          i++;
          break;
        }
      }
      if (a) {
        const c = {
          type: n === e.length || l || a < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: r.end.line,
            column: r.end.column - a,
            offset: r.end.offset - a,
            _index: r.start._index + i,
            _bufferIndex: i ? s : r.start._bufferIndex + s
          },
          end: Object.assign({}, r.end)
        };
        r.end = Object.assign({}, c.start), r.start.offset === r.end.offset ? Object.assign(r, c) : (e.splice(
          n,
          0,
          ["enter", c, t],
          ["exit", c, t]
        ), n += 2);
      }
      n++;
    }
  return e;
}
function _A(e, t, n) {
  let r = Object.assign(
    n ? Object.assign({}, n) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const o = {}, i = [];
  let s = [], a = [];
  const l = {
    consume: x,
    enter: w,
    exit: S,
    attempt: P(R),
    check: P(k),
    interrupt: P(k, {
      interrupt: !0
    })
  }, c = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: e,
    sliceStream: h,
    sliceSerialize: f,
    now: v,
    defineSkip: m,
    write: d
  };
  let u = t.tokenize.call(c, l);
  return t.resolveAll && i.push(t), c;
  function d(L) {
    return s = at(s, L), y(), s[s.length - 1] !== null ? [] : (T(t, 0), c.events = Pl(i, c.events, c), c.events);
  }
  function f(L, I) {
    return NA(h(L), I);
  }
  function h(L) {
    return LA(s, L);
  }
  function v() {
    const { line: L, column: I, offset: H, _index: z, _bufferIndex: W } = r;
    return {
      line: L,
      column: I,
      offset: H,
      _index: z,
      _bufferIndex: W
    };
  }
  function m(L) {
    o[L.line] = L.column, O();
  }
  function y() {
    let L;
    for (; r._index < s.length; ) {
      const I = s[r._index];
      if (typeof I == "string")
        for (L = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === L && r._bufferIndex < I.length; )
          C(I.charCodeAt(r._bufferIndex));
      else
        C(I);
    }
  }
  function C(L) {
    u = u(L);
  }
  function x(L) {
    q(L) ? (r.line++, r.column = 1, r.offset += L === -3 ? 2 : 1, O()) : L !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === s[r._index].length && (r._bufferIndex = -1, r._index++)), c.previous = L;
  }
  function w(L, I) {
    const H = I || {};
    return H.type = L, H.start = v(), c.events.push(["enter", H, c]), a.push(H), H;
  }
  function S(L) {
    const I = a.pop();
    return I.end = v(), c.events.push(["exit", I, c]), I;
  }
  function R(L, I) {
    T(L, I.from);
  }
  function k(L, I) {
    I.restore();
  }
  function P(L, I) {
    return H;
    function H(z, W, Z) {
      let U, B, j, b;
      return Array.isArray(z) ? Ce(z) : "tokenize" in z ? (
        // @ts-expect-error Looks like a construct.
        Ce([z])
      ) : Y(z);
      function Y(le) {
        return Q;
        function Q(te) {
          const se = te !== null && le[te], re = te !== null && le.null, ce = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(se) ? se : se ? [se] : [],
            ...Array.isArray(re) ? re : re ? [re] : []
          ];
          return Ce(ce)(te);
        }
      }
      function Ce(le) {
        return U = le, B = 0, le.length === 0 ? Z : E(le[B]);
      }
      function E(le) {
        return Q;
        function Q(te) {
          return b = _(), j = le, le.partial || (c.currentConstruct = le), le.name && c.parser.constructs.disable.null.includes(le.name) ? Me() : le.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            I ? Object.assign(Object.create(c), I) : c,
            l,
            xe,
            Me
          )(te);
        }
      }
      function xe(le) {
        return L(j, b), W;
      }
      function Me(le) {
        return b.restore(), ++B < U.length ? E(U[B]) : Z;
      }
    }
  }
  function T(L, I) {
    L.resolveAll && !i.includes(L) && i.push(L), L.resolve && Ot(
      c.events,
      I,
      c.events.length - I,
      L.resolve(c.events.slice(I), c)
    ), L.resolveTo && (c.events = L.resolveTo(c.events, c));
  }
  function _() {
    const L = v(), I = c.previous, H = c.currentConstruct, z = c.events.length, W = Array.from(a);
    return {
      restore: Z,
      from: z
    };
    function Z() {
      r = L, c.previous = I, c.currentConstruct = H, c.events.length = z, a = W, O();
    }
  }
  function O() {
    r.line in o && r.column < 2 && (r.column = o[r.line], r.offset += o[r.line] - 1);
  }
}
function LA(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, o = t.end._index, i = t.end._bufferIndex;
  let s;
  if (n === o)
    s = [e[n].slice(r, i)];
  else {
    if (s = e.slice(n, o), r > -1) {
      const a = s[0];
      typeof a == "string" ? s[0] = a.slice(r) : s.shift();
    }
    i > 0 && s.push(e[o].slice(0, i));
  }
  return s;
}
function NA(e, t) {
  let n = -1;
  const r = [];
  let o;
  for (; ++n < e.length; ) {
    const i = e[n];
    let s;
    if (typeof i == "string")
      s = i;
    else
      switch (i) {
        case -5: {
          s = "\r";
          break;
        }
        case -4: {
          s = `
`;
          break;
        }
        case -3: {
          s = `\r
`;
          break;
        }
        case -2: {
          s = t ? " " : "	";
          break;
        }
        case -1: {
          if (!t && o) continue;
          s = " ";
          break;
        }
        default:
          s = String.fromCharCode(i);
      }
    o = i === -2, r.push(s);
  }
  return r.join("");
}
const DA = {
  42: Ze,
  43: Ze,
  45: Ze,
  48: Ze,
  49: Ze,
  50: Ze,
  51: Ze,
  52: Ze,
  53: Ze,
  54: Ze,
  55: Ze,
  56: Ze,
  57: Ze,
  62: xp
}, OA = {
  91: jb
}, jA = {
  [-2]: Ji,
  [-1]: Ji,
  32: Ji
}, VA = {
  35: Ub,
  42: wo,
  45: [su, wo],
  60: Qb,
  61: su,
  95: wo,
  96: ou,
  126: ou
}, FA = {
  38: bp,
  92: wp
}, BA = {
  [-5]: es,
  [-4]: es,
  [-3]: es,
  33: dA,
  38: bp,
  42: $s,
  60: [hb, eA],
  91: hA,
  92: [Hb, wp],
  93: Tl,
  95: $s,
  96: kb
}, HA = {
  null: [$s, PA]
}, zA = {
  null: [42, 95]
}, UA = {
  null: []
}, KA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: zA,
  contentInitial: OA,
  disable: UA,
  document: DA,
  flow: VA,
  flowInitial: jA,
  insideSpan: HA,
  string: FA,
  text: BA
}, Symbol.toStringTag, { value: "Module" }));
function WA(e) {
  const n = (
    /** @type {FullNormalizedExtension} */
    Yw([KA, ...(e || {}).extensions || []])
  ), r = {
    defined: [],
    lazy: {},
    constructs: n,
    content: o(sb),
    document: o(lb),
    flow: o(kA),
    string: o(TA),
    text: o(MA)
  };
  return r;
  function o(i) {
    return s;
    function s(a) {
      return _A(r, i, a);
    }
  }
}
function ZA(e) {
  for (; !Ap(e); )
    ;
  return e;
}
const au = /[\0\t\n\r]/g;
function QA() {
  let e = 1, t = "", n = !0, r;
  return o;
  function o(i, s, a) {
    const l = [];
    let c, u, d, f, h;
    for (i = t + (typeof i == "string" ? i.toString() : new TextDecoder(s || void 0).decode(i)), d = 0, t = "", n && (i.charCodeAt(0) === 65279 && d++, n = void 0); d < i.length; ) {
      if (au.lastIndex = d, c = au.exec(i), f = c && c.index !== void 0 ? c.index : i.length, h = i.charCodeAt(f), !c) {
        t = i.slice(d);
        break;
      }
      if (h === 10 && d === f && r)
        l.push(-3), r = void 0;
      else
        switch (r && (l.push(-5), r = void 0), d < f && (l.push(i.slice(d, f)), e += f - d), h) {
          case 0: {
            l.push(65533), e++;
            break;
          }
          case 9: {
            for (u = Math.ceil(e / 4) * 4, l.push(-2); e++ < u; ) l.push(-1);
            break;
          }
          case 10: {
            l.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      d = f + 1;
    }
    return a && (r && l.push(-5), t && l.push(t), l.push(null)), l;
  }
}
const GA = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $A(e) {
  return e.replace(GA, qA);
}
function qA(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const o = n.charCodeAt(1), i = o === 120 || o === 88;
    return yp(n.slice(i ? 2 : 1), i ? 16 : 10);
  }
  return Rl(n) || e;
}
const Tp = {}.hasOwnProperty;
function XA(e, t, n) {
  return typeof t != "string" && (n = t, t = void 0), YA(n)(ZA(WA(n).document().write(QA()(e, t, !0))));
}
function YA(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: i(rt),
      autolinkProtocol: _,
      autolinkEmail: _,
      atxHeading: i(qe),
      blockQuote: i(re),
      characterEscape: _,
      characterReference: _,
      codeFenced: i(ce),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: i(ce, s),
      codeText: i(de, s),
      codeTextData: _,
      data: _,
      codeFlowValue: _,
      definition: i(_e),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: i(Ue),
      hardBreakEscape: i(Ke),
      hardBreakTrailing: i(Ke),
      htmlFlow: i(dt, s),
      htmlFlowData: _,
      htmlText: i(dt, s),
      htmlTextData: _,
      image: i(Rn),
      label: s,
      link: i(rt),
      listItem: i(Ci),
      listItemValue: f,
      listOrdered: i(qr, d),
      listUnordered: i(qr),
      paragraph: i(lr),
      reference: E,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: i(qe),
      strong: i(yi),
      thematicBreak: i(Xr)
    },
    exit: {
      atxHeading: l(),
      atxHeadingSequence: R,
      autolink: l(),
      autolinkEmail: se,
      autolinkProtocol: te,
      blockQuote: l(),
      characterEscapeValue: O,
      characterReferenceMarkerHexadecimal: Me,
      characterReferenceMarkerNumeric: Me,
      characterReferenceValue: le,
      characterReference: Q,
      codeFenced: l(y),
      codeFencedFence: m,
      codeFencedFenceInfo: h,
      codeFencedFenceMeta: v,
      codeFlowValue: O,
      codeIndented: l(C),
      codeText: l(W),
      codeTextData: O,
      data: O,
      definition: l(),
      definitionDestinationString: S,
      definitionLabelString: x,
      definitionTitleString: w,
      emphasis: l(),
      hardBreakEscape: l(I),
      hardBreakTrailing: l(I),
      htmlFlow: l(H),
      htmlFlowData: O,
      htmlText: l(z),
      htmlTextData: O,
      image: l(U),
      label: j,
      labelText: B,
      lineEnding: L,
      link: l(Z),
      listItem: l(),
      listOrdered: l(),
      listUnordered: l(),
      paragraph: l(),
      referenceString: xe,
      resourceDestinationString: b,
      resourceTitleString: Y,
      resource: Ce,
      setextHeading: l(T),
      setextHeadingLineSequence: P,
      setextHeadingText: k,
      strong: l(),
      thematicBreak: l()
    }
  };
  Mp(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(M) {
    let V = {
      type: "root",
      children: []
    };
    const J = {
      stack: [V],
      tokenStack: [],
      config: t,
      enter: a,
      exit: c,
      buffer: s,
      resume: u,
      data: n
    }, ie = [];
    let me = -1;
    for (; ++me < M.length; )
      if (M[me][1].type === "listOrdered" || M[me][1].type === "listUnordered")
        if (M[me][0] === "enter")
          ie.push(me);
        else {
          const Be = ie.pop();
          me = o(M, Be, me);
        }
    for (me = -1; ++me < M.length; ) {
      const Be = t[M[me][0]];
      Tp.call(Be, M[me][1].type) && Be[M[me][1].type].call(Object.assign({
        sliceSerialize: M[me][2].sliceSerialize
      }, J), M[me][1]);
    }
    if (J.tokenStack.length > 0) {
      const Be = J.tokenStack[J.tokenStack.length - 1];
      (Be[1] || lu).call(J, void 0, Be[0]);
    }
    for (V.position = {
      start: Bt(M.length > 0 ? M[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: Bt(M.length > 0 ? M[M.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, me = -1; ++me < t.transforms.length; )
      V = t.transforms[me](V) || V;
    return V;
  }
  function o(M, V, J) {
    let ie = V - 1, me = -1, Be = !1, Rt, ft, an, ln;
    for (; ++ie <= J; ) {
      const He = M[ie];
      switch (He[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          He[0] === "enter" ? me++ : me--, ln = void 0;
          break;
        }
        case "lineEndingBlank": {
          He[0] === "enter" && (Rt && !ln && !me && !an && (an = ie), ln = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          ln = void 0;
      }
      if (!me && He[0] === "enter" && He[1].type === "listItemPrefix" || me === -1 && He[0] === "exit" && (He[1].type === "listUnordered" || He[1].type === "listOrdered")) {
        if (Rt) {
          let jt = ie;
          for (ft = void 0; jt--; ) {
            const ht = M[jt];
            if (ht[1].type === "lineEnding" || ht[1].type === "lineEndingBlank") {
              if (ht[0] === "exit") continue;
              ft && (M[ft][1].type = "lineEndingBlank", Be = !0), ht[1].type = "lineEnding", ft = jt;
            } else if (!(ht[1].type === "linePrefix" || ht[1].type === "blockQuotePrefix" || ht[1].type === "blockQuotePrefixWhitespace" || ht[1].type === "blockQuoteMarker" || ht[1].type === "listItemIndent")) break;
          }
          an && (!ft || an < ft) && (Rt._spread = !0), Rt.end = Object.assign({}, ft ? M[ft][1].start : He[1].end), M.splice(ft || ie, 0, ["exit", Rt, He[2]]), ie++, J++;
        }
        if (He[1].type === "listItemPrefix") {
          const jt = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, He[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          Rt = jt, M.splice(ie, 0, ["enter", jt, He[2]]), ie++, J++, an = void 0, ln = !0;
        }
      }
    }
    return M[V][1]._spread = Be, J;
  }
  function i(M, V) {
    return J;
    function J(ie) {
      a.call(this, M(ie), ie), V && V.call(this, ie);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function a(M, V, J) {
    this.stack[this.stack.length - 1].children.push(M), this.stack.push(M), this.tokenStack.push([V, J]), M.position = {
      start: Bt(V.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function l(M) {
    return V;
    function V(J) {
      M && M.call(this, J), c.call(this, J);
    }
  }
  function c(M, V) {
    const J = this.stack.pop(), ie = this.tokenStack.pop();
    if (ie)
      ie[0].type !== M.type && (V ? V.call(this, M, ie[0]) : (ie[1] || lu).call(this, M, ie[0]));
    else throw new Error("Cannot close `" + M.type + "` (" + Ar({
      start: M.start,
      end: M.end
    }) + "): it’s not open");
    J.position.end = Bt(M.end);
  }
  function u() {
    return qw(this.stack.pop());
  }
  function d() {
    this.data.expectingFirstListItemValue = !0;
  }
  function f(M) {
    if (this.data.expectingFirstListItemValue) {
      const V = this.stack[this.stack.length - 2];
      V.start = Number.parseInt(this.sliceSerialize(M), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function h() {
    const M = this.resume(), V = this.stack[this.stack.length - 1];
    V.lang = M;
  }
  function v() {
    const M = this.resume(), V = this.stack[this.stack.length - 1];
    V.meta = M;
  }
  function m() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function y() {
    const M = this.resume(), V = this.stack[this.stack.length - 1];
    V.value = M.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function C() {
    const M = this.resume(), V = this.stack[this.stack.length - 1];
    V.value = M.replace(/(\r?\n|\r)$/g, "");
  }
  function x(M) {
    const V = this.resume(), J = this.stack[this.stack.length - 1];
    J.label = V, J.identifier = Kn(this.sliceSerialize(M)).toLowerCase();
  }
  function w() {
    const M = this.resume(), V = this.stack[this.stack.length - 1];
    V.title = M;
  }
  function S() {
    const M = this.resume(), V = this.stack[this.stack.length - 1];
    V.url = M;
  }
  function R(M) {
    const V = this.stack[this.stack.length - 1];
    if (!V.depth) {
      const J = this.sliceSerialize(M).length;
      V.depth = J;
    }
  }
  function k() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function P(M) {
    const V = this.stack[this.stack.length - 1];
    V.depth = this.sliceSerialize(M).codePointAt(0) === 61 ? 1 : 2;
  }
  function T() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function _(M) {
    const J = this.stack[this.stack.length - 1].children;
    let ie = J[J.length - 1];
    (!ie || ie.type !== "text") && (ie = xi(), ie.position = {
      start: Bt(M.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, J.push(ie)), this.stack.push(ie);
  }
  function O(M) {
    const V = this.stack.pop();
    V.value += this.sliceSerialize(M), V.position.end = Bt(M.end);
  }
  function L(M) {
    const V = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const J = V.children[V.children.length - 1];
      J.position.end = Bt(M.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(V.type) && (_.call(this, M), O.call(this, M));
  }
  function I() {
    this.data.atHardBreak = !0;
  }
  function H() {
    const M = this.resume(), V = this.stack[this.stack.length - 1];
    V.value = M;
  }
  function z() {
    const M = this.resume(), V = this.stack[this.stack.length - 1];
    V.value = M;
  }
  function W() {
    const M = this.resume(), V = this.stack[this.stack.length - 1];
    V.value = M;
  }
  function Z() {
    const M = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const V = this.data.referenceType || "shortcut";
      M.type += "Reference", M.referenceType = V, delete M.url, delete M.title;
    } else
      delete M.identifier, delete M.label;
    this.data.referenceType = void 0;
  }
  function U() {
    const M = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const V = this.data.referenceType || "shortcut";
      M.type += "Reference", M.referenceType = V, delete M.url, delete M.title;
    } else
      delete M.identifier, delete M.label;
    this.data.referenceType = void 0;
  }
  function B(M) {
    const V = this.sliceSerialize(M), J = this.stack[this.stack.length - 2];
    J.label = $A(V), J.identifier = Kn(V).toLowerCase();
  }
  function j() {
    const M = this.stack[this.stack.length - 1], V = this.resume(), J = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, J.type === "link") {
      const ie = M.children;
      J.children = ie;
    } else
      J.alt = V;
  }
  function b() {
    const M = this.resume(), V = this.stack[this.stack.length - 1];
    V.url = M;
  }
  function Y() {
    const M = this.resume(), V = this.stack[this.stack.length - 1];
    V.title = M;
  }
  function Ce() {
    this.data.inReference = void 0;
  }
  function E() {
    this.data.referenceType = "collapsed";
  }
  function xe(M) {
    const V = this.resume(), J = this.stack[this.stack.length - 1];
    J.label = V, J.identifier = Kn(this.sliceSerialize(M)).toLowerCase(), this.data.referenceType = "full";
  }
  function Me(M) {
    this.data.characterReferenceType = M.type;
  }
  function le(M) {
    const V = this.sliceSerialize(M), J = this.data.characterReferenceType;
    let ie;
    J ? (ie = yp(V, J === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : ie = Rl(V);
    const me = this.stack[this.stack.length - 1];
    me.value += ie;
  }
  function Q(M) {
    const V = this.stack.pop();
    V.position.end = Bt(M.end);
  }
  function te(M) {
    O.call(this, M);
    const V = this.stack[this.stack.length - 1];
    V.url = this.sliceSerialize(M);
  }
  function se(M) {
    O.call(this, M);
    const V = this.stack[this.stack.length - 1];
    V.url = "mailto:" + this.sliceSerialize(M);
  }
  function re() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function ce() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function de() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function _e() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Ue() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function qe() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function Ke() {
    return {
      type: "break"
    };
  }
  function dt() {
    return {
      type: "html",
      value: ""
    };
  }
  function Rn() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function rt() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function qr(M) {
    return {
      type: "list",
      ordered: M.type === "listOrdered",
      start: null,
      spread: M._spread,
      children: []
    };
  }
  function Ci(M) {
    return {
      type: "listItem",
      spread: M._spread,
      checked: null,
      children: []
    };
  }
  function lr() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function yi() {
    return {
      type: "strong",
      children: []
    };
  }
  function xi() {
    return {
      type: "text",
      value: ""
    };
  }
  function Xr() {
    return {
      type: "thematicBreak"
    };
  }
}
function Bt(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function Mp(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? Mp(e, r) : JA(e, r);
  }
}
function JA(e, t) {
  let n;
  for (n in t)
    if (Tp.call(t, n))
      switch (n) {
        case "canContainEols": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "transforms": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = t[n];
          r && Object.assign(e[n], r);
          break;
        }
      }
}
function lu(e, t) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Ar({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + t.type + "`, " + Ar({
    start: t.start,
    end: t.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + Ar({
    start: t.start,
    end: t.end
  }) + ") is still open");
}
function eE(e) {
  const t = this;
  t.parser = n;
  function n(r) {
    return XA(r, {
      ...t.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function tE(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function nE(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function rE(e, t) {
  const n = t.value ? t.value + `
` : "", r = {};
  t.lang && (r.className = ["language-" + t.lang]);
  let o = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (o.data = { meta: t.meta }), e.patch(t, o), o = e.applyData(t, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(t, o), o;
}
function oE(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function iE(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function sE(e, t) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(t.identifier).toUpperCase(), o = ar(r.toLowerCase()), i = e.footnoteOrder.indexOf(r);
  let s, a = e.footnoteCounts.get(r);
  a === void 0 ? (a = 0, e.footnoteOrder.push(r), s = e.footnoteOrder.length) : s = i + 1, a += 1, e.footnoteCounts.set(r, a);
  const l = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + n + "fn-" + o,
      id: n + "fnref-" + o + (a > 1 ? "-" + a : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(t, l);
  const c = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [l]
  };
  return e.patch(t, c), e.applyData(t, c);
}
function aE(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function lE(e, t) {
  if (e.options.allowDangerousHtml) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
}
function Ip(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return [{ type: "text", value: "![" + t.alt + r }];
  const o = e.all(t), i = o[0];
  i && i.type === "text" ? i.value = "[" + i.value : o.unshift({ type: "text", value: "[" });
  const s = o[o.length - 1];
  return s && s.type === "text" ? s.value += r : o.push({ type: "text", value: r }), o;
}
function cE(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return Ip(e, t);
  const o = { src: ar(r.url || ""), alt: t.alt };
  r.title !== null && r.title !== void 0 && (o.title = r.title);
  const i = { type: "element", tagName: "img", properties: o, children: [] };
  return e.patch(t, i), e.applyData(t, i);
}
function uE(e, t) {
  const n = { src: ar(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, r), e.applyData(t, r);
}
function dE(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, r), e.applyData(t, r);
}
function fE(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return Ip(e, t);
  const o = { href: ar(r.url || "") };
  r.title !== null && r.title !== void 0 && (o.title = r.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: o,
    children: e.all(t)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function hE(e, t) {
  const n = { href: ar(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function pE(e, t, n) {
  const r = e.all(t), o = n ? mE(n) : _p(t), i = {}, s = [];
  if (typeof t.checked == "boolean") {
    const u = r[0];
    let d;
    u && u.type === "element" && u.tagName === "p" ? d = u : (d = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(d)), d.children.length > 0 && d.children.unshift({ type: "text", value: " " }), d.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), i.className = ["task-list-item"];
  }
  let a = -1;
  for (; ++a < r.length; ) {
    const u = r[a];
    (o || a !== 0 || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !o ? s.push(...u.children) : s.push(u);
  }
  const l = r[r.length - 1];
  l && (o || l.type !== "element" || l.tagName !== "p") && s.push({ type: "text", value: `
` });
  const c = { type: "element", tagName: "li", properties: i, children: s };
  return e.patch(t, c), e.applyData(t, c);
}
function mE(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length; )
      t = _p(n[r]);
  }
  return t;
}
function _p(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function gE(e, t) {
  const n = {}, r = e.all(t);
  let o = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++o < r.length; ) {
    const s = r[o];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const i = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(r, !0)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function vE(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function CE(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function yE(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function xE(e, t) {
  const n = e.all(t), r = n.shift(), o = [];
  if (r) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(t.children[0], s), o.push(s);
  }
  if (n.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, a = Al(t.children[1]), l = fp(t.children[t.children.length - 1]);
    a && l && (s.position = { start: a, end: l }), o.push(s);
  }
  const i = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(o, !0)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function wE(e, t, n) {
  const r = n ? n.children : void 0, i = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", s = n && n.type === "table" ? n.align : void 0, a = s ? s.length : t.children.length;
  let l = -1;
  const c = [];
  for (; ++l < a; ) {
    const d = t.children[l], f = {}, h = s ? s[l] : void 0;
    h && (f.align = h);
    let v = { type: "element", tagName: i, properties: f, children: [] };
    d && (v.children = e.all(d), e.patch(d, v), v = e.applyData(d, v)), c.push(v);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(c, !0)
  };
  return e.patch(t, u), e.applyData(t, u);
}
function bE(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const cu = 9, uu = 32;
function AE(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), o = 0;
  const i = [];
  for (; r; )
    i.push(
      du(t.slice(o, r.index), o > 0, !0),
      r[0]
    ), o = r.index + r[0].length, r = n.exec(t);
  return i.push(du(t.slice(o), o > 0, !1)), i.join("");
}
function du(e, t, n) {
  let r = 0, o = e.length;
  if (t) {
    let i = e.codePointAt(r);
    for (; i === cu || i === uu; )
      r++, i = e.codePointAt(r);
  }
  if (n) {
    let i = e.codePointAt(o - 1);
    for (; i === cu || i === uu; )
      o--, i = e.codePointAt(o - 1);
  }
  return o > r ? e.slice(r, o) : "";
}
function EE(e, t) {
  const n = { type: "text", value: AE(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function SE(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const kE = {
  blockquote: tE,
  break: nE,
  code: rE,
  delete: oE,
  emphasis: iE,
  footnoteReference: sE,
  heading: aE,
  html: lE,
  imageReference: cE,
  image: uE,
  inlineCode: dE,
  linkReference: fE,
  link: hE,
  listItem: pE,
  list: gE,
  paragraph: vE,
  // @ts-expect-error: root is different, but hard to type.
  root: CE,
  strong: yE,
  table: xE,
  tableCell: bE,
  tableRow: wE,
  text: EE,
  thematicBreak: SE,
  toml: co,
  yaml: co,
  definition: co,
  footnoteDefinition: co
};
function co() {
}
const Lp = -1, gi = 0, zo = 1, Uo = 2, Ml = 3, Il = 4, _l = 5, Ll = 6, Np = 7, Dp = 8, fu = typeof self == "object" ? self : globalThis, RE = (e, t) => {
  const n = (o, i) => (e.set(i, o), o), r = (o) => {
    if (e.has(o))
      return e.get(o);
    const [i, s] = t[o];
    switch (i) {
      case gi:
      case Lp:
        return n(s, o);
      case zo: {
        const a = n([], o);
        for (const l of s)
          a.push(r(l));
        return a;
      }
      case Uo: {
        const a = n({}, o);
        for (const [l, c] of s)
          a[r(l)] = r(c);
        return a;
      }
      case Ml:
        return n(new Date(s), o);
      case Il: {
        const { source: a, flags: l } = s;
        return n(new RegExp(a, l), o);
      }
      case _l: {
        const a = n(/* @__PURE__ */ new Map(), o);
        for (const [l, c] of s)
          a.set(r(l), r(c));
        return a;
      }
      case Ll: {
        const a = n(/* @__PURE__ */ new Set(), o);
        for (const l of s)
          a.add(r(l));
        return a;
      }
      case Np: {
        const { name: a, message: l } = s;
        return n(new fu[a](l), o);
      }
      case Dp:
        return n(BigInt(s), o);
      case "BigInt":
        return n(Object(BigInt(s)), o);
    }
    return n(new fu[i](s), o);
  };
  return r;
}, hu = (e) => RE(/* @__PURE__ */ new Map(), e)(0), Nn = "", { toString: PE } = {}, { keys: TE } = Object, mr = (e) => {
  const t = typeof e;
  if (t !== "object" || !e)
    return [gi, t];
  const n = PE.call(e).slice(8, -1);
  switch (n) {
    case "Array":
      return [zo, Nn];
    case "Object":
      return [Uo, Nn];
    case "Date":
      return [Ml, Nn];
    case "RegExp":
      return [Il, Nn];
    case "Map":
      return [_l, Nn];
    case "Set":
      return [Ll, Nn];
  }
  return n.includes("Array") ? [zo, n] : n.includes("Error") ? [Np, n] : [Uo, n];
}, uo = ([e, t]) => e === gi && (t === "function" || t === "symbol"), ME = (e, t, n, r) => {
  const o = (s, a) => {
    const l = r.push(s) - 1;
    return n.set(a, l), l;
  }, i = (s) => {
    if (n.has(s))
      return n.get(s);
    let [a, l] = mr(s);
    switch (a) {
      case gi: {
        let u = s;
        switch (l) {
          case "bigint":
            a = Dp, u = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + l);
            u = null;
            break;
          case "undefined":
            return o([Lp], s);
        }
        return o([a, u], s);
      }
      case zo: {
        if (l)
          return o([l, [...s]], s);
        const u = [], d = o([a, u], s);
        for (const f of s)
          u.push(i(f));
        return d;
      }
      case Uo: {
        if (l)
          switch (l) {
            case "BigInt":
              return o([l, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return o([l, s.valueOf()], s);
          }
        if (t && "toJSON" in s)
          return i(s.toJSON());
        const u = [], d = o([a, u], s);
        for (const f of TE(s))
          (e || !uo(mr(s[f]))) && u.push([i(f), i(s[f])]);
        return d;
      }
      case Ml:
        return o([a, s.toISOString()], s);
      case Il: {
        const { source: u, flags: d } = s;
        return o([a, { source: u, flags: d }], s);
      }
      case _l: {
        const u = [], d = o([a, u], s);
        for (const [f, h] of s)
          (e || !(uo(mr(f)) || uo(mr(h)))) && u.push([i(f), i(h)]);
        return d;
      }
      case Ll: {
        const u = [], d = o([a, u], s);
        for (const f of s)
          (e || !uo(mr(f))) && u.push(i(f));
        return d;
      }
    }
    const { message: c } = s;
    return o([a, { name: l, message: c }], s);
  };
  return i;
}, pu = (e, { json: t, lossy: n } = {}) => {
  const r = [];
  return ME(!(t || n), !!t, /* @__PURE__ */ new Map(), r)(e), r;
}, Ko = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, t) => t && ("json" in t || "lossy" in t) ? hu(pu(e, t)) : structuredClone(e)
) : (e, t) => hu(pu(e, t));
function IE(e, t) {
  const n = [{ type: "text", value: "↩" }];
  return t > 1 && n.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(t) }]
  }), n;
}
function _E(e, t) {
  return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function LE(e) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = e.options.footnoteBackContent || IE, r = e.options.footnoteBackLabel || _E, o = e.options.footnoteLabel || "Footnotes", i = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, a = [];
  let l = -1;
  for (; ++l < e.footnoteOrder.length; ) {
    const c = e.footnoteById.get(
      e.footnoteOrder[l]
    );
    if (!c)
      continue;
    const u = e.all(c), d = String(c.identifier).toUpperCase(), f = ar(d.toLowerCase());
    let h = 0;
    const v = [], m = e.footnoteCounts.get(d);
    for (; m !== void 0 && ++h <= m; ) {
      v.length > 0 && v.push({ type: "text", value: " " });
      let x = typeof n == "string" ? n : n(l, h);
      typeof x == "string" && (x = { type: "text", value: x }), v.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t + "fnref-" + f + (h > 1 ? "-" + h : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(l, h),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(x) ? x : [x]
      });
    }
    const y = u[u.length - 1];
    if (y && y.type === "element" && y.tagName === "p") {
      const x = y.children[y.children.length - 1];
      x && x.type === "text" ? x.value += " " : y.children.push({ type: "text", value: " " }), y.children.push(...v);
    } else
      u.push(...v);
    const C = {
      type: "element",
      tagName: "li",
      properties: { id: t + "fn-" + f },
      children: e.wrap(u, !0)
    };
    e.patch(c, C), a.push(C);
  }
  if (a.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: i,
          properties: {
            ...Ko(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: o }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(a, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const Op = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return jE;
    if (typeof e == "function")
      return vi(e);
    if (typeof e == "object")
      return Array.isArray(e) ? NE(e) : DE(e);
    if (typeof e == "string")
      return OE(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function NE(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = Op(e[n]);
  return vi(r);
  function r(...o) {
    let i = -1;
    for (; ++i < t.length; )
      if (t[i].apply(this, o)) return !0;
    return !1;
  }
}
function DE(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return vi(n);
  function n(r) {
    const o = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let i;
    for (i in e)
      if (o[i] !== t[i]) return !1;
    return !0;
  }
}
function OE(e) {
  return vi(t);
  function t(n) {
    return n && n.type === e;
  }
}
function vi(e) {
  return t;
  function t(n, r, o) {
    return !!(VE(n) && e.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      o || void 0
    ));
  }
}
function jE() {
  return !0;
}
function VE(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const jp = [], FE = !0, mu = !1, BE = "skip";
function HE(e, t, n, r) {
  let o;
  typeof t == "function" && typeof n != "function" ? (r = n, n = t) : o = t;
  const i = Op(o), s = r ? -1 : 1;
  a(e, void 0, [])();
  function a(l, c, u) {
    const d = (
      /** @type {Record<string, unknown>} */
      l && typeof l == "object" ? l : {}
    );
    if (typeof d.type == "string") {
      const h = (
        // `hast`
        typeof d.tagName == "string" ? d.tagName : (
          // `xast`
          typeof d.name == "string" ? d.name : void 0
        )
      );
      Object.defineProperty(f, "name", {
        value: "node (" + (l.type + (h ? "<" + h + ">" : "")) + ")"
      });
    }
    return f;
    function f() {
      let h = jp, v, m, y;
      if ((!t || i(l, c, u[u.length - 1] || void 0)) && (h = zE(n(l, u)), h[0] === mu))
        return h;
      if ("children" in l && l.children) {
        const C = (
          /** @type {UnistParent} */
          l
        );
        if (C.children && h[0] !== BE)
          for (m = (r ? C.children.length : -1) + s, y = u.concat(C); m > -1 && m < C.children.length; ) {
            const x = C.children[m];
            if (v = a(x, m, y)(), v[0] === mu)
              return v;
            m = typeof v[1] == "number" ? v[1] : m + s;
          }
      }
      return h;
    }
  }
}
function zE(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [FE, e] : e == null ? jp : [e];
}
function Vp(e, t, n, r) {
  let o, i, s;
  typeof t == "function" && typeof n != "function" ? (i = void 0, s = t, o = n) : (i = t, s = n, o = r), HE(e, i, a, o);
  function a(l, c) {
    const u = c[c.length - 1], d = u ? u.children.indexOf(l) : void 0;
    return s(l, d, u);
  }
}
const qs = {}.hasOwnProperty, UE = {};
function KE(e, t) {
  const n = t || UE, r = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), s = { ...kE, ...n.handlers }, a = {
    all: c,
    applyData: ZE,
    definitionById: r,
    footnoteById: o,
    footnoteCounts: i,
    footnoteOrder: [],
    handlers: s,
    one: l,
    options: n,
    patch: WE,
    wrap: GE
  };
  return Vp(e, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const d = u.type === "definition" ? r : o, f = String(u.identifier).toUpperCase();
      d.has(f) || d.set(f, u);
    }
  }), a;
  function l(u, d) {
    const f = u.type, h = a.handlers[f];
    if (qs.call(a.handlers, f) && h)
      return h(a, u, d);
    if (a.options.passThrough && a.options.passThrough.includes(f)) {
      if ("children" in u) {
        const { children: m, ...y } = u, C = Ko(y);
        return C.children = a.all(u), C;
      }
      return Ko(u);
    }
    return (a.options.unknownHandler || QE)(a, u, d);
  }
  function c(u) {
    const d = [];
    if ("children" in u) {
      const f = u.children;
      let h = -1;
      for (; ++h < f.length; ) {
        const v = a.one(f[h], u);
        if (v) {
          if (h && f[h - 1].type === "break" && (!Array.isArray(v) && v.type === "text" && (v.value = gu(v.value)), !Array.isArray(v) && v.type === "element")) {
            const m = v.children[0];
            m && m.type === "text" && (m.value = gu(m.value));
          }
          Array.isArray(v) ? d.push(...v) : d.push(v);
        }
      }
    }
    return d;
  }
}
function WE(e, t) {
  e.position && (t.position = kw(e));
}
function ZE(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, o = e.data.hChildren, i = e.data.hProperties;
    if (typeof r == "string")
      if (n.type === "element")
        n.tagName = r;
      else {
        const s = "children" in n ? n.children : [n];
        n = { type: "element", tagName: r, properties: {}, children: s };
      }
    n.type === "element" && i && Object.assign(n.properties, Ko(i)), "children" in n && n.children && o !== null && o !== void 0 && (n.children = o);
  }
  return n;
}
function QE(e, t) {
  const n = t.data || {}, r = "value" in t && !(qs.call(n, "hProperties") || qs.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function GE(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({ type: "text", value: `
` }); ++r < e.length; )
    r && n.push({ type: "text", value: `
` }), n.push(e[r]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function gu(e) {
  let t = 0, n = e.charCodeAt(t);
  for (; n === 9 || n === 32; )
    t++, n = e.charCodeAt(t);
  return e.slice(t);
}
function vu(e, t) {
  const n = KE(e, t), r = n.one(e, void 0), o = LE(n), i = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return o && i.children.push({ type: "text", value: `
` }, o), i;
}
function $E(e, t) {
  return e && "run" in e ? async function(n, r) {
    const o = (
      /** @type {HastRoot} */
      vu(n, { file: r, ...t })
    );
    await e.run(o, r);
  } : function(n, r) {
    return (
      /** @type {HastRoot} */
      vu(n, { file: r, ...e || t })
    );
  };
}
function Cu(e) {
  if (e)
    throw e;
}
var bo = Object.prototype.hasOwnProperty, Fp = Object.prototype.toString, yu = Object.defineProperty, xu = Object.getOwnPropertyDescriptor, wu = function(t) {
  return typeof Array.isArray == "function" ? Array.isArray(t) : Fp.call(t) === "[object Array]";
}, bu = function(t) {
  if (!t || Fp.call(t) !== "[object Object]")
    return !1;
  var n = bo.call(t, "constructor"), r = t.constructor && t.constructor.prototype && bo.call(t.constructor.prototype, "isPrototypeOf");
  if (t.constructor && !n && !r)
    return !1;
  var o;
  for (o in t)
    ;
  return typeof o > "u" || bo.call(t, o);
}, Au = function(t, n) {
  yu && n.name === "__proto__" ? yu(t, n.name, {
    enumerable: !0,
    configurable: !0,
    value: n.newValue,
    writable: !0
  }) : t[n.name] = n.newValue;
}, Eu = function(t, n) {
  if (n === "__proto__")
    if (bo.call(t, n)) {
      if (xu)
        return xu(t, n).value;
    } else return;
  return t[n];
}, qE = function e() {
  var t, n, r, o, i, s, a = arguments[0], l = 1, c = arguments.length, u = !1;
  for (typeof a == "boolean" && (u = a, a = arguments[1] || {}, l = 2), (a == null || typeof a != "object" && typeof a != "function") && (a = {}); l < c; ++l)
    if (t = arguments[l], t != null)
      for (n in t)
        r = Eu(a, n), o = Eu(t, n), a !== o && (u && o && (bu(o) || (i = wu(o))) ? (i ? (i = !1, s = r && wu(r) ? r : []) : s = r && bu(r) ? r : {}, Au(a, { name: n, newValue: e(u, s, o) })) : typeof o < "u" && Au(a, { name: n, newValue: o }));
  return a;
};
const ts = /* @__PURE__ */ Jp(qE);
function Xs(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function XE() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...o) {
    let i = -1;
    const s = o.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    a(null, ...o);
    function a(l, ...c) {
      const u = e[++i];
      let d = -1;
      if (l) {
        s(l);
        return;
      }
      for (; ++d < o.length; )
        (c[d] === null || c[d] === void 0) && (c[d] = o[d]);
      o = c, u ? YE(u, a)(...c) : s(null, ...c);
    }
  }
  function r(o) {
    if (typeof o != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + o
      );
    return e.push(o), t;
  }
}
function YE(e, t) {
  let n;
  return r;
  function r(...s) {
    const a = e.length > s.length;
    let l;
    a && s.push(o);
    try {
      l = e.apply(this, s);
    } catch (c) {
      const u = (
        /** @type {Error} */
        c
      );
      if (a && n)
        throw u;
      return o(u);
    }
    a || (l && l.then && typeof l.then == "function" ? l.then(i, o) : l instanceof Error ? o(l) : i(l));
  }
  function o(s, ...a) {
    n || (n = !0, t(s, ...a));
  }
  function i(s) {
    o(null, s);
  }
}
const Ct = { basename: JE, dirname: eS, extname: tS, join: nS, sep: "/" };
function JE(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  $r(e);
  let n = 0, r = -1, o = e.length, i;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; o--; )
      if (e.codePointAt(o) === 47) {
        if (i) {
          n = o + 1;
          break;
        }
      } else r < 0 && (i = !0, r = o + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let s = -1, a = t.length - 1;
  for (; o--; )
    if (e.codePointAt(o) === 47) {
      if (i) {
        n = o + 1;
        break;
      }
    } else
      s < 0 && (i = !0, s = o + 1), a > -1 && (e.codePointAt(o) === t.codePointAt(a--) ? a < 0 && (r = o) : (a = -1, r = s));
  return n === r ? r = s : r < 0 && (r = e.length), e.slice(n, r);
}
function eS(e) {
  if ($r(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.codePointAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else r || (r = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function tS(e) {
  $r(e);
  let t = e.length, n = -1, r = 0, o = -1, i = 0, s;
  for (; t--; ) {
    const a = e.codePointAt(t);
    if (a === 47) {
      if (s) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (s = !0, n = t + 1), a === 46 ? o < 0 ? o = t : i !== 1 && (i = 1) : o > -1 && (i = -1);
  }
  return o < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  i === 0 || // The (right-most) trimmed path component is exactly `..`.
  i === 1 && o === n - 1 && o === r + 1 ? "" : e.slice(o, n);
}
function nS(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    $r(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : rS(n);
}
function rS(e) {
  $r(e);
  const t = e.codePointAt(0) === 47;
  let n = oS(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function oS(e, t) {
  let n = "", r = 0, o = -1, i = 0, s = -1, a, l;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      a = e.codePointAt(s);
    else {
      if (a === 47)
        break;
      a = 47;
    }
    if (a === 47) {
      if (!(o === s - 1 || i === 1)) if (o !== s - 1 && i === 2) {
        if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            if (l = n.lastIndexOf("/"), l !== n.length - 1) {
              l < 0 ? (n = "", r = 0) : (n = n.slice(0, l), r = n.length - 1 - n.lastIndexOf("/")), o = s, i = 0;
              continue;
            }
          } else if (n.length > 0) {
            n = "", r = 0, o = s, i = 0;
            continue;
          }
        }
        t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
      } else
        n.length > 0 ? n += "/" + e.slice(o + 1, s) : n = e.slice(o + 1, s), r = s - o - 1;
      o = s, i = 0;
    } else a === 46 && i > -1 ? i++ : i = -1;
  }
  return n;
}
function $r(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const iS = { cwd: sS };
function sS() {
  return "/";
}
function Ys(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function aS(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!Ys(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return lS(e);
}
function lS(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
      const r = t.codePointAt(n + 2);
      if (r === 70 || r === 102) {
        const o = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw o.code = "ERR_INVALID_FILE_URL_PATH", o;
      }
    }
  return decodeURIComponent(t);
}
const ns = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class Bp {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? Ys(t) ? n = { path: t } : typeof t == "string" || cS(t) ? n = { value: t } : n = t : n = {}, this.cwd = "cwd" in n ? "" : iS.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < ns.length; ) {
      const i = ns[r];
      i in n && n[i] !== void 0 && n[i] !== null && (this[i] = i === "history" ? [...n[i]] : n[i]);
    }
    let o;
    for (o in n)
      ns.includes(o) || (this[o] = n[o]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Ct.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    os(t, "basename"), rs(t, "basename"), this.path = Ct.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Ct.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    Su(this.basename, "dirname"), this.path = Ct.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Ct.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (rs(t, "extname"), Su(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Ct.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    Ys(t) && (t = aS(t)), os(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Ct.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    os(t, "stem"), rs(t, "stem"), this.path = Ct.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const o = this.message(t, n, r);
    throw o.fatal = !0, o;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const o = this.message(t, n, r);
    return o.fatal = void 0, o;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const o = new Fe(
      // @ts-expect-error: the overloads are fine.
      t,
      n,
      r
    );
    return this.path && (o.name = this.path + ":" + o.name, o.file = this.path), o.fatal = !1, this.messages.push(o), o;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function rs(e, t) {
  if (e && e.includes(Ct.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + Ct.sep + "`"
    );
}
function os(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function Su(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function cS(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const uS = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), o = r[e], i = function() {
      return o.apply(i, arguments);
    };
    return Object.setPrototypeOf(i, r), i;
  }
), dS = {}.hasOwnProperty;
class Nl extends uS {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = XE();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Nl()
    );
    let n = -1;
    for (; ++n < this.attachers.length; ) {
      const r = this.attachers[n];
      t.use(...r);
    }
    return t.data(ts(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, n) {
    return typeof t == "string" ? arguments.length === 2 ? (as("data", this.frozen), this.namespace[t] = n, this) : dS.call(this.namespace, t) && this.namespace[t] || void 0 : t ? (as("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [n, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const o = n.call(t, ...r);
      typeof o == "function" && this.transformers.use(o);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const n = fo(t), r = this.parser || this.Parser;
    return is("parse", r), r(String(n), n);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, n) {
    const r = this;
    return this.freeze(), is("process", this.parser || this.Parser), ss("process", this.compiler || this.Compiler), n ? o(void 0, n) : new Promise(o);
    function o(i, s) {
      const a = fo(t), l = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(a)
      );
      r.run(l, a, function(u, d, f) {
        if (u || !d || !f)
          return c(u);
        const h = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          d
        ), v = r.stringify(h, f);
        pS(v) ? f.value = v : f.result = v, c(
          u,
          /** @type {VFileWithOutput<CompileResult>} */
          f
        );
      });
      function c(u, d) {
        u || !d ? s(u) : i ? i(d) : n(void 0, d);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let n = !1, r;
    return this.freeze(), is("processSync", this.parser || this.Parser), ss("processSync", this.compiler || this.Compiler), this.process(t, o), Ru("processSync", "process", n), r;
    function o(i, s) {
      n = !0, Cu(i), r = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, n, r) {
    ku(t), this.freeze();
    const o = this.transformers;
    return !r && typeof n == "function" && (r = n, n = void 0), r ? i(void 0, r) : new Promise(i);
    function i(s, a) {
      const l = fo(n);
      o.run(t, l, c);
      function c(u, d, f) {
        const h = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          d || t
        );
        u ? a(u) : s ? s(h) : r(void 0, h, f);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, n) {
    let r = !1, o;
    return this.run(t, n, i), Ru("runSync", "run", r), o;
    function i(s, a) {
      Cu(s), o = a, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, n) {
    this.freeze();
    const r = fo(n), o = this.compiler || this.Compiler;
    return ss("stringify", o), ku(t), o(t, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...n) {
    const r = this.attachers, o = this.namespace;
    if (as("use", this.frozen), t != null) if (typeof t == "function")
      l(t, n);
    else if (typeof t == "object")
      Array.isArray(t) ? a(t) : s(t);
    else
      throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function i(c) {
      if (typeof c == "function")
        l(c, []);
      else if (typeof c == "object")
        if (Array.isArray(c)) {
          const [u, ...d] = (
            /** @type {PluginTuple<Array<unknown>>} */
            c
          );
          l(u, d);
        } else
          s(c);
      else
        throw new TypeError("Expected usable value, not `" + c + "`");
    }
    function s(c) {
      if (!("plugins" in c) && !("settings" in c))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      a(c.plugins), c.settings && (o.settings = ts(!0, o.settings, c.settings));
    }
    function a(c) {
      let u = -1;
      if (c != null) if (Array.isArray(c))
        for (; ++u < c.length; ) {
          const d = c[u];
          i(d);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + c + "`");
    }
    function l(c, u) {
      let d = -1, f = -1;
      for (; ++d < r.length; )
        if (r[d][0] === c) {
          f = d;
          break;
        }
      if (f === -1)
        r.push([c, ...u]);
      else if (u.length > 0) {
        let [h, ...v] = u;
        const m = r[f][1];
        Xs(m) && Xs(h) && (h = ts(!0, m, h)), r[f] = [c, h, ...v];
      }
    }
  }
}
const fS = new Nl().freeze();
function is(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function ss(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function as(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function ku(e) {
  if (!Xs(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Ru(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function fo(e) {
  return hS(e) ? e : new Bp(e);
}
function hS(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function pS(e) {
  return typeof e == "string" || mS(e);
}
function mS(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const gS = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", Pu = [], Tu = { allowDangerousHtml: !0 }, vS = /^(https?|ircs?|mailto|xmpp)$/i, CS = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function yS(e) {
  const t = e.allowedElements, n = e.allowElement, r = e.children || "", o = e.className, i = e.components, s = e.disallowedElements, a = e.rehypePlugins || Pu, l = e.remarkPlugins || Pu, c = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...Tu } : Tu, u = e.skipHtml, d = e.unwrapDisallowed, f = e.urlTransform || xS, h = fS().use(eE).use(l).use($E, c).use(a), v = new Bp();
  typeof r == "string" && (v.value = r);
  for (const x of CS)
    Object.hasOwn(e, x.from) && ("" + x.from + (x.to ? "use `" + x.to + "` instead" : "remove it") + gS + x.id, void 0);
  const m = h.parse(v);
  let y = h.runSync(m, v);
  return o && (y = {
    type: "element",
    tagName: "div",
    properties: { className: o },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      y.type === "root" ? y.children : [y]
    )
  }), Vp(y, C), _w(y, {
    Fragment: p.Fragment,
    components: i,
    ignoreInvalidStyle: !0,
    jsx: p.jsx,
    jsxs: p.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function C(x, w, S) {
    if (x.type === "raw" && S && typeof w == "number")
      return u ? S.children.splice(w, 1) : S.children[w] = { type: "text", value: x.value }, w;
    if (x.type === "element") {
      let R;
      for (R in Yi)
        if (Object.hasOwn(Yi, R) && Object.hasOwn(x.properties, R)) {
          const k = x.properties[R], P = Yi[R];
          (P === null || P.includes(x.tagName)) && (x.properties[R] = f(String(k || ""), R, x));
        }
    }
    if (x.type === "element") {
      let R = t ? !t.includes(x.tagName) : s ? s.includes(x.tagName) : !1;
      if (!R && n && typeof w == "number" && (R = !n(x, w, S)), R && S && typeof w == "number")
        return d && x.children ? S.children.splice(w, 1, ...x.children) : S.children.splice(w, 1), w;
    }
  }
}
function xS(e) {
  const t = e.indexOf(":"), n = e.indexOf("?"), r = e.indexOf("#"), o = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    t < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    o > -1 && t > o || n > -1 && t > n || r > -1 && t > r || // It is a protocol, it should be allowed.
    vS.test(e.slice(0, t)) ? e : ""
  );
}
function wS(e) {
  const t = e.split(/\r?\n/), n = /^\d+\.\s/, r = /^[-\*\+]\s/;
  for (const o of t) {
    const i = o.trim();
    if (n.test(i) || r.test(i))
      return !0;
  }
  return !1;
}
const bS = ({ answerText: e }) => {
  const t = wS(e);
  return /* @__PURE__ */ p.jsx(
    "div",
    {
      className: `text-gray-900 text-base font-normal ${t ? "" : "whitespace-pre-wrap"}`,
      children: /* @__PURE__ */ p.jsx(yS, { children: e })
    }
  );
}, AS = Ye.memo(() => /* @__PURE__ */ p.jsx(
  vn.div,
  {
    className: "w-2 h-2 bg-blue-500 rounded-full inline-block ml-1",
    animate: {
      scale: [1, 1.4, 1],
      opacity: [1, 0.5, 1]
    },
    transition: {
      duration: 0.8,
      repeat: 1 / 0,
      ease: "easeInOut"
    }
  }
)), ES = Ye.memo(
  ({ answerChunks: e, status: t }) => {
    const n = Kt(null), [r, o] = Sr(0);
    bn(() => {
      n.current && o(n.current.scrollHeight);
    }, [e, t]);
    const i = Wt(() => e && e.length > 0 ? /* @__PURE__ */ p.jsx("div", { className: "flex flex-col", children: e.map((s, a) => /* @__PURE__ */ p.jsx(
      bS,
      {
        answerText: (s == null ? void 0 : s.answer_chunk) || ""
      },
      (s == null ? void 0 : s.chunk_id) || a
    )) }) : null, [e]);
    return /* @__PURE__ */ p.jsx(
      vn.div,
      {
        animate: { height: r },
        transition: { type: "spring", stiffness: 300, damping: 20 },
        className: "overflow-hidden",
        children: /* @__PURE__ */ p.jsx("div", { ref: n, children: /* @__PURE__ */ p.jsxs(np, { mode: "wait", children: [
          t === "initial" && /* @__PURE__ */ p.jsx(
            vn.div,
            {
              initial: { opacity: 0 },
              animate: { opacity: 1 },
              exit: { opacity: 0 },
              transition: { duration: 0.5 }
            },
            "initial"
          ),
          t === "loading" && /* @__PURE__ */ p.jsx(
            vn.div,
            {
              initial: { opacity: 0 },
              animate: { opacity: 1 },
              exit: { opacity: 0 },
              transition: { duration: 0.5 },
              children: /* @__PURE__ */ p.jsx(Wx, { isVisible: !0 })
            },
            "loading"
          ),
          (t === "answering" || t === "complete") && /* @__PURE__ */ p.jsxs(
            vn.div,
            {
              initial: { opacity: 0 },
              animate: { opacity: 1 },
              transition: { duration: 0.5 },
              children: [
                i,
                t === "answering" && /* @__PURE__ */ p.jsx(AS, {})
              ]
            },
            "answer"
          )
        ] }) })
      }
    );
  }
);
ES.displayName = "AnimatedAnswer";
const ik = () => {
  const e = /* @__PURE__ */ new Date(), t = {
    weekday: "long",
    // "Monday" through "Sunday"
    month: "short",
    // "Jan" through "Dec"
    day: "numeric"
    // 1, 2, ..., 31
  }, n = `Today, ${e.toLocaleDateString("en-US", t)}`;
  return /* @__PURE__ */ p.jsx("h3", { className: "text-base text-muted-foreground", children: n });
};
export {
  ES as AnimatedAnswer,
  bS as AnswerFormatter,
  Wx as AnswerProgress,
  YS as Assignee,
  GS as Badge,
  ho as Button,
  Ku as Card,
  Wu as CardContent,
  l3 as CardDescription,
  c3 as CardFooter,
  s3 as CardHeader,
  a3 as CardTitle,
  Zx as CardVariants,
  ok as CardWithTitle,
  WS as Dialog,
  QS as DialogClose,
  Zg as DialogContent,
  qg as DialogDescription,
  Gg as DialogFooter,
  Qg as DialogHeader,
  P5 as DialogOverlay,
  Wg as DialogPortal,
  $g as DialogTitle,
  ZS as DialogTrigger,
  h7 as DropdownMenu,
  v7 as DropdownMenuCheckboxItem,
  Nf as DropdownMenuContent,
  MS as DropdownMenuGroup,
  ys as DropdownMenuItem,
  y7 as DropdownMenuLabel,
  IS as DropdownMenuPortal,
  LS as DropdownMenuRadioGroup,
  C7 as DropdownMenuRadioItem,
  x7 as DropdownMenuSeparator,
  w7 as DropdownMenuShortcut,
  _S as DropdownMenuSub,
  g7 as DropdownMenuSubContent,
  m7 as DropdownMenuSubTrigger,
  p7 as DropdownMenuTrigger,
  ik as FormattedDate,
  z6 as HoverCard,
  Cd as HoverCardContent,
  U6 as HoverCardTrigger,
  he as Icon,
  p8 as InlineSourceListItem,
  m8 as InlineSourceListSeeAll,
  JS as InlineSourceListUI,
  Yg as LetterCircle,
  i8 as NUMBER_OF_COLUMNS_TO_SHOW,
  bc as NUMBER_OF_ITEMS_TO_SHOW,
  H7 as NavigationMenu,
  W7 as NavigationMenuContent,
  Z7 as NavigationMenuIndicator,
  DS as NavigationMenuItem,
  OS as NavigationMenuLink,
  z7 as NavigationMenuList,
  K7 as NavigationMenuTrigger,
  a0 as NavigationMenuViewport,
  $S as PriorityIndicator,
  XS as Progress,
  qS as PropertySelect,
  rk as QuerySuggestionCta,
  VS as Select,
  xg as SelectContent,
  FS as SelectGroup,
  bg as SelectItem,
  wg as SelectLabel,
  W0 as SelectScrollDownButton,
  K0 as SelectScrollUpButton,
  Ag as SelectSeparator,
  yg as SelectTrigger,
  BS as SelectValue,
  Rg as Separator,
  Ut as Skeleton,
  ek as SourcesProgress,
  dn as Status,
  Mn as StatusIcon,
  zS as Tabs,
  Lg as TabsContent,
  Ig as TabsList,
  _g as TabsTrigger,
  Xg as badgeVariants,
  i3 as buttonVariants,
  h8 as formatValue,
  g8 as getBorderRadiusClass,
  f8 as getIconForColumn,
  d8 as getLoaderForColumn,
  s8 as iconMapping,
  a8 as loaderMapping,
  U7 as navigationMenuTriggerStyle,
  l8 as regexIconMapping,
  u8 as sourceConfig
};
